export default [{ province: '北京市', provinceCode: 156110000, adcode: '156110000', name: '北京市', children: [{ province: '北京市', provinceCode: 156110000, city: '北京市', adcode: '156110000', name: '北京市', cityCode: 156110000, children: [{ id: 1, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '东城区', regionCode: 156110101, name: '东城区', adcode: '156110101' }, { id: 2, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '西城区', regionCode: 156110102, name: '西城区', adcode: '156110102' }, { id: 3, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '朝阳区', regionCode: 156110105, name: '朝阳区', adcode: '156110105' }, { id: 4, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '丰台区', regionCode: 156110106, name: '丰台区', adcode: '156110106' }, { id: 5, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '石景山区', regionCode: 156110107, name: '石景山区', adcode: '156110107' }, { id: 6, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '海淀区', regionCode: 156110108, name: '海淀区', adcode: '156110108' }, { id: 7, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '门头沟区', regionCode: 156110109, name: '门头沟区', adcode: '156110109' }, { id: 8, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '房山区', regionCode: 156110111, name: '房山区', adcode: '156110111' }, { id: 9, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '通州区', regionCode: 156110112, name: '通州区', adcode: '156110112' }, { id: 10, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '顺义区', regionCode: 156110113, name: '顺义区', adcode: '156110113' }, { id: 11, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '昌平区', regionCode: 156110114, name: '昌平区', adcode: '156110114' }, { id: 12, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '大兴区', regionCode: 156110115, name: '大兴区', adcode: '156110115' }, { id: 13, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '怀柔区', regionCode: 156110116, name: '怀柔区', adcode: '156110116' }, { id: 14, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '平谷区', regionCode: 156110117, name: '平谷区', adcode: '156110117' }, { id: 15, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '密云区', regionCode: 156110118, name: '密云区', adcode: '156110118' }, { id: 16, province: '北京市', provinceCode: 156110000, city: '北京市', cityCode: 156110000, region: '延庆区', regionCode: 156110119, name: '延庆区', adcode: '156110119' }] }] }, { province: '天津市', provinceCode: 156120000, adcode: '156120000', name: '天津市', children: [{ province: '天津市', provinceCode: 156120000, city: '天津市', adcode: '156120000', name: '天津市', cityCode: 156120000, children: [{ id: 17, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '和平区', regionCode: 156120101, name: '和平区', adcode: '156120101' }, { id: 18, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '河东区', regionCode: 156120102, name: '河东区', adcode: '156120102' }, { id: 19, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '河西区', regionCode: 156120103, name: '河西区', adcode: '156120103' }, { id: 20, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '南开区', regionCode: 156120104, name: '南开区', adcode: '156120104' }, { id: 21, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '河北区', regionCode: 156120105, name: '河北区', adcode: '156120105' }, { id: 22, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '红桥区', regionCode: 156120106, name: '红桥区', adcode: '156120106' }, { id: 23, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '东丽区', regionCode: 156120110, name: '东丽区', adcode: '156120110' }, { id: 24, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '西青区', regionCode: 156120111, name: '西青区', adcode: '156120111' }, { id: 25, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '津南区', regionCode: 156120112, name: '津南区', adcode: '156120112' }, { id: 26, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '北辰区', regionCode: 156120113, name: '北辰区', adcode: '156120113' }, { id: 27, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '武清区', regionCode: 156120114, name: '武清区', adcode: '156120114' }, { id: 28, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '宝坻区', regionCode: 156120115, name: '宝坻区', adcode: '156120115' }, { id: 29, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '滨海新区', regionCode: 156120116, name: '滨海新区', adcode: '156120116' }, { id: 30, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '宁河区', regionCode: 156120117, name: '宁河区', adcode: '156120117' }, { id: 31, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '静海区', regionCode: 156120118, name: '静海区', adcode: '156120118' }, { id: 32, province: '天津市', provinceCode: 156120000, city: '天津市', cityCode: 156120000, region: '蓟州区', regionCode: 156120119, name: '蓟州区', adcode: '156120119' }] }] }, {
province: '河北省',
provinceCode: 156130000,
adcode: '156130000',
name: '河北省',
children: [{ province: '河北省', provinceCode: 156130000, city: '石家庄市', adcode: '156130100', name: '石家庄市', cityCode: 156130100, children: [{ id: 33, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '长安区', regionCode: 156130102, name: '长安区', adcode: '156130102' }, { id: 34, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '桥西区', regionCode: 156130104, name: '桥西区', adcode: '156130104' }, { id: 35, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '新华区', regionCode: 156130105, name: '新华区', adcode: '156130105' }, { id: 36, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '井陉矿区', regionCode: 156130107, name: '井陉矿区', adcode: '156130107' }, { id: 37, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '裕华区', regionCode: 156130108, name: '裕华区', adcode: '156130108' }, { id: 38, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '藁城区', regionCode: 156130109, name: '藁城区', adcode: '156130109' }, { id: 39, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '鹿泉区', regionCode: 156130110, name: '鹿泉区', adcode: '156130110' }, { id: 40, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '栾城区', regionCode: 156130111, name: '栾城区', adcode: '156130111' }, { id: 41, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '井陉县', regionCode: 156130121, name: '井陉县', adcode: '156130121' }, { id: 42, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '正定县', regionCode: 156130123, name: '正定县', adcode: '156130123' }, { id: 43, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '行唐县', regionCode: 156130125, name: '行唐县', adcode: '156130125' }, { id: 44, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '灵寿县', regionCode: 156130126, name: '灵寿县', adcode: '156130126' }, { id: 45, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '高邑县', regionCode: 156130127, name: '高邑县', adcode: '156130127' }, { id: 46, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '深泽县', regionCode: 156130128, name: '深泽县', adcode: '156130128' }, { id: 47, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '赞皇县', regionCode: 156130129, name: '赞皇县', adcode: '156130129' }, { id: 48, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '无极县', regionCode: 156130130, name: '无极县', adcode: '156130130' }, { id: 49, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '平山县', regionCode: 156130131, name: '平山县', adcode: '156130131' }, { id: 50, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '元氏县', regionCode: 156130132, name: '元氏县', adcode: '156130132' }, { id: 51, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '赵县', regionCode: 156130133, name: '赵县', adcode: '156130133' }, { id: 52, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '辛集市', regionCode: 156130181, name: '辛集市', adcode: '156130181' }, { id: 53, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '晋州市', regionCode: 156130183, name: '晋州市', adcode: '156130183' }, { id: 54, province: '河北省', provinceCode: 156130000, city: '石家庄市', cityCode: 156130100, region: '新乐市', regionCode: 156130184, name: '新乐市', adcode: '156130184' }] }, { province: '河北省', provinceCode: 156130000, city: '唐山市', adcode: '156130200', name: '唐山市', cityCode: 156130200, children: [{ id: 55, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '路南区', regionCode: 156130202, name: '路南区', adcode: '156130202' }, { id: 56, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '路北区', regionCode: 156130203, name: '路北区', adcode: '156130203' }, { id: 57, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '古冶区', regionCode: 156130204, name: '古冶区', adcode: '156130204' }, { id: 58, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '开平区', regionCode: 156130205, name: '开平区', adcode: '156130205' }, { id: 59, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '丰南区', regionCode: 156130207, name: '丰南区', adcode: '156130207' }, { id: 60, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '丰润区', regionCode: 156130208, name: '丰润区', adcode: '156130208' }, { id: 61, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '曹妃甸区', regionCode: 156130209, name: '曹妃甸区', adcode: '156130209' }, { id: 62, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '滦南县', regionCode: 156130224, name: '滦南县', adcode: '156130224' }, { id: 63, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '乐亭县', regionCode: 156130225, name: '乐亭县', adcode: '156130225' }, { id: 64, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '迁西县', regionCode: 156130227, name: '迁西县', adcode: '156130227' }, { id: 65, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '玉田县', regionCode: 156130229, name: '玉田县', adcode: '156130229' }, { id: 66, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '遵化市', regionCode: 156130281, name: '遵化市', adcode: '156130281' }, { id: 67, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '迁安市', regionCode: 156130283, name: '迁安市', adcode: '156130283' }, { id: 68, province: '河北省', provinceCode: 156130000, city: '唐山市', cityCode: 156130200, region: '滦州市', regionCode: 156130284, name: '滦州市', adcode: '156130284' }] }, { province: '河北省', provinceCode: 156130000, city: '秦皇岛市', adcode: '156130300', name: '秦皇岛市', cityCode: 156130300, children: [{ id: 69, province: '河北省', provinceCode: 156130000, city: '秦皇岛市', cityCode: 156130300, region: '海港区', regionCode: 156130302, name: '海港区', adcode: '156130302' }, { id: 70, province: '河北省', provinceCode: 156130000, city: '秦皇岛市', cityCode: 156130300, region: '山海关区', regionCode: 156130303, name: '山海关区', adcode: '156130303' }, { id: 71, province: '河北省', provinceCode: 156130000, city: '秦皇岛市', cityCode: 156130300, region: '北戴河区', regionCode: 156130304, name: '北戴河区', adcode: '156130304' }, { id: 72, province: '河北省', provinceCode: 156130000, city: '秦皇岛市', cityCode: 156130300, region: '抚宁区', regionCode: 156130306, name: '抚宁区', adcode: '156130306' }, { id: 73, province: '河北省', provinceCode: 156130000, city: '秦皇岛市', cityCode: 156130300, region: '青龙满族自治县', regionCode: 156130321, name: '青龙满族自治县', adcode: '156130321' }, { id: 74, province: '河北省', provinceCode: 156130000, city: '秦皇岛市', cityCode: 156130300, region: '昌黎县', regionCode: 156130322, name: '昌黎县', adcode: '156130322' }, { id: 75, province: '河北省', provinceCode: 156130000, city: '秦皇岛市', cityCode: 156130300, region: '卢龙县', regionCode: 156130324, name: '卢龙县', adcode: '156130324' }] }, { province: '河北省', provinceCode: 156130000, city: '邯郸市', adcode: '156130400', name: '邯郸市', cityCode: 156130400, children: [{ id: 76, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '邯山区', regionCode: 156130402, name: '邯山区', adcode: '156130402' }, { id: 77, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '丛台区', regionCode: 156130403, name: '丛台区', adcode: '156130403' }, { id: 78, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '复兴区', regionCode: 156130404, name: '复兴区', adcode: '156130404' }, { id: 79, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '峰峰矿区', regionCode: 156130406, name: '峰峰矿区', adcode: '156130406' }, { id: 80, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '肥乡区', regionCode: 156130407, name: '肥乡区', adcode: '156130407' }, { id: 81, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '永年区', regionCode: 156130408, name: '永年区', adcode: '156130408' }, { id: 82, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '临漳县', regionCode: 156130423, name: '临漳县', adcode: '156130423' }, { id: 83, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '成安县', regionCode: 156130424, name: '成安县', adcode: '156130424' }, { id: 84, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '大名县', regionCode: 156130425, name: '大名县', adcode: '156130425' }, { id: 85, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '涉县', regionCode: 156130426, name: '涉县', adcode: '156130426' }, { id: 86, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '磁县', regionCode: 156130427, name: '磁县', adcode: '156130427' }, { id: 87, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '邱县', regionCode: 156130430, name: '邱县', adcode: '156130430' }, { id: 88, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '鸡泽县', regionCode: 156130431, name: '鸡泽县', adcode: '156130431' }, { id: 89, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '广平县', regionCode: 156130432, name: '广平县', adcode: '156130432' }, { id: 90, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '馆陶县', regionCode: 156130433, name: '馆陶县', adcode: '156130433' }, { id: 91, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '魏县', regionCode: 156130434, name: '魏县', adcode: '156130434' }, { id: 92, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '曲周县', regionCode: 156130435, name: '曲周县', adcode: '156130435' }, { id: 93, province: '河北省', provinceCode: 156130000, city: '邯郸市', cityCode: 156130400, region: '武安市', regionCode: 156130481, name: '武安市', adcode: '156130481' }] }, { province: '河北省', provinceCode: 156130000, city: '邢台市', adcode: '156130500', name: '邢台市', cityCode: 156130500, children: [{ id: 94, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '桥东区', regionCode: 156130502, name: '桥东区', adcode: '156130502' }, { id: 95, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '桥西区', regionCode: 156130503, name: '桥西区', adcode: '156130503' }, { id: 96, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '邢台县', regionCode: 156130521, name: '邢台县', adcode: '156130521' }, { id: 97, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '临城县', regionCode: 156130522, name: '临城县', adcode: '156130522' }, { id: 98, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '内丘县', regionCode: 156130523, name: '内丘县', adcode: '156130523' }, { id: 99, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '柏乡县', regionCode: 156130524, name: '柏乡县', adcode: '156130524' }, { id: 100, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '隆尧县', regionCode: 156130525, name: '隆尧县', adcode: '156130525' }, { id: 101, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '任县', regionCode: 156130526, name: '任县', adcode: '156130526' }, { id: 102, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '南和县', regionCode: 156130527, name: '南和县', adcode: '156130527' }, { id: 103, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '宁晋县', regionCode: 156130528, name: '宁晋县', adcode: '156130528' }, { id: 104, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '巨鹿县', regionCode: 156130529, name: '巨鹿县', adcode: '156130529' }, { id: 105, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '新河县', regionCode: 156130530, name: '新河县', adcode: '156130530' }, { id: 106, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '广宗县', regionCode: 156130531, name: '广宗县', adcode: '156130531' }, { id: 107, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '平乡县', regionCode: 156130532, name: '平乡县', adcode: '156130532' }, { id: 108, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '威县', regionCode: 156130533, name: '威县', adcode: '156130533' }, { id: 109, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '清河县', regionCode: 156130534, name: '清河县', adcode: '156130534' }, { id: 110, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '临西县', regionCode: 156130535, name: '临西县', adcode: '156130535' }, { id: 111, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '南宫市', regionCode: 156130581, name: '南宫市', adcode: '156130581' }, { id: 112, province: '河北省', provinceCode: 156130000, city: '邢台市', cityCode: 156130500, region: '沙河市', regionCode: 156130582, name: '沙河市', adcode: '156130582' }] }, {
province: '河北省',
provinceCode: 156130000,
city: '保定市',
adcode: '156130600',
name: '保定市',
cityCode: 156130600,
children: [{ id: 113, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '竞秀区', regionCode: 156130602, name: '竞秀区', adcode: '156130602' }, { id: 114, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '莲池区', regionCode: 156130606, name: '莲池区', adcode: '156130606' }, { id: 115, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '满城区', regionCode: 156130607, name: '满城区', adcode: '156130607' }, { id: 116, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '清苑区', regionCode: 156130608, name: '清苑区', adcode: '156130608' }, { id: 117, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '徐水区', regionCode: 156130609, name: '徐水区', adcode: '156130609' }, { id: 118, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '涞水县', regionCode: 156130623, name: '涞水县', adcode: '156130623' }, { id: 119, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '阜平县', regionCode: 156130624, name: '阜平县', adcode: '156130624' }, { id: 120, province: '河北省', provinceCode: 156130000, city: '保定市', cityCode: 156130600, region: '定兴县', regionCode: 156130626, name: '定兴县', adcode: '156130626' }, {
id: 121,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '唐县',
regionCode: 156130627,
name: '唐县',
adcode: '156130627'
}, {
id: 122,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '高阳县',
regionCode: 156130628,
name: '高阳县',
adcode: '156130628'
}, {
id: 123,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '容城县',
regionCode: 156130629,
name: '容城县',
adcode: '156130629'
}, {
id: 124,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '涞源县',
regionCode: 156130630,
name: '涞源县',
adcode: '156130630'
}, {
id: 125,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '望都县',
regionCode: 156130631,
name: '望都县',
adcode: '156130631'
}, {
id: 126,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '安新县',
regionCode: 156130632,
name: '安新县',
adcode: '156130632'
}, {
id: 127,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '易县',
regionCode: 156130633,
name: '易县',
adcode: '156130633'
}, {
id: 128,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '曲阳县',
regionCode: 156130634,
name: '曲阳县',
adcode: '156130634'
}, {
id: 129,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '蠡县',
regionCode: 156130635,
name: '蠡县',
adcode: '156130635'
}, {
id: 130,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '顺平县',
regionCode: 156130636,
name: '顺平县',
adcode: '156130636'
}, {
id: 131,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '博野县',
regionCode: 156130637,
name: '博野县',
adcode: '156130637'
}, {
id: 132,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '雄县',
regionCode: 156130638,
name: '雄县',
adcode: '156130638'
}, {
id: 133,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '涿州市',
regionCode: 156130681,
name: '涿州市',
adcode: '156130681'
}, {
id: 134,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '定州市',
regionCode: 156130682,
name: '定州市',
adcode: '156130682'
}, {
id: 135,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '安国市',
regionCode: 156130683,
name: '安国市',
adcode: '156130683'
}, {
id: 136,
province: '河北省',
provinceCode: 156130000,
city: '保定市',
cityCode: 156130600,
region: '高碑店市',
regionCode: 156130684,
name: '高碑店市',
adcode: '156130684'
}]
}, {
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
adcode: '156130700',
name: '张家口市',
cityCode: 156130700,
children: [{
id: 137,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '桥东区',
regionCode: 156130702,
name: '桥东区',
adcode: '156130702'
}, {
id: 138,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '桥西区',
regionCode: 156130703,
name: '桥西区',
adcode: '156130703'
}, {
id: 139,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '宣化区',
regionCode: 156130705,
name: '宣化区',
adcode: '156130705'
}, {
id: 140,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '下花园区',
regionCode: 156130706,
name: '下花园区',
adcode: '156130706'
}, {
id: 141,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '万全区',
regionCode: 156130708,
name: '万全区',
adcode: '156130708'
}, {
id: 142,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '崇礼区',
regionCode: 156130709,
name: '崇礼区',
adcode: '156130709'
}, {
id: 143,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '张北县',
regionCode: 156130722,
name: '张北县',
adcode: '156130722'
}, {
id: 144,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '康保县',
regionCode: 156130723,
name: '康保县',
adcode: '156130723'
}, {
id: 145,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '沽源县',
regionCode: 156130724,
name: '沽源县',
adcode: '156130724'
}, {
id: 146,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '尚义县',
regionCode: 156130725,
name: '尚义县',
adcode: '156130725'
}, {
id: 147,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '蔚县',
regionCode: 156130726,
name: '蔚县',
adcode: '156130726'
}, {
id: 148,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '阳原县',
regionCode: 156130727,
name: '阳原县',
adcode: '156130727'
}, {
id: 149,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '怀安县',
regionCode: 156130728,
name: '怀安县',
adcode: '156130728'
}, {
id: 150,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '怀来县',
regionCode: 156130730,
name: '怀来县',
adcode: '156130730'
}, {
id: 151,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '涿鹿县',
regionCode: 156130731,
name: '涿鹿县',
adcode: '156130731'
}, {
id: 152,
province: '河北省',
provinceCode: 156130000,
city: '张家口市',
cityCode: 156130700,
region: '赤城县',
regionCode: 156130732,
name: '赤城县',
adcode: '156130732'
}]
}, {
province: '河北省',
provinceCode: 156130000,
city: '承德市',
adcode: '156130800',
name: '承德市',
cityCode: 156130800,
children: [{
id: 153,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '双桥区',
regionCode: 156130802,
name: '双桥区',
adcode: '156130802'
}, {
id: 154,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '双滦区',
regionCode: 156130803,
name: '双滦区',
adcode: '156130803'
}, {
id: 155,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '鹰手营子矿区',
regionCode: 156130804,
name: '鹰手营子矿区',
adcode: '156130804'
}, {
id: 156,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '承德县',
regionCode: 156130821,
name: '承德县',
adcode: '156130821'
}, {
id: 157,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '兴隆县',
regionCode: 156130822,
name: '兴隆县',
adcode: '156130822'
}, {
id: 158,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '滦平县',
regionCode: 156130824,
name: '滦平县',
adcode: '156130824'
}, {
id: 159,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '隆化县',
regionCode: 156130825,
name: '隆化县',
adcode: '156130825'
}, {
id: 160,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '丰宁满族自治县',
regionCode: 156130826,
name: '丰宁满族自治县',
adcode: '156130826'
}, {
id: 161,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '宽城满族自治县',
regionCode: 156130827,
name: '宽城满族自治县',
adcode: '156130827'
}, {
id: 162,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '围场满族蒙古族自治县',
regionCode: 156130828,
name: '围场满族蒙古族自治县',
adcode: '156130828'
}, {
id: 163,
province: '河北省',
provinceCode: 156130000,
city: '承德市',
cityCode: 156130800,
region: '平泉市',
regionCode: 156130881,
name: '平泉市',
adcode: '156130881'
}]
}, {
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
adcode: '156130900',
name: '沧州市',
cityCode: 156130900,
children: [{
id: 164,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '新华区',
regionCode: 156130902,
name: '新华区',
adcode: '156130902'
}, {
id: 165,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '运河区',
regionCode: 156130903,
name: '运河区',
adcode: '156130903'
}, {
id: 166,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '沧县',
regionCode: 156130921,
name: '沧县',
adcode: '156130921'
}, {
id: 167,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '青县',
regionCode: 156130922,
name: '青县',
adcode: '156130922'
}, {
id: 168,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '东光县',
regionCode: 156130923,
name: '东光县',
adcode: '156130923'
}, {
id: 169,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '海兴县',
regionCode: 156130924,
name: '海兴县',
adcode: '156130924'
}, {
id: 170,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '盐山县',
regionCode: 156130925,
name: '盐山县',
adcode: '156130925'
}, {
id: 171,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '肃宁县',
regionCode: 156130926,
name: '肃宁县',
adcode: '156130926'
}, {
id: 172,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '南皮县',
regionCode: 156130927,
name: '南皮县',
adcode: '156130927'
}, {
id: 173,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '吴桥县',
regionCode: 156130928,
name: '吴桥县',
adcode: '156130928'
}, {
id: 174,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '献县',
regionCode: 156130929,
name: '献县',
adcode: '156130929'
}, {
id: 175,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '孟村回族自治县',
regionCode: 156130930,
name: '孟村回族自治县',
adcode: '156130930'
}, {
id: 176,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '泊头市',
regionCode: 156130981,
name: '泊头市',
adcode: '156130981'
}, {
id: 177,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '任丘市',
regionCode: 156130982,
name: '任丘市',
adcode: '156130982'
}, {
id: 178,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '黄骅市',
regionCode: 156130983,
name: '黄骅市',
adcode: '156130983'
}, {
id: 179,
province: '河北省',
provinceCode: 156130000,
city: '沧州市',
cityCode: 156130900,
region: '河间市',
regionCode: 156130984,
name: '河间市',
adcode: '156130984'
}]
}, {
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
adcode: '156131000',
name: '廊坊市',
cityCode: 156131000,
children: [{
id: 180,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '安次区',
regionCode: 156131002,
name: '安次区',
adcode: '156131002'
}, {
id: 181,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '广阳区',
regionCode: 156131003,
name: '广阳区',
adcode: '156131003'
}, {
id: 182,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '固安县',
regionCode: 156131022,
name: '固安县',
adcode: '156131022'
}, {
id: 183,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '永清县',
regionCode: 156131023,
name: '永清县',
adcode: '156131023'
}, {
id: 184,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '香河县',
regionCode: 156131024,
name: '香河县',
adcode: '156131024'
}, {
id: 185,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '大城县',
regionCode: 156131025,
name: '大城县',
adcode: '156131025'
}, {
id: 186,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '文安县',
regionCode: 156131026,
name: '文安县',
adcode: '156131026'
}, {
id: 187,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '大厂回族自治县',
regionCode: 156131028,
name: '大厂回族自治县',
adcode: '156131028'
}, {
id: 188,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '霸州市',
regionCode: 156131081,
name: '霸州市',
adcode: '156131081'
}, {
id: 189,
province: '河北省',
provinceCode: 156130000,
city: '廊坊市',
cityCode: 156131000,
region: '三河市',
regionCode: 156131082,
name: '三河市',
adcode: '156131082'
}]
}, {
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
adcode: '156131100',
name: '衡水市',
cityCode: 156131100,
children: [{
id: 190,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '桃城区',
regionCode: 156131102,
name: '桃城区',
adcode: '156131102'
}, {
id: 191,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '冀州区',
regionCode: 156131103,
name: '冀州区',
adcode: '156131103'
}, {
id: 192,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '枣强县',
regionCode: 156131121,
name: '枣强县',
adcode: '156131121'
}, {
id: 193,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '武邑县',
regionCode: 156131122,
name: '武邑县',
adcode: '156131122'
}, {
id: 194,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '武强县',
regionCode: 156131123,
name: '武强县',
adcode: '156131123'
}, {
id: 195,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '饶阳县',
regionCode: 156131124,
name: '饶阳县',
adcode: '156131124'
}, {
id: 196,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '安平县',
regionCode: 156131125,
name: '安平县',
adcode: '156131125'
}, {
id: 197,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '故城县',
regionCode: 156131126,
name: '故城县',
adcode: '156131126'
}, {
id: 198,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '景县',
regionCode: 156131127,
name: '景县',
adcode: '156131127'
}, {
id: 199,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '阜城县',
regionCode: 156131128,
name: '阜城县',
adcode: '156131128'
}, {
id: 200,
province: '河北省',
provinceCode: 156130000,
city: '衡水市',
cityCode: 156131100,
region: '深州市',
regionCode: 156131182,
name: '深州市',
adcode: '156131182'
}]
}]
}, {
province: '山西省',
provinceCode: 156140000,
adcode: '156140000',
name: '山西省',
children: [{
province: '山西省',
provinceCode: 156140000,
city: '太原市',
adcode: '156140100',
name: '太原市',
cityCode: 156140100,
children: [{
id: 201,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '小店区',
regionCode: 156140105,
name: '小店区',
adcode: '156140105'
}, {
id: 202,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '迎泽区',
regionCode: 156140106,
name: '迎泽区',
adcode: '156140106'
}, {
id: 203,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '杏花岭区',
regionCode: 156140107,
name: '杏花岭区',
adcode: '156140107'
}, {
id: 204,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '尖草坪区',
regionCode: 156140108,
name: '尖草坪区',
adcode: '156140108'
}, {
id: 205,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '万柏林区',
regionCode: 156140109,
name: '万柏林区',
adcode: '156140109'
}, {
id: 206,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '晋源区',
regionCode: 156140110,
name: '晋源区',
adcode: '156140110'
}, {
id: 207,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '清徐县',
regionCode: 156140121,
name: '清徐县',
adcode: '156140121'
}, {
id: 208,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '阳曲县',
regionCode: 156140122,
name: '阳曲县',
adcode: '156140122'
}, {
id: 209,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '娄烦县',
regionCode: 156140123,
name: '娄烦县',
adcode: '156140123'
}, {
id: 210,
province: '山西省',
provinceCode: 156140000,
city: '太原市',
cityCode: 156140100,
region: '古交市',
regionCode: 156140181,
name: '古交市',
adcode: '156140181'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '大同市',
adcode: '156140200',
name: '大同市',
cityCode: 156140200,
children: [{
id: 211,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '新荣区',
regionCode: 156140212,
name: '新荣区',
adcode: '156140212'
}, {
id: 212,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '平城区',
regionCode: 156140213,
name: '平城区',
adcode: '156140213'
}, {
id: 213,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '云冈区',
regionCode: 156140214,
name: '云冈区',
adcode: '156140214'
}, {
id: 214,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '云州区',
regionCode: 156140215,
name: '云州区',
adcode: '156140215'
}, {
id: 215,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '阳高县',
regionCode: 156140221,
name: '阳高县',
adcode: '156140221'
}, {
id: 216,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '天镇县',
regionCode: 156140222,
name: '天镇县',
adcode: '156140222'
}, {
id: 217,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '广灵县',
regionCode: 156140223,
name: '广灵县',
adcode: '156140223'
}, {
id: 218,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '灵丘县',
regionCode: 156140224,
name: '灵丘县',
adcode: '156140224'
}, {
id: 219,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '浑源县',
regionCode: 156140225,
name: '浑源县',
adcode: '156140225'
}, {
id: 220,
province: '山西省',
provinceCode: 156140000,
city: '大同市',
cityCode: 156140200,
region: '左云县',
regionCode: 156140226,
name: '左云县',
adcode: '156140226'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '阳泉市',
adcode: '156140300',
name: '阳泉市',
cityCode: 156140300,
children: [{
id: 221,
province: '山西省',
provinceCode: 156140000,
city: '阳泉市',
cityCode: 156140300,
region: '城区',
regionCode: 156140302,
name: '城区',
adcode: '156140302'
}, {
id: 222,
province: '山西省',
provinceCode: 156140000,
city: '阳泉市',
cityCode: 156140300,
region: '矿区',
regionCode: 156140303,
name: '矿区',
adcode: '156140303'
}, {
id: 223,
province: '山西省',
provinceCode: 156140000,
city: '阳泉市',
cityCode: 156140300,
region: '郊区',
regionCode: 156140311,
name: '郊区',
adcode: '156140311'
}, {
id: 224,
province: '山西省',
provinceCode: 156140000,
city: '阳泉市',
cityCode: 156140300,
region: '平定县',
regionCode: 156140321,
name: '平定县',
adcode: '156140321'
}, {
id: 225,
province: '山西省',
provinceCode: 156140000,
city: '阳泉市',
cityCode: 156140300,
region: '盂县',
regionCode: 156140322,
name: '盂县',
adcode: '156140322'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '长治市',
adcode: '156140400',
name: '长治市',
cityCode: 156140400,
children: [{
id: 226,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '潞州区',
regionCode: 156140403,
name: '潞州区',
adcode: '156140403'
}, {
id: 227,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '上党区',
regionCode: 156140404,
name: '上党区',
adcode: '156140404'
}, {
id: 228,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '屯留区',
regionCode: 156140405,
name: '屯留区',
adcode: '156140405'
}, {
id: 229,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '潞城区',
regionCode: 156140406,
name: '潞城区',
adcode: '156140406'
}, {
id: 230,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '襄垣县',
regionCode: 156140423,
name: '襄垣县',
adcode: '156140423'
}, {
id: 231,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '平顺县',
regionCode: 156140425,
name: '平顺县',
adcode: '156140425'
}, {
id: 232,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '黎城县',
regionCode: 156140426,
name: '黎城县',
adcode: '156140426'
}, {
id: 233,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '壶关县',
regionCode: 156140427,
name: '壶关县',
adcode: '156140427'
}, {
id: 234,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '长子县',
regionCode: 156140428,
name: '长子县',
adcode: '156140428'
}, {
id: 235,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '武乡县',
regionCode: 156140429,
name: '武乡县',
adcode: '156140429'
}, {
id: 236,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '沁县',
regionCode: 156140430,
name: '沁县',
adcode: '156140430'
}, {
id: 237,
province: '山西省',
provinceCode: 156140000,
city: '长治市',
cityCode: 156140400,
region: '沁源县',
regionCode: 156140431,
name: '沁源县',
adcode: '156140431'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '晋城市',
adcode: '156140500',
name: '晋城市',
cityCode: 156140500,
children: [{
id: 238,
province: '山西省',
provinceCode: 156140000,
city: '晋城市',
cityCode: 156140500,
region: '城区',
regionCode: 156140502,
name: '城区',
adcode: '156140502'
}, {
id: 239,
province: '山西省',
provinceCode: 156140000,
city: '晋城市',
cityCode: 156140500,
region: '沁水县',
regionCode: 156140521,
name: '沁水县',
adcode: '156140521'
}, {
id: 240,
province: '山西省',
provinceCode: 156140000,
city: '晋城市',
cityCode: 156140500,
region: '阳城县',
regionCode: 156140522,
name: '阳城县',
adcode: '156140522'
}, {
id: 241,
province: '山西省',
provinceCode: 156140000,
city: '晋城市',
cityCode: 156140500,
region: '陵川县',
regionCode: 156140524,
name: '陵川县',
adcode: '156140524'
}, {
id: 242,
province: '山西省',
provinceCode: 156140000,
city: '晋城市',
cityCode: 156140500,
region: '泽州县',
regionCode: 156140525,
name: '泽州县',
adcode: '156140525'
}, {
id: 243,
province: '山西省',
provinceCode: 156140000,
city: '晋城市',
cityCode: 156140500,
region: '高平市',
regionCode: 156140581,
name: '高平市',
adcode: '156140581'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '朔州市',
adcode: '156140600',
name: '朔州市',
cityCode: 156140600,
children: [{
id: 244,
province: '山西省',
provinceCode: 156140000,
city: '朔州市',
cityCode: 156140600,
region: '朔城区',
regionCode: 156140602,
name: '朔城区',
adcode: '156140602'
}, {
id: 245,
province: '山西省',
provinceCode: 156140000,
city: '朔州市',
cityCode: 156140600,
region: '平鲁区',
regionCode: 156140603,
name: '平鲁区',
adcode: '156140603'
}, {
id: 246,
province: '山西省',
provinceCode: 156140000,
city: '朔州市',
cityCode: 156140600,
region: '山阴县',
regionCode: 156140621,
name: '山阴县',
adcode: '156140621'
}, {
id: 247,
province: '山西省',
provinceCode: 156140000,
city: '朔州市',
cityCode: 156140600,
region: '应县',
regionCode: 156140622,
name: '应县',
adcode: '156140622'
}, {
id: 248,
province: '山西省',
provinceCode: 156140000,
city: '朔州市',
cityCode: 156140600,
region: '右玉县',
regionCode: 156140623,
name: '右玉县',
adcode: '156140623'
}, {
id: 249,
province: '山西省',
provinceCode: 156140000,
city: '朔州市',
cityCode: 156140600,
region: '怀仁市',
regionCode: 156140681,
name: '怀仁市',
adcode: '156140681'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
adcode: '156140700',
name: '晋中市',
cityCode: 156140700,
children: [{
id: 250,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '榆次区',
regionCode: 156140702,
name: '榆次区',
adcode: '156140702'
}, {
id: 251,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '太谷区',
regionCode: 156140703,
name: '太谷区',
adcode: '156140703'
}, {
id: 252,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '榆社县',
regionCode: 156140721,
name: '榆社县',
adcode: '156140721'
}, {
id: 253,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '左权县',
regionCode: 156140722,
name: '左权县',
adcode: '156140722'
}, {
id: 254,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '和顺县',
regionCode: 156140723,
name: '和顺县',
adcode: '156140723'
}, {
id: 255,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '昔阳县',
regionCode: 156140724,
name: '昔阳县',
adcode: '156140724'
}, {
id: 256,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '寿阳县',
regionCode: 156140725,
name: '寿阳县',
adcode: '156140725'
}, {
id: 257,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '祁县',
regionCode: 156140727,
name: '祁县',
adcode: '156140727'
}, {
id: 258,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '平遥县',
regionCode: 156140728,
name: '平遥县',
adcode: '156140728'
}, {
id: 259,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '灵石县',
regionCode: 156140729,
name: '灵石县',
adcode: '156140729'
}, {
id: 260,
province: '山西省',
provinceCode: 156140000,
city: '晋中市',
cityCode: 156140700,
region: '介休市',
regionCode: 156140781,
name: '介休市',
adcode: '156140781'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '运城市',
adcode: '156140800',
name: '运城市',
cityCode: 156140800,
children: [{
id: 261,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '盐湖区',
regionCode: 156140802,
name: '盐湖区',
adcode: '156140802'
}, {
id: 262,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '临猗县',
regionCode: 156140821,
name: '临猗县',
adcode: '156140821'
}, {
id: 263,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '万荣县',
regionCode: 156140822,
name: '万荣县',
adcode: '156140822'
}, {
id: 264,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '闻喜县',
regionCode: 156140823,
name: '闻喜县',
adcode: '156140823'
}, {
id: 265,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '稷山县',
regionCode: 156140824,
name: '稷山县',
adcode: '156140824'
}, {
id: 266,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '新绛县',
regionCode: 156140825,
name: '新绛县',
adcode: '156140825'
}, {
id: 267,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '绛县',
regionCode: 156140826,
name: '绛县',
adcode: '156140826'
}, {
id: 268,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '垣曲县',
regionCode: 156140827,
name: '垣曲县',
adcode: '156140827'
}, {
id: 269,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '夏县',
regionCode: 156140828,
name: '夏县',
adcode: '156140828'
}, {
id: 270,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '平陆县',
regionCode: 156140829,
name: '平陆县',
adcode: '156140829'
}, {
id: 271,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '芮城县',
regionCode: 156140830,
name: '芮城县',
adcode: '156140830'
}, {
id: 272,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '永济市',
regionCode: 156140881,
name: '永济市',
adcode: '156140881'
}, {
id: 273,
province: '山西省',
provinceCode: 156140000,
city: '运城市',
cityCode: 156140800,
region: '河津市',
regionCode: 156140882,
name: '河津市',
adcode: '156140882'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
adcode: '156140900',
name: '忻州市',
cityCode: 156140900,
children: [{
id: 274,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '忻府区',
regionCode: 156140902,
name: '忻府区',
adcode: '156140902'
}, {
id: 275,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '定襄县',
regionCode: 156140921,
name: '定襄县',
adcode: '156140921'
}, {
id: 276,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '五台县',
regionCode: 156140922,
name: '五台县',
adcode: '156140922'
}, {
id: 277,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '代县',
regionCode: 156140923,
name: '代县',
adcode: '156140923'
}, {
id: 278,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '繁峙县',
regionCode: 156140924,
name: '繁峙县',
adcode: '156140924'
}, {
id: 279,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '宁武县',
regionCode: 156140925,
name: '宁武县',
adcode: '156140925'
}, {
id: 280,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '静乐县',
regionCode: 156140926,
name: '静乐县',
adcode: '156140926'
}, {
id: 281,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '神池县',
regionCode: 156140927,
name: '神池县',
adcode: '156140927'
}, {
id: 282,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '五寨县',
regionCode: 156140928,
name: '五寨县',
adcode: '156140928'
}, {
id: 283,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '岢岚县',
regionCode: 156140929,
name: '岢岚县',
adcode: '156140929'
}, {
id: 284,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '河曲县',
regionCode: 156140930,
name: '河曲县',
adcode: '156140930'
}, {
id: 285,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '保德县',
regionCode: 156140931,
name: '保德县',
adcode: '156140931'
}, {
id: 286,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '偏关县',
regionCode: 156140932,
name: '偏关县',
adcode: '156140932'
}, {
id: 287,
province: '山西省',
provinceCode: 156140000,
city: '忻州市',
cityCode: 156140900,
region: '原平市',
regionCode: 156140981,
name: '原平市',
adcode: '156140981'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
adcode: '156141000',
name: '临汾市',
cityCode: 156141000,
children: [{
id: 288,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '尧都区',
regionCode: 156141002,
name: '尧都区',
adcode: '156141002'
}, {
id: 289,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '曲沃县',
regionCode: 156141021,
name: '曲沃县',
adcode: '156141021'
}, {
id: 290,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '翼城县',
regionCode: 156141022,
name: '翼城县',
adcode: '156141022'
}, {
id: 291,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '襄汾县',
regionCode: 156141023,
name: '襄汾县',
adcode: '156141023'
}, {
id: 292,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '洪洞县',
regionCode: 156141024,
name: '洪洞县',
adcode: '156141024'
}, {
id: 293,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '古县',
regionCode: 156141025,
name: '古县',
adcode: '156141025'
}, {
id: 294,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '安泽县',
regionCode: 156141026,
name: '安泽县',
adcode: '156141026'
}, {
id: 295,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '浮山县',
regionCode: 156141027,
name: '浮山县',
adcode: '156141027'
}, {
id: 296,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '吉县',
regionCode: 156141028,
name: '吉县',
adcode: '156141028'
}, {
id: 297,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '乡宁县',
regionCode: 156141029,
name: '乡宁县',
adcode: '156141029'
}, {
id: 298,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '大宁县',
regionCode: 156141030,
name: '大宁县',
adcode: '156141030'
}, {
id: 299,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '隰县',
regionCode: 156141031,
name: '隰县',
adcode: '156141031'
}, {
id: 300,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '永和县',
regionCode: 156141032,
name: '永和县',
adcode: '156141032'
}, {
id: 301,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '蒲县',
regionCode: 156141033,
name: '蒲县',
adcode: '156141033'
}, {
id: 302,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '汾西县',
regionCode: 156141034,
name: '汾西县',
adcode: '156141034'
}, {
id: 303,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '侯马市',
regionCode: 156141081,
name: '侯马市',
adcode: '156141081'
}, {
id: 304,
province: '山西省',
provinceCode: 156140000,
city: '临汾市',
cityCode: 156141000,
region: '霍州市',
regionCode: 156141082,
name: '霍州市',
adcode: '156141082'
}]
}, {
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
adcode: '156141100',
name: '吕梁市',
cityCode: 156141100,
children: [{
id: 305,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '离石区',
regionCode: 156141102,
name: '离石区',
adcode: '156141102'
}, {
id: 306,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '文水县',
regionCode: 156141121,
name: '文水县',
adcode: '156141121'
}, {
id: 307,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '交城县',
regionCode: 156141122,
name: '交城县',
adcode: '156141122'
}, {
id: 308,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '兴县',
regionCode: 156141123,
name: '兴县',
adcode: '156141123'
}, {
id: 309,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '临县',
regionCode: 156141124,
name: '临县',
adcode: '156141124'
}, {
id: 310,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '柳林县',
regionCode: 156141125,
name: '柳林县',
adcode: '156141125'
}, {
id: 311,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '石楼县',
regionCode: 156141126,
name: '石楼县',
adcode: '156141126'
}, {
id: 312,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '岚县',
regionCode: 156141127,
name: '岚县',
adcode: '156141127'
}, {
id: 313,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '方山县',
regionCode: 156141128,
name: '方山县',
adcode: '156141128'
}, {
id: 314,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '中阳县',
regionCode: 156141129,
name: '中阳县',
adcode: '156141129'
}, {
id: 315,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '交口县',
regionCode: 156141130,
name: '交口县',
adcode: '156141130'
}, {
id: 316,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '孝义市',
regionCode: 156141181,
name: '孝义市',
adcode: '156141181'
}, {
id: 317,
province: '山西省',
provinceCode: 156140000,
city: '吕梁市',
cityCode: 156141100,
region: '汾阳市',
regionCode: 156141182,
name: '汾阳市',
adcode: '156141182'
}]
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
adcode: '156150000',
name: '内蒙古自治区',
children: [{
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
adcode: '156150100',
name: '呼和浩特市',
cityCode: 156150100,
children: [{
id: 318,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '新城区',
regionCode: 156150102,
name: '新城区',
adcode: '156150102'
}, {
id: 319,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '回民区',
regionCode: 156150103,
name: '回民区',
adcode: '156150103'
}, {
id: 320,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '玉泉区',
regionCode: 156150104,
name: '玉泉区',
adcode: '156150104'
}, {
id: 321,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '赛罕区',
regionCode: 156150105,
name: '赛罕区',
adcode: '156150105'
}, {
id: 322,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '土默特左旗',
regionCode: 156150121,
name: '土默特左旗',
adcode: '156150121'
}, {
id: 323,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '托克托县',
regionCode: 156150122,
name: '托克托县',
adcode: '156150122'
}, {
id: 324,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '和林格尔县',
regionCode: 156150123,
name: '和林格尔县',
adcode: '156150123'
}, {
id: 325,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '清水河县',
regionCode: 156150124,
name: '清水河县',
adcode: '156150124'
}, {
id: 326,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼和浩特市',
cityCode: 156150100,
region: '武川县',
regionCode: 156150125,
name: '武川县',
adcode: '156150125'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
adcode: '156150200',
name: '包头市',
cityCode: 156150200,
children: [{
id: 327,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '东河区',
regionCode: 156150202,
name: '东河区',
adcode: '156150202'
}, {
id: 328,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '昆都仑区',
regionCode: 156150203,
name: '昆都仑区',
adcode: '156150203'
}, {
id: 329,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '青山区',
regionCode: 156150204,
name: '青山区',
adcode: '156150204'
}, {
id: 330,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '石拐区',
regionCode: 156150205,
name: '石拐区',
adcode: '156150205'
}, {
id: 331,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '白云鄂博矿区',
regionCode: 156150206,
name: '白云鄂博矿区',
adcode: '156150206'
}, {
id: 332,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '九原区',
regionCode: 156150207,
name: '九原区',
adcode: '156150207'
}, {
id: 333,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '土默特右旗',
regionCode: 156150221,
name: '土默特右旗',
adcode: '156150221'
}, {
id: 334,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '固阳县',
regionCode: 156150222,
name: '固阳县',
adcode: '156150222'
}, {
id: 335,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '包头市',
cityCode: 156150200,
region: '达尔罕茂明安联合旗',
regionCode: 156150223,
name: '达尔罕茂明安联合旗',
adcode: '156150223'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌海市',
adcode: '156150300',
name: '乌海市',
cityCode: 156150300,
children: [{
id: 336,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌海市',
cityCode: 156150300,
region: '海勃湾区',
regionCode: 156150302,
name: '海勃湾区',
adcode: '156150302'
}, {
id: 337,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌海市',
cityCode: 156150300,
region: '海南区',
regionCode: 156150303,
name: '海南区',
adcode: '156150303'
}, {
id: 338,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌海市',
cityCode: 156150300,
region: '乌达区',
regionCode: 156150304,
name: '乌达区',
adcode: '156150304'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
adcode: '156150400',
name: '赤峰市',
cityCode: 156150400,
children: [{
id: 339,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '红山区',
regionCode: 156150402,
name: '红山区',
adcode: '156150402'
}, {
id: 340,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '元宝山区',
regionCode: 156150403,
name: '元宝山区',
adcode: '156150403'
}, {
id: 341,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '松山区',
regionCode: 156150404,
name: '松山区',
adcode: '156150404'
}, {
id: 342,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '阿鲁科尔沁旗',
regionCode: 156150421,
name: '阿鲁科尔沁旗',
adcode: '156150421'
}, {
id: 343,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '巴林左旗',
regionCode: 156150422,
name: '巴林左旗',
adcode: '156150422'
}, {
id: 344,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '巴林右旗',
regionCode: 156150423,
name: '巴林右旗',
adcode: '156150423'
}, {
id: 345,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '林西县',
regionCode: 156150424,
name: '林西县',
adcode: '156150424'
}, {
id: 346,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '克什克腾旗',
regionCode: 156150425,
name: '克什克腾旗',
adcode: '156150425'
}, {
id: 347,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '翁牛特旗',
regionCode: 156150426,
name: '翁牛特旗',
adcode: '156150426'
}, {
id: 348,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '喀喇沁旗',
regionCode: 156150428,
name: '喀喇沁旗',
adcode: '156150428'
}, {
id: 349,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '宁城县',
regionCode: 156150429,
name: '宁城县',
adcode: '156150429'
}, {
id: 350,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '赤峰市',
cityCode: 156150400,
region: '敖汉旗',
regionCode: 156150430,
name: '敖汉旗',
adcode: '156150430'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
adcode: '156150500',
name: '通辽市',
cityCode: 156150500,
children: [{
id: 351,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '科尔沁区',
regionCode: 156150502,
name: '科尔沁区',
adcode: '156150502'
}, {
id: 352,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '科尔沁左翼中旗',
regionCode: 156150521,
name: '科尔沁左翼中旗',
adcode: '156150521'
}, {
id: 353,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '科尔沁左翼后旗',
regionCode: 156150522,
name: '科尔沁左翼后旗',
adcode: '156150522'
}, {
id: 354,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '开鲁县',
regionCode: 156150523,
name: '开鲁县',
adcode: '156150523'
}, {
id: 355,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '库伦旗',
regionCode: 156150524,
name: '库伦旗',
adcode: '156150524'
}, {
id: 356,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '奈曼旗',
regionCode: 156150525,
name: '奈曼旗',
adcode: '156150525'
}, {
id: 357,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '扎鲁特旗',
regionCode: 156150526,
name: '扎鲁特旗',
adcode: '156150526'
}, {
id: 358,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '通辽市',
cityCode: 156150500,
region: '霍林郭勒市',
regionCode: 156150581,
name: '霍林郭勒市',
adcode: '156150581'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
adcode: '156150600',
name: '鄂尔多斯市',
cityCode: 156150600,
children: [{
id: 359,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '东胜区',
regionCode: 156150602,
name: '东胜区',
adcode: '156150602'
}, {
id: 360,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '康巴什区',
regionCode: 156150603,
name: '康巴什区',
adcode: '156150603'
}, {
id: 361,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '达拉特旗',
regionCode: 156150621,
name: '达拉特旗',
adcode: '156150621'
}, {
id: 362,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '准格尔旗',
regionCode: 156150622,
name: '准格尔旗',
adcode: '156150622'
}, {
id: 363,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '鄂托克前旗',
regionCode: 156150623,
name: '鄂托克前旗',
adcode: '156150623'
}, {
id: 364,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '鄂托克旗',
regionCode: 156150624,
name: '鄂托克旗',
adcode: '156150624'
}, {
id: 365,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '杭锦旗',
regionCode: 156150625,
name: '杭锦旗',
adcode: '156150625'
}, {
id: 366,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '乌审旗',
regionCode: 156150626,
name: '乌审旗',
adcode: '156150626'
}, {
id: 367,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '鄂尔多斯市',
cityCode: 156150600,
region: '伊金霍洛旗',
regionCode: 156150627,
name: '伊金霍洛旗',
adcode: '156150627'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
adcode: '156150700',
name: '呼伦贝尔市',
cityCode: 156150700,
children: [{
id: 368,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '海拉尔区',
regionCode: 156150702,
name: '海拉尔区',
adcode: '156150702'
}, {
id: 369,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '扎赉诺尔区',
regionCode: 156150703,
name: '扎赉诺尔区',
adcode: '156150703'
}, {
id: 370,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '阿荣旗',
regionCode: 156150721,
name: '阿荣旗',
adcode: '156150721'
}, {
id: 371,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '莫力达瓦达斡尔族自治旗',
regionCode: 156150722,
name: '莫力达瓦达斡尔族自治旗',
adcode: '156150722'
}, {
id: 372,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '鄂伦春自治旗',
regionCode: 156150723,
name: '鄂伦春自治旗',
adcode: '156150723'
}, {
id: 373,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '鄂温克族自治旗',
regionCode: 156150724,
name: '鄂温克族自治旗',
adcode: '156150724'
}, {
id: 374,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '陈巴尔虎旗',
regionCode: 156150725,
name: '陈巴尔虎旗',
adcode: '156150725'
}, {
id: 375,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '新巴尔虎左旗',
regionCode: 156150726,
name: '新巴尔虎左旗',
adcode: '156150726'
}, {
id: 376,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '新巴尔虎右旗',
regionCode: 156150727,
name: '新巴尔虎右旗',
adcode: '156150727'
}, {
id: 377,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '满洲里市',
regionCode: 156150781,
name: '满洲里市',
adcode: '156150781'
}, {
id: 378,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '牙克石市',
regionCode: 156150782,
name: '牙克石市',
adcode: '156150782'
}, {
id: 379,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '扎兰屯市',
regionCode: 156150783,
name: '扎兰屯市',
adcode: '156150783'
}, {
id: 380,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '额尔古纳市',
regionCode: 156150784,
name: '额尔古纳市',
adcode: '156150784'
}, {
id: 381,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '呼伦贝尔市',
cityCode: 156150700,
region: '根河市',
regionCode: 156150785,
name: '根河市',
adcode: '156150785'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
adcode: '156150800',
name: '巴彦淖尔市',
cityCode: 156150800,
children: [{
id: 382,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
cityCode: 156150800,
region: '临河区',
regionCode: 156150802,
name: '临河区',
adcode: '156150802'
}, {
id: 383,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
cityCode: 156150800,
region: '五原县',
regionCode: 156150821,
name: '五原县',
adcode: '156150821'
}, {
id: 384,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
cityCode: 156150800,
region: '磴口县',
regionCode: 156150822,
name: '磴口县',
adcode: '156150822'
}, {
id: 385,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
cityCode: 156150800,
region: '乌拉特前旗',
regionCode: 156150823,
name: '乌拉特前旗',
adcode: '156150823'
}, {
id: 386,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
cityCode: 156150800,
region: '乌拉特中旗',
regionCode: 156150824,
name: '乌拉特中旗',
adcode: '156150824'
}, {
id: 387,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
cityCode: 156150800,
region: '乌拉特后旗',
regionCode: 156150825,
name: '乌拉特后旗',
adcode: '156150825'
}, {
id: 388,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '巴彦淖尔市',
cityCode: 156150800,
region: '杭锦后旗',
regionCode: 156150826,
name: '杭锦后旗',
adcode: '156150826'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
adcode: '156150900',
name: '乌兰察布市',
cityCode: 156150900,
children: [{
id: 389,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '集宁区',
regionCode: 156150902,
name: '集宁区',
adcode: '156150902'
}, {
id: 390,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '卓资县',
regionCode: 156150921,
name: '卓资县',
adcode: '156150921'
}, {
id: 391,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '化德县',
regionCode: 156150922,
name: '化德县',
adcode: '156150922'
}, {
id: 392,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '商都县',
regionCode: 156150923,
name: '商都县',
adcode: '156150923'
}, {
id: 393,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '兴和县',
regionCode: 156150924,
name: '兴和县',
adcode: '156150924'
}, {
id: 394,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '凉城县',
regionCode: 156150925,
name: '凉城县',
adcode: '156150925'
}, {
id: 395,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '察哈尔右翼前旗',
regionCode: 156150926,
name: '察哈尔右翼前旗',
adcode: '156150926'
}, {
id: 396,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '察哈尔右翼中旗',
regionCode: 156150927,
name: '察哈尔右翼中旗',
adcode: '156150927'
}, {
id: 397,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '察哈尔右翼后旗',
regionCode: 156150928,
name: '察哈尔右翼后旗',
adcode: '156150928'
}, {
id: 398,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '四子王旗',
regionCode: 156150929,
name: '四子王旗',
adcode: '156150929'
}, {
id: 399,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '乌兰察布市',
cityCode: 156150900,
region: '丰镇市',
regionCode: 156150981,
name: '丰镇市',
adcode: '156150981'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '兴安盟',
adcode: '156152200',
name: '兴安盟',
cityCode: 156152200,
children: [{
id: 400,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '兴安盟',
cityCode: 156152200,
region: '乌兰浩特市',
regionCode: 156152201,
name: '乌兰浩特市',
adcode: '156152201'
}, {
id: 401,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '兴安盟',
cityCode: 156152200,
region: '阿尔山市',
regionCode: 156152202,
name: '阿尔山市',
adcode: '156152202'
}, {
id: 402,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '兴安盟',
cityCode: 156152200,
region: '科尔沁右翼前旗',
regionCode: 156152221,
name: '科尔沁右翼前旗',
adcode: '156152221'
}, {
id: 403,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '兴安盟',
cityCode: 156152200,
region: '科尔沁右翼中旗',
regionCode: 156152222,
name: '科尔沁右翼中旗',
adcode: '156152222'
}, {
id: 404,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '兴安盟',
cityCode: 156152200,
region: '扎赉特旗',
regionCode: 156152223,
name: '扎赉特旗',
adcode: '156152223'
}, {
id: 405,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '兴安盟',
cityCode: 156152200,
region: '突泉县',
regionCode: 156152224,
name: '突泉县',
adcode: '156152224'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
adcode: '156152500',
name: '锡林郭勒盟',
cityCode: 156152500,
children: [{
id: 406,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '二连浩特市',
regionCode: 156152501,
name: '二连浩特市',
adcode: '156152501'
}, {
id: 407,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '锡林浩特市',
regionCode: 156152502,
name: '锡林浩特市',
adcode: '156152502'
}, {
id: 408,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '阿巴嘎旗',
regionCode: 156152522,
name: '阿巴嘎旗',
adcode: '156152522'
}, {
id: 409,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '苏尼特左旗',
regionCode: 156152523,
name: '苏尼特左旗',
adcode: '156152523'
}, {
id: 410,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '苏尼特右旗',
regionCode: 156152524,
name: '苏尼特右旗',
adcode: '156152524'
}, {
id: 411,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '东乌珠穆沁旗',
regionCode: 156152525,
name: '东乌珠穆沁旗',
adcode: '156152525'
}, {
id: 412,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '西乌珠穆沁旗',
regionCode: 156152526,
name: '西乌珠穆沁旗',
adcode: '156152526'
}, {
id: 413,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '太仆寺旗',
regionCode: 156152527,
name: '太仆寺旗',
adcode: '156152527'
}, {
id: 414,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '镶黄旗',
regionCode: 156152528,
name: '镶黄旗',
adcode: '156152528'
}, {
id: 415,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '正镶白旗',
regionCode: 156152529,
name: '正镶白旗',
adcode: '156152529'
}, {
id: 416,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '正蓝旗',
regionCode: 156152530,
name: '正蓝旗',
adcode: '156152530'
}, {
id: 417,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '锡林郭勒盟',
cityCode: 156152500,
region: '多伦县',
regionCode: 156152531,
name: '多伦县',
adcode: '156152531'
}]
}, {
province: '内蒙古自治区',
provinceCode: 156150000,
city: '阿拉善盟',
adcode: '156152900',
name: '阿拉善盟',
cityCode: 156152900,
children: [{
id: 418,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '阿拉善盟',
cityCode: 156152900,
region: '阿拉善左旗',
regionCode: 156152921,
name: '阿拉善左旗',
adcode: '156152921'
}, {
id: 419,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '阿拉善盟',
cityCode: 156152900,
region: '阿拉善右旗',
regionCode: 156152922,
name: '阿拉善右旗',
adcode: '156152922'
}, {
id: 420,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '阿拉善盟',
cityCode: 156152900,
region: '额济纳旗',
regionCode: 156152923,
name: '额济纳旗',
adcode: '156152923'
}, {
id: 421,
province: '内蒙古自治区',
provinceCode: 156150000,
city: '阿拉善盟',
cityCode: 156152900,
region: '阿拉善经济开发区',
regionCode: 156152971,
name: '阿拉善经济开发区',
adcode: '156152971'
}]
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
adcode: '156210000',
name: '辽宁省',
children: [{
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
adcode: '156210100',
name: '沈阳市',
cityCode: 156210100,
children: [{
id: 422,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '和平区',
regionCode: 156210102,
name: '和平区',
adcode: '156210102'
}, {
id: 423,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '沈河区',
regionCode: 156210103,
name: '沈河区',
adcode: '156210103'
}, {
id: 424,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '大东区',
regionCode: 156210104,
name: '大东区',
adcode: '156210104'
}, {
id: 425,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '皇姑区',
regionCode: 156210105,
name: '皇姑区',
adcode: '156210105'
}, {
id: 426,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '铁西区',
regionCode: 156210106,
name: '铁西区',
adcode: '156210106'
}, {
id: 427,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '苏家屯区',
regionCode: 156210111,
name: '苏家屯区',
adcode: '156210111'
}, {
id: 428,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '浑南区',
regionCode: 156210112,
name: '浑南区',
adcode: '156210112'
}, {
id: 429,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '沈北新区',
regionCode: 156210113,
name: '沈北新区',
adcode: '156210113'
}, {
id: 430,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '于洪区',
regionCode: 156210114,
name: '于洪区',
adcode: '156210114'
}, {
id: 431,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '辽中区',
regionCode: 156210115,
name: '辽中区',
adcode: '156210115'
}, {
id: 432,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '康平县',
regionCode: 156210123,
name: '康平县',
adcode: '156210123'
}, {
id: 433,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '法库县',
regionCode: 156210124,
name: '法库县',
adcode: '156210124'
}, {
id: 434,
province: '辽宁省',
provinceCode: 156210000,
city: '沈阳市',
cityCode: 156210100,
region: '新民市',
regionCode: 156210181,
name: '新民市',
adcode: '156210181'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
adcode: '156210200',
name: '大连市',
cityCode: 156210200,
children: [{
id: 435,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '中山区',
regionCode: 156210202,
name: '中山区',
adcode: '156210202'
}, {
id: 436,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '西岗区',
regionCode: 156210203,
name: '西岗区',
adcode: '156210203'
}, {
id: 437,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '沙河口区',
regionCode: 156210204,
name: '沙河口区',
adcode: '156210204'
}, {
id: 438,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '甘井子区',
regionCode: 156210211,
name: '甘井子区',
adcode: '156210211'
}, {
id: 439,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '旅顺口区',
regionCode: 156210212,
name: '旅顺口区',
adcode: '156210212'
}, {
id: 440,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '金州区',
regionCode: 156210213,
name: '金州区',
adcode: '156210213'
}, {
id: 441,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '普兰店区',
regionCode: 156210214,
name: '普兰店区',
adcode: '156210214'
}, {
id: 442,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '长海县',
regionCode: 156210224,
name: '长海县',
adcode: '156210224'
}, {
id: 443,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '瓦房店市',
regionCode: 156210281,
name: '瓦房店市',
adcode: '156210281'
}, {
id: 444,
province: '辽宁省',
provinceCode: 156210000,
city: '大连市',
cityCode: 156210200,
region: '庄河市',
regionCode: 156210283,
name: '庄河市',
adcode: '156210283'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
adcode: '156210300',
name: '鞍山市',
cityCode: 156210300,
children: [{
id: 445,
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
cityCode: 156210300,
region: '铁东区',
regionCode: 156210302,
name: '铁东区',
adcode: '156210302'
}, {
id: 446,
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
cityCode: 156210300,
region: '铁西区',
regionCode: 156210303,
name: '铁西区',
adcode: '156210303'
}, {
id: 447,
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
cityCode: 156210300,
region: '立山区',
regionCode: 156210304,
name: '立山区',
adcode: '156210304'
}, {
id: 448,
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
cityCode: 156210300,
region: '千山区',
regionCode: 156210311,
name: '千山区',
adcode: '156210311'
}, {
id: 449,
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
cityCode: 156210300,
region: '台安县',
regionCode: 156210321,
name: '台安县',
adcode: '156210321'
}, {
id: 450,
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
cityCode: 156210300,
region: '岫岩满族自治县',
regionCode: 156210323,
name: '岫岩满族自治县',
adcode: '156210323'
}, {
id: 451,
province: '辽宁省',
provinceCode: 156210000,
city: '鞍山市',
cityCode: 156210300,
region: '海城市',
regionCode: 156210381,
name: '海城市',
adcode: '156210381'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
adcode: '156210400',
name: '抚顺市',
cityCode: 156210400,
children: [{
id: 452,
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
cityCode: 156210400,
region: '新抚区',
regionCode: 156210402,
name: '新抚区',
adcode: '156210402'
}, {
id: 453,
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
cityCode: 156210400,
region: '东洲区',
regionCode: 156210403,
name: '东洲区',
adcode: '156210403'
}, {
id: 454,
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
cityCode: 156210400,
region: '望花区',
regionCode: 156210404,
name: '望花区',
adcode: '156210404'
}, {
id: 455,
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
cityCode: 156210400,
region: '顺城区',
regionCode: 156210411,
name: '顺城区',
adcode: '156210411'
}, {
id: 456,
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
cityCode: 156210400,
region: '抚顺县',
regionCode: 156210421,
name: '抚顺县',
adcode: '156210421'
}, {
id: 457,
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
cityCode: 156210400,
region: '新宾满族自治县',
regionCode: 156210422,
name: '新宾满族自治县',
adcode: '156210422'
}, {
id: 458,
province: '辽宁省',
provinceCode: 156210000,
city: '抚顺市',
cityCode: 156210400,
region: '清原满族自治县',
regionCode: 156210423,
name: '清原满族自治县',
adcode: '156210423'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '本溪市',
adcode: '156210500',
name: '本溪市',
cityCode: 156210500,
children: [{
id: 459,
province: '辽宁省',
provinceCode: 156210000,
city: '本溪市',
cityCode: 156210500,
region: '平山区',
regionCode: 156210502,
name: '平山区',
adcode: '156210502'
}, {
id: 460,
province: '辽宁省',
provinceCode: 156210000,
city: '本溪市',
cityCode: 156210500,
region: '溪湖区',
regionCode: 156210503,
name: '溪湖区',
adcode: '156210503'
}, {
id: 461,
province: '辽宁省',
provinceCode: 156210000,
city: '本溪市',
cityCode: 156210500,
region: '明山区',
regionCode: 156210504,
name: '明山区',
adcode: '156210504'
}, {
id: 462,
province: '辽宁省',
provinceCode: 156210000,
city: '本溪市',
cityCode: 156210500,
region: '南芬区',
regionCode: 156210505,
name: '南芬区',
adcode: '156210505'
}, {
id: 463,
province: '辽宁省',
provinceCode: 156210000,
city: '本溪市',
cityCode: 156210500,
region: '本溪满族自治县',
regionCode: 156210521,
name: '本溪满族自治县',
adcode: '156210521'
}, {
id: 464,
province: '辽宁省',
provinceCode: 156210000,
city: '本溪市',
cityCode: 156210500,
region: '桓仁满族自治县',
regionCode: 156210522,
name: '桓仁满族自治县',
adcode: '156210522'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '丹东市',
adcode: '156210600',
name: '丹东市',
cityCode: 156210600,
children: [{
id: 465,
province: '辽宁省',
provinceCode: 156210000,
city: '丹东市',
cityCode: 156210600,
region: '元宝区',
regionCode: 156210602,
name: '元宝区',
adcode: '156210602'
}, {
id: 466,
province: '辽宁省',
provinceCode: 156210000,
city: '丹东市',
cityCode: 156210600,
region: '振兴区',
regionCode: 156210603,
name: '振兴区',
adcode: '156210603'
}, {
id: 467,
province: '辽宁省',
provinceCode: 156210000,
city: '丹东市',
cityCode: 156210600,
region: '振安区',
regionCode: 156210604,
name: '振安区',
adcode: '156210604'
}, {
id: 468,
province: '辽宁省',
provinceCode: 156210000,
city: '丹东市',
cityCode: 156210600,
region: '宽甸满族自治县',
regionCode: 156210624,
name: '宽甸满族自治县',
adcode: '156210624'
}, {
id: 469,
province: '辽宁省',
provinceCode: 156210000,
city: '丹东市',
cityCode: 156210600,
region: '东港市',
regionCode: 156210681,
name: '东港市',
adcode: '156210681'
}, {
id: 470,
province: '辽宁省',
provinceCode: 156210000,
city: '丹东市',
cityCode: 156210600,
region: '凤城市',
regionCode: 156210682,
name: '凤城市',
adcode: '156210682'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
adcode: '156210700',
name: '锦州市',
cityCode: 156210700,
children: [{
id: 471,
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
cityCode: 156210700,
region: '古塔区',
regionCode: 156210702,
name: '古塔区',
adcode: '156210702'
}, {
id: 472,
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
cityCode: 156210700,
region: '凌河区',
regionCode: 156210703,
name: '凌河区',
adcode: '156210703'
}, {
id: 473,
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
cityCode: 156210700,
region: '太和区',
regionCode: 156210711,
name: '太和区',
adcode: '156210711'
}, {
id: 474,
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
cityCode: 156210700,
region: '黑山县',
regionCode: 156210726,
name: '黑山县',
adcode: '156210726'
}, {
id: 475,
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
cityCode: 156210700,
region: '义县',
regionCode: 156210727,
name: '义县',
adcode: '156210727'
}, {
id: 476,
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
cityCode: 156210700,
region: '凌海市',
regionCode: 156210781,
name: '凌海市',
adcode: '156210781'
}, {
id: 477,
province: '辽宁省',
provinceCode: 156210000,
city: '锦州市',
cityCode: 156210700,
region: '北镇市',
regionCode: 156210782,
name: '北镇市',
adcode: '156210782'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '营口市',
adcode: '156210800',
name: '营口市',
cityCode: 156210800,
children: [{
id: 478,
province: '辽宁省',
provinceCode: 156210000,
city: '营口市',
cityCode: 156210800,
region: '站前区',
regionCode: 156210802,
name: '站前区',
adcode: '156210802'
}, {
id: 479,
province: '辽宁省',
provinceCode: 156210000,
city: '营口市',
cityCode: 156210800,
region: '西市区',
regionCode: 156210803,
name: '西市区',
adcode: '156210803'
}, {
id: 480,
province: '辽宁省',
provinceCode: 156210000,
city: '营口市',
cityCode: 156210800,
region: '鲅鱼圈区',
regionCode: 156210804,
name: '鲅鱼圈区',
adcode: '156210804'
}, {
id: 481,
province: '辽宁省',
provinceCode: 156210000,
city: '营口市',
cityCode: 156210800,
region: '老边区',
regionCode: 156210811,
name: '老边区',
adcode: '156210811'
}, {
id: 482,
province: '辽宁省',
provinceCode: 156210000,
city: '营口市',
cityCode: 156210800,
region: '盖州市',
regionCode: 156210881,
name: '盖州市',
adcode: '156210881'
}, {
id: 483,
province: '辽宁省',
provinceCode: 156210000,
city: '营口市',
cityCode: 156210800,
region: '大石桥市',
regionCode: 156210882,
name: '大石桥市',
adcode: '156210882'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
adcode: '156210900',
name: '阜新市',
cityCode: 156210900,
children: [{
id: 484,
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
cityCode: 156210900,
region: '海州区',
regionCode: 156210902,
name: '海州区',
adcode: '156210902'
}, {
id: 485,
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
cityCode: 156210900,
region: '新邱区',
regionCode: 156210903,
name: '新邱区',
adcode: '156210903'
}, {
id: 486,
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
cityCode: 156210900,
region: '太平区',
regionCode: 156210904,
name: '太平区',
adcode: '156210904'
}, {
id: 487,
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
cityCode: 156210900,
region: '清河门区',
regionCode: 156210905,
name: '清河门区',
adcode: '156210905'
}, {
id: 488,
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
cityCode: 156210900,
region: '细河区',
regionCode: 156210911,
name: '细河区',
adcode: '156210911'
}, {
id: 489,
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
cityCode: 156210900,
region: '阜新蒙古族自治县',
regionCode: 156210921,
name: '阜新蒙古族自治县',
adcode: '156210921'
}, {
id: 490,
province: '辽宁省',
provinceCode: 156210000,
city: '阜新市',
cityCode: 156210900,
region: '彰武县',
regionCode: 156210922,
name: '彰武县',
adcode: '156210922'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
adcode: '156211000',
name: '辽阳市',
cityCode: 156211000,
children: [{
id: 491,
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
cityCode: 156211000,
region: '白塔区',
regionCode: 156211002,
name: '白塔区',
adcode: '156211002'
}, {
id: 492,
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
cityCode: 156211000,
region: '文圣区',
regionCode: 156211003,
name: '文圣区',
adcode: '156211003'
}, {
id: 493,
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
cityCode: 156211000,
region: '宏伟区',
regionCode: 156211004,
name: '宏伟区',
adcode: '156211004'
}, {
id: 494,
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
cityCode: 156211000,
region: '弓长岭区',
regionCode: 156211005,
name: '弓长岭区',
adcode: '156211005'
}, {
id: 495,
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
cityCode: 156211000,
region: '太子河区',
regionCode: 156211011,
name: '太子河区',
adcode: '156211011'
}, {
id: 496,
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
cityCode: 156211000,
region: '辽阳县',
regionCode: 156211021,
name: '辽阳县',
adcode: '156211021'
}, {
id: 497,
province: '辽宁省',
provinceCode: 156210000,
city: '辽阳市',
cityCode: 156211000,
region: '灯塔市',
regionCode: 156211081,
name: '灯塔市',
adcode: '156211081'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '盘锦市',
adcode: '156211100',
name: '盘锦市',
cityCode: 156211100,
children: [{
id: 498,
province: '辽宁省',
provinceCode: 156210000,
city: '盘锦市',
cityCode: 156211100,
region: '双台子区',
regionCode: 156211102,
name: '双台子区',
adcode: '156211102'
}, {
id: 499,
province: '辽宁省',
provinceCode: 156210000,
city: '盘锦市',
cityCode: 156211100,
region: '兴隆台区',
regionCode: 156211103,
name: '兴隆台区',
adcode: '156211103'
}, {
id: 500,
province: '辽宁省',
provinceCode: 156210000,
city: '盘锦市',
cityCode: 156211100,
region: '大洼区',
regionCode: 156211104,
name: '大洼区',
adcode: '156211104'
}, {
id: 501,
province: '辽宁省',
provinceCode: 156210000,
city: '盘锦市',
cityCode: 156211100,
region: '盘山县',
regionCode: 156211122,
name: '盘山县',
adcode: '156211122'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
adcode: '156211200',
name: '铁岭市',
cityCode: 156211200,
children: [{
id: 502,
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
cityCode: 156211200,
region: '银州区',
regionCode: 156211202,
name: '银州区',
adcode: '156211202'
}, {
id: 503,
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
cityCode: 156211200,
region: '清河区',
regionCode: 156211204,
name: '清河区',
adcode: '156211204'
}, {
id: 504,
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
cityCode: 156211200,
region: '铁岭县',
regionCode: 156211221,
name: '铁岭县',
adcode: '156211221'
}, {
id: 505,
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
cityCode: 156211200,
region: '西丰县',
regionCode: 156211223,
name: '西丰县',
adcode: '156211223'
}, {
id: 506,
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
cityCode: 156211200,
region: '昌图县',
regionCode: 156211224,
name: '昌图县',
adcode: '156211224'
}, {
id: 507,
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
cityCode: 156211200,
region: '调兵山市',
regionCode: 156211281,
name: '调兵山市',
adcode: '156211281'
}, {
id: 508,
province: '辽宁省',
provinceCode: 156210000,
city: '铁岭市',
cityCode: 156211200,
region: '开原市',
regionCode: 156211282,
name: '开原市',
adcode: '156211282'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
adcode: '156211300',
name: '朝阳市',
cityCode: 156211300,
children: [{
id: 509,
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
cityCode: 156211300,
region: '双塔区',
regionCode: 156211302,
name: '双塔区',
adcode: '156211302'
}, {
id: 510,
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
cityCode: 156211300,
region: '龙城区',
regionCode: 156211303,
name: '龙城区',
adcode: '156211303'
}, {
id: 511,
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
cityCode: 156211300,
region: '朝阳县',
regionCode: 156211321,
name: '朝阳县',
adcode: '156211321'
}, {
id: 512,
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
cityCode: 156211300,
region: '建平县',
regionCode: 156211322,
name: '建平县',
adcode: '156211322'
}, {
id: 513,
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
cityCode: 156211300,
region: '喀喇沁左翼蒙古族自治县',
regionCode: 156211324,
name: '喀喇沁左翼蒙古族自治县',
adcode: '156211324'
}, {
id: 514,
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
cityCode: 156211300,
region: '北票市',
regionCode: 156211381,
name: '北票市',
adcode: '156211381'
}, {
id: 515,
province: '辽宁省',
provinceCode: 156210000,
city: '朝阳市',
cityCode: 156211300,
region: '凌源市',
regionCode: 156211382,
name: '凌源市',
adcode: '156211382'
}]
}, {
province: '辽宁省',
provinceCode: 156210000,
city: '葫芦岛市',
adcode: '156211400',
name: '葫芦岛市',
cityCode: 156211400,
children: [{
id: 516,
province: '辽宁省',
provinceCode: 156210000,
city: '葫芦岛市',
cityCode: 156211400,
region: '连山区',
regionCode: 156211402,
name: '连山区',
adcode: '156211402'
}, {
id: 517,
province: '辽宁省',
provinceCode: 156210000,
city: '葫芦岛市',
cityCode: 156211400,
region: '龙港区',
regionCode: 156211403,
name: '龙港区',
adcode: '156211403'
}, {
id: 518,
province: '辽宁省',
provinceCode: 156210000,
city: '葫芦岛市',
cityCode: 156211400,
region: '南票区',
regionCode: 156211404,
name: '南票区',
adcode: '156211404'
}, {
id: 519,
province: '辽宁省',
provinceCode: 156210000,
city: '葫芦岛市',
cityCode: 156211400,
region: '绥中县',
regionCode: 156211421,
name: '绥中县',
adcode: '156211421'
}, {
id: 520,
province: '辽宁省',
provinceCode: 156210000,
city: '葫芦岛市',
cityCode: 156211400,
region: '建昌县',
regionCode: 156211422,
name: '建昌县',
adcode: '156211422'
}, {
id: 521,
province: '辽宁省',
provinceCode: 156210000,
city: '葫芦岛市',
cityCode: 156211400,
region: '兴城市',
regionCode: 156211481,
name: '兴城市',
adcode: '156211481'
}]
}]
}, {
province: '吉林省',
provinceCode: 156220000,
adcode: '156220000',
name: '吉林省',
children: [{
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
adcode: '156220100',
name: '长春市',
cityCode: 156220100,
children: [{
id: 522,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '南关区',
regionCode: 156220102,
name: '南关区',
adcode: '156220102'
}, {
id: 523,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '宽城区',
regionCode: 156220103,
name: '宽城区',
adcode: '156220103'
}, {
id: 524,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '朝阳区',
regionCode: 156220104,
name: '朝阳区',
adcode: '156220104'
}, {
id: 525,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '二道区',
regionCode: 156220105,
name: '二道区',
adcode: '156220105'
}, {
id: 526,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '绿园区',
regionCode: 156220106,
name: '绿园区',
adcode: '156220106'
}, {
id: 527,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '双阳区',
regionCode: 156220112,
name: '双阳区',
adcode: '156220112'
}, {
id: 528,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '九台区',
regionCode: 156220113,
name: '九台区',
adcode: '156220113'
}, {
id: 529,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '农安县',
regionCode: 156220122,
name: '农安县',
adcode: '156220122'
}, {
id: 530,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '榆树市',
regionCode: 156220182,
name: '榆树市',
adcode: '156220182'
}, {
id: 531,
province: '吉林省',
provinceCode: 156220000,
city: '长春市',
cityCode: 156220100,
region: '德惠市',
regionCode: 156220183,
name: '德惠市',
adcode: '156220183'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
adcode: '156220200',
name: '吉林市',
cityCode: 156220200,
children: [{
id: 532,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '昌邑区',
regionCode: 156220202,
name: '昌邑区',
adcode: '156220202'
}, {
id: 533,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '龙潭区',
regionCode: 156220203,
name: '龙潭区',
adcode: '156220203'
}, {
id: 534,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '船营区',
regionCode: 156220204,
name: '船营区',
adcode: '156220204'
}, {
id: 535,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '丰满区',
regionCode: 156220211,
name: '丰满区',
adcode: '156220211'
}, {
id: 536,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '永吉县',
regionCode: 156220221,
name: '永吉县',
adcode: '156220221'
}, {
id: 537,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '蛟河市',
regionCode: 156220281,
name: '蛟河市',
adcode: '156220281'
}, {
id: 538,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '桦甸市',
regionCode: 156220282,
name: '桦甸市',
adcode: '156220282'
}, {
id: 539,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '舒兰市',
regionCode: 156220283,
name: '舒兰市',
adcode: '156220283'
}, {
id: 540,
province: '吉林省',
provinceCode: 156220000,
city: '吉林市',
cityCode: 156220200,
region: '磐石市',
regionCode: 156220284,
name: '磐石市',
adcode: '156220284'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '四平市',
adcode: '156220300',
name: '四平市',
cityCode: 156220300,
children: [{
id: 541,
province: '吉林省',
provinceCode: 156220000,
city: '四平市',
cityCode: 156220300,
region: '铁西区',
regionCode: 156220302,
name: '铁西区',
adcode: '156220302'
}, {
id: 542,
province: '吉林省',
provinceCode: 156220000,
city: '四平市',
cityCode: 156220300,
region: '铁东区',
regionCode: 156220303,
name: '铁东区',
adcode: '156220303'
}, {
id: 543,
province: '吉林省',
provinceCode: 156220000,
city: '四平市',
cityCode: 156220300,
region: '梨树县',
regionCode: 156220322,
name: '梨树县',
adcode: '156220322'
}, {
id: 544,
province: '吉林省',
provinceCode: 156220000,
city: '四平市',
cityCode: 156220300,
region: '伊通满族自治县',
regionCode: 156220323,
name: '伊通满族自治县',
adcode: '156220323'
}, {
id: 545,
province: '吉林省',
provinceCode: 156220000,
city: '四平市',
cityCode: 156220300,
region: '公主岭市',
regionCode: 156220381,
name: '公主岭市',
adcode: '156220381'
}, {
id: 546,
province: '吉林省',
provinceCode: 156220000,
city: '四平市',
cityCode: 156220300,
region: '双辽市',
regionCode: 156220382,
name: '双辽市',
adcode: '156220382'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '辽源市',
adcode: '156220400',
name: '辽源市',
cityCode: 156220400,
children: [{
id: 547,
province: '吉林省',
provinceCode: 156220000,
city: '辽源市',
cityCode: 156220400,
region: '龙山区',
regionCode: 156220402,
name: '龙山区',
adcode: '156220402'
}, {
id: 548,
province: '吉林省',
provinceCode: 156220000,
city: '辽源市',
cityCode: 156220400,
region: '西安区',
regionCode: 156220403,
name: '西安区',
adcode: '156220403'
}, {
id: 549,
province: '吉林省',
provinceCode: 156220000,
city: '辽源市',
cityCode: 156220400,
region: '东丰县',
regionCode: 156220421,
name: '东丰县',
adcode: '156220421'
}, {
id: 550,
province: '吉林省',
provinceCode: 156220000,
city: '辽源市',
cityCode: 156220400,
region: '东辽县',
regionCode: 156220422,
name: '东辽县',
adcode: '156220422'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
adcode: '156220500',
name: '通化市',
cityCode: 156220500,
children: [{
id: 551,
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
cityCode: 156220500,
region: '东昌区',
regionCode: 156220502,
name: '东昌区',
adcode: '156220502'
}, {
id: 552,
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
cityCode: 156220500,
region: '二道江区',
regionCode: 156220503,
name: '二道江区',
adcode: '156220503'
}, {
id: 553,
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
cityCode: 156220500,
region: '通化县',
regionCode: 156220521,
name: '通化县',
adcode: '156220521'
}, {
id: 554,
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
cityCode: 156220500,
region: '辉南县',
regionCode: 156220523,
name: '辉南县',
adcode: '156220523'
}, {
id: 555,
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
cityCode: 156220500,
region: '柳河县',
regionCode: 156220524,
name: '柳河县',
adcode: '156220524'
}, {
id: 556,
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
cityCode: 156220500,
region: '梅河口市',
regionCode: 156220581,
name: '梅河口市',
adcode: '156220581'
}, {
id: 557,
province: '吉林省',
provinceCode: 156220000,
city: '通化市',
cityCode: 156220500,
region: '集安市',
regionCode: 156220582,
name: '集安市',
adcode: '156220582'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '白山市',
adcode: '156220600',
name: '白山市',
cityCode: 156220600,
children: [{
id: 558,
province: '吉林省',
provinceCode: 156220000,
city: '白山市',
cityCode: 156220600,
region: '浑江区',
regionCode: 156220602,
name: '浑江区',
adcode: '156220602'
}, {
id: 559,
province: '吉林省',
provinceCode: 156220000,
city: '白山市',
cityCode: 156220600,
region: '江源区',
regionCode: 156220605,
name: '江源区',
adcode: '156220605'
}, {
id: 560,
province: '吉林省',
provinceCode: 156220000,
city: '白山市',
cityCode: 156220600,
region: '抚松县',
regionCode: 156220621,
name: '抚松县',
adcode: '156220621'
}, {
id: 561,
province: '吉林省',
provinceCode: 156220000,
city: '白山市',
cityCode: 156220600,
region: '靖宇县',
regionCode: 156220622,
name: '靖宇县',
adcode: '156220622'
}, {
id: 562,
province: '吉林省',
provinceCode: 156220000,
city: '白山市',
cityCode: 156220600,
region: '长白朝鲜族自治县',
regionCode: 156220623,
name: '长白朝鲜族自治县',
adcode: '156220623'
}, {
id: 563,
province: '吉林省',
provinceCode: 156220000,
city: '白山市',
cityCode: 156220600,
region: '临江市',
regionCode: 156220681,
name: '临江市',
adcode: '156220681'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '松原市',
adcode: '156220700',
name: '松原市',
cityCode: 156220700,
children: [{
id: 564,
province: '吉林省',
provinceCode: 156220000,
city: '松原市',
cityCode: 156220700,
region: '宁江区',
regionCode: 156220702,
name: '宁江区',
adcode: '156220702'
}, {
id: 565,
province: '吉林省',
provinceCode: 156220000,
city: '松原市',
cityCode: 156220700,
region: '前郭尔罗斯蒙古族自治县',
regionCode: 156220721,
name: '前郭尔罗斯蒙古族自治县',
adcode: '156220721'
}, {
id: 566,
province: '吉林省',
provinceCode: 156220000,
city: '松原市',
cityCode: 156220700,
region: '长岭县',
regionCode: 156220722,
name: '长岭县',
adcode: '156220722'
}, {
id: 567,
province: '吉林省',
provinceCode: 156220000,
city: '松原市',
cityCode: 156220700,
region: '乾安县',
regionCode: 156220723,
name: '乾安县',
adcode: '156220723'
}, {
id: 568,
province: '吉林省',
provinceCode: 156220000,
city: '松原市',
cityCode: 156220700,
region: '扶余市',
regionCode: 156220781,
name: '扶余市',
adcode: '156220781'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '白城市',
adcode: '156220800',
name: '白城市',
cityCode: 156220800,
children: [{
id: 569,
province: '吉林省',
provinceCode: 156220000,
city: '白城市',
cityCode: 156220800,
region: '洮北区',
regionCode: 156220802,
name: '洮北区',
adcode: '156220802'
}, {
id: 570,
province: '吉林省',
provinceCode: 156220000,
city: '白城市',
cityCode: 156220800,
region: '镇赉县',
regionCode: 156220821,
name: '镇赉县',
adcode: '156220821'
}, {
id: 571,
province: '吉林省',
provinceCode: 156220000,
city: '白城市',
cityCode: 156220800,
region: '通榆县',
regionCode: 156220822,
name: '通榆县',
adcode: '156220822'
}, {
id: 572,
province: '吉林省',
provinceCode: 156220000,
city: '白城市',
cityCode: 156220800,
region: '洮南市',
regionCode: 156220881,
name: '洮南市',
adcode: '156220881'
}, {
id: 573,
province: '吉林省',
provinceCode: 156220000,
city: '白城市',
cityCode: 156220800,
region: '大安市',
regionCode: 156220882,
name: '大安市',
adcode: '156220882'
}]
}, {
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
adcode: '156222400',
name: '延边朝鲜族自治州',
cityCode: 156222400,
children: [{
id: 574,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '延吉市',
regionCode: 156222401,
name: '延吉市',
adcode: '156222401'
}, {
id: 575,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '图们市',
regionCode: 156222402,
name: '图们市',
adcode: '156222402'
}, {
id: 576,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '敦化市',
regionCode: 156222403,
name: '敦化市',
adcode: '156222403'
}, {
id: 577,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '珲春市',
regionCode: 156222404,
name: '珲春市',
adcode: '156222404'
}, {
id: 578,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '龙井市',
regionCode: 156222405,
name: '龙井市',
adcode: '156222405'
}, {
id: 579,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '和龙市',
regionCode: 156222406,
name: '和龙市',
adcode: '156222406'
}, {
id: 580,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '汪清县',
regionCode: 156222424,
name: '汪清县',
adcode: '156222424'
}, {
id: 581,
province: '吉林省',
provinceCode: 156220000,
city: '延边朝鲜族自治州',
cityCode: 156222400,
region: '安图县',
regionCode: 156222426,
name: '安图县',
adcode: '156222426'
}]
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
adcode: '156230000',
name: '黑龙江省',
children: [{
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
adcode: '156230100',
name: '哈尔滨市',
cityCode: 156230100,
children: [{
id: 582,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '道里区',
regionCode: 156230102,
name: '道里区',
adcode: '156230102'
}, {
id: 583,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '南岗区',
regionCode: 156230103,
name: '南岗区',
adcode: '156230103'
}, {
id: 584,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '道外区',
regionCode: 156230104,
name: '道外区',
adcode: '156230104'
}, {
id: 585,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '平房区',
regionCode: 156230108,
name: '平房区',
adcode: '156230108'
}, {
id: 586,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '松北区',
regionCode: 156230109,
name: '松北区',
adcode: '156230109'
}, {
id: 587,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '香坊区',
regionCode: 156230110,
name: '香坊区',
adcode: '156230110'
}, {
id: 588,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '呼兰区',
regionCode: 156230111,
name: '呼兰区',
adcode: '156230111'
}, {
id: 589,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '阿城区',
regionCode: 156230112,
name: '阿城区',
adcode: '156230112'
}, {
id: 590,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '双城区',
regionCode: 156230113,
name: '双城区',
adcode: '156230113'
}, {
id: 591,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '依兰县',
regionCode: 156230123,
name: '依兰县',
adcode: '156230123'
}, {
id: 592,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '方正县',
regionCode: 156230124,
name: '方正县',
adcode: '156230124'
}, {
id: 593,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '宾县',
regionCode: 156230125,
name: '宾县',
adcode: '156230125'
}, {
id: 594,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '巴彦县',
regionCode: 156230126,
name: '巴彦县',
adcode: '156230126'
}, {
id: 595,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '木兰县',
regionCode: 156230127,
name: '木兰县',
adcode: '156230127'
}, {
id: 596,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '通河县',
regionCode: 156230128,
name: '通河县',
adcode: '156230128'
}, {
id: 597,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '延寿县',
regionCode: 156230129,
name: '延寿县',
adcode: '156230129'
}, {
id: 598,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '尚志市',
regionCode: 156230183,
name: '尚志市',
adcode: '156230183'
}, {
id: 599,
province: '黑龙江省',
provinceCode: 156230000,
city: '哈尔滨市',
cityCode: 156230100,
region: '五常市',
regionCode: 156230184,
name: '五常市',
adcode: '156230184'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
adcode: '156230200',
name: '齐齐哈尔市',
cityCode: 156230200,
children: [{
id: 600,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '龙沙区',
regionCode: 156230202,
name: '龙沙区',
adcode: '156230202'
}, {
id: 601,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '建华区',
regionCode: 156230203,
name: '建华区',
adcode: '156230203'
}, {
id: 602,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '铁锋区',
regionCode: 156230204,
name: '铁锋区',
adcode: '156230204'
}, {
id: 603,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '昂昂溪区',
regionCode: 156230205,
name: '昂昂溪区',
adcode: '156230205'
}, {
id: 604,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '富拉尔基区',
regionCode: 156230206,
name: '富拉尔基区',
adcode: '156230206'
}, {
id: 605,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '碾子山区',
regionCode: 156230207,
name: '碾子山区',
adcode: '156230207'
}, {
id: 606,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '梅里斯达斡尔族区',
regionCode: 156230208,
name: '梅里斯达斡尔族区',
adcode: '156230208'
}, {
id: 607,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '龙江县',
regionCode: 156230221,
name: '龙江县',
adcode: '156230221'
}, {
id: 608,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '依安县',
regionCode: 156230223,
name: '依安县',
adcode: '156230223'
}, {
id: 609,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '泰来县',
regionCode: 156230224,
name: '泰来县',
adcode: '156230224'
}, {
id: 610,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '甘南县',
regionCode: 156230225,
name: '甘南县',
adcode: '156230225'
}, {
id: 611,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '富裕县',
regionCode: 156230227,
name: '富裕县',
adcode: '156230227'
}, {
id: 612,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '克山县',
regionCode: 156230229,
name: '克山县',
adcode: '156230229'
}, {
id: 613,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '克东县',
regionCode: 156230230,
name: '克东县',
adcode: '156230230'
}, {
id: 614,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '拜泉县',
regionCode: 156230231,
name: '拜泉县',
adcode: '156230231'
}, {
id: 615,
province: '黑龙江省',
provinceCode: 156230000,
city: '齐齐哈尔市',
cityCode: 156230200,
region: '讷河市',
regionCode: 156230281,
name: '讷河市',
adcode: '156230281'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
adcode: '156230300',
name: '鸡西市',
cityCode: 156230300,
children: [{
id: 616,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '鸡冠区',
regionCode: 156230302,
name: '鸡冠区',
adcode: '156230302'
}, {
id: 617,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '恒山区',
regionCode: 156230303,
name: '恒山区',
adcode: '156230303'
}, {
id: 618,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '滴道区',
regionCode: 156230304,
name: '滴道区',
adcode: '156230304'
}, {
id: 619,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '梨树区',
regionCode: 156230305,
name: '梨树区',
adcode: '156230305'
}, {
id: 620,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '城子河区',
regionCode: 156230306,
name: '城子河区',
adcode: '156230306'
}, {
id: 621,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '麻山区',
regionCode: 156230307,
name: '麻山区',
adcode: '156230307'
}, {
id: 622,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '鸡东县',
regionCode: 156230321,
name: '鸡东县',
adcode: '156230321'
}, {
id: 623,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '虎林市',
regionCode: 156230381,
name: '虎林市',
adcode: '156230381'
}, {
id: 624,
province: '黑龙江省',
provinceCode: 156230000,
city: '鸡西市',
cityCode: 156230300,
region: '密山市',
regionCode: 156230382,
name: '密山市',
adcode: '156230382'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
adcode: '156230400',
name: '鹤岗市',
cityCode: 156230400,
children: [{
id: 625,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '向阳区',
regionCode: 156230402,
name: '向阳区',
adcode: '156230402'
}, {
id: 626,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '工农区',
regionCode: 156230403,
name: '工农区',
adcode: '156230403'
}, {
id: 627,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '南山区',
regionCode: 156230404,
name: '南山区',
adcode: '156230404'
}, {
id: 628,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '兴安区',
regionCode: 156230405,
name: '兴安区',
adcode: '156230405'
}, {
id: 629,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '东山区',
regionCode: 156230406,
name: '东山区',
adcode: '156230406'
}, {
id: 630,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '兴山区',
regionCode: 156230407,
name: '兴山区',
adcode: '156230407'
}, {
id: 631,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '萝北县',
regionCode: 156230421,
name: '萝北县',
adcode: '156230421'
}, {
id: 632,
province: '黑龙江省',
provinceCode: 156230000,
city: '鹤岗市',
cityCode: 156230400,
region: '绥滨县',
regionCode: 156230422,
name: '绥滨县',
adcode: '156230422'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
adcode: '156230500',
name: '双鸭山市',
cityCode: 156230500,
children: [{
id: 633,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '尖山区',
regionCode: 156230502,
name: '尖山区',
adcode: '156230502'
}, {
id: 634,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '岭东区',
regionCode: 156230503,
name: '岭东区',
adcode: '156230503'
}, {
id: 635,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '四方台区',
regionCode: 156230505,
name: '四方台区',
adcode: '156230505'
}, {
id: 636,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '宝山区',
regionCode: 156230506,
name: '宝山区',
adcode: '156230506'
}, {
id: 637,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '集贤县',
regionCode: 156230521,
name: '集贤县',
adcode: '156230521'
}, {
id: 638,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '友谊县',
regionCode: 156230522,
name: '友谊县',
adcode: '156230522'
}, {
id: 639,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '宝清县',
regionCode: 156230523,
name: '宝清县',
adcode: '156230523'
}, {
id: 640,
province: '黑龙江省',
provinceCode: 156230000,
city: '双鸭山市',
cityCode: 156230500,
region: '饶河县',
regionCode: 156230524,
name: '饶河县',
adcode: '156230524'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
adcode: '156230600',
name: '大庆市',
cityCode: 156230600,
children: [{
id: 641,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '萨尔图区',
regionCode: 156230602,
name: '萨尔图区',
adcode: '156230602'
}, {
id: 642,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '龙凤区',
regionCode: 156230603,
name: '龙凤区',
adcode: '156230603'
}, {
id: 643,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '让胡路区',
regionCode: 156230604,
name: '让胡路区',
adcode: '156230604'
}, {
id: 644,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '红岗区',
regionCode: 156230605,
name: '红岗区',
adcode: '156230605'
}, {
id: 645,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '大同区',
regionCode: 156230606,
name: '大同区',
adcode: '156230606'
}, {
id: 646,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '肇州县',
regionCode: 156230621,
name: '肇州县',
adcode: '156230621'
}, {
id: 647,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '肇源县',
regionCode: 156230622,
name: '肇源县',
adcode: '156230622'
}, {
id: 648,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '林甸县',
regionCode: 156230623,
name: '林甸县',
adcode: '156230623'
}, {
id: 649,
province: '黑龙江省',
provinceCode: 156230000,
city: '大庆市',
cityCode: 156230600,
region: '杜尔伯特蒙古族自治县',
regionCode: 156230624,
name: '杜尔伯特蒙古族自治县',
adcode: '156230624'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
adcode: '156230700',
name: '伊春市',
cityCode: 156230700,
children: [{
id: 650,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '伊美区',
regionCode: 156230717,
name: '伊美区',
adcode: '156230717'
}, {
id: 651,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '乌翠区',
regionCode: 156230718,
name: '乌翠区',
adcode: '156230718'
}, {
id: 652,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '友好区',
regionCode: 156230719,
name: '友好区',
adcode: '156230719'
}, {
id: 653,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '嘉荫县',
regionCode: 156230722,
name: '嘉荫县',
adcode: '156230722'
}, {
id: 654,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '汤旺县',
regionCode: 156230723,
name: '汤旺县',
adcode: '156230723'
}, {
id: 655,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '丰林县',
regionCode: 156230724,
name: '丰林县',
adcode: '156230724'
}, {
id: 656,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '大箐山县',
regionCode: 156230725,
name: '大箐山县',
adcode: '156230725'
}, {
id: 657,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '南岔县',
regionCode: 156230726,
name: '南岔县',
adcode: '156230726'
}, {
id: 658,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '金林区',
regionCode: 156230751,
name: '金林区',
adcode: '156230751'
}, {
id: 659,
province: '黑龙江省',
provinceCode: 156230000,
city: '伊春市',
cityCode: 156230700,
region: '铁力市',
regionCode: 156230781,
name: '铁力市',
adcode: '156230781'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
adcode: '156230800',
name: '佳木斯市',
cityCode: 156230800,
children: [{
id: 660,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '向阳区',
regionCode: 156230803,
name: '向阳区',
adcode: '156230803'
}, {
id: 661,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '前进区',
regionCode: 156230804,
name: '前进区',
adcode: '156230804'
}, {
id: 662,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '东风区',
regionCode: 156230805,
name: '东风区',
adcode: '156230805'
}, {
id: 663,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '郊区',
regionCode: 156230811,
name: '郊区',
adcode: '156230811'
}, {
id: 664,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '桦南县',
regionCode: 156230822,
name: '桦南县',
adcode: '156230822'
}, {
id: 665,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '桦川县',
regionCode: 156230826,
name: '桦川县',
adcode: '156230826'
}, {
id: 666,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '汤原县',
regionCode: 156230828,
name: '汤原县',
adcode: '156230828'
}, {
id: 667,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '同江市',
regionCode: 156230881,
name: '同江市',
adcode: '156230881'
}, {
id: 668,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '富锦市',
regionCode: 156230882,
name: '富锦市',
adcode: '156230882'
}, {
id: 669,
province: '黑龙江省',
provinceCode: 156230000,
city: '佳木斯市',
cityCode: 156230800,
region: '抚远市',
regionCode: 156230883,
name: '抚远市',
adcode: '156230883'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '七台河市',
adcode: '156230900',
name: '七台河市',
cityCode: 156230900,
children: [{
id: 670,
province: '黑龙江省',
provinceCode: 156230000,
city: '七台河市',
cityCode: 156230900,
region: '新兴区',
regionCode: 156230902,
name: '新兴区',
adcode: '156230902'
}, {
id: 671,
province: '黑龙江省',
provinceCode: 156230000,
city: '七台河市',
cityCode: 156230900,
region: '桃山区',
regionCode: 156230903,
name: '桃山区',
adcode: '156230903'
}, {
id: 672,
province: '黑龙江省',
provinceCode: 156230000,
city: '七台河市',
cityCode: 156230900,
region: '茄子河区',
regionCode: 156230904,
name: '茄子河区',
adcode: '156230904'
}, {
id: 673,
province: '黑龙江省',
provinceCode: 156230000,
city: '七台河市',
cityCode: 156230900,
region: '勃利县',
regionCode: 156230921,
name: '勃利县',
adcode: '156230921'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
adcode: '156231000',
name: '牡丹江市',
cityCode: 156231000,
children: [{
id: 674,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '东安区',
regionCode: 156231002,
name: '东安区',
adcode: '156231002'
}, {
id: 675,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '阳明区',
regionCode: 156231003,
name: '阳明区',
adcode: '156231003'
}, {
id: 676,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '爱民区',
regionCode: 156231004,
name: '爱民区',
adcode: '156231004'
}, {
id: 677,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '西安区',
regionCode: 156231005,
name: '西安区',
adcode: '156231005'
}, {
id: 678,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '林口县',
regionCode: 156231025,
name: '林口县',
adcode: '156231025'
}, {
id: 679,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '绥芬河市',
regionCode: 156231081,
name: '绥芬河市',
adcode: '156231081'
}, {
id: 680,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '海林市',
regionCode: 156231083,
name: '海林市',
adcode: '156231083'
}, {
id: 681,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '宁安市',
regionCode: 156231084,
name: '宁安市',
adcode: '156231084'
}, {
id: 682,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '穆棱市',
regionCode: 156231085,
name: '穆棱市',
adcode: '156231085'
}, {
id: 683,
province: '黑龙江省',
provinceCode: 156230000,
city: '牡丹江市',
cityCode: 156231000,
region: '东宁市',
regionCode: 156231086,
name: '东宁市',
adcode: '156231086'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '黑河市',
adcode: '156231100',
name: '黑河市',
cityCode: 156231100,
children: [{
id: 684,
province: '黑龙江省',
provinceCode: 156230000,
city: '黑河市',
cityCode: 156231100,
region: '爱辉区',
regionCode: 156231102,
name: '爱辉区',
adcode: '156231102'
}, {
id: 685,
province: '黑龙江省',
provinceCode: 156230000,
city: '黑河市',
cityCode: 156231100,
region: '逊克县',
regionCode: 156231123,
name: '逊克县',
adcode: '156231123'
}, {
id: 686,
province: '黑龙江省',
provinceCode: 156230000,
city: '黑河市',
cityCode: 156231100,
region: '孙吴县',
regionCode: 156231124,
name: '孙吴县',
adcode: '156231124'
}, {
id: 687,
province: '黑龙江省',
provinceCode: 156230000,
city: '黑河市',
cityCode: 156231100,
region: '北安市',
regionCode: 156231181,
name: '北安市',
adcode: '156231181'
}, {
id: 688,
province: '黑龙江省',
provinceCode: 156230000,
city: '黑河市',
cityCode: 156231100,
region: '五大连池市',
regionCode: 156231182,
name: '五大连池市',
adcode: '156231182'
}, {
id: 689,
province: '黑龙江省',
provinceCode: 156230000,
city: '黑河市',
cityCode: 156231100,
region: '嫩江市',
regionCode: 156231183,
name: '嫩江市',
adcode: '156231183'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
adcode: '156231200',
name: '绥化市',
cityCode: 156231200,
children: [{
id: 690,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '北林区',
regionCode: 156231202,
name: '北林区',
adcode: '156231202'
}, {
id: 691,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '望奎县',
regionCode: 156231221,
name: '望奎县',
adcode: '156231221'
}, {
id: 692,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '兰西县',
regionCode: 156231222,
name: '兰西县',
adcode: '156231222'
}, {
id: 693,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '青冈县',
regionCode: 156231223,
name: '青冈县',
adcode: '156231223'
}, {
id: 694,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '庆安县',
regionCode: 156231224,
name: '庆安县',
adcode: '156231224'
}, {
id: 695,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '明水县',
regionCode: 156231225,
name: '明水县',
adcode: '156231225'
}, {
id: 696,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '绥棱县',
regionCode: 156231226,
name: '绥棱县',
adcode: '156231226'
}, {
id: 697,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '安达市',
regionCode: 156231281,
name: '安达市',
adcode: '156231281'
}, {
id: 698,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '肇东市',
regionCode: 156231282,
name: '肇东市',
adcode: '156231282'
}, {
id: 699,
province: '黑龙江省',
provinceCode: 156230000,
city: '绥化市',
cityCode: 156231200,
region: '海伦市',
regionCode: 156231283,
name: '海伦市',
adcode: '156231283'
}]
}, {
province: '黑龙江省',
provinceCode: 156230000,
city: '大兴安岭地区',
adcode: '156232700',
name: '大兴安岭地区',
cityCode: 156232700,
children: [{
id: 700,
province: '黑龙江省',
provinceCode: 156230000,
city: '大兴安岭地区',
cityCode: 156232700,
region: '漠河市',
regionCode: 156232701,
name: '漠河市',
adcode: '156232701'
}, {
id: 701,
province: '黑龙江省',
provinceCode: 156230000,
city: '大兴安岭地区',
cityCode: 156232700,
region: '呼玛县',
regionCode: 156232721,
name: '呼玛县',
adcode: '156232721'
}, {
id: 702,
province: '黑龙江省',
provinceCode: 156230000,
city: '大兴安岭地区',
cityCode: 156232700,
region: '塔河县',
regionCode: 156232722,
name: '塔河县',
adcode: '156232722'
}]
}]
}, {
province: '上海市',
provinceCode: 156310000,
adcode: '156310000',
name: '上海市',
children: [{
province: '上海市',
provinceCode: 156310000,
city: '上海市',
adcode: '156310000',
name: '上海市',
cityCode: 156310000,
children: [{
id: 703,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '黄浦区',
regionCode: 156310101,
name: '黄浦区',
adcode: '156310101'
}, {
id: 704,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '徐汇区',
regionCode: 156310104,
name: '徐汇区',
adcode: '156310104'
}, {
id: 705,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '长宁区',
regionCode: 156310105,
name: '长宁区',
adcode: '156310105'
}, {
id: 706,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '静安区',
regionCode: 156310106,
name: '静安区',
adcode: '156310106'
}, {
id: 707,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '普陀区',
regionCode: 156310107,
name: '普陀区',
adcode: '156310107'
}, {
id: 708,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '虹口区',
regionCode: 156310109,
name: '虹口区',
adcode: '156310109'
}, {
id: 709,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '杨浦区',
regionCode: 156310110,
name: '杨浦区',
adcode: '156310110'
}, {
id: 710,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '闵行区',
regionCode: 156310112,
name: '闵行区',
adcode: '156310112'
}, {
id: 711,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '宝山区',
regionCode: 156310113,
name: '宝山区',
adcode: '156310113'
}, {
id: 712,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '嘉定区',
regionCode: 156310114,
name: '嘉定区',
adcode: '156310114'
}, {
id: 713,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '浦东新区',
regionCode: 156310115,
name: '浦东新区',
adcode: '156310115'
}, {
id: 714,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '金山区',
regionCode: 156310116,
name: '金山区',
adcode: '156310116'
}, {
id: 715,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '松江区',
regionCode: 156310117,
name: '松江区',
adcode: '156310117'
}, {
id: 716,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '青浦区',
regionCode: 156310118,
name: '青浦区',
adcode: '156310118'
}, {
id: 717,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '奉贤区',
regionCode: 156310120,
name: '奉贤区',
adcode: '156310120'
}, {
id: 718,
province: '上海市',
provinceCode: 156310000,
city: '上海市',
cityCode: 156310000,
region: '崇明区',
regionCode: 156310151,
name: '崇明区',
adcode: '156310151'
}]
}]
}, {
province: '江苏省',
provinceCode: 156320000,
adcode: '156320000',
name: '江苏省',
children: [{
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
adcode: '156320100',
name: '南京市',
cityCode: 156320100,
children: [{
id: 719,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '玄武区',
regionCode: 156320102,
name: '玄武区',
adcode: '156320102'
}, {
id: 720,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '秦淮区',
regionCode: 156320104,
name: '秦淮区',
adcode: '156320104'
}, {
id: 721,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '建邺区',
regionCode: 156320105,
name: '建邺区',
adcode: '156320105'
}, {
id: 722,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '鼓楼区',
regionCode: 156320106,
name: '鼓楼区',
adcode: '156320106'
}, {
id: 723,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '浦口区',
regionCode: 156320111,
name: '浦口区',
adcode: '156320111'
}, {
id: 724,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '栖霞区',
regionCode: 156320113,
name: '栖霞区',
adcode: '156320113'
}, {
id: 725,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '雨花台区',
regionCode: 156320114,
name: '雨花台区',
adcode: '156320114'
}, {
id: 726,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '江宁区',
regionCode: 156320115,
name: '江宁区',
adcode: '156320115'
}, {
id: 727,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '六合区',
regionCode: 156320116,
name: '六合区',
adcode: '156320116'
}, {
id: 728,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '溧水区',
regionCode: 156320117,
name: '溧水区',
adcode: '156320117'
}, {
id: 729,
province: '江苏省',
provinceCode: 156320000,
city: '南京市',
cityCode: 156320100,
region: '高淳区',
regionCode: 156320118,
name: '高淳区',
adcode: '156320118'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
adcode: '156320200',
name: '无锡市',
cityCode: 156320200,
children: [{
id: 730,
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
cityCode: 156320200,
region: '锡山区',
regionCode: 156320205,
name: '锡山区',
adcode: '156320205'
}, {
id: 731,
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
cityCode: 156320200,
region: '惠山区',
regionCode: 156320206,
name: '惠山区',
adcode: '156320206'
}, {
id: 732,
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
cityCode: 156320200,
region: '滨湖区',
regionCode: 156320211,
name: '滨湖区',
adcode: '156320211'
}, {
id: 733,
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
cityCode: 156320200,
region: '梁溪区',
regionCode: 156320213,
name: '梁溪区',
adcode: '156320213'
}, {
id: 734,
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
cityCode: 156320200,
region: '新吴区',
regionCode: 156320214,
name: '新吴区',
adcode: '156320214'
}, {
id: 735,
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
cityCode: 156320200,
region: '江阴市',
regionCode: 156320281,
name: '江阴市',
adcode: '156320281'
}, {
id: 736,
province: '江苏省',
provinceCode: 156320000,
city: '无锡市',
cityCode: 156320200,
region: '宜兴市',
regionCode: 156320282,
name: '宜兴市',
adcode: '156320282'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
adcode: '156320300',
name: '徐州市',
cityCode: 156320300,
children: [{
id: 737,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '鼓楼区',
regionCode: 156320302,
name: '鼓楼区',
adcode: '156320302'
}, {
id: 738,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '云龙区',
regionCode: 156320303,
name: '云龙区',
adcode: '156320303'
}, {
id: 739,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '贾汪区',
regionCode: 156320305,
name: '贾汪区',
adcode: '156320305'
}, {
id: 740,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '泉山区',
regionCode: 156320311,
name: '泉山区',
adcode: '156320311'
}, {
id: 741,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '铜山区',
regionCode: 156320312,
name: '铜山区',
adcode: '156320312'
}, {
id: 742,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '丰县',
regionCode: 156320321,
name: '丰县',
adcode: '156320321'
}, {
id: 743,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '沛县',
regionCode: 156320322,
name: '沛县',
adcode: '156320322'
}, {
id: 744,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '睢宁县',
regionCode: 156320324,
name: '睢宁县',
adcode: '156320324'
}, {
id: 745,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '新沂市',
regionCode: 156320381,
name: '新沂市',
adcode: '156320381'
}, {
id: 746,
province: '江苏省',
provinceCode: 156320000,
city: '徐州市',
cityCode: 156320300,
region: '邳州市',
regionCode: 156320382,
name: '邳州市',
adcode: '156320382'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '常州市',
adcode: '156320400',
name: '常州市',
cityCode: 156320400,
children: [{
id: 747,
province: '江苏省',
provinceCode: 156320000,
city: '常州市',
cityCode: 156320400,
region: '天宁区',
regionCode: 156320402,
name: '天宁区',
adcode: '156320402'
}, {
id: 748,
province: '江苏省',
provinceCode: 156320000,
city: '常州市',
cityCode: 156320400,
region: '钟楼区',
regionCode: 156320404,
name: '钟楼区',
adcode: '156320404'
}, {
id: 749,
province: '江苏省',
provinceCode: 156320000,
city: '常州市',
cityCode: 156320400,
region: '新北区',
regionCode: 156320411,
name: '新北区',
adcode: '156320411'
}, {
id: 750,
province: '江苏省',
provinceCode: 156320000,
city: '常州市',
cityCode: 156320400,
region: '武进区',
regionCode: 156320412,
name: '武进区',
adcode: '156320412'
}, {
id: 751,
province: '江苏省',
provinceCode: 156320000,
city: '常州市',
cityCode: 156320400,
region: '金坛区',
regionCode: 156320413,
name: '金坛区',
adcode: '156320413'
}, {
id: 752,
province: '江苏省',
provinceCode: 156320000,
city: '常州市',
cityCode: 156320400,
region: '溧阳市',
regionCode: 156320481,
name: '溧阳市',
adcode: '156320481'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
adcode: '156320500',
name: '苏州市',
cityCode: 156320500,
children: [{
id: 753,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '虎丘区',
regionCode: 156320505,
name: '虎丘区',
adcode: '156320505'
}, {
id: 754,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '吴中区',
regionCode: 156320506,
name: '吴中区',
adcode: '156320506'
}, {
id: 755,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '相城区',
regionCode: 156320507,
name: '相城区',
adcode: '156320507'
}, {
id: 756,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '姑苏区',
regionCode: 156320508,
name: '姑苏区',
adcode: '156320508'
}, {
id: 757,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '吴江区',
regionCode: 156320509,
name: '吴江区',
adcode: '156320509'
}, {
id: 758,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '常熟市',
regionCode: 156320581,
name: '常熟市',
adcode: '156320581'
}, {
id: 759,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '张家港市',
regionCode: 156320582,
name: '张家港市',
adcode: '156320582'
}, {
id: 760,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '昆山市',
regionCode: 156320583,
name: '昆山市',
adcode: '156320583'
}, {
id: 761,
province: '江苏省',
provinceCode: 156320000,
city: '苏州市',
cityCode: 156320500,
region: '太仓市',
regionCode: 156320585,
name: '太仓市',
adcode: '156320585'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
adcode: '156320600',
name: '南通市',
cityCode: 156320600,
children: [{
id: 762,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '崇川区',
regionCode: 156320602,
name: '崇川区',
adcode: '156320602'
}, {
id: 763,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '港闸区',
regionCode: 156320611,
name: '港闸区',
adcode: '156320611'
}, {
id: 764,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '通州区',
regionCode: 156320612,
name: '通州区',
adcode: '156320612'
}, {
id: 765,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '如东县',
regionCode: 156320623,
name: '如东县',
adcode: '156320623'
}, {
id: 766,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '启东市',
regionCode: 156320681,
name: '启东市',
adcode: '156320681'
}, {
id: 767,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '如皋市',
regionCode: 156320682,
name: '如皋市',
adcode: '156320682'
}, {
id: 768,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '海门市',
regionCode: 156320684,
name: '海门市',
adcode: '156320684'
}, {
id: 769,
province: '江苏省',
provinceCode: 156320000,
city: '南通市',
cityCode: 156320600,
region: '海安市',
regionCode: 156320685,
name: '海安市',
adcode: '156320685'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '连云港市',
adcode: '156320700',
name: '连云港市',
cityCode: 156320700,
children: [{
id: 770,
province: '江苏省',
provinceCode: 156320000,
city: '连云港市',
cityCode: 156320700,
region: '连云区',
regionCode: 156320703,
name: '连云区',
adcode: '156320703'
}, {
id: 771,
province: '江苏省',
provinceCode: 156320000,
city: '连云港市',
cityCode: 156320700,
region: '海州区',
regionCode: 156320706,
name: '海州区',
adcode: '156320706'
}, {
id: 772,
province: '江苏省',
provinceCode: 156320000,
city: '连云港市',
cityCode: 156320700,
region: '赣榆区',
regionCode: 156320707,
name: '赣榆区',
adcode: '156320707'
}, {
id: 773,
province: '江苏省',
provinceCode: 156320000,
city: '连云港市',
cityCode: 156320700,
region: '东海县',
regionCode: 156320722,
name: '东海县',
adcode: '156320722'
}, {
id: 774,
province: '江苏省',
provinceCode: 156320000,
city: '连云港市',
cityCode: 156320700,
region: '灌云县',
regionCode: 156320723,
name: '灌云县',
adcode: '156320723'
}, {
id: 775,
province: '江苏省',
provinceCode: 156320000,
city: '连云港市',
cityCode: 156320700,
region: '灌南县',
regionCode: 156320724,
name: '灌南县',
adcode: '156320724'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
adcode: '156320800',
name: '淮安市',
cityCode: 156320800,
children: [{
id: 776,
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
cityCode: 156320800,
region: '淮安区',
regionCode: 156320803,
name: '淮安区',
adcode: '156320803'
}, {
id: 777,
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
cityCode: 156320800,
region: '淮阴区',
regionCode: 156320804,
name: '淮阴区',
adcode: '156320804'
}, {
id: 778,
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
cityCode: 156320800,
region: '清江浦区',
regionCode: 156320812,
name: '清江浦区',
adcode: '156320812'
}, {
id: 779,
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
cityCode: 156320800,
region: '洪泽区',
regionCode: 156320813,
name: '洪泽区',
adcode: '156320813'
}, {
id: 780,
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
cityCode: 156320800,
region: '涟水县',
regionCode: 156320826,
name: '涟水县',
adcode: '156320826'
}, {
id: 781,
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
cityCode: 156320800,
region: '盱眙县',
regionCode: 156320830,
name: '盱眙县',
adcode: '156320830'
}, {
id: 782,
province: '江苏省',
provinceCode: 156320000,
city: '淮安市',
cityCode: 156320800,
region: '金湖县',
regionCode: 156320831,
name: '金湖县',
adcode: '156320831'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
adcode: '156320900',
name: '盐城市',
cityCode: 156320900,
children: [{
id: 783,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '亭湖区',
regionCode: 156320902,
name: '亭湖区',
adcode: '156320902'
}, {
id: 784,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '盐都区',
regionCode: 156320903,
name: '盐都区',
adcode: '156320903'
}, {
id: 785,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '大丰区',
regionCode: 156320904,
name: '大丰区',
adcode: '156320904'
}, {
id: 786,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '响水县',
regionCode: 156320921,
name: '响水县',
adcode: '156320921'
}, {
id: 787,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '滨海县',
regionCode: 156320922,
name: '滨海县',
adcode: '156320922'
}, {
id: 788,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '阜宁县',
regionCode: 156320923,
name: '阜宁县',
adcode: '156320923'
}, {
id: 789,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '射阳县',
regionCode: 156320924,
name: '射阳县',
adcode: '156320924'
}, {
id: 790,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '建湖县',
regionCode: 156320925,
name: '建湖县',
adcode: '156320925'
}, {
id: 791,
province: '江苏省',
provinceCode: 156320000,
city: '盐城市',
cityCode: 156320900,
region: '东台市',
regionCode: 156320981,
name: '东台市',
adcode: '156320981'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '扬州市',
adcode: '156321000',
name: '扬州市',
cityCode: 156321000,
children: [{
id: 792,
province: '江苏省',
provinceCode: 156320000,
city: '扬州市',
cityCode: 156321000,
region: '广陵区',
regionCode: 156321002,
name: '广陵区',
adcode: '156321002'
}, {
id: 793,
province: '江苏省',
provinceCode: 156320000,
city: '扬州市',
cityCode: 156321000,
region: '邗江区',
regionCode: 156321003,
name: '邗江区',
adcode: '156321003'
}, {
id: 794,
province: '江苏省',
provinceCode: 156320000,
city: '扬州市',
cityCode: 156321000,
region: '江都区',
regionCode: 156321012,
name: '江都区',
adcode: '156321012'
}, {
id: 795,
province: '江苏省',
provinceCode: 156320000,
city: '扬州市',
cityCode: 156321000,
region: '宝应县',
regionCode: 156321023,
name: '宝应县',
adcode: '156321023'
}, {
id: 796,
province: '江苏省',
provinceCode: 156320000,
city: '扬州市',
cityCode: 156321000,
region: '仪征市',
regionCode: 156321081,
name: '仪征市',
adcode: '156321081'
}, {
id: 797,
province: '江苏省',
provinceCode: 156320000,
city: '扬州市',
cityCode: 156321000,
region: '高邮市',
regionCode: 156321084,
name: '高邮市',
adcode: '156321084'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '镇江市',
adcode: '156321100',
name: '镇江市',
cityCode: 156321100,
children: [{
id: 798,
province: '江苏省',
provinceCode: 156320000,
city: '镇江市',
cityCode: 156321100,
region: '京口区',
regionCode: 156321102,
name: '京口区',
adcode: '156321102'
}, {
id: 799,
province: '江苏省',
provinceCode: 156320000,
city: '镇江市',
cityCode: 156321100,
region: '润州区',
regionCode: 156321111,
name: '润州区',
adcode: '156321111'
}, {
id: 800,
province: '江苏省',
provinceCode: 156320000,
city: '镇江市',
cityCode: 156321100,
region: '丹徒区',
regionCode: 156321112,
name: '丹徒区',
adcode: '156321112'
}, {
id: 801,
province: '江苏省',
provinceCode: 156320000,
city: '镇江市',
cityCode: 156321100,
region: '丹阳市',
regionCode: 156321181,
name: '丹阳市',
adcode: '156321181'
}, {
id: 802,
province: '江苏省',
provinceCode: 156320000,
city: '镇江市',
cityCode: 156321100,
region: '扬中市',
regionCode: 156321182,
name: '扬中市',
adcode: '156321182'
}, {
id: 803,
province: '江苏省',
provinceCode: 156320000,
city: '镇江市',
cityCode: 156321100,
region: '句容市',
regionCode: 156321183,
name: '句容市',
adcode: '156321183'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '泰州市',
adcode: '156321200',
name: '泰州市',
cityCode: 156321200,
children: [{
id: 804,
province: '江苏省',
provinceCode: 156320000,
city: '泰州市',
cityCode: 156321200,
region: '海陵区',
regionCode: 156321202,
name: '海陵区',
adcode: '156321202'
}, {
id: 805,
province: '江苏省',
provinceCode: 156320000,
city: '泰州市',
cityCode: 156321200,
region: '高港区',
regionCode: 156321203,
name: '高港区',
adcode: '156321203'
}, {
id: 806,
province: '江苏省',
provinceCode: 156320000,
city: '泰州市',
cityCode: 156321200,
region: '姜堰区',
regionCode: 156321204,
name: '姜堰区',
adcode: '156321204'
}, {
id: 807,
province: '江苏省',
provinceCode: 156320000,
city: '泰州市',
cityCode: 156321200,
region: '兴化市',
regionCode: 156321281,
name: '兴化市',
adcode: '156321281'
}, {
id: 808,
province: '江苏省',
provinceCode: 156320000,
city: '泰州市',
cityCode: 156321200,
region: '靖江市',
regionCode: 156321282,
name: '靖江市',
adcode: '156321282'
}, {
id: 809,
province: '江苏省',
provinceCode: 156320000,
city: '泰州市',
cityCode: 156321200,
region: '泰兴市',
regionCode: 156321283,
name: '泰兴市',
adcode: '156321283'
}]
}, {
province: '江苏省',
provinceCode: 156320000,
city: '宿迁市',
adcode: '156321300',
name: '宿迁市',
cityCode: 156321300,
children: [{
id: 810,
province: '江苏省',
provinceCode: 156320000,
city: '宿迁市',
cityCode: 156321300,
region: '宿城区',
regionCode: 156321302,
name: '宿城区',
adcode: '156321302'
}, {
id: 811,
province: '江苏省',
provinceCode: 156320000,
city: '宿迁市',
cityCode: 156321300,
region: '宿豫区',
regionCode: 156321311,
name: '宿豫区',
adcode: '156321311'
}, {
id: 812,
province: '江苏省',
provinceCode: 156320000,
city: '宿迁市',
cityCode: 156321300,
region: '沭阳县',
regionCode: 156321322,
name: '沭阳县',
adcode: '156321322'
}, {
id: 813,
province: '江苏省',
provinceCode: 156320000,
city: '宿迁市',
cityCode: 156321300,
region: '泗阳县',
regionCode: 156321323,
name: '泗阳县',
adcode: '156321323'
}, {
id: 814,
province: '江苏省',
provinceCode: 156320000,
city: '宿迁市',
cityCode: 156321300,
region: '泗洪县',
regionCode: 156321324,
name: '泗洪县',
adcode: '156321324'
}]
}]
}, {
province: '浙江省',
provinceCode: 156330000,
adcode: '156330000',
name: '浙江省',
children: [{
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
adcode: '156330100',
name: '杭州市',
cityCode: 156330100,
children: [{
id: 815,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '上城区',
regionCode: 156330102,
name: '上城区',
adcode: '156330102'
}, {
id: 816,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '下城区',
regionCode: 156330103,
name: '下城区',
adcode: '156330103'
}, {
id: 817,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '江干区',
regionCode: 156330104,
name: '江干区',
adcode: '156330104'
}, {
id: 818,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '拱墅区',
regionCode: 156330105,
name: '拱墅区',
adcode: '156330105'
}, {
id: 819,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '西湖区',
regionCode: 156330106,
name: '西湖区',
adcode: '156330106'
}, {
id: 820,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '滨江区',
regionCode: 156330108,
name: '滨江区',
adcode: '156330108'
}, {
id: 821,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '萧山区',
regionCode: 156330109,
name: '萧山区',
adcode: '156330109'
}, {
id: 822,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '余杭区',
regionCode: 156330110,
name: '余杭区',
adcode: '156330110'
}, {
id: 823,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '富阳区',
regionCode: 156330111,
name: '富阳区',
adcode: '156330111'
}, {
id: 824,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '临安区',
regionCode: 156330112,
name: '临安区',
adcode: '156330112'
}, {
id: 825,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '桐庐县',
regionCode: 156330122,
name: '桐庐县',
adcode: '156330122'
}, {
id: 826,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '淳安县',
regionCode: 156330127,
name: '淳安县',
adcode: '156330127'
}, {
id: 827,
province: '浙江省',
provinceCode: 156330000,
city: '杭州市',
cityCode: 156330100,
region: '建德市',
regionCode: 156330182,
name: '建德市',
adcode: '156330182'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
adcode: '156330200',
name: '宁波市',
cityCode: 156330200,
children: [{
id: 828,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '海曙区',
regionCode: 156330203,
name: '海曙区',
adcode: '156330203'
}, {
id: 829,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '江北区',
regionCode: 156330205,
name: '江北区',
adcode: '156330205'
}, {
id: 830,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '北仑区',
regionCode: 156330206,
name: '北仑区',
adcode: '156330206'
}, {
id: 831,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '镇海区',
regionCode: 156330211,
name: '镇海区',
adcode: '156330211'
}, {
id: 832,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '鄞州区',
regionCode: 156330212,
name: '鄞州区',
adcode: '156330212'
}, {
id: 833,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '奉化区',
regionCode: 156330213,
name: '奉化区',
adcode: '156330213'
}, {
id: 834,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '象山县',
regionCode: 156330225,
name: '象山县',
adcode: '156330225'
}, {
id: 835,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '宁海县',
regionCode: 156330226,
name: '宁海县',
adcode: '156330226'
}, {
id: 836,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '余姚市',
regionCode: 156330281,
name: '余姚市',
adcode: '156330281'
}, {
id: 837,
province: '浙江省',
provinceCode: 156330000,
city: '宁波市',
cityCode: 156330200,
region: '慈溪市',
regionCode: 156330282,
name: '慈溪市',
adcode: '156330282'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
adcode: '156330300',
name: '温州市',
cityCode: 156330300,
children: [{
id: 838,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '鹿城区',
regionCode: 156330302,
name: '鹿城区',
adcode: '156330302'
}, {
id: 839,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '龙湾区',
regionCode: 156330303,
name: '龙湾区',
adcode: '156330303'
}, {
id: 840,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '瓯海区',
regionCode: 156330304,
name: '瓯海区',
adcode: '156330304'
}, {
id: 841,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '洞头区',
regionCode: 156330305,
name: '洞头区',
adcode: '156330305'
}, {
id: 842,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '永嘉县',
regionCode: 156330324,
name: '永嘉县',
adcode: '156330324'
}, {
id: 843,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '平阳县',
regionCode: 156330326,
name: '平阳县',
adcode: '156330326'
}, {
id: 844,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '苍南县',
regionCode: 156330327,
name: '苍南县',
adcode: '156330327'
}, {
id: 845,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '文成县',
regionCode: 156330328,
name: '文成县',
adcode: '156330328'
}, {
id: 846,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '泰顺县',
regionCode: 156330329,
name: '泰顺县',
adcode: '156330329'
}, {
id: 847,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '瑞安市',
regionCode: 156330381,
name: '瑞安市',
adcode: '156330381'
}, {
id: 848,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '乐清市',
regionCode: 156330382,
name: '乐清市',
adcode: '156330382'
}, {
id: 849,
province: '浙江省',
provinceCode: 156330000,
city: '温州市',
cityCode: 156330300,
region: '龙港市',
regionCode: 156330383,
name: '龙港市',
adcode: '156330383'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
adcode: '156330400',
name: '嘉兴市',
cityCode: 156330400,
children: [{
id: 850,
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
cityCode: 156330400,
region: '南湖区',
regionCode: 156330402,
name: '南湖区',
adcode: '156330402'
}, {
id: 851,
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
cityCode: 156330400,
region: '秀洲区',
regionCode: 156330411,
name: '秀洲区',
adcode: '156330411'
}, {
id: 852,
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
cityCode: 156330400,
region: '嘉善县',
regionCode: 156330421,
name: '嘉善县',
adcode: '156330421'
}, {
id: 853,
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
cityCode: 156330400,
region: '海盐县',
regionCode: 156330424,
name: '海盐县',
adcode: '156330424'
}, {
id: 854,
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
cityCode: 156330400,
region: '海宁市',
regionCode: 156330481,
name: '海宁市',
adcode: '156330481'
}, {
id: 855,
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
cityCode: 156330400,
region: '平湖市',
regionCode: 156330482,
name: '平湖市',
adcode: '156330482'
}, {
id: 856,
province: '浙江省',
provinceCode: 156330000,
city: '嘉兴市',
cityCode: 156330400,
region: '桐乡市',
regionCode: 156330483,
name: '桐乡市',
adcode: '156330483'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '湖州市',
adcode: '156330500',
name: '湖州市',
cityCode: 156330500,
children: [{
id: 857,
province: '浙江省',
provinceCode: 156330000,
city: '湖州市',
cityCode: 156330500,
region: '吴兴区',
regionCode: 156330502,
name: '吴兴区',
adcode: '156330502'
}, {
id: 858,
province: '浙江省',
provinceCode: 156330000,
city: '湖州市',
cityCode: 156330500,
region: '南浔区',
regionCode: 156330503,
name: '南浔区',
adcode: '156330503'
}, {
id: 859,
province: '浙江省',
provinceCode: 156330000,
city: '湖州市',
cityCode: 156330500,
region: '德清县',
regionCode: 156330521,
name: '德清县',
adcode: '156330521'
}, {
id: 860,
province: '浙江省',
provinceCode: 156330000,
city: '湖州市',
cityCode: 156330500,
region: '长兴县',
regionCode: 156330522,
name: '长兴县',
adcode: '156330522'
}, {
id: 861,
province: '浙江省',
provinceCode: 156330000,
city: '湖州市',
cityCode: 156330500,
region: '安吉县',
regionCode: 156330523,
name: '安吉县',
adcode: '156330523'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '绍兴市',
adcode: '156330600',
name: '绍兴市',
cityCode: 156330600,
children: [{
id: 862,
province: '浙江省',
provinceCode: 156330000,
city: '绍兴市',
cityCode: 156330600,
region: '越城区',
regionCode: 156330602,
name: '越城区',
adcode: '156330602'
}, {
id: 863,
province: '浙江省',
provinceCode: 156330000,
city: '绍兴市',
cityCode: 156330600,
region: '柯桥区',
regionCode: 156330603,
name: '柯桥区',
adcode: '156330603'
}, {
id: 864,
province: '浙江省',
provinceCode: 156330000,
city: '绍兴市',
cityCode: 156330600,
region: '上虞区',
regionCode: 156330604,
name: '上虞区',
adcode: '156330604'
}, {
id: 865,
province: '浙江省',
provinceCode: 156330000,
city: '绍兴市',
cityCode: 156330600,
region: '新昌县',
regionCode: 156330624,
name: '新昌县',
adcode: '156330624'
}, {
id: 866,
province: '浙江省',
provinceCode: 156330000,
city: '绍兴市',
cityCode: 156330600,
region: '诸暨市',
regionCode: 156330681,
name: '诸暨市',
adcode: '156330681'
}, {
id: 867,
province: '浙江省',
provinceCode: 156330000,
city: '绍兴市',
cityCode: 156330600,
region: '嵊州市',
regionCode: 156330683,
name: '嵊州市',
adcode: '156330683'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
adcode: '156330700',
name: '金华市',
cityCode: 156330700,
children: [{
id: 868,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '婺城区',
regionCode: 156330702,
name: '婺城区',
adcode: '156330702'
}, {
id: 869,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '金东区',
regionCode: 156330703,
name: '金东区',
adcode: '156330703'
}, {
id: 870,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '武义县',
regionCode: 156330723,
name: '武义县',
adcode: '156330723'
}, {
id: 871,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '浦江县',
regionCode: 156330726,
name: '浦江县',
adcode: '156330726'
}, {
id: 872,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '磐安县',
regionCode: 156330727,
name: '磐安县',
adcode: '156330727'
}, {
id: 873,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '兰溪市',
regionCode: 156330781,
name: '兰溪市',
adcode: '156330781'
}, {
id: 874,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '义乌市',
regionCode: 156330782,
name: '义乌市',
adcode: '156330782'
}, {
id: 875,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '东阳市',
regionCode: 156330783,
name: '东阳市',
adcode: '156330783'
}, {
id: 876,
province: '浙江省',
provinceCode: 156330000,
city: '金华市',
cityCode: 156330700,
region: '永康市',
regionCode: 156330784,
name: '永康市',
adcode: '156330784'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '衢州市',
adcode: '156330800',
name: '衢州市',
cityCode: 156330800,
children: [{
id: 877,
province: '浙江省',
provinceCode: 156330000,
city: '衢州市',
cityCode: 156330800,
region: '柯城区',
regionCode: 156330802,
name: '柯城区',
adcode: '156330802'
}, {
id: 878,
province: '浙江省',
provinceCode: 156330000,
city: '衢州市',
cityCode: 156330800,
region: '衢江区',
regionCode: 156330803,
name: '衢江区',
adcode: '156330803'
}, {
id: 879,
province: '浙江省',
provinceCode: 156330000,
city: '衢州市',
cityCode: 156330800,
region: '常山县',
regionCode: 156330822,
name: '常山县',
adcode: '156330822'
}, {
id: 880,
province: '浙江省',
provinceCode: 156330000,
city: '衢州市',
cityCode: 156330800,
region: '开化县',
regionCode: 156330824,
name: '开化县',
adcode: '156330824'
}, {
id: 881,
province: '浙江省',
provinceCode: 156330000,
city: '衢州市',
cityCode: 156330800,
region: '龙游县',
regionCode: 156330825,
name: '龙游县',
adcode: '156330825'
}, {
id: 882,
province: '浙江省',
provinceCode: 156330000,
city: '衢州市',
cityCode: 156330800,
region: '江山市',
regionCode: 156330881,
name: '江山市',
adcode: '156330881'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '舟山市',
adcode: '156330900',
name: '舟山市',
cityCode: 156330900,
children: [{
id: 883,
province: '浙江省',
provinceCode: 156330000,
city: '舟山市',
cityCode: 156330900,
region: '定海区',
regionCode: 156330902,
name: '定海区',
adcode: '156330902'
}, {
id: 884,
province: '浙江省',
provinceCode: 156330000,
city: '舟山市',
cityCode: 156330900,
region: '普陀区',
regionCode: 156330903,
name: '普陀区',
adcode: '156330903'
}, {
id: 885,
province: '浙江省',
provinceCode: 156330000,
city: '舟山市',
cityCode: 156330900,
region: '岱山县',
regionCode: 156330921,
name: '岱山县',
adcode: '156330921'
}, {
id: 886,
province: '浙江省',
provinceCode: 156330000,
city: '舟山市',
cityCode: 156330900,
region: '嵊泗县',
regionCode: 156330922,
name: '嵊泗县',
adcode: '156330922'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
adcode: '156331000',
name: '台州市',
cityCode: 156331000,
children: [{
id: 887,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '椒江区',
regionCode: 156331002,
name: '椒江区',
adcode: '156331002'
}, {
id: 888,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '黄岩区',
regionCode: 156331003,
name: '黄岩区',
adcode: '156331003'
}, {
id: 889,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '路桥区',
regionCode: 156331004,
name: '路桥区',
adcode: '156331004'
}, {
id: 890,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '三门县',
regionCode: 156331022,
name: '三门县',
adcode: '156331022'
}, {
id: 891,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '天台县',
regionCode: 156331023,
name: '天台县',
adcode: '156331023'
}, {
id: 892,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '仙居县',
regionCode: 156331024,
name: '仙居县',
adcode: '156331024'
}, {
id: 893,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '温岭市',
regionCode: 156331081,
name: '温岭市',
adcode: '156331081'
}, {
id: 894,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '临海市',
regionCode: 156331082,
name: '临海市',
adcode: '156331082'
}, {
id: 895,
province: '浙江省',
provinceCode: 156330000,
city: '台州市',
cityCode: 156331000,
region: '玉环市',
regionCode: 156331083,
name: '玉环市',
adcode: '156331083'
}]
}, {
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
adcode: '156331100',
name: '丽水市',
cityCode: 156331100,
children: [{
id: 896,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '莲都区',
regionCode: 156331102,
name: '莲都区',
adcode: '156331102'
}, {
id: 897,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '青田县',
regionCode: 156331121,
name: '青田县',
adcode: '156331121'
}, {
id: 898,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '缙云县',
regionCode: 156331122,
name: '缙云县',
adcode: '156331122'
}, {
id: 899,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '遂昌县',
regionCode: 156331123,
name: '遂昌县',
adcode: '156331123'
}, {
id: 900,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '松阳县',
regionCode: 156331124,
name: '松阳县',
adcode: '156331124'
}, {
id: 901,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '云和县',
regionCode: 156331125,
name: '云和县',
adcode: '156331125'
}, {
id: 902,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '庆元县',
regionCode: 156331126,
name: '庆元县',
adcode: '156331126'
}, {
id: 903,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '景宁畲族自治县',
regionCode: 156331127,
name: '景宁畲族自治县',
adcode: '156331127'
}, {
id: 904,
province: '浙江省',
provinceCode: 156330000,
city: '丽水市',
cityCode: 156331100,
region: '龙泉市',
regionCode: 156331181,
name: '龙泉市',
adcode: '156331181'
}]
}]
}, {
province: '安徽省',
provinceCode: 156340000,
adcode: '156340000',
name: '安徽省',
children: [{
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
adcode: '156340100',
name: '合肥市',
cityCode: 156340100,
children: [{
id: 905,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '瑶海区',
regionCode: 156340102,
name: '瑶海区',
adcode: '156340102'
}, {
id: 906,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '庐阳区',
regionCode: 156340103,
name: '庐阳区',
adcode: '156340103'
}, {
id: 907,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '蜀山区',
regionCode: 156340104,
name: '蜀山区',
adcode: '156340104'
}, {
id: 908,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '包河区',
regionCode: 156340111,
name: '包河区',
adcode: '156340111'
}, {
id: 909,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '长丰县',
regionCode: 156340121,
name: '长丰县',
adcode: '156340121'
}, {
id: 910,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '肥东县',
regionCode: 156340122,
name: '肥东县',
adcode: '156340122'
}, {
id: 911,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '肥西县',
regionCode: 156340123,
name: '肥西县',
adcode: '156340123'
}, {
id: 912,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '庐江县',
regionCode: 156340124,
name: '庐江县',
adcode: '156340124'
}, {
id: 913,
province: '安徽省',
provinceCode: 156340000,
city: '合肥市',
cityCode: 156340100,
region: '巢湖市',
regionCode: 156340181,
name: '巢湖市',
adcode: '156340181'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
adcode: '156340200',
name: '芜湖市',
cityCode: 156340200,
children: [{
id: 914,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '镜湖区',
regionCode: 156340202,
name: '镜湖区',
adcode: '156340202'
}, {
id: 915,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '弋江区',
regionCode: 156340203,
name: '弋江区',
adcode: '156340203'
}, {
id: 916,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '鸠江区',
regionCode: 156340207,
name: '鸠江区',
adcode: '156340207'
}, {
id: 917,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '三山区',
regionCode: 156340208,
name: '三山区',
adcode: '156340208'
}, {
id: 918,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '芜湖县',
regionCode: 156340221,
name: '芜湖县',
adcode: '156340221'
}, {
id: 919,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '繁昌县',
regionCode: 156340222,
name: '繁昌县',
adcode: '156340222'
}, {
id: 920,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '南陵县',
regionCode: 156340223,
name: '南陵县',
adcode: '156340223'
}, {
id: 921,
province: '安徽省',
provinceCode: 156340000,
city: '芜湖市',
cityCode: 156340200,
region: '无为市',
regionCode: 156340281,
name: '无为市',
adcode: '156340281'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
adcode: '156340300',
name: '蚌埠市',
cityCode: 156340300,
children: [{
id: 922,
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
cityCode: 156340300,
region: '龙子湖区',
regionCode: 156340302,
name: '龙子湖区',
adcode: '156340302'
}, {
id: 923,
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
cityCode: 156340300,
region: '蚌山区',
regionCode: 156340303,
name: '蚌山区',
adcode: '156340303'
}, {
id: 924,
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
cityCode: 156340300,
region: '禹会区',
regionCode: 156340304,
name: '禹会区',
adcode: '156340304'
}, {
id: 925,
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
cityCode: 156340300,
region: '淮上区',
regionCode: 156340311,
name: '淮上区',
adcode: '156340311'
}, {
id: 926,
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
cityCode: 156340300,
region: '怀远县',
regionCode: 156340321,
name: '怀远县',
adcode: '156340321'
}, {
id: 927,
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
cityCode: 156340300,
region: '五河县',
regionCode: 156340322,
name: '五河县',
adcode: '156340322'
}, {
id: 928,
province: '安徽省',
provinceCode: 156340000,
city: '蚌埠市',
cityCode: 156340300,
region: '固镇县',
regionCode: 156340323,
name: '固镇县',
adcode: '156340323'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
adcode: '156340400',
name: '淮南市',
cityCode: 156340400,
children: [{
id: 929,
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
cityCode: 156340400,
region: '大通区',
regionCode: 156340402,
name: '大通区',
adcode: '156340402'
}, {
id: 930,
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
cityCode: 156340400,
region: '田家庵区',
regionCode: 156340403,
name: '田家庵区',
adcode: '156340403'
}, {
id: 931,
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
cityCode: 156340400,
region: '谢家集区',
regionCode: 156340404,
name: '谢家集区',
adcode: '156340404'
}, {
id: 932,
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
cityCode: 156340400,
region: '八公山区',
regionCode: 156340405,
name: '八公山区',
adcode: '156340405'
}, {
id: 933,
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
cityCode: 156340400,
region: '潘集区',
regionCode: 156340406,
name: '潘集区',
adcode: '156340406'
}, {
id: 934,
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
cityCode: 156340400,
region: '凤台县',
regionCode: 156340421,
name: '凤台县',
adcode: '156340421'
}, {
id: 935,
province: '安徽省',
provinceCode: 156340000,
city: '淮南市',
cityCode: 156340400,
region: '寿县',
regionCode: 156340422,
name: '寿县',
adcode: '156340422'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '马鞍山市',
adcode: '156340500',
name: '马鞍山市',
cityCode: 156340500,
children: [{
id: 936,
province: '安徽省',
provinceCode: 156340000,
city: '马鞍山市',
cityCode: 156340500,
region: '花山区',
regionCode: 156340503,
name: '花山区',
adcode: '156340503'
}, {
id: 937,
province: '安徽省',
provinceCode: 156340000,
city: '马鞍山市',
cityCode: 156340500,
region: '雨山区',
regionCode: 156340504,
name: '雨山区',
adcode: '156340504'
}, {
id: 938,
province: '安徽省',
provinceCode: 156340000,
city: '马鞍山市',
cityCode: 156340500,
region: '博望区',
regionCode: 156340506,
name: '博望区',
adcode: '156340506'
}, {
id: 939,
province: '安徽省',
provinceCode: 156340000,
city: '马鞍山市',
cityCode: 156340500,
region: '当涂县',
regionCode: 156340521,
name: '当涂县',
adcode: '156340521'
}, {
id: 940,
province: '安徽省',
provinceCode: 156340000,
city: '马鞍山市',
cityCode: 156340500,
region: '含山县',
regionCode: 156340522,
name: '含山县',
adcode: '156340522'
}, {
id: 941,
province: '安徽省',
provinceCode: 156340000,
city: '马鞍山市',
cityCode: 156340500,
region: '和县',
regionCode: 156340523,
name: '和县',
adcode: '156340523'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '淮北市',
adcode: '156340600',
name: '淮北市',
cityCode: 156340600,
children: [{
id: 942,
province: '安徽省',
provinceCode: 156340000,
city: '淮北市',
cityCode: 156340600,
region: '杜集区',
regionCode: 156340602,
name: '杜集区',
adcode: '156340602'
}, {
id: 943,
province: '安徽省',
provinceCode: 156340000,
city: '淮北市',
cityCode: 156340600,
region: '相山区',
regionCode: 156340603,
name: '相山区',
adcode: '156340603'
}, {
id: 944,
province: '安徽省',
provinceCode: 156340000,
city: '淮北市',
cityCode: 156340600,
region: '烈山区',
regionCode: 156340604,
name: '烈山区',
adcode: '156340604'
}, {
id: 945,
province: '安徽省',
provinceCode: 156340000,
city: '淮北市',
cityCode: 156340600,
region: '濉溪县',
regionCode: 156340621,
name: '濉溪县',
adcode: '156340621'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '铜陵市',
adcode: '156340700',
name: '铜陵市',
cityCode: 156340700,
children: [{
id: 946,
province: '安徽省',
provinceCode: 156340000,
city: '铜陵市',
cityCode: 156340700,
region: '铜官区',
regionCode: 156340705,
name: '铜官区',
adcode: '156340705'
}, {
id: 947,
province: '安徽省',
provinceCode: 156340000,
city: '铜陵市',
cityCode: 156340700,
region: '义安区',
regionCode: 156340706,
name: '义安区',
adcode: '156340706'
}, {
id: 948,
province: '安徽省',
provinceCode: 156340000,
city: '铜陵市',
cityCode: 156340700,
region: '郊区',
regionCode: 156340711,
name: '郊区',
adcode: '156340711'
}, {
id: 949,
province: '安徽省',
provinceCode: 156340000,
city: '铜陵市',
cityCode: 156340700,
region: '枞阳县',
regionCode: 156340722,
name: '枞阳县',
adcode: '156340722'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
adcode: '156340800',
name: '安庆市',
cityCode: 156340800,
children: [{
id: 950,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '迎江区',
regionCode: 156340802,
name: '迎江区',
adcode: '156340802'
}, {
id: 951,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '大观区',
regionCode: 156340803,
name: '大观区',
adcode: '156340803'
}, {
id: 952,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '宜秀区',
regionCode: 156340811,
name: '宜秀区',
adcode: '156340811'
}, {
id: 953,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '怀宁县',
regionCode: 156340822,
name: '怀宁县',
adcode: '156340822'
}, {
id: 954,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '太湖县',
regionCode: 156340825,
name: '太湖县',
adcode: '156340825'
}, {
id: 955,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '宿松县',
regionCode: 156340826,
name: '宿松县',
adcode: '156340826'
}, {
id: 956,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '望江县',
regionCode: 156340827,
name: '望江县',
adcode: '156340827'
}, {
id: 957,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '岳西县',
regionCode: 156340828,
name: '岳西县',
adcode: '156340828'
}, {
id: 958,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '桐城市',
regionCode: 156340881,
name: '桐城市',
adcode: '156340881'
}, {
id: 959,
province: '安徽省',
provinceCode: 156340000,
city: '安庆市',
cityCode: 156340800,
region: '潜山市',
regionCode: 156340882,
name: '潜山市',
adcode: '156340882'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
adcode: '156341000',
name: '黄山市',
cityCode: 156341000,
children: [{
id: 960,
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
cityCode: 156341000,
region: '屯溪区',
regionCode: 156341002,
name: '屯溪区',
adcode: '156341002'
}, {
id: 961,
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
cityCode: 156341000,
region: '黄山区',
regionCode: 156341003,
name: '黄山区',
adcode: '156341003'
}, {
id: 962,
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
cityCode: 156341000,
region: '徽州区',
regionCode: 156341004,
name: '徽州区',
adcode: '156341004'
}, {
id: 963,
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
cityCode: 156341000,
region: '歙县',
regionCode: 156341021,
name: '歙县',
adcode: '156341021'
}, {
id: 964,
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
cityCode: 156341000,
region: '休宁县',
regionCode: 156341022,
name: '休宁县',
adcode: '156341022'
}, {
id: 965,
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
cityCode: 156341000,
region: '黟县',
regionCode: 156341023,
name: '黟县',
adcode: '156341023'
}, {
id: 966,
province: '安徽省',
provinceCode: 156340000,
city: '黄山市',
cityCode: 156341000,
region: '祁门县',
regionCode: 156341024,
name: '祁门县',
adcode: '156341024'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
adcode: '156341100',
name: '滁州市',
cityCode: 156341100,
children: [{
id: 967,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '琅琊区',
regionCode: 156341102,
name: '琅琊区',
adcode: '156341102'
}, {
id: 968,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '南谯区',
regionCode: 156341103,
name: '南谯区',
adcode: '156341103'
}, {
id: 969,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '来安县',
regionCode: 156341122,
name: '来安县',
adcode: '156341122'
}, {
id: 970,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '全椒县',
regionCode: 156341124,
name: '全椒县',
adcode: '156341124'
}, {
id: 971,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '定远县',
regionCode: 156341125,
name: '定远县',
adcode: '156341125'
}, {
id: 972,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '凤阳县',
regionCode: 156341126,
name: '凤阳县',
adcode: '156341126'
}, {
id: 973,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '天长市',
regionCode: 156341181,
name: '天长市',
adcode: '156341181'
}, {
id: 974,
province: '安徽省',
provinceCode: 156340000,
city: '滁州市',
cityCode: 156341100,
region: '明光市',
regionCode: 156341182,
name: '明光市',
adcode: '156341182'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
adcode: '156341200',
name: '阜阳市',
cityCode: 156341200,
children: [{
id: 975,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '颍州区',
regionCode: 156341202,
name: '颍州区',
adcode: '156341202'
}, {
id: 976,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '颍东区',
regionCode: 156341203,
name: '颍东区',
adcode: '156341203'
}, {
id: 977,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '颍泉区',
regionCode: 156341204,
name: '颍泉区',
adcode: '156341204'
}, {
id: 978,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '临泉县',
regionCode: 156341221,
name: '临泉县',
adcode: '156341221'
}, {
id: 979,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '太和县',
regionCode: 156341222,
name: '太和县',
adcode: '156341222'
}, {
id: 980,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '阜南县',
regionCode: 156341225,
name: '阜南县',
adcode: '156341225'
}, {
id: 981,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '颍上县',
regionCode: 156341226,
name: '颍上县',
adcode: '156341226'
}, {
id: 982,
province: '安徽省',
provinceCode: 156340000,
city: '阜阳市',
cityCode: 156341200,
region: '界首市',
regionCode: 156341282,
name: '界首市',
adcode: '156341282'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '宿州市',
adcode: '156341300',
name: '宿州市',
cityCode: 156341300,
children: [{
id: 983,
province: '安徽省',
provinceCode: 156340000,
city: '宿州市',
cityCode: 156341300,
region: '埇桥区',
regionCode: 156341302,
name: '埇桥区',
adcode: '156341302'
}, {
id: 984,
province: '安徽省',
provinceCode: 156340000,
city: '宿州市',
cityCode: 156341300,
region: '砀山县',
regionCode: 156341321,
name: '砀山县',
adcode: '156341321'
}, {
id: 985,
province: '安徽省',
provinceCode: 156340000,
city: '宿州市',
cityCode: 156341300,
region: '萧县',
regionCode: 156341322,
name: '萧县',
adcode: '156341322'
}, {
id: 986,
province: '安徽省',
provinceCode: 156340000,
city: '宿州市',
cityCode: 156341300,
region: '灵璧县',
regionCode: 156341323,
name: '灵璧县',
adcode: '156341323'
}, {
id: 987,
province: '安徽省',
provinceCode: 156340000,
city: '宿州市',
cityCode: 156341300,
region: '泗县',
regionCode: 156341324,
name: '泗县',
adcode: '156341324'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
adcode: '156341500',
name: '六安市',
cityCode: 156341500,
children: [{
id: 988,
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
cityCode: 156341500,
region: '金安区',
regionCode: 156341502,
name: '金安区',
adcode: '156341502'
}, {
id: 989,
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
cityCode: 156341500,
region: '裕安区',
regionCode: 156341503,
name: '裕安区',
adcode: '156341503'
}, {
id: 990,
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
cityCode: 156341500,
region: '叶集区',
regionCode: 156341504,
name: '叶集区',
adcode: '156341504'
}, {
id: 991,
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
cityCode: 156341500,
region: '霍邱县',
regionCode: 156341522,
name: '霍邱县',
adcode: '156341522'
}, {
id: 992,
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
cityCode: 156341500,
region: '舒城县',
regionCode: 156341523,
name: '舒城县',
adcode: '156341523'
}, {
id: 993,
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
cityCode: 156341500,
region: '金寨县',
regionCode: 156341524,
name: '金寨县',
adcode: '156341524'
}, {
id: 994,
province: '安徽省',
provinceCode: 156340000,
city: '六安市',
cityCode: 156341500,
region: '霍山县',
regionCode: 156341525,
name: '霍山县',
adcode: '156341525'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '亳州市',
adcode: '156341600',
name: '亳州市',
cityCode: 156341600,
children: [{
id: 995,
province: '安徽省',
provinceCode: 156340000,
city: '亳州市',
cityCode: 156341600,
region: '谯城区',
regionCode: 156341602,
name: '谯城区',
adcode: '156341602'
}, {
id: 996,
province: '安徽省',
provinceCode: 156340000,
city: '亳州市',
cityCode: 156341600,
region: '涡阳县',
regionCode: 156341621,
name: '涡阳县',
adcode: '156341621'
}, {
id: 997,
province: '安徽省',
provinceCode: 156340000,
city: '亳州市',
cityCode: 156341600,
region: '蒙城县',
regionCode: 156341622,
name: '蒙城县',
adcode: '156341622'
}, {
id: 998,
province: '安徽省',
provinceCode: 156340000,
city: '亳州市',
cityCode: 156341600,
region: '利辛县',
regionCode: 156341623,
name: '利辛县',
adcode: '156341623'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '池州市',
adcode: '156341700',
name: '池州市',
cityCode: 156341700,
children: [{
id: 999,
province: '安徽省',
provinceCode: 156340000,
city: '池州市',
cityCode: 156341700,
region: '贵池区',
regionCode: 156341702,
name: '贵池区',
adcode: '156341702'
}, {
id: 1000,
province: '安徽省',
provinceCode: 156340000,
city: '池州市',
cityCode: 156341700,
region: '东至县',
regionCode: 156341721,
name: '东至县',
adcode: '156341721'
}, {
id: 1001,
province: '安徽省',
provinceCode: 156340000,
city: '池州市',
cityCode: 156341700,
region: '石台县',
regionCode: 156341722,
name: '石台县',
adcode: '156341722'
}, {
id: 1002,
province: '安徽省',
provinceCode: 156340000,
city: '池州市',
cityCode: 156341700,
region: '青阳县',
regionCode: 156341723,
name: '青阳县',
adcode: '156341723'
}]
}, {
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
adcode: '156341800',
name: '宣城市',
cityCode: 156341800,
children: [{
id: 1003,
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
cityCode: 156341800,
region: '宣州区',
regionCode: 156341802,
name: '宣州区',
adcode: '156341802'
}, {
id: 1004,
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
cityCode: 156341800,
region: '郎溪县',
regionCode: 156341821,
name: '郎溪县',
adcode: '156341821'
}, {
id: 1005,
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
cityCode: 156341800,
region: '泾县',
regionCode: 156341823,
name: '泾县',
adcode: '156341823'
}, {
id: 1006,
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
cityCode: 156341800,
region: '绩溪县',
regionCode: 156341824,
name: '绩溪县',
adcode: '156341824'
}, {
id: 1007,
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
cityCode: 156341800,
region: '旌德县',
regionCode: 156341825,
name: '旌德县',
adcode: '156341825'
}, {
id: 1008,
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
cityCode: 156341800,
region: '宁国市',
regionCode: 156341881,
name: '宁国市',
adcode: '156341881'
}, {
id: 1009,
province: '安徽省',
provinceCode: 156340000,
city: '宣城市',
cityCode: 156341800,
region: '广德市',
regionCode: 156341882,
name: '广德市',
adcode: '156341882'
}]
}]
}, {
province: '福建省',
provinceCode: 156350000,
adcode: '156350000',
name: '福建省',
children: [{
province: '福建省',
provinceCode: 156350000,
city: '福州市',
adcode: '156350100',
name: '福州市',
cityCode: 156350100,
children: [{
id: 1010,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '鼓楼区',
regionCode: 156350102,
name: '鼓楼区',
adcode: '156350102'
}, {
id: 1011,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '台江区',
regionCode: 156350103,
name: '台江区',
adcode: '156350103'
}, {
id: 1012,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '仓山区',
regionCode: 156350104,
name: '仓山区',
adcode: '156350104'
}, {
id: 1013,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '马尾区',
regionCode: 156350105,
name: '马尾区',
adcode: '156350105'
}, {
id: 1014,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '晋安区',
regionCode: 156350111,
name: '晋安区',
adcode: '156350111'
}, {
id: 1015,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '长乐区',
regionCode: 156350112,
name: '长乐区',
adcode: '156350112'
}, {
id: 1016,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '闽侯县',
regionCode: 156350121,
name: '闽侯县',
adcode: '156350121'
}, {
id: 1017,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '连江县',
regionCode: 156350122,
name: '连江县',
adcode: '156350122'
}, {
id: 1018,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '罗源县',
regionCode: 156350123,
name: '罗源县',
adcode: '156350123'
}, {
id: 1019,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '闽清县',
regionCode: 156350124,
name: '闽清县',
adcode: '156350124'
}, {
id: 1020,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '永泰县',
regionCode: 156350125,
name: '永泰县',
adcode: '156350125'
}, {
id: 1021,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '平潭县',
regionCode: 156350128,
name: '平潭县',
adcode: '156350128'
}, {
id: 1022,
province: '福建省',
provinceCode: 156350000,
city: '福州市',
cityCode: 156350100,
region: '福清市',
regionCode: 156350181,
name: '福清市',
adcode: '156350181'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '厦门市',
adcode: '156350200',
name: '厦门市',
cityCode: 156350200,
children: [{
id: 1023,
province: '福建省',
provinceCode: 156350000,
city: '厦门市',
cityCode: 156350200,
region: '思明区',
regionCode: 156350203,
name: '思明区',
adcode: '156350203'
}, {
id: 1024,
province: '福建省',
provinceCode: 156350000,
city: '厦门市',
cityCode: 156350200,
region: '海沧区',
regionCode: 156350205,
name: '海沧区',
adcode: '156350205'
}, {
id: 1025,
province: '福建省',
provinceCode: 156350000,
city: '厦门市',
cityCode: 156350200,
region: '湖里区',
regionCode: 156350206,
name: '湖里区',
adcode: '156350206'
}, {
id: 1026,
province: '福建省',
provinceCode: 156350000,
city: '厦门市',
cityCode: 156350200,
region: '集美区',
regionCode: 156350211,
name: '集美区',
adcode: '156350211'
}, {
id: 1027,
province: '福建省',
provinceCode: 156350000,
city: '厦门市',
cityCode: 156350200,
region: '同安区',
regionCode: 156350212,
name: '同安区',
adcode: '156350212'
}, {
id: 1028,
province: '福建省',
provinceCode: 156350000,
city: '厦门市',
cityCode: 156350200,
region: '翔安区',
regionCode: 156350213,
name: '翔安区',
adcode: '156350213'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '莆田市',
adcode: '156350300',
name: '莆田市',
cityCode: 156350300,
children: [{
id: 1029,
province: '福建省',
provinceCode: 156350000,
city: '莆田市',
cityCode: 156350300,
region: '城厢区',
regionCode: 156350302,
name: '城厢区',
adcode: '156350302'
}, {
id: 1030,
province: '福建省',
provinceCode: 156350000,
city: '莆田市',
cityCode: 156350300,
region: '涵江区',
regionCode: 156350303,
name: '涵江区',
adcode: '156350303'
}, {
id: 1031,
province: '福建省',
provinceCode: 156350000,
city: '莆田市',
cityCode: 156350300,
region: '荔城区',
regionCode: 156350304,
name: '荔城区',
adcode: '156350304'
}, {
id: 1032,
province: '福建省',
provinceCode: 156350000,
city: '莆田市',
cityCode: 156350300,
region: '秀屿区',
regionCode: 156350305,
name: '秀屿区',
adcode: '156350305'
}, {
id: 1033,
province: '福建省',
provinceCode: 156350000,
city: '莆田市',
cityCode: 156350300,
region: '仙游县',
regionCode: 156350322,
name: '仙游县',
adcode: '156350322'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '三明市',
adcode: '156350400',
name: '三明市',
cityCode: 156350400,
children: [{
id: 1034,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '梅列区',
regionCode: 156350402,
name: '梅列区',
adcode: '156350402'
}, {
id: 1035,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '三元区',
regionCode: 156350403,
name: '三元区',
adcode: '156350403'
}, {
id: 1036,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '明溪县',
regionCode: 156350421,
name: '明溪县',
adcode: '156350421'
}, {
id: 1037,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '清流县',
regionCode: 156350423,
name: '清流县',
adcode: '156350423'
}, {
id: 1038,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '宁化县',
regionCode: 156350424,
name: '宁化县',
adcode: '156350424'
}, {
id: 1039,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '大田县',
regionCode: 156350425,
name: '大田县',
adcode: '156350425'
}, {
id: 1040,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '尤溪县',
regionCode: 156350426,
name: '尤溪县',
adcode: '156350426'
}, {
id: 1041,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '沙县',
regionCode: 156350427,
name: '沙县',
adcode: '156350427'
}, {
id: 1042,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '将乐县',
regionCode: 156350428,
name: '将乐县',
adcode: '156350428'
}, {
id: 1043,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '泰宁县',
regionCode: 156350429,
name: '泰宁县',
adcode: '156350429'
}, {
id: 1044,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '建宁县',
regionCode: 156350430,
name: '建宁县',
adcode: '156350430'
}, {
id: 1045,
province: '福建省',
provinceCode: 156350000,
city: '三明市',
cityCode: 156350400,
region: '永安市',
regionCode: 156350481,
name: '永安市',
adcode: '156350481'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
adcode: '156350500',
name: '泉州市',
cityCode: 156350500,
children: [{
id: 1046,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '鲤城区',
regionCode: 156350502,
name: '鲤城区',
adcode: '156350502'
}, {
id: 1047,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '丰泽区',
regionCode: 156350503,
name: '丰泽区',
adcode: '156350503'
}, {
id: 1048,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '洛江区',
regionCode: 156350504,
name: '洛江区',
adcode: '156350504'
}, {
id: 1049,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '泉港区',
regionCode: 156350505,
name: '泉港区',
adcode: '156350505'
}, {
id: 1050,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '惠安县',
regionCode: 156350521,
name: '惠安县',
adcode: '156350521'
}, {
id: 1051,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '安溪县',
regionCode: 156350524,
name: '安溪县',
adcode: '156350524'
}, {
id: 1052,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '永春县',
regionCode: 156350525,
name: '永春县',
adcode: '156350525'
}, {
id: 1053,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '德化县',
regionCode: 156350526,
name: '德化县',
adcode: '156350526'
}, {
id: 1054,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '金门县',
regionCode: 156350527,
name: '金门县',
adcode: '156350527'
}, {
id: 1055,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '石狮市',
regionCode: 156350581,
name: '石狮市',
adcode: '156350581'
}, {
id: 1056,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '晋江市',
regionCode: 156350582,
name: '晋江市',
adcode: '156350582'
}, {
id: 1057,
province: '福建省',
provinceCode: 156350000,
city: '泉州市',
cityCode: 156350500,
region: '南安市',
regionCode: 156350583,
name: '南安市',
adcode: '156350583'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
adcode: '156350600',
name: '漳州市',
cityCode: 156350600,
children: [{
id: 1058,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '芗城区',
regionCode: 156350602,
name: '芗城区',
adcode: '156350602'
}, {
id: 1059,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '龙文区',
regionCode: 156350603,
name: '龙文区',
adcode: '156350603'
}, {
id: 1060,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '云霄县',
regionCode: 156350622,
name: '云霄县',
adcode: '156350622'
}, {
id: 1061,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '漳浦县',
regionCode: 156350623,
name: '漳浦县',
adcode: '156350623'
}, {
id: 1062,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '诏安县',
regionCode: 156350624,
name: '诏安县',
adcode: '156350624'
}, {
id: 1063,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '长泰县',
regionCode: 156350625,
name: '长泰县',
adcode: '156350625'
}, {
id: 1064,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '东山县',
regionCode: 156350626,
name: '东山县',
adcode: '156350626'
}, {
id: 1065,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '南靖县',
regionCode: 156350627,
name: '南靖县',
adcode: '156350627'
}, {
id: 1066,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '平和县',
regionCode: 156350628,
name: '平和县',
adcode: '156350628'
}, {
id: 1067,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '华安县',
regionCode: 156350629,
name: '华安县',
adcode: '156350629'
}, {
id: 1068,
province: '福建省',
provinceCode: 156350000,
city: '漳州市',
cityCode: 156350600,
region: '龙海市',
regionCode: 156350681,
name: '龙海市',
adcode: '156350681'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '南平市',
adcode: '156350700',
name: '南平市',
cityCode: 156350700,
children: [{
id: 1069,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '延平区',
regionCode: 156350702,
name: '延平区',
adcode: '156350702'
}, {
id: 1070,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '建阳区',
regionCode: 156350703,
name: '建阳区',
adcode: '156350703'
}, {
id: 1071,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '顺昌县',
regionCode: 156350721,
name: '顺昌县',
adcode: '156350721'
}, {
id: 1072,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '浦城县',
regionCode: 156350722,
name: '浦城县',
adcode: '156350722'
}, {
id: 1073,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '光泽县',
regionCode: 156350723,
name: '光泽县',
adcode: '156350723'
}, {
id: 1074,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '松溪县',
regionCode: 156350724,
name: '松溪县',
adcode: '156350724'
}, {
id: 1075,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '政和县',
regionCode: 156350725,
name: '政和县',
adcode: '156350725'
}, {
id: 1076,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '邵武市',
regionCode: 156350781,
name: '邵武市',
adcode: '156350781'
}, {
id: 1077,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '武夷山市',
regionCode: 156350782,
name: '武夷山市',
adcode: '156350782'
}, {
id: 1078,
province: '福建省',
provinceCode: 156350000,
city: '南平市',
cityCode: 156350700,
region: '建瓯市',
regionCode: 156350783,
name: '建瓯市',
adcode: '156350783'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
adcode: '156350800',
name: '龙岩市',
cityCode: 156350800,
children: [{
id: 1079,
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
cityCode: 156350800,
region: '新罗区',
regionCode: 156350802,
name: '新罗区',
adcode: '156350802'
}, {
id: 1080,
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
cityCode: 156350800,
region: '永定区',
regionCode: 156350803,
name: '永定区',
adcode: '156350803'
}, {
id: 1081,
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
cityCode: 156350800,
region: '长汀县',
regionCode: 156350821,
name: '长汀县',
adcode: '156350821'
}, {
id: 1082,
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
cityCode: 156350800,
region: '上杭县',
regionCode: 156350823,
name: '上杭县',
adcode: '156350823'
}, {
id: 1083,
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
cityCode: 156350800,
region: '武平县',
regionCode: 156350824,
name: '武平县',
adcode: '156350824'
}, {
id: 1084,
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
cityCode: 156350800,
region: '连城县',
regionCode: 156350825,
name: '连城县',
adcode: '156350825'
}, {
id: 1085,
province: '福建省',
provinceCode: 156350000,
city: '龙岩市',
cityCode: 156350800,
region: '漳平市',
regionCode: 156350881,
name: '漳平市',
adcode: '156350881'
}]
}, {
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
adcode: '156350900',
name: '宁德市',
cityCode: 156350900,
children: [{
id: 1086,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '蕉城区',
regionCode: 156350902,
name: '蕉城区',
adcode: '156350902'
}, {
id: 1087,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '霞浦县',
regionCode: 156350921,
name: '霞浦县',
adcode: '156350921'
}, {
id: 1088,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '古田县',
regionCode: 156350922,
name: '古田县',
adcode: '156350922'
}, {
id: 1089,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '屏南县',
regionCode: 156350923,
name: '屏南县',
adcode: '156350923'
}, {
id: 1090,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '寿宁县',
regionCode: 156350924,
name: '寿宁县',
adcode: '156350924'
}, {
id: 1091,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '周宁县',
regionCode: 156350925,
name: '周宁县',
adcode: '156350925'
}, {
id: 1092,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '柘荣县',
regionCode: 156350926,
name: '柘荣县',
adcode: '156350926'
}, {
id: 1093,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '福安市',
regionCode: 156350981,
name: '福安市',
adcode: '156350981'
}, {
id: 1094,
province: '福建省',
provinceCode: 156350000,
city: '宁德市',
cityCode: 156350900,
region: '福鼎市',
regionCode: 156350982,
name: '福鼎市',
adcode: '156350982'
}]
}]
}, {
province: '江西省',
provinceCode: 156360000,
adcode: '156360000',
name: '江西省',
children: [{
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
adcode: '156360100',
name: '南昌市',
cityCode: 156360100,
children: [{
id: 1095,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '东湖区',
regionCode: 156360102,
name: '东湖区',
adcode: '156360102'
}, {
id: 1096,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '西湖区',
regionCode: 156360103,
name: '西湖区',
adcode: '156360103'
}, {
id: 1097,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '青云谱区',
regionCode: 156360104,
name: '青云谱区',
adcode: '156360104'
}, {
id: 1098,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '青山湖区',
regionCode: 156360111,
name: '青山湖区',
adcode: '156360111'
}, {
id: 1099,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '新建区',
regionCode: 156360112,
name: '新建区',
adcode: '156360112'
}, {
id: 1100,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '红谷滩区',
regionCode: 156360113,
name: '红谷滩区',
adcode: '156360113'
}, {
id: 1101,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '南昌县',
regionCode: 156360121,
name: '南昌县',
adcode: '156360121'
}, {
id: 1102,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '安义县',
regionCode: 156360123,
name: '安义县',
adcode: '156360123'
}, {
id: 1103,
province: '江西省',
provinceCode: 156360000,
city: '南昌市',
cityCode: 156360100,
region: '进贤县',
regionCode: 156360124,
name: '进贤县',
adcode: '156360124'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '景德镇市',
adcode: '156360200',
name: '景德镇市',
cityCode: 156360200,
children: [{
id: 1104,
province: '江西省',
provinceCode: 156360000,
city: '景德镇市',
cityCode: 156360200,
region: '昌江区',
regionCode: 156360202,
name: '昌江区',
adcode: '156360202'
}, {
id: 1105,
province: '江西省',
provinceCode: 156360000,
city: '景德镇市',
cityCode: 156360200,
region: '珠山区',
regionCode: 156360203,
name: '珠山区',
adcode: '156360203'
}, {
id: 1106,
province: '江西省',
provinceCode: 156360000,
city: '景德镇市',
cityCode: 156360200,
region: '浮梁县',
regionCode: 156360222,
name: '浮梁县',
adcode: '156360222'
}, {
id: 1107,
province: '江西省',
provinceCode: 156360000,
city: '景德镇市',
cityCode: 156360200,
region: '乐平市',
regionCode: 156360281,
name: '乐平市',
adcode: '156360281'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '萍乡市',
adcode: '156360300',
name: '萍乡市',
cityCode: 156360300,
children: [{
id: 1108,
province: '江西省',
provinceCode: 156360000,
city: '萍乡市',
cityCode: 156360300,
region: '安源区',
regionCode: 156360302,
name: '安源区',
adcode: '156360302'
}, {
id: 1109,
province: '江西省',
provinceCode: 156360000,
city: '萍乡市',
cityCode: 156360300,
region: '湘东区',
regionCode: 156360313,
name: '湘东区',
adcode: '156360313'
}, {
id: 1110,
province: '江西省',
provinceCode: 156360000,
city: '萍乡市',
cityCode: 156360300,
region: '莲花县',
regionCode: 156360321,
name: '莲花县',
adcode: '156360321'
}, {
id: 1111,
province: '江西省',
provinceCode: 156360000,
city: '萍乡市',
cityCode: 156360300,
region: '上栗县',
regionCode: 156360322,
name: '上栗县',
adcode: '156360322'
}, {
id: 1112,
province: '江西省',
provinceCode: 156360000,
city: '萍乡市',
cityCode: 156360300,
region: '芦溪县',
regionCode: 156360323,
name: '芦溪县',
adcode: '156360323'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '九江市',
adcode: '156360400',
name: '九江市',
cityCode: 156360400,
children: [{
id: 1113,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '濂溪区',
regionCode: 156360402,
name: '濂溪区',
adcode: '156360402'
}, {
id: 1114,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '浔阳区',
regionCode: 156360403,
name: '浔阳区',
adcode: '156360403'
}, {
id: 1115,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '柴桑区',
regionCode: 156360404,
name: '柴桑区',
adcode: '156360404'
}, {
id: 1116,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '武宁县',
regionCode: 156360423,
name: '武宁县',
adcode: '156360423'
}, {
id: 1117,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '修水县',
regionCode: 156360424,
name: '修水县',
adcode: '156360424'
}, {
id: 1118,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '永修县',
regionCode: 156360425,
name: '永修县',
adcode: '156360425'
}, {
id: 1119,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '德安县',
regionCode: 156360426,
name: '德安县',
adcode: '156360426'
}, {
id: 1120,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '都昌县',
regionCode: 156360428,
name: '都昌县',
adcode: '156360428'
}, {
id: 1121,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '湖口县',
regionCode: 156360429,
name: '湖口县',
adcode: '156360429'
}, {
id: 1122,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '彭泽县',
regionCode: 156360430,
name: '彭泽县',
adcode: '156360430'
}, {
id: 1123,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '瑞昌市',
regionCode: 156360481,
name: '瑞昌市',
adcode: '156360481'
}, {
id: 1124,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '共青城市',
regionCode: 156360482,
name: '共青城市',
adcode: '156360482'
}, {
id: 1125,
province: '江西省',
provinceCode: 156360000,
city: '九江市',
cityCode: 156360400,
region: '庐山市',
regionCode: 156360483,
name: '庐山市',
adcode: '156360483'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '新余市',
adcode: '156360500',
name: '新余市',
cityCode: 156360500,
children: [{
id: 1126,
province: '江西省',
provinceCode: 156360000,
city: '新余市',
cityCode: 156360500,
region: '渝水区',
regionCode: 156360502,
name: '渝水区',
adcode: '156360502'
}, {
id: 1127,
province: '江西省',
provinceCode: 156360000,
city: '新余市',
cityCode: 156360500,
region: '分宜县',
regionCode: 156360521,
name: '分宜县',
adcode: '156360521'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '鹰潭市',
adcode: '156360600',
name: '鹰潭市',
cityCode: 156360600,
children: [{
id: 1128,
province: '江西省',
provinceCode: 156360000,
city: '鹰潭市',
cityCode: 156360600,
region: '月湖区',
regionCode: 156360602,
name: '月湖区',
adcode: '156360602'
}, {
id: 1129,
province: '江西省',
provinceCode: 156360000,
city: '鹰潭市',
cityCode: 156360600,
region: '余江区',
regionCode: 156360603,
name: '余江区',
adcode: '156360603'
}, {
id: 1130,
province: '江西省',
provinceCode: 156360000,
city: '鹰潭市',
cityCode: 156360600,
region: '贵溪市',
regionCode: 156360681,
name: '贵溪市',
adcode: '156360681'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
adcode: '156360700',
name: '赣州市',
cityCode: 156360700,
children: [{
id: 1131,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '章贡区',
regionCode: 156360702,
name: '章贡区',
adcode: '156360702'
}, {
id: 1132,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '南康区',
regionCode: 156360703,
name: '南康区',
adcode: '156360703'
}, {
id: 1133,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '赣县区',
regionCode: 156360704,
name: '赣县区',
adcode: '156360704'
}, {
id: 1134,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '信丰县',
regionCode: 156360722,
name: '信丰县',
adcode: '156360722'
}, {
id: 1135,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '大余县',
regionCode: 156360723,
name: '大余县',
adcode: '156360723'
}, {
id: 1136,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '上犹县',
regionCode: 156360724,
name: '上犹县',
adcode: '156360724'
}, {
id: 1137,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '崇义县',
regionCode: 156360725,
name: '崇义县',
adcode: '156360725'
}, {
id: 1138,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '安远县',
regionCode: 156360726,
name: '安远县',
adcode: '156360726'
}, {
id: 1139,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '龙南县',
regionCode: 156360727,
name: '龙南县',
adcode: '156360727'
}, {
id: 1140,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '定南县',
regionCode: 156360728,
name: '定南县',
adcode: '156360728'
}, {
id: 1141,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '全南县',
regionCode: 156360729,
name: '全南县',
adcode: '156360729'
}, {
id: 1142,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '宁都县',
regionCode: 156360730,
name: '宁都县',
adcode: '156360730'
}, {
id: 1143,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '于都县',
regionCode: 156360731,
name: '于都县',
adcode: '156360731'
}, {
id: 1144,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '兴国县',
regionCode: 156360732,
name: '兴国县',
adcode: '156360732'
}, {
id: 1145,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '会昌县',
regionCode: 156360733,
name: '会昌县',
adcode: '156360733'
}, {
id: 1146,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '寻乌县',
regionCode: 156360734,
name: '寻乌县',
adcode: '156360734'
}, {
id: 1147,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '石城县',
regionCode: 156360735,
name: '石城县',
adcode: '156360735'
}, {
id: 1148,
province: '江西省',
provinceCode: 156360000,
city: '赣州市',
cityCode: 156360700,
region: '瑞金市',
regionCode: 156360781,
name: '瑞金市',
adcode: '156360781'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
adcode: '156360800',
name: '吉安市',
cityCode: 156360800,
children: [{
id: 1149,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '吉州区',
regionCode: 156360802,
name: '吉州区',
adcode: '156360802'
}, {
id: 1150,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '青原区',
regionCode: 156360803,
name: '青原区',
adcode: '156360803'
}, {
id: 1151,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '吉安县',
regionCode: 156360821,
name: '吉安县',
adcode: '156360821'
}, {
id: 1152,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '吉水县',
regionCode: 156360822,
name: '吉水县',
adcode: '156360822'
}, {
id: 1153,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '峡江县',
regionCode: 156360823,
name: '峡江县',
adcode: '156360823'
}, {
id: 1154,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '新干县',
regionCode: 156360824,
name: '新干县',
adcode: '156360824'
}, {
id: 1155,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '永丰县',
regionCode: 156360825,
name: '永丰县',
adcode: '156360825'
}, {
id: 1156,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '泰和县',
regionCode: 156360826,
name: '泰和县',
adcode: '156360826'
}, {
id: 1157,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '遂川县',
regionCode: 156360827,
name: '遂川县',
adcode: '156360827'
}, {
id: 1158,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '万安县',
regionCode: 156360828,
name: '万安县',
adcode: '156360828'
}, {
id: 1159,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '安福县',
regionCode: 156360829,
name: '安福县',
adcode: '156360829'
}, {
id: 1160,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '永新县',
regionCode: 156360830,
name: '永新县',
adcode: '156360830'
}, {
id: 1161,
province: '江西省',
provinceCode: 156360000,
city: '吉安市',
cityCode: 156360800,
region: '井冈山市',
regionCode: 156360881,
name: '井冈山市',
adcode: '156360881'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
adcode: '156360900',
name: '宜春市',
cityCode: 156360900,
children: [{
id: 1162,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '袁州区',
regionCode: 156360902,
name: '袁州区',
adcode: '156360902'
}, {
id: 1163,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '奉新县',
regionCode: 156360921,
name: '奉新县',
adcode: '156360921'
}, {
id: 1164,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '万载县',
regionCode: 156360922,
name: '万载县',
adcode: '156360922'
}, {
id: 1165,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '上高县',
regionCode: 156360923,
name: '上高县',
adcode: '156360923'
}, {
id: 1166,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '宜丰县',
regionCode: 156360924,
name: '宜丰县',
adcode: '156360924'
}, {
id: 1167,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '靖安县',
regionCode: 156360925,
name: '靖安县',
adcode: '156360925'
}, {
id: 1168,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '铜鼓县',
regionCode: 156360926,
name: '铜鼓县',
adcode: '156360926'
}, {
id: 1169,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '丰城市',
regionCode: 156360981,
name: '丰城市',
adcode: '156360981'
}, {
id: 1170,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '樟树市',
regionCode: 156360982,
name: '樟树市',
adcode: '156360982'
}, {
id: 1171,
province: '江西省',
provinceCode: 156360000,
city: '宜春市',
cityCode: 156360900,
region: '高安市',
regionCode: 156360983,
name: '高安市',
adcode: '156360983'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
adcode: '156361000',
name: '抚州市',
cityCode: 156361000,
children: [{
id: 1172,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '临川区',
regionCode: 156361002,
name: '临川区',
adcode: '156361002'
}, {
id: 1173,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '东乡区',
regionCode: 156361003,
name: '东乡区',
adcode: '156361003'
}, {
id: 1174,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '南城县',
regionCode: 156361021,
name: '南城县',
adcode: '156361021'
}, {
id: 1175,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '黎川县',
regionCode: 156361022,
name: '黎川县',
adcode: '156361022'
}, {
id: 1176,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '南丰县',
regionCode: 156361023,
name: '南丰县',
adcode: '156361023'
}, {
id: 1177,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '崇仁县',
regionCode: 156361024,
name: '崇仁县',
adcode: '156361024'
}, {
id: 1178,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '乐安县',
regionCode: 156361025,
name: '乐安县',
adcode: '156361025'
}, {
id: 1179,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '宜黄县',
regionCode: 156361026,
name: '宜黄县',
adcode: '156361026'
}, {
id: 1180,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '金溪县',
regionCode: 156361027,
name: '金溪县',
adcode: '156361027'
}, {
id: 1181,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '资溪县',
regionCode: 156361028,
name: '资溪县',
adcode: '156361028'
}, {
id: 1182,
province: '江西省',
provinceCode: 156360000,
city: '抚州市',
cityCode: 156361000,
region: '广昌县',
regionCode: 156361030,
name: '广昌县',
adcode: '156361030'
}]
}, {
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
adcode: '156361100',
name: '上饶市',
cityCode: 156361100,
children: [{
id: 1183,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '信州区',
regionCode: 156361102,
name: '信州区',
adcode: '156361102'
}, {
id: 1184,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '广丰区',
regionCode: 156361103,
name: '广丰区',
adcode: '156361103'
}, {
id: 1185,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '广信区',
regionCode: 156361104,
name: '广信区',
adcode: '156361104'
}, {
id: 1186,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '玉山县',
regionCode: 156361123,
name: '玉山县',
adcode: '156361123'
}, {
id: 1187,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '铅山县',
regionCode: 156361124,
name: '铅山县',
adcode: '156361124'
}, {
id: 1188,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '横峰县',
regionCode: 156361125,
name: '横峰县',
adcode: '156361125'
}, {
id: 1189,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '弋阳县',
regionCode: 156361126,
name: '弋阳县',
adcode: '156361126'
}, {
id: 1190,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '余干县',
regionCode: 156361127,
name: '余干县',
adcode: '156361127'
}, {
id: 1191,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '鄱阳县',
regionCode: 156361128,
name: '鄱阳县',
adcode: '156361128'
}, {
id: 1192,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '万年县',
regionCode: 156361129,
name: '万年县',
adcode: '156361129'
}, {
id: 1193,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '婺源县',
regionCode: 156361130,
name: '婺源县',
adcode: '156361130'
}, {
id: 1194,
province: '江西省',
provinceCode: 156360000,
city: '上饶市',
cityCode: 156361100,
region: '德兴市',
regionCode: 156361181,
name: '德兴市',
adcode: '156361181'
}]
}]
}, {
province: '山东省',
provinceCode: 156370000,
adcode: '156370000',
name: '山东省',
children: [{
province: '山东省',
provinceCode: 156370000,
city: '济南市',
adcode: '156370100',
name: '济南市',
cityCode: 156370100,
children: [{
id: 1195,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '历下区',
regionCode: 156370102,
name: '历下区',
adcode: '156370102'
}, {
id: 1196,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '市中区',
regionCode: 156370103,
name: '市中区',
adcode: '156370103'
}, {
id: 1197,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '槐荫区',
regionCode: 156370104,
name: '槐荫区',
adcode: '156370104'
}, {
id: 1198,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '天桥区',
regionCode: 156370105,
name: '天桥区',
adcode: '156370105'
}, {
id: 1199,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '历城区',
regionCode: 156370112,
name: '历城区',
adcode: '156370112'
}, {
id: 1200,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '长清区',
regionCode: 156370113,
name: '长清区',
adcode: '156370113'
}, {
id: 1201,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '章丘区',
regionCode: 156370114,
name: '章丘区',
adcode: '156370114'
}, {
id: 1202,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '济阳区',
regionCode: 156370115,
name: '济阳区',
adcode: '156370115'
}, {
id: 1203,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '莱芜区',
regionCode: 156370116,
name: '莱芜区',
adcode: '156370116'
}, {
id: 1204,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '钢城区',
regionCode: 156370117,
name: '钢城区',
adcode: '156370117'
}, {
id: 1205,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '平阴县',
regionCode: 156370124,
name: '平阴县',
adcode: '156370124'
}, {
id: 1206,
province: '山东省',
provinceCode: 156370000,
city: '济南市',
cityCode: 156370100,
region: '商河县',
regionCode: 156370126,
name: '商河县',
adcode: '156370126'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
adcode: '156370200',
name: '青岛市',
cityCode: 156370200,
children: [{
id: 1207,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '市南区',
regionCode: 156370202,
name: '市南区',
adcode: '156370202'
}, {
id: 1208,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '市北区',
regionCode: 156370203,
name: '市北区',
adcode: '156370203'
}, {
id: 1209,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '黄岛区',
regionCode: 156370211,
name: '黄岛区',
adcode: '156370211'
}, {
id: 1210,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '崂山区',
regionCode: 156370212,
name: '崂山区',
adcode: '156370212'
}, {
id: 1211,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '李沧区',
regionCode: 156370213,
name: '李沧区',
adcode: '156370213'
}, {
id: 1212,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '城阳区',
regionCode: 156370214,
name: '城阳区',
adcode: '156370214'
}, {
id: 1213,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '即墨区',
regionCode: 156370215,
name: '即墨区',
adcode: '156370215'
}, {
id: 1214,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '胶州市',
regionCode: 156370281,
name: '胶州市',
adcode: '156370281'
}, {
id: 1215,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '平度市',
regionCode: 156370283,
name: '平度市',
adcode: '156370283'
}, {
id: 1216,
province: '山东省',
provinceCode: 156370000,
city: '青岛市',
cityCode: 156370200,
region: '莱西市',
regionCode: 156370285,
name: '莱西市',
adcode: '156370285'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
adcode: '156370300',
name: '淄博市',
cityCode: 156370300,
children: [{
id: 1217,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '淄川区',
regionCode: 156370302,
name: '淄川区',
adcode: '156370302'
}, {
id: 1218,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '张店区',
regionCode: 156370303,
name: '张店区',
adcode: '156370303'
}, {
id: 1219,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '博山区',
regionCode: 156370304,
name: '博山区',
adcode: '156370304'
}, {
id: 1220,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '临淄区',
regionCode: 156370305,
name: '临淄区',
adcode: '156370305'
}, {
id: 1221,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '周村区',
regionCode: 156370306,
name: '周村区',
adcode: '156370306'
}, {
id: 1222,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '桓台县',
regionCode: 156370321,
name: '桓台县',
adcode: '156370321'
}, {
id: 1223,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '高青县',
regionCode: 156370322,
name: '高青县',
adcode: '156370322'
}, {
id: 1224,
province: '山东省',
provinceCode: 156370000,
city: '淄博市',
cityCode: 156370300,
region: '沂源县',
regionCode: 156370323,
name: '沂源县',
adcode: '156370323'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '枣庄市',
adcode: '156370400',
name: '枣庄市',
cityCode: 156370400,
children: [{
id: 1225,
province: '山东省',
provinceCode: 156370000,
city: '枣庄市',
cityCode: 156370400,
region: '市中区',
regionCode: 156370402,
name: '市中区',
adcode: '156370402'
}, {
id: 1226,
province: '山东省',
provinceCode: 156370000,
city: '枣庄市',
cityCode: 156370400,
region: '薛城区',
regionCode: 156370403,
name: '薛城区',
adcode: '156370403'
}, {
id: 1227,
province: '山东省',
provinceCode: 156370000,
city: '枣庄市',
cityCode: 156370400,
region: '峄城区',
regionCode: 156370404,
name: '峄城区',
adcode: '156370404'
}, {
id: 1228,
province: '山东省',
provinceCode: 156370000,
city: '枣庄市',
cityCode: 156370400,
region: '台儿庄区',
regionCode: 156370405,
name: '台儿庄区',
adcode: '156370405'
}, {
id: 1229,
province: '山东省',
provinceCode: 156370000,
city: '枣庄市',
cityCode: 156370400,
region: '山亭区',
regionCode: 156370406,
name: '山亭区',
adcode: '156370406'
}, {
id: 1230,
province: '山东省',
provinceCode: 156370000,
city: '枣庄市',
cityCode: 156370400,
region: '滕州市',
regionCode: 156370481,
name: '滕州市',
adcode: '156370481'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '东营市',
adcode: '156370500',
name: '东营市',
cityCode: 156370500,
children: [{
id: 1231,
province: '山东省',
provinceCode: 156370000,
city: '东营市',
cityCode: 156370500,
region: '东营区',
regionCode: 156370502,
name: '东营区',
adcode: '156370502'
}, {
id: 1232,
province: '山东省',
provinceCode: 156370000,
city: '东营市',
cityCode: 156370500,
region: '河口区',
regionCode: 156370503,
name: '河口区',
adcode: '156370503'
}, {
id: 1233,
province: '山东省',
provinceCode: 156370000,
city: '东营市',
cityCode: 156370500,
region: '垦利区',
regionCode: 156370505,
name: '垦利区',
adcode: '156370505'
}, {
id: 1234,
province: '山东省',
provinceCode: 156370000,
city: '东营市',
cityCode: 156370500,
region: '利津县',
regionCode: 156370522,
name: '利津县',
adcode: '156370522'
}, {
id: 1235,
province: '山东省',
provinceCode: 156370000,
city: '东营市',
cityCode: 156370500,
region: '广饶县',
regionCode: 156370523,
name: '广饶县',
adcode: '156370523'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
adcode: '156370600',
name: '烟台市',
cityCode: 156370600,
children: [{
id: 1236,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '芝罘区',
regionCode: 156370602,
name: '芝罘区',
adcode: '156370602'
}, {
id: 1237,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '福山区',
regionCode: 156370611,
name: '福山区',
adcode: '156370611'
}, {
id: 1238,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '牟平区',
regionCode: 156370612,
name: '牟平区',
adcode: '156370612'
}, {
id: 1239,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '莱山区',
regionCode: 156370613,
name: '莱山区',
adcode: '156370613'
}, {
id: 1240,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '长岛县',
regionCode: 156370634,
name: '长岛县',
adcode: '156370634'
}, {
id: 1241,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '龙口市',
regionCode: 156370681,
name: '龙口市',
adcode: '156370681'
}, {
id: 1242,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '莱阳市',
regionCode: 156370682,
name: '莱阳市',
adcode: '156370682'
}, {
id: 1243,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '莱州市',
regionCode: 156370683,
name: '莱州市',
adcode: '156370683'
}, {
id: 1244,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '蓬莱市',
regionCode: 156370684,
name: '蓬莱市',
adcode: '156370684'
}, {
id: 1245,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '招远市',
regionCode: 156370685,
name: '招远市',
adcode: '156370685'
}, {
id: 1246,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '栖霞市',
regionCode: 156370686,
name: '栖霞市',
adcode: '156370686'
}, {
id: 1247,
province: '山东省',
provinceCode: 156370000,
city: '烟台市',
cityCode: 156370600,
region: '海阳市',
regionCode: 156370687,
name: '海阳市',
adcode: '156370687'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
adcode: '156370700',
name: '潍坊市',
cityCode: 156370700,
children: [{
id: 1248,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '潍城区',
regionCode: 156370702,
name: '潍城区',
adcode: '156370702'
}, {
id: 1249,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '寒亭区',
regionCode: 156370703,
name: '寒亭区',
adcode: '156370703'
}, {
id: 1250,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '坊子区',
regionCode: 156370704,
name: '坊子区',
adcode: '156370704'
}, {
id: 1251,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '奎文区',
regionCode: 156370705,
name: '奎文区',
adcode: '156370705'
}, {
id: 1252,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '临朐县',
regionCode: 156370724,
name: '临朐县',
adcode: '156370724'
}, {
id: 1253,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '昌乐县',
regionCode: 156370725,
name: '昌乐县',
adcode: '156370725'
}, {
id: 1254,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '青州市',
regionCode: 156370781,
name: '青州市',
adcode: '156370781'
}, {
id: 1255,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '诸城市',
regionCode: 156370782,
name: '诸城市',
adcode: '156370782'
}, {
id: 1256,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '寿光市',
regionCode: 156370783,
name: '寿光市',
adcode: '156370783'
}, {
id: 1257,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '安丘市',
regionCode: 156370784,
name: '安丘市',
adcode: '156370784'
}, {
id: 1258,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '高密市',
regionCode: 156370785,
name: '高密市',
adcode: '156370785'
}, {
id: 1259,
province: '山东省',
provinceCode: 156370000,
city: '潍坊市',
cityCode: 156370700,
region: '昌邑市',
regionCode: 156370786,
name: '昌邑市',
adcode: '156370786'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
adcode: '156370800',
name: '济宁市',
cityCode: 156370800,
children: [{
id: 1260,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '任城区',
regionCode: 156370811,
name: '任城区',
adcode: '156370811'
}, {
id: 1261,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '兖州区',
regionCode: 156370812,
name: '兖州区',
adcode: '156370812'
}, {
id: 1262,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '微山县',
regionCode: 156370826,
name: '微山县',
adcode: '156370826'
}, {
id: 1263,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '鱼台县',
regionCode: 156370827,
name: '鱼台县',
adcode: '156370827'
}, {
id: 1264,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '金乡县',
regionCode: 156370828,
name: '金乡县',
adcode: '156370828'
}, {
id: 1265,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '嘉祥县',
regionCode: 156370829,
name: '嘉祥县',
adcode: '156370829'
}, {
id: 1266,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '汶上县',
regionCode: 156370830,
name: '汶上县',
adcode: '156370830'
}, {
id: 1267,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '泗水县',
regionCode: 156370831,
name: '泗水县',
adcode: '156370831'
}, {
id: 1268,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '梁山县',
regionCode: 156370832,
name: '梁山县',
adcode: '156370832'
}, {
id: 1269,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '曲阜市',
regionCode: 156370881,
name: '曲阜市',
adcode: '156370881'
}, {
id: 1270,
province: '山东省',
provinceCode: 156370000,
city: '济宁市',
cityCode: 156370800,
region: '邹城市',
regionCode: 156370883,
name: '邹城市',
adcode: '156370883'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '泰安市',
adcode: '156370900',
name: '泰安市',
cityCode: 156370900,
children: [{
id: 1271,
province: '山东省',
provinceCode: 156370000,
city: '泰安市',
cityCode: 156370900,
region: '泰山区',
regionCode: 156370902,
name: '泰山区',
adcode: '156370902'
}, {
id: 1272,
province: '山东省',
provinceCode: 156370000,
city: '泰安市',
cityCode: 156370900,
region: '岱岳区',
regionCode: 156370911,
name: '岱岳区',
adcode: '156370911'
}, {
id: 1273,
province: '山东省',
provinceCode: 156370000,
city: '泰安市',
cityCode: 156370900,
region: '宁阳县',
regionCode: 156370921,
name: '宁阳县',
adcode: '156370921'
}, {
id: 1274,
province: '山东省',
provinceCode: 156370000,
city: '泰安市',
cityCode: 156370900,
region: '东平县',
regionCode: 156370923,
name: '东平县',
adcode: '156370923'
}, {
id: 1275,
province: '山东省',
provinceCode: 156370000,
city: '泰安市',
cityCode: 156370900,
region: '新泰市',
regionCode: 156370982,
name: '新泰市',
adcode: '156370982'
}, {
id: 1276,
province: '山东省',
provinceCode: 156370000,
city: '泰安市',
cityCode: 156370900,
region: '肥城市',
regionCode: 156370983,
name: '肥城市',
adcode: '156370983'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '威海市',
adcode: '156371000',
name: '威海市',
cityCode: 156371000,
children: [{
id: 1277,
province: '山东省',
provinceCode: 156370000,
city: '威海市',
cityCode: 156371000,
region: '环翠区',
regionCode: 156371002,
name: '环翠区',
adcode: '156371002'
}, {
id: 1278,
province: '山东省',
provinceCode: 156370000,
city: '威海市',
cityCode: 156371000,
region: '文登区',
regionCode: 156371003,
name: '文登区',
adcode: '156371003'
}, {
id: 1279,
province: '山东省',
provinceCode: 156370000,
city: '威海市',
cityCode: 156371000,
region: '荣成市',
regionCode: 156371082,
name: '荣成市',
adcode: '156371082'
}, {
id: 1280,
province: '山东省',
provinceCode: 156370000,
city: '威海市',
cityCode: 156371000,
region: '乳山市',
regionCode: 156371083,
name: '乳山市',
adcode: '156371083'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '日照市',
adcode: '156371100',
name: '日照市',
cityCode: 156371100,
children: [{
id: 1281,
province: '山东省',
provinceCode: 156370000,
city: '日照市',
cityCode: 156371100,
region: '东港区',
regionCode: 156371102,
name: '东港区',
adcode: '156371102'
}, {
id: 1282,
province: '山东省',
provinceCode: 156370000,
city: '日照市',
cityCode: 156371100,
region: '岚山区',
regionCode: 156371103,
name: '岚山区',
adcode: '156371103'
}, {
id: 1283,
province: '山东省',
provinceCode: 156370000,
city: '日照市',
cityCode: 156371100,
region: '五莲县',
regionCode: 156371121,
name: '五莲县',
adcode: '156371121'
}, {
id: 1284,
province: '山东省',
provinceCode: 156370000,
city: '日照市',
cityCode: 156371100,
region: '莒县',
regionCode: 156371122,
name: '莒县',
adcode: '156371122'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
adcode: '156371300',
name: '临沂市',
cityCode: 156371300,
children: [{
id: 1285,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '兰山区',
regionCode: 156371302,
name: '兰山区',
adcode: '156371302'
}, {
id: 1286,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '罗庄区',
regionCode: 156371311,
name: '罗庄区',
adcode: '156371311'
}, {
id: 1287,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '河东区',
regionCode: 156371312,
name: '河东区',
adcode: '156371312'
}, {
id: 1288,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '沂南县',
regionCode: 156371321,
name: '沂南县',
adcode: '156371321'
}, {
id: 1289,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '郯城县',
regionCode: 156371322,
name: '郯城县',
adcode: '156371322'
}, {
id: 1290,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '沂水县',
regionCode: 156371323,
name: '沂水县',
adcode: '156371323'
}, {
id: 1291,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '兰陵县',
regionCode: 156371324,
name: '兰陵县',
adcode: '156371324'
}, {
id: 1292,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '费县',
regionCode: 156371325,
name: '费县',
adcode: '156371325'
}, {
id: 1293,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '平邑县',
regionCode: 156371326,
name: '平邑县',
adcode: '156371326'
}, {
id: 1294,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '莒南县',
regionCode: 156371327,
name: '莒南县',
adcode: '156371327'
}, {
id: 1295,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '蒙阴县',
regionCode: 156371328,
name: '蒙阴县',
adcode: '156371328'
}, {
id: 1296,
province: '山东省',
provinceCode: 156370000,
city: '临沂市',
cityCode: 156371300,
region: '临沭县',
regionCode: 156371329,
name: '临沭县',
adcode: '156371329'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '德州市',
adcode: '156371400',
name: '德州市',
cityCode: 156371400,
children: [{
id: 1297,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '德城区',
regionCode: 156371402,
name: '德城区',
adcode: '156371402'
}, {
id: 1298,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '陵城区',
regionCode: 156371403,
name: '陵城区',
adcode: '156371403'
}, {
id: 1299,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '宁津县',
regionCode: 156371422,
name: '宁津县',
adcode: '156371422'
}, {
id: 1300,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '庆云县',
regionCode: 156371423,
name: '庆云县',
adcode: '156371423'
}, {
id: 1301,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '临邑县',
regionCode: 156371424,
name: '临邑县',
adcode: '156371424'
}, {
id: 1302,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '齐河县',
regionCode: 156371425,
name: '齐河县',
adcode: '156371425'
}, {
id: 1303,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '平原县',
regionCode: 156371426,
name: '平原县',
adcode: '156371426'
}, {
id: 1304,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '夏津县',
regionCode: 156371427,
name: '夏津县',
adcode: '156371427'
}, {
id: 1305,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '武城县',
regionCode: 156371428,
name: '武城县',
adcode: '156371428'
}, {
id: 1306,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '乐陵市',
regionCode: 156371481,
name: '乐陵市',
adcode: '156371481'
}, {
id: 1307,
province: '山东省',
provinceCode: 156370000,
city: '德州市',
cityCode: 156371400,
region: '禹城市',
regionCode: 156371482,
name: '禹城市',
adcode: '156371482'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
adcode: '156371500',
name: '聊城市',
cityCode: 156371500,
children: [{
id: 1308,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '东昌府区',
regionCode: 156371502,
name: '东昌府区',
adcode: '156371502'
}, {
id: 1309,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '茌平区',
regionCode: 156371503,
name: '茌平区',
adcode: '156371503'
}, {
id: 1310,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '阳谷县',
regionCode: 156371521,
name: '阳谷县',
adcode: '156371521'
}, {
id: 1311,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '莘县',
regionCode: 156371522,
name: '莘县',
adcode: '156371522'
}, {
id: 1312,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '东阿县',
regionCode: 156371524,
name: '东阿县',
adcode: '156371524'
}, {
id: 1313,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '冠县',
regionCode: 156371525,
name: '冠县',
adcode: '156371525'
}, {
id: 1314,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '高唐县',
regionCode: 156371526,
name: '高唐县',
adcode: '156371526'
}, {
id: 1315,
province: '山东省',
provinceCode: 156370000,
city: '聊城市',
cityCode: 156371500,
region: '临清市',
regionCode: 156371581,
name: '临清市',
adcode: '156371581'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
adcode: '156371600',
name: '滨州市',
cityCode: 156371600,
children: [{
id: 1316,
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
cityCode: 156371600,
region: '滨城区',
regionCode: 156371602,
name: '滨城区',
adcode: '156371602'
}, {
id: 1317,
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
cityCode: 156371600,
region: '沾化区',
regionCode: 156371603,
name: '沾化区',
adcode: '156371603'
}, {
id: 1318,
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
cityCode: 156371600,
region: '惠民县',
regionCode: 156371621,
name: '惠民县',
adcode: '156371621'
}, {
id: 1319,
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
cityCode: 156371600,
region: '阳信县',
regionCode: 156371622,
name: '阳信县',
adcode: '156371622'
}, {
id: 1320,
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
cityCode: 156371600,
region: '无棣县',
regionCode: 156371623,
name: '无棣县',
adcode: '156371623'
}, {
id: 1321,
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
cityCode: 156371600,
region: '博兴县',
regionCode: 156371625,
name: '博兴县',
adcode: '156371625'
}, {
id: 1322,
province: '山东省',
provinceCode: 156370000,
city: '滨州市',
cityCode: 156371600,
region: '邹平市',
regionCode: 156371681,
name: '邹平市',
adcode: '156371681'
}]
}, {
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
adcode: '156371700',
name: '菏泽市',
cityCode: 156371700,
children: [{
id: 1323,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '牡丹区',
regionCode: 156371702,
name: '牡丹区',
adcode: '156371702'
}, {
id: 1324,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '定陶区',
regionCode: 156371703,
name: '定陶区',
adcode: '156371703'
}, {
id: 1325,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '曹县',
regionCode: 156371721,
name: '曹县',
adcode: '156371721'
}, {
id: 1326,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '单县',
regionCode: 156371722,
name: '单县',
adcode: '156371722'
}, {
id: 1327,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '成武县',
regionCode: 156371723,
name: '成武县',
adcode: '156371723'
}, {
id: 1328,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '巨野县',
regionCode: 156371724,
name: '巨野县',
adcode: '156371724'
}, {
id: 1329,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '郓城县',
regionCode: 156371725,
name: '郓城县',
adcode: '156371725'
}, {
id: 1330,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '鄄城县',
regionCode: 156371726,
name: '鄄城县',
adcode: '156371726'
}, {
id: 1331,
province: '山东省',
provinceCode: 156370000,
city: '菏泽市',
cityCode: 156371700,
region: '东明县',
regionCode: 156371728,
name: '东明县',
adcode: '156371728'
}]
}]
}, {
province: '河南省',
provinceCode: 156410000,
adcode: '156410000',
name: '河南省',
children: [{
province: '河南省',
provinceCode: 156410000,
city: '河南省直辖',
adcode: '156410000',
name: '河南省直辖',
cityCode: 156410000,
children: [{
id: 1489,
province: '河南省',
provinceCode: 156410000,
city: '河南省直辖',
cityCode: 156410000,
region: '济源市',
regionCode: 156419001,
name: '济源市',
adcode: '156419001'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
adcode: '156410100',
name: '郑州市',
cityCode: 156410100,
children: [{
id: 1332,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '中原区',
regionCode: 156410102,
name: '中原区',
adcode: '156410102'
}, {
id: 1333,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '二七区',
regionCode: 156410103,
name: '二七区',
adcode: '156410103'
}, {
id: 1334,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '管城回族区',
regionCode: 156410104,
name: '管城回族区',
adcode: '156410104'
}, {
id: 1335,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '金水区',
regionCode: 156410105,
name: '金水区',
adcode: '156410105'
}, {
id: 1336,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '上街区',
regionCode: 156410106,
name: '上街区',
adcode: '156410106'
}, {
id: 1337,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '惠济区',
regionCode: 156410108,
name: '惠济区',
adcode: '156410108'
}, {
id: 1338,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '中牟县',
regionCode: 156410122,
name: '中牟县',
adcode: '156410122'
}, {
id: 1339,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '巩义市',
regionCode: 156410181,
name: '巩义市',
adcode: '156410181'
}, {
id: 1340,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '荥阳市',
regionCode: 156410182,
name: '荥阳市',
adcode: '156410182'
}, {
id: 1341,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '新密市',
regionCode: 156410183,
name: '新密市',
adcode: '156410183'
}, {
id: 1342,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '新郑市',
regionCode: 156410184,
name: '新郑市',
adcode: '156410184'
}, {
id: 1343,
province: '河南省',
provinceCode: 156410000,
city: '郑州市',
cityCode: 156410100,
region: '登封市',
regionCode: 156410185,
name: '登封市',
adcode: '156410185'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '开封市',
adcode: '156410200',
name: '开封市',
cityCode: 156410200,
children: [{
id: 1344,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '龙亭区',
regionCode: 156410202,
name: '龙亭区',
adcode: '156410202'
}, {
id: 1345,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '顺河回族区',
regionCode: 156410203,
name: '顺河回族区',
adcode: '156410203'
}, {
id: 1346,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '鼓楼区',
regionCode: 156410204,
name: '鼓楼区',
adcode: '156410204'
}, {
id: 1347,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '禹王台区',
regionCode: 156410205,
name: '禹王台区',
adcode: '156410205'
}, {
id: 1348,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '祥符区',
regionCode: 156410212,
name: '祥符区',
adcode: '156410212'
}, {
id: 1349,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '杞县',
regionCode: 156410221,
name: '杞县',
adcode: '156410221'
}, {
id: 1350,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '通许县',
regionCode: 156410222,
name: '通许县',
adcode: '156410222'
}, {
id: 1351,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '尉氏县',
regionCode: 156410223,
name: '尉氏县',
adcode: '156410223'
}, {
id: 1352,
province: '河南省',
provinceCode: 156410000,
city: '开封市',
cityCode: 156410200,
region: '兰考县',
regionCode: 156410225,
name: '兰考县',
adcode: '156410225'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
adcode: '156410300',
name: '洛阳市',
cityCode: 156410300,
children: [{
id: 1353,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '老城区',
regionCode: 156410302,
name: '老城区',
adcode: '156410302'
}, {
id: 1354,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '西工区',
regionCode: 156410303,
name: '西工区',
adcode: '156410303'
}, {
id: 1355,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '瀍河回族区',
regionCode: 156410304,
name: '瀍河回族区',
adcode: '156410304'
}, {
id: 1356,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '涧西区',
regionCode: 156410305,
name: '涧西区',
adcode: '156410305'
}, {
id: 1357,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '吉利区',
regionCode: 156410306,
name: '吉利区',
adcode: '156410306'
}, {
id: 1358,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '洛龙区',
regionCode: 156410311,
name: '洛龙区',
adcode: '156410311'
}, {
id: 1359,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '孟津县',
regionCode: 156410322,
name: '孟津县',
adcode: '156410322'
}, {
id: 1360,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '新安县',
regionCode: 156410323,
name: '新安县',
adcode: '156410323'
}, {
id: 1361,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '栾川县',
regionCode: 156410324,
name: '栾川县',
adcode: '156410324'
}, {
id: 1362,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '嵩县',
regionCode: 156410325,
name: '嵩县',
adcode: '156410325'
}, {
id: 1363,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '汝阳县',
regionCode: 156410326,
name: '汝阳县',
adcode: '156410326'
}, {
id: 1364,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '宜阳县',
regionCode: 156410327,
name: '宜阳县',
adcode: '156410327'
}, {
id: 1365,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '洛宁县',
regionCode: 156410328,
name: '洛宁县',
adcode: '156410328'
}, {
id: 1366,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '伊川县',
regionCode: 156410329,
name: '伊川县',
adcode: '156410329'
}, {
id: 1367,
province: '河南省',
provinceCode: 156410000,
city: '洛阳市',
cityCode: 156410300,
region: '偃师市',
regionCode: 156410381,
name: '偃师市',
adcode: '156410381'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
adcode: '156410400',
name: '平顶山市',
cityCode: 156410400,
children: [{
id: 1368,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '新华区',
regionCode: 156410402,
name: '新华区',
adcode: '156410402'
}, {
id: 1369,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '卫东区',
regionCode: 156410403,
name: '卫东区',
adcode: '156410403'
}, {
id: 1370,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '石龙区',
regionCode: 156410404,
name: '石龙区',
adcode: '156410404'
}, {
id: 1371,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '湛河区',
regionCode: 156410411,
name: '湛河区',
adcode: '156410411'
}, {
id: 1372,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '宝丰县',
regionCode: 156410421,
name: '宝丰县',
adcode: '156410421'
}, {
id: 1373,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '叶县',
regionCode: 156410422,
name: '叶县',
adcode: '156410422'
}, {
id: 1374,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '鲁山县',
regionCode: 156410423,
name: '鲁山县',
adcode: '156410423'
}, {
id: 1375,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '郏县',
regionCode: 156410425,
name: '郏县',
adcode: '156410425'
}, {
id: 1376,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '舞钢市',
regionCode: 156410481,
name: '舞钢市',
adcode: '156410481'
}, {
id: 1377,
province: '河南省',
provinceCode: 156410000,
city: '平顶山市',
cityCode: 156410400,
region: '汝州市',
regionCode: 156410482,
name: '汝州市',
adcode: '156410482'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
adcode: '156410500',
name: '安阳市',
cityCode: 156410500,
children: [{
id: 1378,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '文峰区',
regionCode: 156410502,
name: '文峰区',
adcode: '156410502'
}, {
id: 1379,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '北关区',
regionCode: 156410503,
name: '北关区',
adcode: '156410503'
}, {
id: 1380,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '殷都区',
regionCode: 156410505,
name: '殷都区',
adcode: '156410505'
}, {
id: 1381,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '龙安区',
regionCode: 156410506,
name: '龙安区',
adcode: '156410506'
}, {
id: 1382,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '安阳县',
regionCode: 156410522,
name: '安阳县',
adcode: '156410522'
}, {
id: 1383,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '汤阴县',
regionCode: 156410523,
name: '汤阴县',
adcode: '156410523'
}, {
id: 1384,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '滑县',
regionCode: 156410526,
name: '滑县',
adcode: '156410526'
}, {
id: 1385,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '内黄县',
regionCode: 156410527,
name: '内黄县',
adcode: '156410527'
}, {
id: 1386,
province: '河南省',
provinceCode: 156410000,
city: '安阳市',
cityCode: 156410500,
region: '林州市',
regionCode: 156410581,
name: '林州市',
adcode: '156410581'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '鹤壁市',
adcode: '156410600',
name: '鹤壁市',
cityCode: 156410600,
children: [{
id: 1387,
province: '河南省',
provinceCode: 156410000,
city: '鹤壁市',
cityCode: 156410600,
region: '鹤山区',
regionCode: 156410602,
name: '鹤山区',
adcode: '156410602'
}, {
id: 1388,
province: '河南省',
provinceCode: 156410000,
city: '鹤壁市',
cityCode: 156410600,
region: '山城区',
regionCode: 156410603,
name: '山城区',
adcode: '156410603'
}, {
id: 1389,
province: '河南省',
provinceCode: 156410000,
city: '鹤壁市',
cityCode: 156410600,
region: '淇滨区',
regionCode: 156410611,
name: '淇滨区',
adcode: '156410611'
}, {
id: 1390,
province: '河南省',
provinceCode: 156410000,
city: '鹤壁市',
cityCode: 156410600,
region: '浚县',
regionCode: 156410621,
name: '浚县',
adcode: '156410621'
}, {
id: 1391,
province: '河南省',
provinceCode: 156410000,
city: '鹤壁市',
cityCode: 156410600,
region: '淇县',
regionCode: 156410622,
name: '淇县',
adcode: '156410622'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
adcode: '156410700',
name: '新乡市',
cityCode: 156410700,
children: [{
id: 1392,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '红旗区',
regionCode: 156410702,
name: '红旗区',
adcode: '156410702'
}, {
id: 1393,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '卫滨区',
regionCode: 156410703,
name: '卫滨区',
adcode: '156410703'
}, {
id: 1394,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '凤泉区',
regionCode: 156410704,
name: '凤泉区',
adcode: '156410704'
}, {
id: 1395,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '牧野区',
regionCode: 156410711,
name: '牧野区',
adcode: '156410711'
}, {
id: 1396,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '新乡县',
regionCode: 156410721,
name: '新乡县',
adcode: '156410721'
}, {
id: 1397,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '获嘉县',
regionCode: 156410724,
name: '获嘉县',
adcode: '156410724'
}, {
id: 1398,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '原阳县',
regionCode: 156410725,
name: '原阳县',
adcode: '156410725'
}, {
id: 1399,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '延津县',
regionCode: 156410726,
name: '延津县',
adcode: '156410726'
}, {
id: 1400,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '封丘县',
regionCode: 156410727,
name: '封丘县',
adcode: '156410727'
}, {
id: 1401,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '卫辉市',
regionCode: 156410781,
name: '卫辉市',
adcode: '156410781'
}, {
id: 1402,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '辉县市',
regionCode: 156410782,
name: '辉县市',
adcode: '156410782'
}, {
id: 1403,
province: '河南省',
provinceCode: 156410000,
city: '新乡市',
cityCode: 156410700,
region: '长垣市',
regionCode: 156410783,
name: '长垣市',
adcode: '156410783'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
adcode: '156410800',
name: '焦作市',
cityCode: 156410800,
children: [{
id: 1404,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '解放区',
regionCode: 156410802,
name: '解放区',
adcode: '156410802'
}, {
id: 1405,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '中站区',
regionCode: 156410803,
name: '中站区',
adcode: '156410803'
}, {
id: 1406,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '马村区',
regionCode: 156410804,
name: '马村区',
adcode: '156410804'
}, {
id: 1407,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '山阳区',
regionCode: 156410811,
name: '山阳区',
adcode: '156410811'
}, {
id: 1408,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '修武县',
regionCode: 156410821,
name: '修武县',
adcode: '156410821'
}, {
id: 1409,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '博爱县',
regionCode: 156410822,
name: '博爱县',
adcode: '156410822'
}, {
id: 1410,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '武陟县',
regionCode: 156410823,
name: '武陟县',
adcode: '156410823'
}, {
id: 1411,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '温县',
regionCode: 156410825,
name: '温县',
adcode: '156410825'
}, {
id: 1412,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '沁阳市',
regionCode: 156410882,
name: '沁阳市',
adcode: '156410882'
}, {
id: 1413,
province: '河南省',
provinceCode: 156410000,
city: '焦作市',
cityCode: 156410800,
region: '孟州市',
regionCode: 156410883,
name: '孟州市',
adcode: '156410883'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '濮阳市',
adcode: '156410900',
name: '濮阳市',
cityCode: 156410900,
children: [{
id: 1414,
province: '河南省',
provinceCode: 156410000,
city: '濮阳市',
cityCode: 156410900,
region: '华龙区',
regionCode: 156410902,
name: '华龙区',
adcode: '156410902'
}, {
id: 1415,
province: '河南省',
provinceCode: 156410000,
city: '濮阳市',
cityCode: 156410900,
region: '清丰县',
regionCode: 156410922,
name: '清丰县',
adcode: '156410922'
}, {
id: 1416,
province: '河南省',
provinceCode: 156410000,
city: '濮阳市',
cityCode: 156410900,
region: '南乐县',
regionCode: 156410923,
name: '南乐县',
adcode: '156410923'
}, {
id: 1417,
province: '河南省',
provinceCode: 156410000,
city: '濮阳市',
cityCode: 156410900,
region: '范县',
regionCode: 156410926,
name: '范县',
adcode: '156410926'
}, {
id: 1418,
province: '河南省',
provinceCode: 156410000,
city: '濮阳市',
cityCode: 156410900,
region: '台前县',
regionCode: 156410927,
name: '台前县',
adcode: '156410927'
}, {
id: 1419,
province: '河南省',
provinceCode: 156410000,
city: '濮阳市',
cityCode: 156410900,
region: '濮阳县',
regionCode: 156410928,
name: '濮阳县',
adcode: '156410928'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '许昌市',
adcode: '156411000',
name: '许昌市',
cityCode: 156411000,
children: [{
id: 1420,
province: '河南省',
provinceCode: 156410000,
city: '许昌市',
cityCode: 156411000,
region: '魏都区',
regionCode: 156411002,
name: '魏都区',
adcode: '156411002'
}, {
id: 1421,
province: '河南省',
provinceCode: 156410000,
city: '许昌市',
cityCode: 156411000,
region: '建安区',
regionCode: 156411003,
name: '建安区',
adcode: '156411003'
}, {
id: 1422,
province: '河南省',
provinceCode: 156410000,
city: '许昌市',
cityCode: 156411000,
region: '鄢陵县',
regionCode: 156411024,
name: '鄢陵县',
adcode: '156411024'
}, {
id: 1423,
province: '河南省',
provinceCode: 156410000,
city: '许昌市',
cityCode: 156411000,
region: '襄城县',
regionCode: 156411025,
name: '襄城县',
adcode: '156411025'
}, {
id: 1424,
province: '河南省',
provinceCode: 156410000,
city: '许昌市',
cityCode: 156411000,
region: '禹州市',
regionCode: 156411081,
name: '禹州市',
adcode: '156411081'
}, {
id: 1425,
province: '河南省',
provinceCode: 156410000,
city: '许昌市',
cityCode: 156411000,
region: '长葛市',
regionCode: 156411082,
name: '长葛市',
adcode: '156411082'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '漯河市',
adcode: '156411100',
name: '漯河市',
cityCode: 156411100,
children: [{
id: 1426,
province: '河南省',
provinceCode: 156410000,
city: '漯河市',
cityCode: 156411100,
region: '源汇区',
regionCode: 156411102,
name: '源汇区',
adcode: '156411102'
}, {
id: 1427,
province: '河南省',
provinceCode: 156410000,
city: '漯河市',
cityCode: 156411100,
region: '郾城区',
regionCode: 156411103,
name: '郾城区',
adcode: '156411103'
}, {
id: 1428,
province: '河南省',
provinceCode: 156410000,
city: '漯河市',
cityCode: 156411100,
region: '召陵区',
regionCode: 156411104,
name: '召陵区',
adcode: '156411104'
}, {
id: 1429,
province: '河南省',
provinceCode: 156410000,
city: '漯河市',
cityCode: 156411100,
region: '舞阳县',
regionCode: 156411121,
name: '舞阳县',
adcode: '156411121'
}, {
id: 1430,
province: '河南省',
provinceCode: 156410000,
city: '漯河市',
cityCode: 156411100,
region: '临颍县',
regionCode: 156411122,
name: '临颍县',
adcode: '156411122'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '三门峡市',
adcode: '156411200',
name: '三门峡市',
cityCode: 156411200,
children: [{
id: 1431,
province: '河南省',
provinceCode: 156410000,
city: '三门峡市',
cityCode: 156411200,
region: '湖滨区',
regionCode: 156411202,
name: '湖滨区',
adcode: '156411202'
}, {
id: 1432,
province: '河南省',
provinceCode: 156410000,
city: '三门峡市',
cityCode: 156411200,
region: '陕州区',
regionCode: 156411203,
name: '陕州区',
adcode: '156411203'
}, {
id: 1433,
province: '河南省',
provinceCode: 156410000,
city: '三门峡市',
cityCode: 156411200,
region: '渑池县',
regionCode: 156411221,
name: '渑池县',
adcode: '156411221'
}, {
id: 1434,
province: '河南省',
provinceCode: 156410000,
city: '三门峡市',
cityCode: 156411200,
region: '卢氏县',
regionCode: 156411224,
name: '卢氏县',
adcode: '156411224'
}, {
id: 1435,
province: '河南省',
provinceCode: 156410000,
city: '三门峡市',
cityCode: 156411200,
region: '义马市',
regionCode: 156411281,
name: '义马市',
adcode: '156411281'
}, {
id: 1436,
province: '河南省',
provinceCode: 156410000,
city: '三门峡市',
cityCode: 156411200,
region: '灵宝市',
regionCode: 156411282,
name: '灵宝市',
adcode: '156411282'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
adcode: '156411300',
name: '南阳市',
cityCode: 156411300,
children: [{
id: 1437,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '宛城区',
regionCode: 156411302,
name: '宛城区',
adcode: '156411302'
}, {
id: 1438,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '卧龙区',
regionCode: 156411303,
name: '卧龙区',
adcode: '156411303'
}, {
id: 1439,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '南召县',
regionCode: 156411321,
name: '南召县',
adcode: '156411321'
}, {
id: 1440,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '方城县',
regionCode: 156411322,
name: '方城县',
adcode: '156411322'
}, {
id: 1441,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '西峡县',
regionCode: 156411323,
name: '西峡县',
adcode: '156411323'
}, {
id: 1442,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '镇平县',
regionCode: 156411324,
name: '镇平县',
adcode: '156411324'
}, {
id: 1443,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '内乡县',
regionCode: 156411325,
name: '内乡县',
adcode: '156411325'
}, {
id: 1444,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '淅川县',
regionCode: 156411326,
name: '淅川县',
adcode: '156411326'
}, {
id: 1445,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '社旗县',
regionCode: 156411327,
name: '社旗县',
adcode: '156411327'
}, {
id: 1446,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '唐河县',
regionCode: 156411328,
name: '唐河县',
adcode: '156411328'
}, {
id: 1447,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '新野县',
regionCode: 156411329,
name: '新野县',
adcode: '156411329'
}, {
id: 1448,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '桐柏县',
regionCode: 156411330,
name: '桐柏县',
adcode: '156411330'
}, {
id: 1449,
province: '河南省',
provinceCode: 156410000,
city: '南阳市',
cityCode: 156411300,
region: '邓州市',
regionCode: 156411381,
name: '邓州市',
adcode: '156411381'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
adcode: '156411400',
name: '商丘市',
cityCode: 156411400,
children: [{
id: 1450,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '梁园区',
regionCode: 156411402,
name: '梁园区',
adcode: '156411402'
}, {
id: 1451,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '睢阳区',
regionCode: 156411403,
name: '睢阳区',
adcode: '156411403'
}, {
id: 1452,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '民权县',
regionCode: 156411421,
name: '民权县',
adcode: '156411421'
}, {
id: 1453,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '睢县',
regionCode: 156411422,
name: '睢县',
adcode: '156411422'
}, {
id: 1454,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '宁陵县',
regionCode: 156411423,
name: '宁陵县',
adcode: '156411423'
}, {
id: 1455,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '柘城县',
regionCode: 156411424,
name: '柘城县',
adcode: '156411424'
}, {
id: 1456,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '虞城县',
regionCode: 156411425,
name: '虞城县',
adcode: '156411425'
}, {
id: 1457,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '夏邑县',
regionCode: 156411426,
name: '夏邑县',
adcode: '156411426'
}, {
id: 1458,
province: '河南省',
provinceCode: 156410000,
city: '商丘市',
cityCode: 156411400,
region: '永城市',
regionCode: 156411481,
name: '永城市',
adcode: '156411481'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
adcode: '156411500',
name: '信阳市',
cityCode: 156411500,
children: [{
id: 1459,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '浉河区',
regionCode: 156411502,
name: '浉河区',
adcode: '156411502'
}, {
id: 1460,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '平桥区',
regionCode: 156411503,
name: '平桥区',
adcode: '156411503'
}, {
id: 1461,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '罗山县',
regionCode: 156411521,
name: '罗山县',
adcode: '156411521'
}, {
id: 1462,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '光山县',
regionCode: 156411522,
name: '光山县',
adcode: '156411522'
}, {
id: 1463,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '新县',
regionCode: 156411523,
name: '新县',
adcode: '156411523'
}, {
id: 1464,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '商城县',
regionCode: 156411524,
name: '商城县',
adcode: '156411524'
}, {
id: 1465,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '固始县',
regionCode: 156411525,
name: '固始县',
adcode: '156411525'
}, {
id: 1466,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '潢川县',
regionCode: 156411526,
name: '潢川县',
adcode: '156411526'
}, {
id: 1467,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '淮滨县',
regionCode: 156411527,
name: '淮滨县',
adcode: '156411527'
}, {
id: 1468,
province: '河南省',
provinceCode: 156410000,
city: '信阳市',
cityCode: 156411500,
region: '息县',
regionCode: 156411528,
name: '息县',
adcode: '156411528'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '周口市',
adcode: '156411600',
name: '周口市',
cityCode: 156411600,
children: [{
id: 1469,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '川汇区',
regionCode: 156411602,
name: '川汇区',
adcode: '156411602'
}, {
id: 1470,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '淮阳区',
regionCode: 156411603,
name: '淮阳区',
adcode: '156411603'
}, {
id: 1471,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '扶沟县',
regionCode: 156411621,
name: '扶沟县',
adcode: '156411621'
}, {
id: 1472,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '西华县',
regionCode: 156411622,
name: '西华县',
adcode: '156411622'
}, {
id: 1473,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '商水县',
regionCode: 156411623,
name: '商水县',
adcode: '156411623'
}, {
id: 1474,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '沈丘县',
regionCode: 156411624,
name: '沈丘县',
adcode: '156411624'
}, {
id: 1475,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '郸城县',
regionCode: 156411625,
name: '郸城县',
adcode: '156411625'
}, {
id: 1476,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '太康县',
regionCode: 156411627,
name: '太康县',
adcode: '156411627'
}, {
id: 1477,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '鹿邑县',
regionCode: 156411628,
name: '鹿邑县',
adcode: '156411628'
}, {
id: 1478,
province: '河南省',
provinceCode: 156410000,
city: '周口市',
cityCode: 156411600,
region: '项城市',
regionCode: 156411681,
name: '项城市',
adcode: '156411681'
}]
}, {
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
adcode: '156411700',
name: '驻马店市',
cityCode: 156411700,
children: [{
id: 1479,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '驿城区',
regionCode: 156411702,
name: '驿城区',
adcode: '156411702'
}, {
id: 1480,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '西平县',
regionCode: 156411721,
name: '西平县',
adcode: '156411721'
}, {
id: 1481,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '上蔡县',
regionCode: 156411722,
name: '上蔡县',
adcode: '156411722'
}, {
id: 1482,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '平舆县',
regionCode: 156411723,
name: '平舆县',
adcode: '156411723'
}, {
id: 1483,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '正阳县',
regionCode: 156411724,
name: '正阳县',
adcode: '156411724'
}, {
id: 1484,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '确山县',
regionCode: 156411725,
name: '确山县',
adcode: '156411725'
}, {
id: 1485,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '泌阳县',
regionCode: 156411726,
name: '泌阳县',
adcode: '156411726'
}, {
id: 1486,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '汝南县',
regionCode: 156411727,
name: '汝南县',
adcode: '156411727'
}, {
id: 1487,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '遂平县',
regionCode: 156411728,
name: '遂平县',
adcode: '156411728'
}, {
id: 1488,
province: '河南省',
provinceCode: 156410000,
city: '驻马店市',
cityCode: 156411700,
region: '新蔡县',
regionCode: 156411729,
name: '新蔡县',
adcode: '156411729'
}]
}]
}, {
province: '湖北省',
provinceCode: 156420000,
adcode: '156420000',
name: '湖北省',
children: [{
province: '湖北省',
provinceCode: 156420000,
city: '湖北省直辖',
adcode: '156420000',
name: '湖北省直辖',
cityCode: 156420000,
children: [{
id: 1589,
province: '湖北省',
provinceCode: 156420000,
city: '湖北省直辖',
cityCode: 156420000,
region: '仙桃市',
regionCode: 156429004,
name: '仙桃市',
adcode: '156429004'
}, {
id: 1590,
province: '湖北省',
provinceCode: 156420000,
city: '湖北省直辖',
cityCode: 156420000,
region: '潜江市',
regionCode: 156429005,
name: '潜江市',
adcode: '156429005'
}, {
id: 1591,
province: '湖北省',
provinceCode: 156420000,
city: '湖北省直辖',
cityCode: 156420000,
region: '天门市',
regionCode: 156429006,
name: '天门市',
adcode: '156429006'
}, {
id: 1592,
province: '湖北省',
provinceCode: 156420000,
city: '湖北省直辖',
cityCode: 156420000,
region: '神农架林区',
regionCode: 156429021,
name: '神农架林区',
adcode: '156429021'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
adcode: '156420100',
name: '武汉市',
cityCode: 156420100,
children: [{
id: 1490,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '江岸区',
regionCode: 156420102,
name: '江岸区',
adcode: '156420102'
}, {
id: 1491,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '江汉区',
regionCode: 156420103,
name: '江汉区',
adcode: '156420103'
}, {
id: 1492,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '硚口区',
regionCode: 156420104,
name: '硚口区',
adcode: '156420104'
}, {
id: 1493,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '汉阳区',
regionCode: 156420105,
name: '汉阳区',
adcode: '156420105'
}, {
id: 1494,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '武昌区',
regionCode: 156420106,
name: '武昌区',
adcode: '156420106'
}, {
id: 1495,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '青山区',
regionCode: 156420107,
name: '青山区',
adcode: '156420107'
}, {
id: 1496,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '洪山区',
regionCode: 156420111,
name: '洪山区',
adcode: '156420111'
}, {
id: 1497,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '东西湖区',
regionCode: 156420112,
name: '东西湖区',
adcode: '156420112'
}, {
id: 1498,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '汉南区',
regionCode: 156420113,
name: '汉南区',
adcode: '156420113'
}, {
id: 1499,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '蔡甸区',
regionCode: 156420114,
name: '蔡甸区',
adcode: '156420114'
}, {
id: 1500,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '江夏区',
regionCode: 156420115,
name: '江夏区',
adcode: '156420115'
}, {
id: 1501,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '黄陂区',
regionCode: 156420116,
name: '黄陂区',
adcode: '156420116'
}, {
id: 1502,
province: '湖北省',
provinceCode: 156420000,
city: '武汉市',
cityCode: 156420100,
region: '新洲区',
regionCode: 156420117,
name: '新洲区',
adcode: '156420117'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '黄石市',
adcode: '156420200',
name: '黄石市',
cityCode: 156420200,
children: [{
id: 1503,
province: '湖北省',
provinceCode: 156420000,
city: '黄石市',
cityCode: 156420200,
region: '黄石港区',
regionCode: 156420202,
name: '黄石港区',
adcode: '156420202'
}, {
id: 1504,
province: '湖北省',
provinceCode: 156420000,
city: '黄石市',
cityCode: 156420200,
region: '西塞山区',
regionCode: 156420203,
name: '西塞山区',
adcode: '156420203'
}, {
id: 1505,
province: '湖北省',
provinceCode: 156420000,
city: '黄石市',
cityCode: 156420200,
region: '下陆区',
regionCode: 156420204,
name: '下陆区',
adcode: '156420204'
}, {
id: 1506,
province: '湖北省',
provinceCode: 156420000,
city: '黄石市',
cityCode: 156420200,
region: '铁山区',
regionCode: 156420205,
name: '铁山区',
adcode: '156420205'
}, {
id: 1507,
province: '湖北省',
provinceCode: 156420000,
city: '黄石市',
cityCode: 156420200,
region: '阳新县',
regionCode: 156420222,
name: '阳新县',
adcode: '156420222'
}, {
id: 1508,
province: '湖北省',
provinceCode: 156420000,
city: '黄石市',
cityCode: 156420200,
region: '大冶市',
regionCode: 156420281,
name: '大冶市',
adcode: '156420281'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
adcode: '156420300',
name: '十堰市',
cityCode: 156420300,
children: [{
id: 1509,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '茅箭区',
regionCode: 156420302,
name: '茅箭区',
adcode: '156420302'
}, {
id: 1510,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '张湾区',
regionCode: 156420303,
name: '张湾区',
adcode: '156420303'
}, {
id: 1511,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '郧阳区',
regionCode: 156420304,
name: '郧阳区',
adcode: '156420304'
}, {
id: 1512,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '郧西县',
regionCode: 156420322,
name: '郧西县',
adcode: '156420322'
}, {
id: 1513,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '竹山县',
regionCode: 156420323,
name: '竹山县',
adcode: '156420323'
}, {
id: 1514,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '竹溪县',
regionCode: 156420324,
name: '竹溪县',
adcode: '156420324'
}, {
id: 1515,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '房县',
regionCode: 156420325,
name: '房县',
adcode: '156420325'
}, {
id: 1516,
province: '湖北省',
provinceCode: 156420000,
city: '十堰市',
cityCode: 156420300,
region: '丹江口市',
regionCode: 156420381,
name: '丹江口市',
adcode: '156420381'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
adcode: '156420500',
name: '宜昌市',
cityCode: 156420500,
children: [{
id: 1517,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '西陵区',
regionCode: 156420502,
name: '西陵区',
adcode: '156420502'
}, {
id: 1518,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '伍家岗区',
regionCode: 156420503,
name: '伍家岗区',
adcode: '156420503'
}, {
id: 1519,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '点军区',
regionCode: 156420504,
name: '点军区',
adcode: '156420504'
}, {
id: 1520,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '猇亭区',
regionCode: 156420505,
name: '猇亭区',
adcode: '156420505'
}, {
id: 1521,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '夷陵区',
regionCode: 156420506,
name: '夷陵区',
adcode: '156420506'
}, {
id: 1522,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '远安县',
regionCode: 156420525,
name: '远安县',
adcode: '156420525'
}, {
id: 1523,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '兴山县',
regionCode: 156420526,
name: '兴山县',
adcode: '156420526'
}, {
id: 1524,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '秭归县',
regionCode: 156420527,
name: '秭归县',
adcode: '156420527'
}, {
id: 1525,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '长阳土家族自治县',
regionCode: 156420528,
name: '长阳土家族自治县',
adcode: '156420528'
}, {
id: 1526,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '五峰土家族自治县',
regionCode: 156420529,
name: '五峰土家族自治县',
adcode: '156420529'
}, {
id: 1527,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '宜都市',
regionCode: 156420581,
name: '宜都市',
adcode: '156420581'
}, {
id: 1528,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '当阳市',
regionCode: 156420582,
name: '当阳市',
adcode: '156420582'
}, {
id: 1529,
province: '湖北省',
provinceCode: 156420000,
city: '宜昌市',
cityCode: 156420500,
region: '枝江市',
regionCode: 156420583,
name: '枝江市',
adcode: '156420583'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
adcode: '156420600',
name: '襄阳市',
cityCode: 156420600,
children: [{
id: 1530,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '襄城区',
regionCode: 156420602,
name: '襄城区',
adcode: '156420602'
}, {
id: 1531,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '樊城区',
regionCode: 156420606,
name: '樊城区',
adcode: '156420606'
}, {
id: 1532,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '襄州区',
regionCode: 156420607,
name: '襄州区',
adcode: '156420607'
}, {
id: 1533,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '南漳县',
regionCode: 156420624,
name: '南漳县',
adcode: '156420624'
}, {
id: 1534,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '谷城县',
regionCode: 156420625,
name: '谷城县',
adcode: '156420625'
}, {
id: 1535,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '保康县',
regionCode: 156420626,
name: '保康县',
adcode: '156420626'
}, {
id: 1536,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '老河口市',
regionCode: 156420682,
name: '老河口市',
adcode: '156420682'
}, {
id: 1537,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '枣阳市',
regionCode: 156420683,
name: '枣阳市',
adcode: '156420683'
}, {
id: 1538,
province: '湖北省',
provinceCode: 156420000,
city: '襄阳市',
cityCode: 156420600,
region: '宜城市',
regionCode: 156420684,
name: '宜城市',
adcode: '156420684'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '鄂州市',
adcode: '156420700',
name: '鄂州市',
cityCode: 156420700,
children: [{
id: 1539,
province: '湖北省',
provinceCode: 156420000,
city: '鄂州市',
cityCode: 156420700,
region: '梁子湖区',
regionCode: 156420702,
name: '梁子湖区',
adcode: '156420702'
}, {
id: 1540,
province: '湖北省',
provinceCode: 156420000,
city: '鄂州市',
cityCode: 156420700,
region: '华容区',
regionCode: 156420703,
name: '华容区',
adcode: '156420703'
}, {
id: 1541,
province: '湖北省',
provinceCode: 156420000,
city: '鄂州市',
cityCode: 156420700,
region: '鄂城区',
regionCode: 156420704,
name: '鄂城区',
adcode: '156420704'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '荆门市',
adcode: '156420800',
name: '荆门市',
cityCode: 156420800,
children: [{
id: 1542,
province: '湖北省',
provinceCode: 156420000,
city: '荆门市',
cityCode: 156420800,
region: '东宝区',
regionCode: 156420802,
name: '东宝区',
adcode: '156420802'
}, {
id: 1543,
province: '湖北省',
provinceCode: 156420000,
city: '荆门市',
cityCode: 156420800,
region: '掇刀区',
regionCode: 156420804,
name: '掇刀区',
adcode: '156420804'
}, {
id: 1544,
province: '湖北省',
provinceCode: 156420000,
city: '荆门市',
cityCode: 156420800,
region: '沙洋县',
regionCode: 156420822,
name: '沙洋县',
adcode: '156420822'
}, {
id: 1545,
province: '湖北省',
provinceCode: 156420000,
city: '荆门市',
cityCode: 156420800,
region: '钟祥市',
regionCode: 156420881,
name: '钟祥市',
adcode: '156420881'
}, {
id: 1546,
province: '湖北省',
provinceCode: 156420000,
city: '荆门市',
cityCode: 156420800,
region: '京山市',
regionCode: 156420882,
name: '京山市',
adcode: '156420882'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
adcode: '156420900',
name: '孝感市',
cityCode: 156420900,
children: [{
id: 1547,
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
cityCode: 156420900,
region: '孝南区',
regionCode: 156420902,
name: '孝南区',
adcode: '156420902'
}, {
id: 1548,
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
cityCode: 156420900,
region: '孝昌县',
regionCode: 156420921,
name: '孝昌县',
adcode: '156420921'
}, {
id: 1549,
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
cityCode: 156420900,
region: '大悟县',
regionCode: 156420922,
name: '大悟县',
adcode: '156420922'
}, {
id: 1550,
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
cityCode: 156420900,
region: '云梦县',
regionCode: 156420923,
name: '云梦县',
adcode: '156420923'
}, {
id: 1551,
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
cityCode: 156420900,
region: '应城市',
regionCode: 156420981,
name: '应城市',
adcode: '156420981'
}, {
id: 1552,
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
cityCode: 156420900,
region: '安陆市',
regionCode: 156420982,
name: '安陆市',
adcode: '156420982'
}, {
id: 1553,
province: '湖北省',
provinceCode: 156420000,
city: '孝感市',
cityCode: 156420900,
region: '汉川市',
regionCode: 156420984,
name: '汉川市',
adcode: '156420984'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
adcode: '156421000',
name: '荆州市',
cityCode: 156421000,
children: [{
id: 1554,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '沙市区',
regionCode: 156421002,
name: '沙市区',
adcode: '156421002'
}, {
id: 1555,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '荆州区',
regionCode: 156421003,
name: '荆州区',
adcode: '156421003'
}, {
id: 1556,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '公安县',
regionCode: 156421022,
name: '公安县',
adcode: '156421022'
}, {
id: 1557,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '监利县',
regionCode: 156421023,
name: '监利县',
adcode: '156421023'
}, {
id: 1558,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '江陵县',
regionCode: 156421024,
name: '江陵县',
adcode: '156421024'
}, {
id: 1559,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '石首市',
regionCode: 156421081,
name: '石首市',
adcode: '156421081'
}, {
id: 1560,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '洪湖市',
regionCode: 156421083,
name: '洪湖市',
adcode: '156421083'
}, {
id: 1561,
province: '湖北省',
provinceCode: 156420000,
city: '荆州市',
cityCode: 156421000,
region: '松滋市',
regionCode: 156421087,
name: '松滋市',
adcode: '156421087'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
adcode: '156421100',
name: '黄冈市',
cityCode: 156421100,
children: [{
id: 1562,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '黄州区',
regionCode: 156421102,
name: '黄州区',
adcode: '156421102'
}, {
id: 1563,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '团风县',
regionCode: 156421121,
name: '团风县',
adcode: '156421121'
}, {
id: 1564,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '红安县',
regionCode: 156421122,
name: '红安县',
adcode: '156421122'
}, {
id: 1565,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '罗田县',
regionCode: 156421123,
name: '罗田县',
adcode: '156421123'
}, {
id: 1566,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '英山县',
regionCode: 156421124,
name: '英山县',
adcode: '156421124'
}, {
id: 1567,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '浠水县',
regionCode: 156421125,
name: '浠水县',
adcode: '156421125'
}, {
id: 1568,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '蕲春县',
regionCode: 156421126,
name: '蕲春县',
adcode: '156421126'
}, {
id: 1569,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '黄梅县',
regionCode: 156421127,
name: '黄梅县',
adcode: '156421127'
}, {
id: 1570,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '麻城市',
regionCode: 156421181,
name: '麻城市',
adcode: '156421181'
}, {
id: 1571,
province: '湖北省',
provinceCode: 156420000,
city: '黄冈市',
cityCode: 156421100,
region: '武穴市',
regionCode: 156421182,
name: '武穴市',
adcode: '156421182'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '咸宁市',
adcode: '156421200',
name: '咸宁市',
cityCode: 156421200,
children: [{
id: 1572,
province: '湖北省',
provinceCode: 156420000,
city: '咸宁市',
cityCode: 156421200,
region: '咸安区',
regionCode: 156421202,
name: '咸安区',
adcode: '156421202'
}, {
id: 1573,
province: '湖北省',
provinceCode: 156420000,
city: '咸宁市',
cityCode: 156421200,
region: '嘉鱼县',
regionCode: 156421221,
name: '嘉鱼县',
adcode: '156421221'
}, {
id: 1574,
province: '湖北省',
provinceCode: 156420000,
city: '咸宁市',
cityCode: 156421200,
region: '通城县',
regionCode: 156421222,
name: '通城县',
adcode: '156421222'
}, {
id: 1575,
province: '湖北省',
provinceCode: 156420000,
city: '咸宁市',
cityCode: 156421200,
region: '崇阳县',
regionCode: 156421223,
name: '崇阳县',
adcode: '156421223'
}, {
id: 1576,
province: '湖北省',
provinceCode: 156420000,
city: '咸宁市',
cityCode: 156421200,
region: '通山县',
regionCode: 156421224,
name: '通山县',
adcode: '156421224'
}, {
id: 1577,
province: '湖北省',
provinceCode: 156420000,
city: '咸宁市',
cityCode: 156421200,
region: '赤壁市',
regionCode: 156421281,
name: '赤壁市',
adcode: '156421281'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '随州市',
adcode: '156421300',
name: '随州市',
cityCode: 156421300,
children: [{
id: 1578,
province: '湖北省',
provinceCode: 156420000,
city: '随州市',
cityCode: 156421300,
region: '曾都区',
regionCode: 156421303,
name: '曾都区',
adcode: '156421303'
}, {
id: 1579,
province: '湖北省',
provinceCode: 156420000,
city: '随州市',
cityCode: 156421300,
region: '随县',
regionCode: 156421321,
name: '随县',
adcode: '156421321'
}, {
id: 1580,
province: '湖北省',
provinceCode: 156420000,
city: '随州市',
cityCode: 156421300,
region: '广水市',
regionCode: 156421381,
name: '广水市',
adcode: '156421381'
}]
}, {
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
adcode: '156422800',
name: '恩施土家族苗族自治州',
cityCode: 156422800,
children: [{
id: 1581,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '恩施市',
regionCode: 156422801,
name: '恩施市',
adcode: '156422801'
}, {
id: 1582,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '利川市',
regionCode: 156422802,
name: '利川市',
adcode: '156422802'
}, {
id: 1583,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '建始县',
regionCode: 156422822,
name: '建始县',
adcode: '156422822'
}, {
id: 1584,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '巴东县',
regionCode: 156422823,
name: '巴东县',
adcode: '156422823'
}, {
id: 1585,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '宣恩县',
regionCode: 156422825,
name: '宣恩县',
adcode: '156422825'
}, {
id: 1586,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '咸丰县',
regionCode: 156422826,
name: '咸丰县',
adcode: '156422826'
}, {
id: 1587,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '来凤县',
regionCode: 156422827,
name: '来凤县',
adcode: '156422827'
}, {
id: 1588,
province: '湖北省',
provinceCode: 156420000,
city: '恩施土家族苗族自治州',
cityCode: 156422800,
region: '鹤峰县',
regionCode: 156422828,
name: '鹤峰县',
adcode: '156422828'
}]
}]
}, {
province: '湖南省',
provinceCode: 156430000,
adcode: '156430000',
name: '湖南省',
children: [{
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
adcode: '156430100',
name: '长沙市',
cityCode: 156430100,
children: [{
id: 1593,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '芙蓉区',
regionCode: 156430102,
name: '芙蓉区',
adcode: '156430102'
}, {
id: 1594,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '天心区',
regionCode: 156430103,
name: '天心区',
adcode: '156430103'
}, {
id: 1595,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '岳麓区',
regionCode: 156430104,
name: '岳麓区',
adcode: '156430104'
}, {
id: 1596,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '开福区',
regionCode: 156430105,
name: '开福区',
adcode: '156430105'
}, {
id: 1597,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '雨花区',
regionCode: 156430111,
name: '雨花区',
adcode: '156430111'
}, {
id: 1598,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '望城区',
regionCode: 156430112,
name: '望城区',
adcode: '156430112'
}, {
id: 1599,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '长沙县',
regionCode: 156430121,
name: '长沙县',
adcode: '156430121'
}, {
id: 1600,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '浏阳市',
regionCode: 156430181,
name: '浏阳市',
adcode: '156430181'
}, {
id: 1601,
province: '湖南省',
provinceCode: 156430000,
city: '长沙市',
cityCode: 156430100,
region: '宁乡市',
regionCode: 156430182,
name: '宁乡市',
adcode: '156430182'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
adcode: '156430200',
name: '株洲市',
cityCode: 156430200,
children: [{
id: 1602,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '荷塘区',
regionCode: 156430202,
name: '荷塘区',
adcode: '156430202'
}, {
id: 1603,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '芦淞区',
regionCode: 156430203,
name: '芦淞区',
adcode: '156430203'
}, {
id: 1604,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '石峰区',
regionCode: 156430204,
name: '石峰区',
adcode: '156430204'
}, {
id: 1605,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '天元区',
regionCode: 156430211,
name: '天元区',
adcode: '156430211'
}, {
id: 1606,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '渌口区',
regionCode: 156430212,
name: '渌口区',
adcode: '156430212'
}, {
id: 1607,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '攸县',
regionCode: 156430223,
name: '攸县',
adcode: '156430223'
}, {
id: 1608,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '茶陵县',
regionCode: 156430224,
name: '茶陵县',
adcode: '156430224'
}, {
id: 1609,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '炎陵县',
regionCode: 156430225,
name: '炎陵县',
adcode: '156430225'
}, {
id: 1610,
province: '湖南省',
provinceCode: 156430000,
city: '株洲市',
cityCode: 156430200,
region: '醴陵市',
regionCode: 156430281,
name: '醴陵市',
adcode: '156430281'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '湘潭市',
adcode: '156430300',
name: '湘潭市',
cityCode: 156430300,
children: [{
id: 1611,
province: '湖南省',
provinceCode: 156430000,
city: '湘潭市',
cityCode: 156430300,
region: '雨湖区',
regionCode: 156430302,
name: '雨湖区',
adcode: '156430302'
}, {
id: 1612,
province: '湖南省',
provinceCode: 156430000,
city: '湘潭市',
cityCode: 156430300,
region: '岳塘区',
regionCode: 156430304,
name: '岳塘区',
adcode: '156430304'
}, {
id: 1613,
province: '湖南省',
provinceCode: 156430000,
city: '湘潭市',
cityCode: 156430300,
region: '湘潭县',
regionCode: 156430321,
name: '湘潭县',
adcode: '156430321'
}, {
id: 1614,
province: '湖南省',
provinceCode: 156430000,
city: '湘潭市',
cityCode: 156430300,
region: '湘乡市',
regionCode: 156430381,
name: '湘乡市',
adcode: '156430381'
}, {
id: 1615,
province: '湖南省',
provinceCode: 156430000,
city: '湘潭市',
cityCode: 156430300,
region: '韶山市',
regionCode: 156430382,
name: '韶山市',
adcode: '156430382'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
adcode: '156430400',
name: '衡阳市',
cityCode: 156430400,
children: [{
id: 1616,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '珠晖区',
regionCode: 156430405,
name: '珠晖区',
adcode: '156430405'
}, {
id: 1617,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '雁峰区',
regionCode: 156430406,
name: '雁峰区',
adcode: '156430406'
}, {
id: 1618,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '石鼓区',
regionCode: 156430407,
name: '石鼓区',
adcode: '156430407'
}, {
id: 1619,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '蒸湘区',
regionCode: 156430408,
name: '蒸湘区',
adcode: '156430408'
}, {
id: 1620,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '南岳区',
regionCode: 156430412,
name: '南岳区',
adcode: '156430412'
}, {
id: 1621,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '衡阳县',
regionCode: 156430421,
name: '衡阳县',
adcode: '156430421'
}, {
id: 1622,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '衡南县',
regionCode: 156430422,
name: '衡南县',
adcode: '156430422'
}, {
id: 1623,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '衡山县',
regionCode: 156430423,
name: '衡山县',
adcode: '156430423'
}, {
id: 1624,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '衡东县',
regionCode: 156430424,
name: '衡东县',
adcode: '156430424'
}, {
id: 1625,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '祁东县',
regionCode: 156430426,
name: '祁东县',
adcode: '156430426'
}, {
id: 1626,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '耒阳市',
regionCode: 156430481,
name: '耒阳市',
adcode: '156430481'
}, {
id: 1627,
province: '湖南省',
provinceCode: 156430000,
city: '衡阳市',
cityCode: 156430400,
region: '常宁市',
regionCode: 156430482,
name: '常宁市',
adcode: '156430482'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
adcode: '156430500',
name: '邵阳市',
cityCode: 156430500,
children: [{
id: 1628,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '双清区',
regionCode: 156430502,
name: '双清区',
adcode: '156430502'
}, {
id: 1629,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '大祥区',
regionCode: 156430503,
name: '大祥区',
adcode: '156430503'
}, {
id: 1630,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '北塔区',
regionCode: 156430511,
name: '北塔区',
adcode: '156430511'
}, {
id: 1631,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '新邵县',
regionCode: 156430522,
name: '新邵县',
adcode: '156430522'
}, {
id: 1632,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '邵阳县',
regionCode: 156430523,
name: '邵阳县',
adcode: '156430523'
}, {
id: 1633,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '隆回县',
regionCode: 156430524,
name: '隆回县',
adcode: '156430524'
}, {
id: 1634,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '洞口县',
regionCode: 156430525,
name: '洞口县',
adcode: '156430525'
}, {
id: 1635,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '绥宁县',
regionCode: 156430527,
name: '绥宁县',
adcode: '156430527'
}, {
id: 1636,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '新宁县',
regionCode: 156430528,
name: '新宁县',
adcode: '156430528'
}, {
id: 1637,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '城步苗族自治县',
regionCode: 156430529,
name: '城步苗族自治县',
adcode: '156430529'
}, {
id: 1638,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '武冈市',
regionCode: 156430581,
name: '武冈市',
adcode: '156430581'
}, {
id: 1639,
province: '湖南省',
provinceCode: 156430000,
city: '邵阳市',
cityCode: 156430500,
region: '邵东市',
regionCode: 156430582,
name: '邵东市',
adcode: '156430582'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
adcode: '156430600',
name: '岳阳市',
cityCode: 156430600,
children: [{
id: 1640,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '岳阳楼区',
regionCode: 156430602,
name: '岳阳楼区',
adcode: '156430602'
}, {
id: 1641,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '云溪区',
regionCode: 156430603,
name: '云溪区',
adcode: '156430603'
}, {
id: 1642,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '君山区',
regionCode: 156430611,
name: '君山区',
adcode: '156430611'
}, {
id: 1643,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '岳阳县',
regionCode: 156430621,
name: '岳阳县',
adcode: '156430621'
}, {
id: 1644,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '华容县',
regionCode: 156430623,
name: '华容县',
adcode: '156430623'
}, {
id: 1645,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '湘阴县',
regionCode: 156430624,
name: '湘阴县',
adcode: '156430624'
}, {
id: 1646,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '平江县',
regionCode: 156430626,
name: '平江县',
adcode: '156430626'
}, {
id: 1647,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '汨罗市',
regionCode: 156430681,
name: '汨罗市',
adcode: '156430681'
}, {
id: 1648,
province: '湖南省',
provinceCode: 156430000,
city: '岳阳市',
cityCode: 156430600,
region: '临湘市',
regionCode: 156430682,
name: '临湘市',
adcode: '156430682'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
adcode: '156430700',
name: '常德市',
cityCode: 156430700,
children: [{
id: 1649,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '武陵区',
regionCode: 156430702,
name: '武陵区',
adcode: '156430702'
}, {
id: 1650,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '鼎城区',
regionCode: 156430703,
name: '鼎城区',
adcode: '156430703'
}, {
id: 1651,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '安乡县',
regionCode: 156430721,
name: '安乡县',
adcode: '156430721'
}, {
id: 1652,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '汉寿县',
regionCode: 156430722,
name: '汉寿县',
adcode: '156430722'
}, {
id: 1653,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '澧县',
regionCode: 156430723,
name: '澧县',
adcode: '156430723'
}, {
id: 1654,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '临澧县',
regionCode: 156430724,
name: '临澧县',
adcode: '156430724'
}, {
id: 1655,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '桃源县',
regionCode: 156430725,
name: '桃源县',
adcode: '156430725'
}, {
id: 1656,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '石门县',
regionCode: 156430726,
name: '石门县',
adcode: '156430726'
}, {
id: 1657,
province: '湖南省',
provinceCode: 156430000,
city: '常德市',
cityCode: 156430700,
region: '津市市',
regionCode: 156430781,
name: '津市市',
adcode: '156430781'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '张家界市',
adcode: '156430800',
name: '张家界市',
cityCode: 156430800,
children: [{
id: 1658,
province: '湖南省',
provinceCode: 156430000,
city: '张家界市',
cityCode: 156430800,
region: '永定区',
regionCode: 156430802,
name: '永定区',
adcode: '156430802'
}, {
id: 1659,
province: '湖南省',
provinceCode: 156430000,
city: '张家界市',
cityCode: 156430800,
region: '武陵源区',
regionCode: 156430811,
name: '武陵源区',
adcode: '156430811'
}, {
id: 1660,
province: '湖南省',
provinceCode: 156430000,
city: '张家界市',
cityCode: 156430800,
region: '慈利县',
regionCode: 156430821,
name: '慈利县',
adcode: '156430821'
}, {
id: 1661,
province: '湖南省',
provinceCode: 156430000,
city: '张家界市',
cityCode: 156430800,
region: '桑植县',
regionCode: 156430822,
name: '桑植县',
adcode: '156430822'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '益阳市',
adcode: '156430900',
name: '益阳市',
cityCode: 156430900,
children: [{
id: 1662,
province: '湖南省',
provinceCode: 156430000,
city: '益阳市',
cityCode: 156430900,
region: '资阳区',
regionCode: 156430902,
name: '资阳区',
adcode: '156430902'
}, {
id: 1663,
province: '湖南省',
provinceCode: 156430000,
city: '益阳市',
cityCode: 156430900,
region: '赫山区',
regionCode: 156430903,
name: '赫山区',
adcode: '156430903'
}, {
id: 1664,
province: '湖南省',
provinceCode: 156430000,
city: '益阳市',
cityCode: 156430900,
region: '南县',
regionCode: 156430921,
name: '南县',
adcode: '156430921'
}, {
id: 1665,
province: '湖南省',
provinceCode: 156430000,
city: '益阳市',
cityCode: 156430900,
region: '桃江县',
regionCode: 156430922,
name: '桃江县',
adcode: '156430922'
}, {
id: 1666,
province: '湖南省',
provinceCode: 156430000,
city: '益阳市',
cityCode: 156430900,
region: '安化县',
regionCode: 156430923,
name: '安化县',
adcode: '156430923'
}, {
id: 1667,
province: '湖南省',
provinceCode: 156430000,
city: '益阳市',
cityCode: 156430900,
region: '沅江市',
regionCode: 156430981,
name: '沅江市',
adcode: '156430981'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
adcode: '156431000',
name: '郴州市',
cityCode: 156431000,
children: [{
id: 1668,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '北湖区',
regionCode: 156431002,
name: '北湖区',
adcode: '156431002'
}, {
id: 1669,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '苏仙区',
regionCode: 156431003,
name: '苏仙区',
adcode: '156431003'
}, {
id: 1670,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '桂阳县',
regionCode: 156431021,
name: '桂阳县',
adcode: '156431021'
}, {
id: 1671,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '宜章县',
regionCode: 156431022,
name: '宜章县',
adcode: '156431022'
}, {
id: 1672,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '永兴县',
regionCode: 156431023,
name: '永兴县',
adcode: '156431023'
}, {
id: 1673,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '嘉禾县',
regionCode: 156431024,
name: '嘉禾县',
adcode: '156431024'
}, {
id: 1674,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '临武县',
regionCode: 156431025,
name: '临武县',
adcode: '156431025'
}, {
id: 1675,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '汝城县',
regionCode: 156431026,
name: '汝城县',
adcode: '156431026'
}, {
id: 1676,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '桂东县',
regionCode: 156431027,
name: '桂东县',
adcode: '156431027'
}, {
id: 1677,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '安仁县',
regionCode: 156431028,
name: '安仁县',
adcode: '156431028'
}, {
id: 1678,
province: '湖南省',
provinceCode: 156430000,
city: '郴州市',
cityCode: 156431000,
region: '资兴市',
regionCode: 156431081,
name: '资兴市',
adcode: '156431081'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
adcode: '156431100',
name: '永州市',
cityCode: 156431100,
children: [{
id: 1679,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '零陵区',
regionCode: 156431102,
name: '零陵区',
adcode: '156431102'
}, {
id: 1680,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '冷水滩区',
regionCode: 156431103,
name: '冷水滩区',
adcode: '156431103'
}, {
id: 1681,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '祁阳县',
regionCode: 156431121,
name: '祁阳县',
adcode: '156431121'
}, {
id: 1682,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '东安县',
regionCode: 156431122,
name: '东安县',
adcode: '156431122'
}, {
id: 1683,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '双牌县',
regionCode: 156431123,
name: '双牌县',
adcode: '156431123'
}, {
id: 1684,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '道县',
regionCode: 156431124,
name: '道县',
adcode: '156431124'
}, {
id: 1685,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '江永县',
regionCode: 156431125,
name: '江永县',
adcode: '156431125'
}, {
id: 1686,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '宁远县',
regionCode: 156431126,
name: '宁远县',
adcode: '156431126'
}, {
id: 1687,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '蓝山县',
regionCode: 156431127,
name: '蓝山县',
adcode: '156431127'
}, {
id: 1688,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '新田县',
regionCode: 156431128,
name: '新田县',
adcode: '156431128'
}, {
id: 1689,
province: '湖南省',
provinceCode: 156430000,
city: '永州市',
cityCode: 156431100,
region: '江华瑶族自治县',
regionCode: 156431129,
name: '江华瑶族自治县',
adcode: '156431129'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
adcode: '156431200',
name: '怀化市',
cityCode: 156431200,
children: [{
id: 1690,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '鹤城区',
regionCode: 156431202,
name: '鹤城区',
adcode: '156431202'
}, {
id: 1691,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '中方县',
regionCode: 156431221,
name: '中方县',
adcode: '156431221'
}, {
id: 1692,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '沅陵县',
regionCode: 156431222,
name: '沅陵县',
adcode: '156431222'
}, {
id: 1693,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '辰溪县',
regionCode: 156431223,
name: '辰溪县',
adcode: '156431223'
}, {
id: 1694,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '溆浦县',
regionCode: 156431224,
name: '溆浦县',
adcode: '156431224'
}, {
id: 1695,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '会同县',
regionCode: 156431225,
name: '会同县',
adcode: '156431225'
}, {
id: 1696,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '麻阳苗族自治县',
regionCode: 156431226,
name: '麻阳苗族自治县',
adcode: '156431226'
}, {
id: 1697,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '新晃侗族自治县',
regionCode: 156431227,
name: '新晃侗族自治县',
adcode: '156431227'
}, {
id: 1698,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '芷江侗族自治县',
regionCode: 156431228,
name: '芷江侗族自治县',
adcode: '156431228'
}, {
id: 1699,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '靖州苗族侗族自治县',
regionCode: 156431229,
name: '靖州苗族侗族自治县',
adcode: '156431229'
}, {
id: 1700,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '通道侗族自治县',
regionCode: 156431230,
name: '通道侗族自治县',
adcode: '156431230'
}, {
id: 1701,
province: '湖南省',
provinceCode: 156430000,
city: '怀化市',
cityCode: 156431200,
region: '洪江市',
regionCode: 156431281,
name: '洪江市',
adcode: '156431281'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '娄底市',
adcode: '156431300',
name: '娄底市',
cityCode: 156431300,
children: [{
id: 1702,
province: '湖南省',
provinceCode: 156430000,
city: '娄底市',
cityCode: 156431300,
region: '娄星区',
regionCode: 156431302,
name: '娄星区',
adcode: '156431302'
}, {
id: 1703,
province: '湖南省',
provinceCode: 156430000,
city: '娄底市',
cityCode: 156431300,
region: '双峰县',
regionCode: 156431321,
name: '双峰县',
adcode: '156431321'
}, {
id: 1704,
province: '湖南省',
provinceCode: 156430000,
city: '娄底市',
cityCode: 156431300,
region: '新化县',
regionCode: 156431322,
name: '新化县',
adcode: '156431322'
}, {
id: 1705,
province: '湖南省',
provinceCode: 156430000,
city: '娄底市',
cityCode: 156431300,
region: '冷水江市',
regionCode: 156431381,
name: '冷水江市',
adcode: '156431381'
}, {
id: 1706,
province: '湖南省',
provinceCode: 156430000,
city: '娄底市',
cityCode: 156431300,
region: '涟源市',
regionCode: 156431382,
name: '涟源市',
adcode: '156431382'
}]
}, {
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
adcode: '156433100',
name: '湘西土家族苗族自治州',
cityCode: 156433100,
children: [{
id: 1707,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '吉首市',
regionCode: 156433101,
name: '吉首市',
adcode: '156433101'
}, {
id: 1708,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '泸溪县',
regionCode: 156433122,
name: '泸溪县',
adcode: '156433122'
}, {
id: 1709,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '凤凰县',
regionCode: 156433123,
name: '凤凰县',
adcode: '156433123'
}, {
id: 1710,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '花垣县',
regionCode: 156433124,
name: '花垣县',
adcode: '156433124'
}, {
id: 1711,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '保靖县',
regionCode: 156433125,
name: '保靖县',
adcode: '156433125'
}, {
id: 1712,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '古丈县',
regionCode: 156433126,
name: '古丈县',
adcode: '156433126'
}, {
id: 1713,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '永顺县',
regionCode: 156433127,
name: '永顺县',
adcode: '156433127'
}, {
id: 1714,
province: '湖南省',
provinceCode: 156430000,
city: '湘西土家族苗族自治州',
cityCode: 156433100,
region: '龙山县',
regionCode: 156433130,
name: '龙山县',
adcode: '156433130'
}]
}]
}, {
province: '广东省',
provinceCode: 156440000,
adcode: '156440000',
name: '广东省',
children: [{
province: '广东省',
provinceCode: 156440000,
city: '广州市',
adcode: '156440100',
name: '广州市',
cityCode: 156440100,
children: [{
id: 1715,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '荔湾区',
regionCode: 156440103,
name: '荔湾区',
adcode: '156440103'
}, {
id: 1716,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '越秀区',
regionCode: 156440104,
name: '越秀区',
adcode: '156440104'
}, {
id: 1717,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '海珠区',
regionCode: 156440105,
name: '海珠区',
adcode: '156440105'
}, {
id: 1718,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '天河区',
regionCode: 156440106,
name: '天河区',
adcode: '156440106'
}, {
id: 1719,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '白云区',
regionCode: 156440111,
name: '白云区',
adcode: '156440111'
}, {
id: 1720,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '黄埔区',
regionCode: 156440112,
name: '黄埔区',
adcode: '156440112'
}, {
id: 1721,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '番禺区',
regionCode: 156440113,
name: '番禺区',
adcode: '156440113'
}, {
id: 1722,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '花都区',
regionCode: 156440114,
name: '花都区',
adcode: '156440114'
}, {
id: 1723,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '南沙区',
regionCode: 156440115,
name: '南沙区',
adcode: '156440115'
}, {
id: 1724,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '从化区',
regionCode: 156440117,
name: '从化区',
adcode: '156440117'
}, {
id: 1725,
province: '广东省',
provinceCode: 156440000,
city: '广州市',
cityCode: 156440100,
region: '增城区',
regionCode: 156440118,
name: '增城区',
adcode: '156440118'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
adcode: '156440200',
name: '韶关市',
cityCode: 156440200,
children: [{
id: 1726,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '武江区',
regionCode: 156440203,
name: '武江区',
adcode: '156440203'
}, {
id: 1727,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '浈江区',
regionCode: 156440204,
name: '浈江区',
adcode: '156440204'
}, {
id: 1728,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '曲江区',
regionCode: 156440205,
name: '曲江区',
adcode: '156440205'
}, {
id: 1729,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '始兴县',
regionCode: 156440222,
name: '始兴县',
adcode: '156440222'
}, {
id: 1730,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '仁化县',
regionCode: 156440224,
name: '仁化县',
adcode: '156440224'
}, {
id: 1731,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '翁源县',
regionCode: 156440229,
name: '翁源县',
adcode: '156440229'
}, {
id: 1732,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '乳源瑶族自治县',
regionCode: 156440232,
name: '乳源瑶族自治县',
adcode: '156440232'
}, {
id: 1733,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '新丰县',
regionCode: 156440233,
name: '新丰县',
adcode: '156440233'
}, {
id: 1734,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '乐昌市',
regionCode: 156440281,
name: '乐昌市',
adcode: '156440281'
}, {
id: 1735,
province: '广东省',
provinceCode: 156440000,
city: '韶关市',
cityCode: 156440200,
region: '南雄市',
regionCode: 156440282,
name: '南雄市',
adcode: '156440282'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
adcode: '156440300',
name: '深圳市',
cityCode: 156440300,
children: [{
id: 1736,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '罗湖区',
regionCode: 156440303,
name: '罗湖区',
adcode: '156440303'
}, {
id: 1737,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '福田区',
regionCode: 156440304,
name: '福田区',
adcode: '156440304'
}, {
id: 1738,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '南山区',
regionCode: 156440305,
name: '南山区',
adcode: '156440305'
}, {
id: 1739,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '宝安区',
regionCode: 156440306,
name: '宝安区',
adcode: '156440306'
}, {
id: 1740,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '龙岗区',
regionCode: 156440307,
name: '龙岗区',
adcode: '156440307'
}, {
id: 1741,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '盐田区',
regionCode: 156440308,
name: '盐田区',
adcode: '156440308'
}, {
id: 1742,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '龙华区',
regionCode: 156440309,
name: '龙华区',
adcode: '156440309'
}, {
id: 1743,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '坪山区',
regionCode: 156440310,
name: '坪山区',
adcode: '156440310'
}, {
id: 1744,
province: '广东省',
provinceCode: 156440000,
city: '深圳市',
cityCode: 156440300,
region: '光明区',
regionCode: 156440311,
name: '光明区',
adcode: '156440311'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '珠海市',
adcode: '156440400',
name: '珠海市',
cityCode: 156440400,
children: [{
id: 1745,
province: '广东省',
provinceCode: 156440000,
city: '珠海市',
cityCode: 156440400,
region: '香洲区',
regionCode: 156440402,
name: '香洲区',
adcode: '156440402'
}, {
id: 1746,
province: '广东省',
provinceCode: 156440000,
city: '珠海市',
cityCode: 156440400,
region: '斗门区',
regionCode: 156440403,
name: '斗门区',
adcode: '156440403'
}, {
id: 1747,
province: '广东省',
provinceCode: 156440000,
city: '珠海市',
cityCode: 156440400,
region: '金湾区',
regionCode: 156440404,
name: '金湾区',
adcode: '156440404'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
adcode: '156440500',
name: '汕头市',
cityCode: 156440500,
children: [{
id: 1748,
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
cityCode: 156440500,
region: '龙湖区',
regionCode: 156440507,
name: '龙湖区',
adcode: '156440507'
}, {
id: 1749,
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
cityCode: 156440500,
region: '金平区',
regionCode: 156440511,
name: '金平区',
adcode: '156440511'
}, {
id: 1750,
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
cityCode: 156440500,
region: '濠江区',
regionCode: 156440512,
name: '濠江区',
adcode: '156440512'
}, {
id: 1751,
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
cityCode: 156440500,
region: '潮阳区',
regionCode: 156440513,
name: '潮阳区',
adcode: '156440513'
}, {
id: 1752,
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
cityCode: 156440500,
region: '潮南区',
regionCode: 156440514,
name: '潮南区',
adcode: '156440514'
}, {
id: 1753,
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
cityCode: 156440500,
region: '澄海区',
regionCode: 156440515,
name: '澄海区',
adcode: '156440515'
}, {
id: 1754,
province: '广东省',
provinceCode: 156440000,
city: '汕头市',
cityCode: 156440500,
region: '南澳县',
regionCode: 156440523,
name: '南澳县',
adcode: '156440523'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '佛山市',
adcode: '156440600',
name: '佛山市',
cityCode: 156440600,
children: [{
id: 1755,
province: '广东省',
provinceCode: 156440000,
city: '佛山市',
cityCode: 156440600,
region: '禅城区',
regionCode: 156440604,
name: '禅城区',
adcode: '156440604'
}, {
id: 1756,
province: '广东省',
provinceCode: 156440000,
city: '佛山市',
cityCode: 156440600,
region: '南海区',
regionCode: 156440605,
name: '南海区',
adcode: '156440605'
}, {
id: 1757,
province: '广东省',
provinceCode: 156440000,
city: '佛山市',
cityCode: 156440600,
region: '顺德区',
regionCode: 156440606,
name: '顺德区',
adcode: '156440606'
}, {
id: 1758,
province: '广东省',
provinceCode: 156440000,
city: '佛山市',
cityCode: 156440600,
region: '三水区',
regionCode: 156440607,
name: '三水区',
adcode: '156440607'
}, {
id: 1759,
province: '广东省',
provinceCode: 156440000,
city: '佛山市',
cityCode: 156440600,
region: '高明区',
regionCode: 156440608,
name: '高明区',
adcode: '156440608'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '江门市',
adcode: '156440700',
name: '江门市',
cityCode: 156440700,
children: [{
id: 1760,
province: '广东省',
provinceCode: 156440000,
city: '江门市',
cityCode: 156440700,
region: '蓬江区',
regionCode: 156440703,
name: '蓬江区',
adcode: '156440703'
}, {
id: 1761,
province: '广东省',
provinceCode: 156440000,
city: '江门市',
cityCode: 156440700,
region: '江海区',
regionCode: 156440704,
name: '江海区',
adcode: '156440704'
}, {
id: 1762,
province: '广东省',
provinceCode: 156440000,
city: '江门市',
cityCode: 156440700,
region: '新会区',
regionCode: 156440705,
name: '新会区',
adcode: '156440705'
}, {
id: 1763,
province: '广东省',
provinceCode: 156440000,
city: '江门市',
cityCode: 156440700,
region: '台山市',
regionCode: 156440781,
name: '台山市',
adcode: '156440781'
}, {
id: 1764,
province: '广东省',
provinceCode: 156440000,
city: '江门市',
cityCode: 156440700,
region: '开平市',
regionCode: 156440783,
name: '开平市',
adcode: '156440783'
}, {
id: 1765,
province: '广东省',
provinceCode: 156440000,
city: '江门市',
cityCode: 156440700,
region: '鹤山市',
regionCode: 156440784,
name: '鹤山市',
adcode: '156440784'
}, {
id: 1766,
province: '广东省',
provinceCode: 156440000,
city: '江门市',
cityCode: 156440700,
region: '恩平市',
regionCode: 156440785,
name: '恩平市',
adcode: '156440785'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
adcode: '156440800',
name: '湛江市',
cityCode: 156440800,
children: [{
id: 1767,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '赤坎区',
regionCode: 156440802,
name: '赤坎区',
adcode: '156440802'
}, {
id: 1768,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '霞山区',
regionCode: 156440803,
name: '霞山区',
adcode: '156440803'
}, {
id: 1769,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '坡头区',
regionCode: 156440804,
name: '坡头区',
adcode: '156440804'
}, {
id: 1770,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '麻章区',
regionCode: 156440811,
name: '麻章区',
adcode: '156440811'
}, {
id: 1771,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '遂溪县',
regionCode: 156440823,
name: '遂溪县',
adcode: '156440823'
}, {
id: 1772,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '徐闻县',
regionCode: 156440825,
name: '徐闻县',
adcode: '156440825'
}, {
id: 1773,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '廉江市',
regionCode: 156440881,
name: '廉江市',
adcode: '156440881'
}, {
id: 1774,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '雷州市',
regionCode: 156440882,
name: '雷州市',
adcode: '156440882'
}, {
id: 1775,
province: '广东省',
provinceCode: 156440000,
city: '湛江市',
cityCode: 156440800,
region: '吴川市',
regionCode: 156440883,
name: '吴川市',
adcode: '156440883'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '茂名市',
adcode: '156440900',
name: '茂名市',
cityCode: 156440900,
children: [{
id: 1776,
province: '广东省',
provinceCode: 156440000,
city: '茂名市',
cityCode: 156440900,
region: '茂南区',
regionCode: 156440902,
name: '茂南区',
adcode: '156440902'
}, {
id: 1777,
province: '广东省',
provinceCode: 156440000,
city: '茂名市',
cityCode: 156440900,
region: '电白区',
regionCode: 156440904,
name: '电白区',
adcode: '156440904'
}, {
id: 1778,
province: '广东省',
provinceCode: 156440000,
city: '茂名市',
cityCode: 156440900,
region: '高州市',
regionCode: 156440981,
name: '高州市',
adcode: '156440981'
}, {
id: 1779,
province: '广东省',
provinceCode: 156440000,
city: '茂名市',
cityCode: 156440900,
region: '化州市',
regionCode: 156440982,
name: '化州市',
adcode: '156440982'
}, {
id: 1780,
province: '广东省',
provinceCode: 156440000,
city: '茂名市',
cityCode: 156440900,
region: '信宜市',
regionCode: 156440983,
name: '信宜市',
adcode: '156440983'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
adcode: '156441200',
name: '肇庆市',
cityCode: 156441200,
children: [{
id: 1781,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '端州区',
regionCode: 156441202,
name: '端州区',
adcode: '156441202'
}, {
id: 1782,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '鼎湖区',
regionCode: 156441203,
name: '鼎湖区',
adcode: '156441203'
}, {
id: 1783,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '高要区',
regionCode: 156441204,
name: '高要区',
adcode: '156441204'
}, {
id: 1784,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '广宁县',
regionCode: 156441223,
name: '广宁县',
adcode: '156441223'
}, {
id: 1785,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '怀集县',
regionCode: 156441224,
name: '怀集县',
adcode: '156441224'
}, {
id: 1786,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '封开县',
regionCode: 156441225,
name: '封开县',
adcode: '156441225'
}, {
id: 1787,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '德庆县',
regionCode: 156441226,
name: '德庆县',
adcode: '156441226'
}, {
id: 1788,
province: '广东省',
provinceCode: 156440000,
city: '肇庆市',
cityCode: 156441200,
region: '四会市',
regionCode: 156441284,
name: '四会市',
adcode: '156441284'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '惠州市',
adcode: '156441300',
name: '惠州市',
cityCode: 156441300,
children: [{
id: 1789,
province: '广东省',
provinceCode: 156440000,
city: '惠州市',
cityCode: 156441300,
region: '惠城区',
regionCode: 156441302,
name: '惠城区',
adcode: '156441302'
}, {
id: 1790,
province: '广东省',
provinceCode: 156440000,
city: '惠州市',
cityCode: 156441300,
region: '惠阳区',
regionCode: 156441303,
name: '惠阳区',
adcode: '156441303'
}, {
id: 1791,
province: '广东省',
provinceCode: 156440000,
city: '惠州市',
cityCode: 156441300,
region: '博罗县',
regionCode: 156441322,
name: '博罗县',
adcode: '156441322'
}, {
id: 1792,
province: '广东省',
provinceCode: 156440000,
city: '惠州市',
cityCode: 156441300,
region: '惠东县',
regionCode: 156441323,
name: '惠东县',
adcode: '156441323'
}, {
id: 1793,
province: '广东省',
provinceCode: 156440000,
city: '惠州市',
cityCode: 156441300,
region: '龙门县',
regionCode: 156441324,
name: '龙门县',
adcode: '156441324'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
adcode: '156441400',
name: '梅州市',
cityCode: 156441400,
children: [{
id: 1794,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '梅江区',
regionCode: 156441402,
name: '梅江区',
adcode: '156441402'
}, {
id: 1795,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '梅县区',
regionCode: 156441403,
name: '梅县区',
adcode: '156441403'
}, {
id: 1796,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '大埔县',
regionCode: 156441422,
name: '大埔县',
adcode: '156441422'
}, {
id: 1797,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '丰顺县',
regionCode: 156441423,
name: '丰顺县',
adcode: '156441423'
}, {
id: 1798,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '五华县',
regionCode: 156441424,
name: '五华县',
adcode: '156441424'
}, {
id: 1799,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '平远县',
regionCode: 156441426,
name: '平远县',
adcode: '156441426'
}, {
id: 1800,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '蕉岭县',
regionCode: 156441427,
name: '蕉岭县',
adcode: '156441427'
}, {
id: 1801,
province: '广东省',
provinceCode: 156440000,
city: '梅州市',
cityCode: 156441400,
region: '兴宁市',
regionCode: 156441481,
name: '兴宁市',
adcode: '156441481'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '汕尾市',
adcode: '156441500',
name: '汕尾市',
cityCode: 156441500,
children: [{
id: 1802,
province: '广东省',
provinceCode: 156440000,
city: '汕尾市',
cityCode: 156441500,
region: '城区',
regionCode: 156441502,
name: '城区',
adcode: '156441502'
}, {
id: 1803,
province: '广东省',
provinceCode: 156440000,
city: '汕尾市',
cityCode: 156441500,
region: '海丰县',
regionCode: 156441521,
name: '海丰县',
adcode: '156441521'
}, {
id: 1804,
province: '广东省',
provinceCode: 156440000,
city: '汕尾市',
cityCode: 156441500,
region: '陆河县',
regionCode: 156441523,
name: '陆河县',
adcode: '156441523'
}, {
id: 1805,
province: '广东省',
provinceCode: 156440000,
city: '汕尾市',
cityCode: 156441500,
region: '陆丰市',
regionCode: 156441581,
name: '陆丰市',
adcode: '156441581'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '河源市',
adcode: '156441600',
name: '河源市',
cityCode: 156441600,
children: [{
id: 1806,
province: '广东省',
provinceCode: 156440000,
city: '河源市',
cityCode: 156441600,
region: '源城区',
regionCode: 156441602,
name: '源城区',
adcode: '156441602'
}, {
id: 1807,
province: '广东省',
provinceCode: 156440000,
city: '河源市',
cityCode: 156441600,
region: '紫金县',
regionCode: 156441621,
name: '紫金县',
adcode: '156441621'
}, {
id: 1808,
province: '广东省',
provinceCode: 156440000,
city: '河源市',
cityCode: 156441600,
region: '龙川县',
regionCode: 156441622,
name: '龙川县',
adcode: '156441622'
}, {
id: 1809,
province: '广东省',
provinceCode: 156440000,
city: '河源市',
cityCode: 156441600,
region: '连平县',
regionCode: 156441623,
name: '连平县',
adcode: '156441623'
}, {
id: 1810,
province: '广东省',
provinceCode: 156440000,
city: '河源市',
cityCode: 156441600,
region: '和平县',
regionCode: 156441624,
name: '和平县',
adcode: '156441624'
}, {
id: 1811,
province: '广东省',
provinceCode: 156440000,
city: '河源市',
cityCode: 156441600,
region: '东源县',
regionCode: 156441625,
name: '东源县',
adcode: '156441625'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '阳江市',
adcode: '156441700',
name: '阳江市',
cityCode: 156441700,
children: [{
id: 1812,
province: '广东省',
provinceCode: 156440000,
city: '阳江市',
cityCode: 156441700,
region: '江城区',
regionCode: 156441702,
name: '江城区',
adcode: '156441702'
}, {
id: 1813,
province: '广东省',
provinceCode: 156440000,
city: '阳江市',
cityCode: 156441700,
region: '阳东区',
regionCode: 156441704,
name: '阳东区',
adcode: '156441704'
}, {
id: 1814,
province: '广东省',
provinceCode: 156440000,
city: '阳江市',
cityCode: 156441700,
region: '阳西县',
regionCode: 156441721,
name: '阳西县',
adcode: '156441721'
}, {
id: 1815,
province: '广东省',
provinceCode: 156440000,
city: '阳江市',
cityCode: 156441700,
region: '阳春市',
regionCode: 156441781,
name: '阳春市',
adcode: '156441781'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '清远市',
adcode: '156441800',
name: '清远市',
cityCode: 156441800,
children: [{
id: 1816,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '清城区',
regionCode: 156441802,
name: '清城区',
adcode: '156441802'
}, {
id: 1817,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '清新区',
regionCode: 156441803,
name: '清新区',
adcode: '156441803'
}, {
id: 1818,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '佛冈县',
regionCode: 156441821,
name: '佛冈县',
adcode: '156441821'
}, {
id: 1819,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '阳山县',
regionCode: 156441823,
name: '阳山县',
adcode: '156441823'
}, {
id: 1820,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '连山壮族瑶族自治县',
regionCode: 156441825,
name: '连山壮族瑶族自治县',
adcode: '156441825'
}, {
id: 1821,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '连南瑶族自治县',
regionCode: 156441826,
name: '连南瑶族自治县',
adcode: '156441826'
}, {
id: 1822,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '英德市',
regionCode: 156441881,
name: '英德市',
adcode: '156441881'
}, {
id: 1823,
province: '广东省',
provinceCode: 156440000,
city: '清远市',
cityCode: 156441800,
region: '连州市',
regionCode: 156441882,
name: '连州市',
adcode: '156441882'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '东莞市',
adcode: '156441900',
name: '东莞市',
cityCode: 156441900,
children: [{
id: 1824,
province: '广东省',
provinceCode: 156440000,
city: '东莞市',
cityCode: 156441900,
region: '东莞市',
regionCode: 156441900,
name: '东莞市',
adcode: '156441900'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '中山市',
adcode: '156442000',
name: '中山市',
cityCode: 156442000,
children: [{
id: 1825,
province: '广东省',
provinceCode: 156440000,
city: '中山市',
cityCode: 156442000,
region: '中山市',
regionCode: 156442000,
name: '中山市',
adcode: '156442000'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '潮州市',
adcode: '156445100',
name: '潮州市',
cityCode: 156445100,
children: [{
id: 1826,
province: '广东省',
provinceCode: 156440000,
city: '潮州市',
cityCode: 156445100,
region: '湘桥区',
regionCode: 156445102,
name: '湘桥区',
adcode: '156445102'
}, {
id: 1827,
province: '广东省',
provinceCode: 156440000,
city: '潮州市',
cityCode: 156445100,
region: '潮安区',
regionCode: 156445103,
name: '潮安区',
adcode: '156445103'
}, {
id: 1828,
province: '广东省',
provinceCode: 156440000,
city: '潮州市',
cityCode: 156445100,
region: '饶平县',
regionCode: 156445122,
name: '饶平县',
adcode: '156445122'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '揭阳市',
adcode: '156445200',
name: '揭阳市',
cityCode: 156445200,
children: [{
id: 1829,
province: '广东省',
provinceCode: 156440000,
city: '揭阳市',
cityCode: 156445200,
region: '榕城区',
regionCode: 156445202,
name: '榕城区',
adcode: '156445202'
}, {
id: 1830,
province: '广东省',
provinceCode: 156440000,
city: '揭阳市',
cityCode: 156445200,
region: '揭东区',
regionCode: 156445203,
name: '揭东区',
adcode: '156445203'
}, {
id: 1831,
province: '广东省',
provinceCode: 156440000,
city: '揭阳市',
cityCode: 156445200,
region: '揭西县',
regionCode: 156445222,
name: '揭西县',
adcode: '156445222'
}, {
id: 1832,
province: '广东省',
provinceCode: 156440000,
city: '揭阳市',
cityCode: 156445200,
region: '惠来县',
regionCode: 156445224,
name: '惠来县',
adcode: '156445224'
}, {
id: 1833,
province: '广东省',
provinceCode: 156440000,
city: '揭阳市',
cityCode: 156445200,
region: '普宁市',
regionCode: 156445281,
name: '普宁市',
adcode: '156445281'
}]
}, {
province: '广东省',
provinceCode: 156440000,
city: '云浮市',
adcode: '156445300',
name: '云浮市',
cityCode: 156445300,
children: [{
id: 1834,
province: '广东省',
provinceCode: 156440000,
city: '云浮市',
cityCode: 156445300,
region: '云城区',
regionCode: 156445302,
name: '云城区',
adcode: '156445302'
}, {
id: 1835,
province: '广东省',
provinceCode: 156440000,
city: '云浮市',
cityCode: 156445300,
region: '云安区',
regionCode: 156445303,
name: '云安区',
adcode: '156445303'
}, {
id: 1836,
province: '广东省',
provinceCode: 156440000,
city: '云浮市',
cityCode: 156445300,
region: '新兴县',
regionCode: 156445321,
name: '新兴县',
adcode: '156445321'
}, {
id: 1837,
province: '广东省',
provinceCode: 156440000,
city: '云浮市',
cityCode: 156445300,
region: '郁南县',
regionCode: 156445322,
name: '郁南县',
adcode: '156445322'
}, {
id: 1838,
province: '广东省',
provinceCode: 156440000,
city: '云浮市',
cityCode: 156445300,
region: '罗定市',
regionCode: 156445381,
name: '罗定市',
adcode: '156445381'
}]
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
adcode: '156450000',
name: '广西壮族自治区',
children: [{
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
adcode: '156450100',
name: '南宁市',
cityCode: 156450100,
children: [{
id: 1839,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '兴宁区',
regionCode: 156450102,
name: '兴宁区',
adcode: '156450102'
}, {
id: 1840,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '青秀区',
regionCode: 156450103,
name: '青秀区',
adcode: '156450103'
}, {
id: 1841,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '江南区',
regionCode: 156450105,
name: '江南区',
adcode: '156450105'
}, {
id: 1842,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '西乡塘区',
regionCode: 156450107,
name: '西乡塘区',
adcode: '156450107'
}, {
id: 1843,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '良庆区',
regionCode: 156450108,
name: '良庆区',
adcode: '156450108'
}, {
id: 1844,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '邕宁区',
regionCode: 156450109,
name: '邕宁区',
adcode: '156450109'
}, {
id: 1845,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '武鸣区',
regionCode: 156450110,
name: '武鸣区',
adcode: '156450110'
}, {
id: 1846,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '隆安县',
regionCode: 156450123,
name: '隆安县',
adcode: '156450123'
}, {
id: 1847,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '马山县',
regionCode: 156450124,
name: '马山县',
adcode: '156450124'
}, {
id: 1848,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '上林县',
regionCode: 156450125,
name: '上林县',
adcode: '156450125'
}, {
id: 1849,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '宾阳县',
regionCode: 156450126,
name: '宾阳县',
adcode: '156450126'
}, {
id: 1850,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '南宁市',
cityCode: 156450100,
region: '横县',
regionCode: 156450127,
name: '横县',
adcode: '156450127'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
adcode: '156450200',
name: '柳州市',
cityCode: 156450200,
children: [{
id: 1851,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '城中区',
regionCode: 156450202,
name: '城中区',
adcode: '156450202'
}, {
id: 1852,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '鱼峰区',
regionCode: 156450203,
name: '鱼峰区',
adcode: '156450203'
}, {
id: 1853,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '柳南区',
regionCode: 156450204,
name: '柳南区',
adcode: '156450204'
}, {
id: 1854,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '柳北区',
regionCode: 156450205,
name: '柳北区',
adcode: '156450205'
}, {
id: 1855,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '柳江区',
regionCode: 156450206,
name: '柳江区',
adcode: '156450206'
}, {
id: 1856,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '柳城县',
regionCode: 156450222,
name: '柳城县',
adcode: '156450222'
}, {
id: 1857,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '鹿寨县',
regionCode: 156450223,
name: '鹿寨县',
adcode: '156450223'
}, {
id: 1858,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '融安县',
regionCode: 156450224,
name: '融安县',
adcode: '156450224'
}, {
id: 1859,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '融水苗族自治县',
regionCode: 156450225,
name: '融水苗族自治县',
adcode: '156450225'
}, {
id: 1860,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '柳州市',
cityCode: 156450200,
region: '三江侗族自治县',
regionCode: 156450226,
name: '三江侗族自治县',
adcode: '156450226'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
adcode: '156450300',
name: '桂林市',
cityCode: 156450300,
children: [{
id: 1861,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '秀峰区',
regionCode: 156450302,
name: '秀峰区',
adcode: '156450302'
}, {
id: 1862,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '叠彩区',
regionCode: 156450303,
name: '叠彩区',
adcode: '156450303'
}, {
id: 1863,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '象山区',
regionCode: 156450304,
name: '象山区',
adcode: '156450304'
}, {
id: 1864,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '七星区',
regionCode: 156450305,
name: '七星区',
adcode: '156450305'
}, {
id: 1865,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '雁山区',
regionCode: 156450311,
name: '雁山区',
adcode: '156450311'
}, {
id: 1866,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '临桂区',
regionCode: 156450312,
name: '临桂区',
adcode: '156450312'
}, {
id: 1867,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '阳朔县',
regionCode: 156450321,
name: '阳朔县',
adcode: '156450321'
}, {
id: 1868,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '灵川县',
regionCode: 156450323,
name: '灵川县',
adcode: '156450323'
}, {
id: 1869,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '全州县',
regionCode: 156450324,
name: '全州县',
adcode: '156450324'
}, {
id: 1870,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '兴安县',
regionCode: 156450325,
name: '兴安县',
adcode: '156450325'
}, {
id: 1871,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '永福县',
regionCode: 156450326,
name: '永福县',
adcode: '156450326'
}, {
id: 1872,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '灌阳县',
regionCode: 156450327,
name: '灌阳县',
adcode: '156450327'
}, {
id: 1873,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '龙胜各族自治县',
regionCode: 156450328,
name: '龙胜各族自治县',
adcode: '156450328'
}, {
id: 1874,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '资源县',
regionCode: 156450329,
name: '资源县',
adcode: '156450329'
}, {
id: 1875,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '平乐县',
regionCode: 156450330,
name: '平乐县',
adcode: '156450330'
}, {
id: 1876,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '恭城瑶族自治县',
regionCode: 156450332,
name: '恭城瑶族自治县',
adcode: '156450332'
}, {
id: 1877,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '桂林市',
cityCode: 156450300,
region: '荔浦市',
regionCode: 156450381,
name: '荔浦市',
adcode: '156450381'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
adcode: '156450400',
name: '梧州市',
cityCode: 156450400,
children: [{
id: 1878,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
cityCode: 156450400,
region: '万秀区',
regionCode: 156450403,
name: '万秀区',
adcode: '156450403'
}, {
id: 1879,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
cityCode: 156450400,
region: '长洲区',
regionCode: 156450405,
name: '长洲区',
adcode: '156450405'
}, {
id: 1880,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
cityCode: 156450400,
region: '龙圩区',
regionCode: 156450406,
name: '龙圩区',
adcode: '156450406'
}, {
id: 1881,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
cityCode: 156450400,
region: '苍梧县',
regionCode: 156450421,
name: '苍梧县',
adcode: '156450421'
}, {
id: 1882,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
cityCode: 156450400,
region: '藤县',
regionCode: 156450422,
name: '藤县',
adcode: '156450422'
}, {
id: 1883,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
cityCode: 156450400,
region: '蒙山县',
regionCode: 156450423,
name: '蒙山县',
adcode: '156450423'
}, {
id: 1884,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '梧州市',
cityCode: 156450400,
region: '岑溪市',
regionCode: 156450481,
name: '岑溪市',
adcode: '156450481'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '北海市',
adcode: '156450500',
name: '北海市',
cityCode: 156450500,
children: [{
id: 1885,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '北海市',
cityCode: 156450500,
region: '海城区',
regionCode: 156450502,
name: '海城区',
adcode: '156450502'
}, {
id: 1886,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '北海市',
cityCode: 156450500,
region: '银海区',
regionCode: 156450503,
name: '银海区',
adcode: '156450503'
}, {
id: 1887,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '北海市',
cityCode: 156450500,
region: '铁山港区',
regionCode: 156450512,
name: '铁山港区',
adcode: '156450512'
}, {
id: 1888,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '北海市',
cityCode: 156450500,
region: '合浦县',
regionCode: 156450521,
name: '合浦县',
adcode: '156450521'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '防城港市',
adcode: '156450600',
name: '防城港市',
cityCode: 156450600,
children: [{
id: 1889,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '防城港市',
cityCode: 156450600,
region: '港口区',
regionCode: 156450602,
name: '港口区',
adcode: '156450602'
}, {
id: 1890,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '防城港市',
cityCode: 156450600,
region: '防城区',
regionCode: 156450603,
name: '防城区',
adcode: '156450603'
}, {
id: 1891,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '防城港市',
cityCode: 156450600,
region: '上思县',
regionCode: 156450621,
name: '上思县',
adcode: '156450621'
}, {
id: 1892,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '防城港市',
cityCode: 156450600,
region: '东兴市',
regionCode: 156450681,
name: '东兴市',
adcode: '156450681'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '钦州市',
adcode: '156450700',
name: '钦州市',
cityCode: 156450700,
children: [{
id: 1893,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '钦州市',
cityCode: 156450700,
region: '钦南区',
regionCode: 156450702,
name: '钦南区',
adcode: '156450702'
}, {
id: 1894,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '钦州市',
cityCode: 156450700,
region: '钦北区',
regionCode: 156450703,
name: '钦北区',
adcode: '156450703'
}, {
id: 1895,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '钦州市',
cityCode: 156450700,
region: '灵山县',
regionCode: 156450721,
name: '灵山县',
adcode: '156450721'
}, {
id: 1896,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '钦州市',
cityCode: 156450700,
region: '浦北县',
regionCode: 156450722,
name: '浦北县',
adcode: '156450722'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贵港市',
adcode: '156450800',
name: '贵港市',
cityCode: 156450800,
children: [{
id: 1897,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贵港市',
cityCode: 156450800,
region: '港北区',
regionCode: 156450802,
name: '港北区',
adcode: '156450802'
}, {
id: 1898,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贵港市',
cityCode: 156450800,
region: '港南区',
regionCode: 156450803,
name: '港南区',
adcode: '156450803'
}, {
id: 1899,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贵港市',
cityCode: 156450800,
region: '覃塘区',
regionCode: 156450804,
name: '覃塘区',
adcode: '156450804'
}, {
id: 1900,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贵港市',
cityCode: 156450800,
region: '平南县',
regionCode: 156450821,
name: '平南县',
adcode: '156450821'
}, {
id: 1901,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贵港市',
cityCode: 156450800,
region: '桂平市',
regionCode: 156450881,
name: '桂平市',
adcode: '156450881'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
adcode: '156450900',
name: '玉林市',
cityCode: 156450900,
children: [{
id: 1902,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
cityCode: 156450900,
region: '玉州区',
regionCode: 156450902,
name: '玉州区',
adcode: '156450902'
}, {
id: 1903,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
cityCode: 156450900,
region: '福绵区',
regionCode: 156450903,
name: '福绵区',
adcode: '156450903'
}, {
id: 1904,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
cityCode: 156450900,
region: '容县',
regionCode: 156450921,
name: '容县',
adcode: '156450921'
}, {
id: 1905,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
cityCode: 156450900,
region: '陆川县',
regionCode: 156450922,
name: '陆川县',
adcode: '156450922'
}, {
id: 1906,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
cityCode: 156450900,
region: '博白县',
regionCode: 156450923,
name: '博白县',
adcode: '156450923'
}, {
id: 1907,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
cityCode: 156450900,
region: '兴业县',
regionCode: 156450924,
name: '兴业县',
adcode: '156450924'
}, {
id: 1908,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '玉林市',
cityCode: 156450900,
region: '北流市',
regionCode: 156450981,
name: '北流市',
adcode: '156450981'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
adcode: '156451000',
name: '百色市',
cityCode: 156451000,
children: [{
id: 1909,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '右江区',
regionCode: 156451002,
name: '右江区',
adcode: '156451002'
}, {
id: 1910,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '田阳区',
regionCode: 156451003,
name: '田阳区',
adcode: '156451003'
}, {
id: 1911,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '田东县',
regionCode: 156451022,
name: '田东县',
adcode: '156451022'
}, {
id: 1912,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '德保县',
regionCode: 156451024,
name: '德保县',
adcode: '156451024'
}, {
id: 1913,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '那坡县',
regionCode: 156451026,
name: '那坡县',
adcode: '156451026'
}, {
id: 1914,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '凌云县',
regionCode: 156451027,
name: '凌云县',
adcode: '156451027'
}, {
id: 1915,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '乐业县',
regionCode: 156451028,
name: '乐业县',
adcode: '156451028'
}, {
id: 1916,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '田林县',
regionCode: 156451029,
name: '田林县',
adcode: '156451029'
}, {
id: 1917,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '西林县',
regionCode: 156451030,
name: '西林县',
adcode: '156451030'
}, {
id: 1918,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '隆林各族自治县',
regionCode: 156451031,
name: '隆林各族自治县',
adcode: '156451031'
}, {
id: 1919,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '靖西市',
regionCode: 156451081,
name: '靖西市',
adcode: '156451081'
}, {
id: 1920,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '百色市',
cityCode: 156451000,
region: '平果市',
regionCode: 156451082,
name: '平果市',
adcode: '156451082'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贺州市',
adcode: '156451100',
name: '贺州市',
cityCode: 156451100,
children: [{
id: 1921,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贺州市',
cityCode: 156451100,
region: '八步区',
regionCode: 156451102,
name: '八步区',
adcode: '156451102'
}, {
id: 1922,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贺州市',
cityCode: 156451100,
region: '平桂区',
regionCode: 156451103,
name: '平桂区',
adcode: '156451103'
}, {
id: 1923,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贺州市',
cityCode: 156451100,
region: '昭平县',
regionCode: 156451121,
name: '昭平县',
adcode: '156451121'
}, {
id: 1924,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贺州市',
cityCode: 156451100,
region: '钟山县',
regionCode: 156451122,
name: '钟山县',
adcode: '156451122'
}, {
id: 1925,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '贺州市',
cityCode: 156451100,
region: '富川瑶族自治县',
regionCode: 156451123,
name: '富川瑶族自治县',
adcode: '156451123'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
adcode: '156451200',
name: '河池市',
cityCode: 156451200,
children: [{
id: 1926,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '金城江区',
regionCode: 156451202,
name: '金城江区',
adcode: '156451202'
}, {
id: 1927,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '宜州区',
regionCode: 156451203,
name: '宜州区',
adcode: '156451203'
}, {
id: 1928,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '南丹县',
regionCode: 156451221,
name: '南丹县',
adcode: '156451221'
}, {
id: 1929,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '天峨县',
regionCode: 156451222,
name: '天峨县',
adcode: '156451222'
}, {
id: 1930,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '凤山县',
regionCode: 156451223,
name: '凤山县',
adcode: '156451223'
}, {
id: 1931,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '东兰县',
regionCode: 156451224,
name: '东兰县',
adcode: '156451224'
}, {
id: 1932,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '罗城仫佬族自治县',
regionCode: 156451225,
name: '罗城仫佬族自治县',
adcode: '156451225'
}, {
id: 1933,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '环江毛南族自治县',
regionCode: 156451226,
name: '环江毛南族自治县',
adcode: '156451226'
}, {
id: 1934,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '巴马瑶族自治县',
regionCode: 156451227,
name: '巴马瑶族自治县',
adcode: '156451227'
}, {
id: 1935,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '都安瑶族自治县',
regionCode: 156451228,
name: '都安瑶族自治县',
adcode: '156451228'
}, {
id: 1936,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '河池市',
cityCode: 156451200,
region: '大化瑶族自治县',
regionCode: 156451229,
name: '大化瑶族自治县',
adcode: '156451229'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '来宾市',
adcode: '156451300',
name: '来宾市',
cityCode: 156451300,
children: [{
id: 1937,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '来宾市',
cityCode: 156451300,
region: '兴宾区',
regionCode: 156451302,
name: '兴宾区',
adcode: '156451302'
}, {
id: 1938,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '来宾市',
cityCode: 156451300,
region: '忻城县',
regionCode: 156451321,
name: '忻城县',
adcode: '156451321'
}, {
id: 1939,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '来宾市',
cityCode: 156451300,
region: '象州县',
regionCode: 156451322,
name: '象州县',
adcode: '156451322'
}, {
id: 1940,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '来宾市',
cityCode: 156451300,
region: '武宣县',
regionCode: 156451323,
name: '武宣县',
adcode: '156451323'
}, {
id: 1941,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '来宾市',
cityCode: 156451300,
region: '金秀瑶族自治县',
regionCode: 156451324,
name: '金秀瑶族自治县',
adcode: '156451324'
}, {
id: 1942,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '来宾市',
cityCode: 156451300,
region: '合山市',
regionCode: 156451381,
name: '合山市',
adcode: '156451381'
}]
}, {
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
adcode: '156451400',
name: '崇左市',
cityCode: 156451400,
children: [{
id: 1943,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
cityCode: 156451400,
region: '江州区',
regionCode: 156451402,
name: '江州区',
adcode: '156451402'
}, {
id: 1944,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
cityCode: 156451400,
region: '扶绥县',
regionCode: 156451421,
name: '扶绥县',
adcode: '156451421'
}, {
id: 1945,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
cityCode: 156451400,
region: '宁明县',
regionCode: 156451422,
name: '宁明县',
adcode: '156451422'
}, {
id: 1946,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
cityCode: 156451400,
region: '龙州县',
regionCode: 156451423,
name: '龙州县',
adcode: '156451423'
}, {
id: 1947,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
cityCode: 156451400,
region: '大新县',
regionCode: 156451424,
name: '大新县',
adcode: '156451424'
}, {
id: 1948,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
cityCode: 156451400,
region: '天等县',
regionCode: 156451425,
name: '天等县',
adcode: '156451425'
}, {
id: 1949,
province: '广西壮族自治区',
provinceCode: 156450000,
city: '崇左市',
cityCode: 156451400,
region: '凭祥市',
regionCode: 156451481,
name: '凭祥市',
adcode: '156451481'
}]
}]
}, {
province: '海南省',
provinceCode: 156460000,
adcode: '156460000',
name: '海南省',
children: [{
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
adcode: '156460000',
name: '海南省直辖',
cityCode: 156460000,
children: [{
id: 1962,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '五指山市',
regionCode: 156469001,
name: '五指山市',
adcode: '156469001'
}, {
id: 1963,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '琼海市',
regionCode: 156469002,
name: '琼海市',
adcode: '156469002'
}, {
id: 1964,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '文昌市',
regionCode: 156469005,
name: '文昌市',
adcode: '156469005'
}, {
id: 1965,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '万宁市',
regionCode: 156469006,
name: '万宁市',
adcode: '156469006'
}, {
id: 1966,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '东方市',
regionCode: 156469007,
name: '东方市',
adcode: '156469007'
}, {
id: 1967,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '定安县',
regionCode: 156469021,
name: '定安县',
adcode: '156469021'
}, {
id: 1968,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '屯昌县',
regionCode: 156469022,
name: '屯昌县',
adcode: '156469022'
}, {
id: 1969,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '澄迈县',
regionCode: 156469023,
name: '澄迈县',
adcode: '156469023'
}, {
id: 1970,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '临高县',
regionCode: 156469024,
name: '临高县',
adcode: '156469024'
}, {
id: 1971,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '白沙黎族自治县',
regionCode: 156469025,
name: '白沙黎族自治县',
adcode: '156469025'
}, {
id: 1972,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '昌江黎族自治县',
regionCode: 156469026,
name: '昌江黎族自治县',
adcode: '156469026'
}, {
id: 1973,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '乐东黎族自治县',
regionCode: 156469027,
name: '乐东黎族自治县',
adcode: '156469027'
}, {
id: 1974,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '陵水黎族自治县',
regionCode: 156469028,
name: '陵水黎族自治县',
adcode: '156469028'
}, {
id: 1975,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '保亭黎族苗族自治县',
regionCode: 156469029,
name: '保亭黎族苗族自治县',
adcode: '156469029'
}, {
id: 1976,
province: '海南省',
provinceCode: 156460000,
city: '海南省直辖',
cityCode: 156460000,
region: '琼中黎族苗族自治县',
regionCode: 156469030,
name: '琼中黎族苗族自治县',
adcode: '156469030'
}]
}, {
province: '海南省',
provinceCode: 156460000,
city: '海口市',
adcode: '156460100',
name: '海口市',
cityCode: 156460100,
children: [{
id: 1950,
province: '海南省',
provinceCode: 156460000,
city: '海口市',
cityCode: 156460100,
region: '秀英区',
regionCode: 156460105,
name: '秀英区',
adcode: '156460105'
}, {
id: 1951,
province: '海南省',
provinceCode: 156460000,
city: '海口市',
cityCode: 156460100,
region: '龙华区',
regionCode: 156460106,
name: '龙华区',
adcode: '156460106'
}, {
id: 1952,
province: '海南省',
provinceCode: 156460000,
city: '海口市',
cityCode: 156460100,
region: '琼山区',
regionCode: 156460107,
name: '琼山区',
adcode: '156460107'
}, {
id: 1953,
province: '海南省',
provinceCode: 156460000,
city: '海口市',
cityCode: 156460100,
region: '美兰区',
regionCode: 156460108,
name: '美兰区',
adcode: '156460108'
}]
}, {
province: '海南省',
provinceCode: 156460000,
city: '三亚市',
adcode: '156460200',
name: '三亚市',
cityCode: 156460200,
children: [{
id: 1954,
province: '海南省',
provinceCode: 156460000,
city: '三亚市',
cityCode: 156460200,
region: '海棠区',
regionCode: 156460202,
name: '海棠区',
adcode: '156460202'
}, {
id: 1955,
province: '海南省',
provinceCode: 156460000,
city: '三亚市',
cityCode: 156460200,
region: '吉阳区',
regionCode: 156460203,
name: '吉阳区',
adcode: '156460203'
}, {
id: 1956,
province: '海南省',
provinceCode: 156460000,
city: '三亚市',
cityCode: 156460200,
region: '天涯区',
regionCode: 156460204,
name: '天涯区',
adcode: '156460204'
}, {
id: 1957,
province: '海南省',
provinceCode: 156460000,
city: '三亚市',
cityCode: 156460200,
region: '崖州区',
regionCode: 156460205,
name: '崖州区',
adcode: '156460205'
}]
}, {
province: '海南省',
provinceCode: 156460000,
city: '三沙市',
adcode: '156460300',
name: '三沙市',
cityCode: 156460300,
children: [{
id: 1958,
province: '海南省',
provinceCode: 156460000,
city: '三沙市',
cityCode: 156460300,
region: '西沙群岛',
regionCode: 156460321,
name: '西沙群岛',
adcode: '156460321'
}, {
id: 1959,
province: '海南省',
provinceCode: 156460000,
city: '三沙市',
cityCode: 156460300,
region: '南沙群岛',
regionCode: 156460322,
name: '南沙群岛',
adcode: '156460322'
}, {
id: 1960,
province: '海南省',
provinceCode: 156460000,
city: '三沙市',
cityCode: 156460300,
region: '中沙群岛',
regionCode: 156460323,
name: '中沙群岛',
adcode: '156460323'
}]
}, {
province: '海南省',
provinceCode: 156460000,
city: '儋州市',
adcode: '156460400',
name: '儋州市',
cityCode: 156460400,
children: [{
id: 1961,
province: '海南省',
provinceCode: 156460000,
city: '儋州市',
cityCode: 156460400,
region: '儋州市',
regionCode: 156460400,
name: '儋州市',
adcode: '156460400'
}]
}]
}, {
province: '重庆市',
provinceCode: 156500000,
adcode: '156500000',
name: '重庆市',
children: [{
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
adcode: '156500000',
name: '重庆市',
cityCode: 156500000,
children: [{
id: 1977,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '万州区',
regionCode: 156500101,
name: '万州区',
adcode: '156500101'
}, {
id: 1978,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '涪陵区',
regionCode: 156500102,
name: '涪陵区',
adcode: '156500102'
}, {
id: 1979,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '渝中区',
regionCode: 156500103,
name: '渝中区',
adcode: '156500103'
}, {
id: 1980,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '大渡口区',
regionCode: 156500104,
name: '大渡口区',
adcode: '156500104'
}, {
id: 1981,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '江北区',
regionCode: 156500105,
name: '江北区',
adcode: '156500105'
}, {
id: 1982,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '沙坪坝区',
regionCode: 156500106,
name: '沙坪坝区',
adcode: '156500106'
}, {
id: 1983,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '九龙坡区',
regionCode: 156500107,
name: '九龙坡区',
adcode: '156500107'
}, {
id: 1984,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '南岸区',
regionCode: 156500108,
name: '南岸区',
adcode: '156500108'
}, {
id: 1985,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '北碚区',
regionCode: 156500109,
name: '北碚区',
adcode: '156500109'
}, {
id: 1986,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '綦江区',
regionCode: 156500110,
name: '綦江区',
adcode: '156500110'
}, {
id: 1987,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '大足区',
regionCode: 156500111,
name: '大足区',
adcode: '156500111'
}, {
id: 1988,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '渝北区',
regionCode: 156500112,
name: '渝北区',
adcode: '156500112'
}, {
id: 1989,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '巴南区',
regionCode: 156500113,
name: '巴南区',
adcode: '156500113'
}, {
id: 1990,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '黔江区',
regionCode: 156500114,
name: '黔江区',
adcode: '156500114'
}, {
id: 1991,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '长寿区',
regionCode: 156500115,
name: '长寿区',
adcode: '156500115'
}, {
id: 1992,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '江津区',
regionCode: 156500116,
name: '江津区',
adcode: '156500116'
}, {
id: 1993,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '合川区',
regionCode: 156500117,
name: '合川区',
adcode: '156500117'
}, {
id: 1994,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '永川区',
regionCode: 156500118,
name: '永川区',
adcode: '156500118'
}, {
id: 1995,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '南川区',
regionCode: 156500119,
name: '南川区',
adcode: '156500119'
}, {
id: 1996,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '璧山区',
regionCode: 156500120,
name: '璧山区',
adcode: '156500120'
}, {
id: 1997,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '铜梁区',
regionCode: 156500151,
name: '铜梁区',
adcode: '156500151'
}, {
id: 1998,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '潼南区',
regionCode: 156500152,
name: '潼南区',
adcode: '156500152'
}, {
id: 1999,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '荣昌区',
regionCode: 156500153,
name: '荣昌区',
adcode: '156500153'
}, {
id: 2000,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '开州区',
regionCode: 156500154,
name: '开州区',
adcode: '156500154'
}, {
id: 2001,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '梁平区',
regionCode: 156500155,
name: '梁平区',
adcode: '156500155'
}, {
id: 2002,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '武隆区',
regionCode: 156500156,
name: '武隆区',
adcode: '156500156'
}, {
id: 2003,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '城口县',
regionCode: 156500229,
name: '城口县',
adcode: '156500229'
}, {
id: 2004,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '丰都县',
regionCode: 156500230,
name: '丰都县',
adcode: '156500230'
}, {
id: 2005,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '垫江县',
regionCode: 156500231,
name: '垫江县',
adcode: '156500231'
}, {
id: 2006,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '忠县',
regionCode: 156500233,
name: '忠县',
adcode: '156500233'
}, {
id: 2007,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '云阳县',
regionCode: 156500235,
name: '云阳县',
adcode: '156500235'
}, {
id: 2008,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '奉节县',
regionCode: 156500236,
name: '奉节县',
adcode: '156500236'
}, {
id: 2009,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '巫山县',
regionCode: 156500237,
name: '巫山县',
adcode: '156500237'
}, {
id: 2010,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '巫溪县',
regionCode: 156500238,
name: '巫溪县',
adcode: '156500238'
}, {
id: 2011,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '石柱土家族自治县',
regionCode: 156500240,
name: '石柱土家族自治县',
adcode: '156500240'
}, {
id: 2012,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '秀山土家族苗族自治县',
regionCode: 156500241,
name: '秀山土家族苗族自治县',
adcode: '156500241'
}, {
id: 2013,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '酉阳土家族苗族自治县',
regionCode: 156500242,
name: '酉阳土家族苗族自治县',
adcode: '156500242'
}, {
id: 2014,
province: '重庆市',
provinceCode: 156500000,
city: '重庆市',
cityCode: 156500000,
region: '彭水苗族土家族自治县',
regionCode: 156500243,
name: '彭水苗族土家族自治县',
adcode: '156500243'
}]
}]
}, {
province: '四川省',
provinceCode: 156510000,
adcode: '156510000',
name: '四川省',
children: [{
province: '四川省',
provinceCode: 156510000,
city: '成都市',
adcode: '156510100',
name: '成都市',
cityCode: 156510100,
children: [{
id: 2015,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '锦江区',
regionCode: 156510104,
name: '锦江区',
adcode: '156510104'
}, {
id: 2016,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '青羊区',
regionCode: 156510105,
name: '青羊区',
adcode: '156510105'
}, {
id: 2017,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '金牛区',
regionCode: 156510106,
name: '金牛区',
adcode: '156510106'
}, {
id: 2018,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '武侯区',
regionCode: 156510107,
name: '武侯区',
adcode: '156510107'
}, {
id: 2019,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '成华区',
regionCode: 156510108,
name: '成华区',
adcode: '156510108'
}, {
id: 2020,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '龙泉驿区',
regionCode: 156510112,
name: '龙泉驿区',
adcode: '156510112'
}, {
id: 2021,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '青白江区',
regionCode: 156510113,
name: '青白江区',
adcode: '156510113'
}, {
id: 2022,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '新都区',
regionCode: 156510114,
name: '新都区',
adcode: '156510114'
}, {
id: 2023,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '温江区',
regionCode: 156510115,
name: '温江区',
adcode: '156510115'
}, {
id: 2024,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '双流区',
regionCode: 156510116,
name: '双流区',
adcode: '156510116'
}, {
id: 2025,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '郫都区',
regionCode: 156510117,
name: '郫都区',
adcode: '156510117'
}, {
id: 2026,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '金堂县',
regionCode: 156510121,
name: '金堂县',
adcode: '156510121'
}, {
id: 2027,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '大邑县',
regionCode: 156510129,
name: '大邑县',
adcode: '156510129'
}, {
id: 2028,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '蒲江县',
regionCode: 156510131,
name: '蒲江县',
adcode: '156510131'
}, {
id: 2029,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '新津县',
regionCode: 156510132,
name: '新津县',
adcode: '156510132'
}, {
id: 2030,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '都江堰市',
regionCode: 156510181,
name: '都江堰市',
adcode: '156510181'
}, {
id: 2031,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '彭州市',
regionCode: 156510182,
name: '彭州市',
adcode: '156510182'
}, {
id: 2032,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '邛崃市',
regionCode: 156510183,
name: '邛崃市',
adcode: '156510183'
}, {
id: 2033,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '崇州市',
regionCode: 156510184,
name: '崇州市',
adcode: '156510184'
}, {
id: 2034,
province: '四川省',
provinceCode: 156510000,
city: '成都市',
cityCode: 156510100,
region: '简阳市',
regionCode: 156510185,
name: '简阳市',
adcode: '156510185'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '自贡市',
adcode: '156510300',
name: '自贡市',
cityCode: 156510300,
children: [{
id: 2035,
province: '四川省',
provinceCode: 156510000,
city: '自贡市',
cityCode: 156510300,
region: '自流井区',
regionCode: 156510302,
name: '自流井区',
adcode: '156510302'
}, {
id: 2036,
province: '四川省',
provinceCode: 156510000,
city: '自贡市',
cityCode: 156510300,
region: '贡井区',
regionCode: 156510303,
name: '贡井区',
adcode: '156510303'
}, {
id: 2037,
province: '四川省',
provinceCode: 156510000,
city: '自贡市',
cityCode: 156510300,
region: '大安区',
regionCode: 156510304,
name: '大安区',
adcode: '156510304'
}, {
id: 2038,
province: '四川省',
provinceCode: 156510000,
city: '自贡市',
cityCode: 156510300,
region: '沿滩区',
regionCode: 156510311,
name: '沿滩区',
adcode: '156510311'
}, {
id: 2039,
province: '四川省',
provinceCode: 156510000,
city: '自贡市',
cityCode: 156510300,
region: '荣县',
regionCode: 156510321,
name: '荣县',
adcode: '156510321'
}, {
id: 2040,
province: '四川省',
provinceCode: 156510000,
city: '自贡市',
cityCode: 156510300,
region: '富顺县',
regionCode: 156510322,
name: '富顺县',
adcode: '156510322'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '攀枝花市',
adcode: '156510400',
name: '攀枝花市',
cityCode: 156510400,
children: [{
id: 2041,
province: '四川省',
provinceCode: 156510000,
city: '攀枝花市',
cityCode: 156510400,
region: '东区',
regionCode: 156510402,
name: '东区',
adcode: '156510402'
}, {
id: 2042,
province: '四川省',
provinceCode: 156510000,
city: '攀枝花市',
cityCode: 156510400,
region: '西区',
regionCode: 156510403,
name: '西区',
adcode: '156510403'
}, {
id: 2043,
province: '四川省',
provinceCode: 156510000,
city: '攀枝花市',
cityCode: 156510400,
region: '仁和区',
regionCode: 156510411,
name: '仁和区',
adcode: '156510411'
}, {
id: 2044,
province: '四川省',
provinceCode: 156510000,
city: '攀枝花市',
cityCode: 156510400,
region: '米易县',
regionCode: 156510421,
name: '米易县',
adcode: '156510421'
}, {
id: 2045,
province: '四川省',
provinceCode: 156510000,
city: '攀枝花市',
cityCode: 156510400,
region: '盐边县',
regionCode: 156510422,
name: '盐边县',
adcode: '156510422'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
adcode: '156510500',
name: '泸州市',
cityCode: 156510500,
children: [{
id: 2046,
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
cityCode: 156510500,
region: '江阳区',
regionCode: 156510502,
name: '江阳区',
adcode: '156510502'
}, {
id: 2047,
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
cityCode: 156510500,
region: '纳溪区',
regionCode: 156510503,
name: '纳溪区',
adcode: '156510503'
}, {
id: 2048,
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
cityCode: 156510500,
region: '龙马潭区',
regionCode: 156510504,
name: '龙马潭区',
adcode: '156510504'
}, {
id: 2049,
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
cityCode: 156510500,
region: '泸县',
regionCode: 156510521,
name: '泸县',
adcode: '156510521'
}, {
id: 2050,
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
cityCode: 156510500,
region: '合江县',
regionCode: 156510522,
name: '合江县',
adcode: '156510522'
}, {
id: 2051,
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
cityCode: 156510500,
region: '叙永县',
regionCode: 156510524,
name: '叙永县',
adcode: '156510524'
}, {
id: 2052,
province: '四川省',
provinceCode: 156510000,
city: '泸州市',
cityCode: 156510500,
region: '古蔺县',
regionCode: 156510525,
name: '古蔺县',
adcode: '156510525'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '德阳市',
adcode: '156510600',
name: '德阳市',
cityCode: 156510600,
children: [{
id: 2053,
province: '四川省',
provinceCode: 156510000,
city: '德阳市',
cityCode: 156510600,
region: '旌阳区',
regionCode: 156510603,
name: '旌阳区',
adcode: '156510603'
}, {
id: 2054,
province: '四川省',
provinceCode: 156510000,
city: '德阳市',
cityCode: 156510600,
region: '罗江区',
regionCode: 156510604,
name: '罗江区',
adcode: '156510604'
}, {
id: 2055,
province: '四川省',
provinceCode: 156510000,
city: '德阳市',
cityCode: 156510600,
region: '中江县',
regionCode: 156510623,
name: '中江县',
adcode: '156510623'
}, {
id: 2056,
province: '四川省',
provinceCode: 156510000,
city: '德阳市',
cityCode: 156510600,
region: '广汉市',
regionCode: 156510681,
name: '广汉市',
adcode: '156510681'
}, {
id: 2057,
province: '四川省',
provinceCode: 156510000,
city: '德阳市',
cityCode: 156510600,
region: '什邡市',
regionCode: 156510682,
name: '什邡市',
adcode: '156510682'
}, {
id: 2058,
province: '四川省',
provinceCode: 156510000,
city: '德阳市',
cityCode: 156510600,
region: '绵竹市',
regionCode: 156510683,
name: '绵竹市',
adcode: '156510683'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
adcode: '156510700',
name: '绵阳市',
cityCode: 156510700,
children: [{
id: 2059,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '涪城区',
regionCode: 156510703,
name: '涪城区',
adcode: '156510703'
}, {
id: 2060,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '游仙区',
regionCode: 156510704,
name: '游仙区',
adcode: '156510704'
}, {
id: 2061,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '安州区',
regionCode: 156510705,
name: '安州区',
adcode: '156510705'
}, {
id: 2062,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '三台县',
regionCode: 156510722,
name: '三台县',
adcode: '156510722'
}, {
id: 2063,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '盐亭县',
regionCode: 156510723,
name: '盐亭县',
adcode: '156510723'
}, {
id: 2064,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '梓潼县',
regionCode: 156510725,
name: '梓潼县',
adcode: '156510725'
}, {
id: 2065,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '北川羌族自治县',
regionCode: 156510726,
name: '北川羌族自治县',
adcode: '156510726'
}, {
id: 2066,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '平武县',
regionCode: 156510727,
name: '平武县',
adcode: '156510727'
}, {
id: 2067,
province: '四川省',
provinceCode: 156510000,
city: '绵阳市',
cityCode: 156510700,
region: '江油市',
regionCode: 156510781,
name: '江油市',
adcode: '156510781'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '广元市',
adcode: '156510800',
name: '广元市',
cityCode: 156510800,
children: [{
id: 2068,
province: '四川省',
provinceCode: 156510000,
city: '广元市',
cityCode: 156510800,
region: '利州区',
regionCode: 156510802,
name: '利州区',
adcode: '156510802'
}, {
id: 2069,
province: '四川省',
provinceCode: 156510000,
city: '广元市',
cityCode: 156510800,
region: '昭化区',
regionCode: 156510811,
name: '昭化区',
adcode: '156510811'
}, {
id: 2070,
province: '四川省',
provinceCode: 156510000,
city: '广元市',
cityCode: 156510800,
region: '朝天区',
regionCode: 156510812,
name: '朝天区',
adcode: '156510812'
}, {
id: 2071,
province: '四川省',
provinceCode: 156510000,
city: '广元市',
cityCode: 156510800,
region: '旺苍县',
regionCode: 156510821,
name: '旺苍县',
adcode: '156510821'
}, {
id: 2072,
province: '四川省',
provinceCode: 156510000,
city: '广元市',
cityCode: 156510800,
region: '青川县',
regionCode: 156510822,
name: '青川县',
adcode: '156510822'
}, {
id: 2073,
province: '四川省',
provinceCode: 156510000,
city: '广元市',
cityCode: 156510800,
region: '剑阁县',
regionCode: 156510823,
name: '剑阁县',
adcode: '156510823'
}, {
id: 2074,
province: '四川省',
provinceCode: 156510000,
city: '广元市',
cityCode: 156510800,
region: '苍溪县',
regionCode: 156510824,
name: '苍溪县',
adcode: '156510824'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '遂宁市',
adcode: '156510900',
name: '遂宁市',
cityCode: 156510900,
children: [{
id: 2075,
province: '四川省',
provinceCode: 156510000,
city: '遂宁市',
cityCode: 156510900,
region: '船山区',
regionCode: 156510903,
name: '船山区',
adcode: '156510903'
}, {
id: 2076,
province: '四川省',
provinceCode: 156510000,
city: '遂宁市',
cityCode: 156510900,
region: '安居区',
regionCode: 156510904,
name: '安居区',
adcode: '156510904'
}, {
id: 2077,
province: '四川省',
provinceCode: 156510000,
city: '遂宁市',
cityCode: 156510900,
region: '蓬溪县',
regionCode: 156510921,
name: '蓬溪县',
adcode: '156510921'
}, {
id: 2078,
province: '四川省',
provinceCode: 156510000,
city: '遂宁市',
cityCode: 156510900,
region: '大英县',
regionCode: 156510923,
name: '大英县',
adcode: '156510923'
}, {
id: 2079,
province: '四川省',
provinceCode: 156510000,
city: '遂宁市',
cityCode: 156510900,
region: '射洪市',
regionCode: 156510981,
name: '射洪市',
adcode: '156510981'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '内江市',
adcode: '156511000',
name: '内江市',
cityCode: 156511000,
children: [{
id: 2080,
province: '四川省',
provinceCode: 156510000,
city: '内江市',
cityCode: 156511000,
region: '市中区',
regionCode: 156511002,
name: '市中区',
adcode: '156511002'
}, {
id: 2081,
province: '四川省',
provinceCode: 156510000,
city: '内江市',
cityCode: 156511000,
region: '东兴区',
regionCode: 156511011,
name: '东兴区',
adcode: '156511011'
}, {
id: 2082,
province: '四川省',
provinceCode: 156510000,
city: '内江市',
cityCode: 156511000,
region: '威远县',
regionCode: 156511024,
name: '威远县',
adcode: '156511024'
}, {
id: 2083,
province: '四川省',
provinceCode: 156510000,
city: '内江市',
cityCode: 156511000,
region: '资中县',
regionCode: 156511025,
name: '资中县',
adcode: '156511025'
}, {
id: 2084,
province: '四川省',
provinceCode: 156510000,
city: '内江市',
cityCode: 156511000,
region: '隆昌市',
regionCode: 156511083,
name: '隆昌市',
adcode: '156511083'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
adcode: '156511100',
name: '乐山市',
cityCode: 156511100,
children: [{
id: 2085,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '市中区',
regionCode: 156511102,
name: '市中区',
adcode: '156511102'
}, {
id: 2086,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '沙湾区',
regionCode: 156511111,
name: '沙湾区',
adcode: '156511111'
}, {
id: 2087,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '五通桥区',
regionCode: 156511112,
name: '五通桥区',
adcode: '156511112'
}, {
id: 2088,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '金口河区',
regionCode: 156511113,
name: '金口河区',
adcode: '156511113'
}, {
id: 2089,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '犍为县',
regionCode: 156511123,
name: '犍为县',
adcode: '156511123'
}, {
id: 2090,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '井研县',
regionCode: 156511124,
name: '井研县',
adcode: '156511124'
}, {
id: 2091,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '夹江县',
regionCode: 156511126,
name: '夹江县',
adcode: '156511126'
}, {
id: 2092,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '沐川县',
regionCode: 156511129,
name: '沐川县',
adcode: '156511129'
}, {
id: 2093,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '峨边彝族自治县',
regionCode: 156511132,
name: '峨边彝族自治县',
adcode: '156511132'
}, {
id: 2094,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '马边彝族自治县',
regionCode: 156511133,
name: '马边彝族自治县',
adcode: '156511133'
}, {
id: 2095,
province: '四川省',
provinceCode: 156510000,
city: '乐山市',
cityCode: 156511100,
region: '峨眉山市',
regionCode: 156511181,
name: '峨眉山市',
adcode: '156511181'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '南充市',
adcode: '156511300',
name: '南充市',
cityCode: 156511300,
children: [{
id: 2096,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '顺庆区',
regionCode: 156511302,
name: '顺庆区',
adcode: '156511302'
}, {
id: 2097,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '高坪区',
regionCode: 156511303,
name: '高坪区',
adcode: '156511303'
}, {
id: 2098,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '嘉陵区',
regionCode: 156511304,
name: '嘉陵区',
adcode: '156511304'
}, {
id: 2099,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '南部县',
regionCode: 156511321,
name: '南部县',
adcode: '156511321'
}, {
id: 2100,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '营山县',
regionCode: 156511322,
name: '营山县',
adcode: '156511322'
}, {
id: 2101,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '蓬安县',
regionCode: 156511323,
name: '蓬安县',
adcode: '156511323'
}, {
id: 2102,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '仪陇县',
regionCode: 156511324,
name: '仪陇县',
adcode: '156511324'
}, {
id: 2103,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '西充县',
regionCode: 156511325,
name: '西充县',
adcode: '156511325'
}, {
id: 2104,
province: '四川省',
provinceCode: 156510000,
city: '南充市',
cityCode: 156511300,
region: '阆中市',
regionCode: 156511381,
name: '阆中市',
adcode: '156511381'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '眉山市',
adcode: '156511400',
name: '眉山市',
cityCode: 156511400,
children: [{
id: 2105,
province: '四川省',
provinceCode: 156510000,
city: '眉山市',
cityCode: 156511400,
region: '东坡区',
regionCode: 156511402,
name: '东坡区',
adcode: '156511402'
}, {
id: 2106,
province: '四川省',
provinceCode: 156510000,
city: '眉山市',
cityCode: 156511400,
region: '彭山区',
regionCode: 156511403,
name: '彭山区',
adcode: '156511403'
}, {
id: 2107,
province: '四川省',
provinceCode: 156510000,
city: '眉山市',
cityCode: 156511400,
region: '仁寿县',
regionCode: 156511421,
name: '仁寿县',
adcode: '156511421'
}, {
id: 2108,
province: '四川省',
provinceCode: 156510000,
city: '眉山市',
cityCode: 156511400,
region: '洪雅县',
regionCode: 156511423,
name: '洪雅县',
adcode: '156511423'
}, {
id: 2109,
province: '四川省',
provinceCode: 156510000,
city: '眉山市',
cityCode: 156511400,
region: '丹棱县',
regionCode: 156511424,
name: '丹棱县',
adcode: '156511424'
}, {
id: 2110,
province: '四川省',
provinceCode: 156510000,
city: '眉山市',
cityCode: 156511400,
region: '青神县',
regionCode: 156511425,
name: '青神县',
adcode: '156511425'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
adcode: '156511500',
name: '宜宾市',
cityCode: 156511500,
children: [{
id: 2111,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '翠屏区',
regionCode: 156511502,
name: '翠屏区',
adcode: '156511502'
}, {
id: 2112,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '南溪区',
regionCode: 156511503,
name: '南溪区',
adcode: '156511503'
}, {
id: 2113,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '叙州区',
regionCode: 156511504,
name: '叙州区',
adcode: '156511504'
}, {
id: 2114,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '江安县',
regionCode: 156511523,
name: '江安县',
adcode: '156511523'
}, {
id: 2115,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '长宁县',
regionCode: 156511524,
name: '长宁县',
adcode: '156511524'
}, {
id: 2116,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '高县',
regionCode: 156511525,
name: '高县',
adcode: '156511525'
}, {
id: 2117,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '珙县',
regionCode: 156511526,
name: '珙县',
adcode: '156511526'
}, {
id: 2118,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '筠连县',
regionCode: 156511527,
name: '筠连县',
adcode: '156511527'
}, {
id: 2119,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '兴文县',
regionCode: 156511528,
name: '兴文县',
adcode: '156511528'
}, {
id: 2120,
province: '四川省',
provinceCode: 156510000,
city: '宜宾市',
cityCode: 156511500,
region: '屏山县',
regionCode: 156511529,
name: '屏山县',
adcode: '156511529'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '广安市',
adcode: '156511600',
name: '广安市',
cityCode: 156511600,
children: [{
id: 2121,
province: '四川省',
provinceCode: 156510000,
city: '广安市',
cityCode: 156511600,
region: '广安区',
regionCode: 156511602,
name: '广安区',
adcode: '156511602'
}, {
id: 2122,
province: '四川省',
provinceCode: 156510000,
city: '广安市',
cityCode: 156511600,
region: '前锋区',
regionCode: 156511603,
name: '前锋区',
adcode: '156511603'
}, {
id: 2123,
province: '四川省',
provinceCode: 156510000,
city: '广安市',
cityCode: 156511600,
region: '岳池县',
regionCode: 156511621,
name: '岳池县',
adcode: '156511621'
}, {
id: 2124,
province: '四川省',
provinceCode: 156510000,
city: '广安市',
cityCode: 156511600,
region: '武胜县',
regionCode: 156511622,
name: '武胜县',
adcode: '156511622'
}, {
id: 2125,
province: '四川省',
provinceCode: 156510000,
city: '广安市',
cityCode: 156511600,
region: '邻水县',
regionCode: 156511623,
name: '邻水县',
adcode: '156511623'
}, {
id: 2126,
province: '四川省',
provinceCode: 156510000,
city: '广安市',
cityCode: 156511600,
region: '华蓥市',
regionCode: 156511681,
name: '华蓥市',
adcode: '156511681'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '达州市',
adcode: '156511700',
name: '达州市',
cityCode: 156511700,
children: [{
id: 2127,
province: '四川省',
provinceCode: 156510000,
city: '达州市',
cityCode: 156511700,
region: '通川区',
regionCode: 156511702,
name: '通川区',
adcode: '156511702'
}, {
id: 2128,
province: '四川省',
provinceCode: 156510000,
city: '达州市',
cityCode: 156511700,
region: '达川区',
regionCode: 156511703,
name: '达川区',
adcode: '156511703'
}, {
id: 2129,
province: '四川省',
provinceCode: 156510000,
city: '达州市',
cityCode: 156511700,
region: '宣汉县',
regionCode: 156511722,
name: '宣汉县',
adcode: '156511722'
}, {
id: 2130,
province: '四川省',
provinceCode: 156510000,
city: '达州市',
cityCode: 156511700,
region: '开江县',
regionCode: 156511723,
name: '开江县',
adcode: '156511723'
}, {
id: 2131,
province: '四川省',
provinceCode: 156510000,
city: '达州市',
cityCode: 156511700,
region: '大竹县',
regionCode: 156511724,
name: '大竹县',
adcode: '156511724'
}, {
id: 2132,
province: '四川省',
provinceCode: 156510000,
city: '达州市',
cityCode: 156511700,
region: '渠县',
regionCode: 156511725,
name: '渠县',
adcode: '156511725'
}, {
id: 2133,
province: '四川省',
provinceCode: 156510000,
city: '达州市',
cityCode: 156511700,
region: '万源市',
regionCode: 156511781,
name: '万源市',
adcode: '156511781'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
adcode: '156511800',
name: '雅安市',
cityCode: 156511800,
children: [{
id: 2134,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '雨城区',
regionCode: 156511802,
name: '雨城区',
adcode: '156511802'
}, {
id: 2135,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '名山区',
regionCode: 156511803,
name: '名山区',
adcode: '156511803'
}, {
id: 2136,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '荥经县',
regionCode: 156511822,
name: '荥经县',
adcode: '156511822'
}, {
id: 2137,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '汉源县',
regionCode: 156511823,
name: '汉源县',
adcode: '156511823'
}, {
id: 2138,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '石棉县',
regionCode: 156511824,
name: '石棉县',
adcode: '156511824'
}, {
id: 2139,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '天全县',
regionCode: 156511825,
name: '天全县',
adcode: '156511825'
}, {
id: 2140,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '芦山县',
regionCode: 156511826,
name: '芦山县',
adcode: '156511826'
}, {
id: 2141,
province: '四川省',
provinceCode: 156510000,
city: '雅安市',
cityCode: 156511800,
region: '宝兴县',
regionCode: 156511827,
name: '宝兴县',
adcode: '156511827'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '巴中市',
adcode: '156511900',
name: '巴中市',
cityCode: 156511900,
children: [{
id: 2142,
province: '四川省',
provinceCode: 156510000,
city: '巴中市',
cityCode: 156511900,
region: '巴州区',
regionCode: 156511902,
name: '巴州区',
adcode: '156511902'
}, {
id: 2143,
province: '四川省',
provinceCode: 156510000,
city: '巴中市',
cityCode: 156511900,
region: '恩阳区',
regionCode: 156511903,
name: '恩阳区',
adcode: '156511903'
}, {
id: 2144,
province: '四川省',
provinceCode: 156510000,
city: '巴中市',
cityCode: 156511900,
region: '通江县',
regionCode: 156511921,
name: '通江县',
adcode: '156511921'
}, {
id: 2145,
province: '四川省',
provinceCode: 156510000,
city: '巴中市',
cityCode: 156511900,
region: '南江县',
regionCode: 156511922,
name: '南江县',
adcode: '156511922'
}, {
id: 2146,
province: '四川省',
provinceCode: 156510000,
city: '巴中市',
cityCode: 156511900,
region: '平昌县',
regionCode: 156511923,
name: '平昌县',
adcode: '156511923'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '资阳市',
adcode: '156512000',
name: '资阳市',
cityCode: 156512000,
children: [{
id: 2147,
province: '四川省',
provinceCode: 156510000,
city: '资阳市',
cityCode: 156512000,
region: '雁江区',
regionCode: 156512002,
name: '雁江区',
adcode: '156512002'
}, {
id: 2148,
province: '四川省',
provinceCode: 156510000,
city: '资阳市',
cityCode: 156512000,
region: '安岳县',
regionCode: 156512021,
name: '安岳县',
adcode: '156512021'
}, {
id: 2149,
province: '四川省',
provinceCode: 156510000,
city: '资阳市',
cityCode: 156512000,
region: '乐至县',
regionCode: 156512022,
name: '乐至县',
adcode: '156512022'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
adcode: '156513200',
name: '阿坝藏族羌族自治州',
cityCode: 156513200,
children: [{
id: 2150,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '马尔康市',
regionCode: 156513201,
name: '马尔康市',
adcode: '156513201'
}, {
id: 2151,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '汶川县',
regionCode: 156513221,
name: '汶川县',
adcode: '156513221'
}, {
id: 2152,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '理县',
regionCode: 156513222,
name: '理县',
adcode: '156513222'
}, {
id: 2153,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '茂县',
regionCode: 156513223,
name: '茂县',
adcode: '156513223'
}, {
id: 2154,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '松潘县',
regionCode: 156513224,
name: '松潘县',
adcode: '156513224'
}, {
id: 2155,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '九寨沟县',
regionCode: 156513225,
name: '九寨沟县',
adcode: '156513225'
}, {
id: 2156,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '金川县',
regionCode: 156513226,
name: '金川县',
adcode: '156513226'
}, {
id: 2157,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '小金县',
regionCode: 156513227,
name: '小金县',
adcode: '156513227'
}, {
id: 2158,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '黑水县',
regionCode: 156513228,
name: '黑水县',
adcode: '156513228'
}, {
id: 2159,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '壤塘县',
regionCode: 156513230,
name: '壤塘县',
adcode: '156513230'
}, {
id: 2160,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '阿坝县',
regionCode: 156513231,
name: '阿坝县',
adcode: '156513231'
}, {
id: 2161,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '若尔盖县',
regionCode: 156513232,
name: '若尔盖县',
adcode: '156513232'
}, {
id: 2162,
province: '四川省',
provinceCode: 156510000,
city: '阿坝藏族羌族自治州',
cityCode: 156513200,
region: '红原县',
regionCode: 156513233,
name: '红原县',
adcode: '156513233'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
adcode: '156513300',
name: '甘孜藏族自治州',
cityCode: 156513300,
children: [{
id: 2163,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '康定市',
regionCode: 156513301,
name: '康定市',
adcode: '156513301'
}, {
id: 2164,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '泸定县',
regionCode: 156513322,
name: '泸定县',
adcode: '156513322'
}, {
id: 2165,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '丹巴县',
regionCode: 156513323,
name: '丹巴县',
adcode: '156513323'
}, {
id: 2166,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '九龙县',
regionCode: 156513324,
name: '九龙县',
adcode: '156513324'
}, {
id: 2167,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '雅江县',
regionCode: 156513325,
name: '雅江县',
adcode: '156513325'
}, {
id: 2168,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '道孚县',
regionCode: 156513326,
name: '道孚县',
adcode: '156513326'
}, {
id: 2169,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '炉霍县',
regionCode: 156513327,
name: '炉霍县',
adcode: '156513327'
}, {
id: 2170,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '甘孜县',
regionCode: 156513328,
name: '甘孜县',
adcode: '156513328'
}, {
id: 2171,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '新龙县',
regionCode: 156513329,
name: '新龙县',
adcode: '156513329'
}, {
id: 2172,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '德格县',
regionCode: 156513330,
name: '德格县',
adcode: '156513330'
}, {
id: 2173,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '白玉县',
regionCode: 156513331,
name: '白玉县',
adcode: '156513331'
}, {
id: 2174,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '石渠县',
regionCode: 156513332,
name: '石渠县',
adcode: '156513332'
}, {
id: 2175,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '色达县',
regionCode: 156513333,
name: '色达县',
adcode: '156513333'
}, {
id: 2176,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '理塘县',
regionCode: 156513334,
name: '理塘县',
adcode: '156513334'
}, {
id: 2177,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '巴塘县',
regionCode: 156513335,
name: '巴塘县',
adcode: '156513335'
}, {
id: 2178,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '乡城县',
regionCode: 156513336,
name: '乡城县',
adcode: '156513336'
}, {
id: 2179,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '稻城县',
regionCode: 156513337,
name: '稻城县',
adcode: '156513337'
}, {
id: 2180,
province: '四川省',
provinceCode: 156510000,
city: '甘孜藏族自治州',
cityCode: 156513300,
region: '得荣县',
regionCode: 156513338,
name: '得荣县',
adcode: '156513338'
}]
}, {
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
adcode: '156513400',
name: '凉山彝族自治州',
cityCode: 156513400,
children: [{
id: 2181,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '西昌市',
regionCode: 156513401,
name: '西昌市',
adcode: '156513401'
}, {
id: 2182,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '木里藏族自治县',
regionCode: 156513422,
name: '木里藏族自治县',
adcode: '156513422'
}, {
id: 2183,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '盐源县',
regionCode: 156513423,
name: '盐源县',
adcode: '156513423'
}, {
id: 2184,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '德昌县',
regionCode: 156513424,
name: '德昌县',
adcode: '156513424'
}, {
id: 2185,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '会理县',
regionCode: 156513425,
name: '会理县',
adcode: '156513425'
}, {
id: 2186,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '会东县',
regionCode: 156513426,
name: '会东县',
adcode: '156513426'
}, {
id: 2187,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '宁南县',
regionCode: 156513427,
name: '宁南县',
adcode: '156513427'
}, {
id: 2188,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '普格县',
regionCode: 156513428,
name: '普格县',
adcode: '156513428'
}, {
id: 2189,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '布拖县',
regionCode: 156513429,
name: '布拖县',
adcode: '156513429'
}, {
id: 2190,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '金阳县',
regionCode: 156513430,
name: '金阳县',
adcode: '156513430'
}, {
id: 2191,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '昭觉县',
regionCode: 156513431,
name: '昭觉县',
adcode: '156513431'
}, {
id: 2192,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '喜德县',
regionCode: 156513432,
name: '喜德县',
adcode: '156513432'
}, {
id: 2193,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '冕宁县',
regionCode: 156513433,
name: '冕宁县',
adcode: '156513433'
}, {
id: 2194,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '越西县',
regionCode: 156513434,
name: '越西县',
adcode: '156513434'
}, {
id: 2195,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '甘洛县',
regionCode: 156513435,
name: '甘洛县',
adcode: '156513435'
}, {
id: 2196,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '美姑县',
regionCode: 156513436,
name: '美姑县',
adcode: '156513436'
}, {
id: 2197,
province: '四川省',
provinceCode: 156510000,
city: '凉山彝族自治州',
cityCode: 156513400,
region: '雷波县',
regionCode: 156513437,
name: '雷波县',
adcode: '156513437'
}]
}]
}, {
province: '贵州省',
provinceCode: 156520000,
adcode: '156520000',
name: '贵州省',
children: [{
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
adcode: '156520100',
name: '贵阳市',
cityCode: 156520100,
children: [{
id: 2198,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '南明区',
regionCode: 156520102,
name: '南明区',
adcode: '156520102'
}, {
id: 2199,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '云岩区',
regionCode: 156520103,
name: '云岩区',
adcode: '156520103'
}, {
id: 2200,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '花溪区',
regionCode: 156520111,
name: '花溪区',
adcode: '156520111'
}, {
id: 2201,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '乌当区',
regionCode: 156520112,
name: '乌当区',
adcode: '156520112'
}, {
id: 2202,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '白云区',
regionCode: 156520113,
name: '白云区',
adcode: '156520113'
}, {
id: 2203,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '观山湖区',
regionCode: 156520115,
name: '观山湖区',
adcode: '156520115'
}, {
id: 2204,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '开阳县',
regionCode: 156520121,
name: '开阳县',
adcode: '156520121'
}, {
id: 2205,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '息烽县',
regionCode: 156520122,
name: '息烽县',
adcode: '156520122'
}, {
id: 2206,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '修文县',
regionCode: 156520123,
name: '修文县',
adcode: '156520123'
}, {
id: 2207,
province: '贵州省',
provinceCode: 156520000,
city: '贵阳市',
cityCode: 156520100,
region: '清镇市',
regionCode: 156520181,
name: '清镇市',
adcode: '156520181'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '六盘水市',
adcode: '156520200',
name: '六盘水市',
cityCode: 156520200,
children: [{
id: 2208,
province: '贵州省',
provinceCode: 156520000,
city: '六盘水市',
cityCode: 156520200,
region: '钟山区',
regionCode: 156520201,
name: '钟山区',
adcode: '156520201'
}, {
id: 2209,
province: '贵州省',
provinceCode: 156520000,
city: '六盘水市',
cityCode: 156520200,
region: '六枝特区',
regionCode: 156520203,
name: '六枝特区',
adcode: '156520203'
}, {
id: 2210,
province: '贵州省',
provinceCode: 156520000,
city: '六盘水市',
cityCode: 156520200,
region: '水城县',
regionCode: 156520221,
name: '水城县',
adcode: '156520221'
}, {
id: 2211,
province: '贵州省',
provinceCode: 156520000,
city: '六盘水市',
cityCode: 156520200,
region: '盘州市',
regionCode: 156520281,
name: '盘州市',
adcode: '156520281'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
adcode: '156520300',
name: '遵义市',
cityCode: 156520300,
children: [{
id: 2212,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '红花岗区',
regionCode: 156520302,
name: '红花岗区',
adcode: '156520302'
}, {
id: 2213,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '汇川区',
regionCode: 156520303,
name: '汇川区',
adcode: '156520303'
}, {
id: 2214,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '播州区',
regionCode: 156520304,
name: '播州区',
adcode: '156520304'
}, {
id: 2215,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '桐梓县',
regionCode: 156520322,
name: '桐梓县',
adcode: '156520322'
}, {
id: 2216,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '绥阳县',
regionCode: 156520323,
name: '绥阳县',
adcode: '156520323'
}, {
id: 2217,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '正安县',
regionCode: 156520324,
name: '正安县',
adcode: '156520324'
}, {
id: 2218,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '道真仡佬族苗族自治县',
regionCode: 156520325,
name: '道真仡佬族苗族自治县',
adcode: '156520325'
}, {
id: 2219,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '务川仡佬族苗族自治县',
regionCode: 156520326,
name: '务川仡佬族苗族自治县',
adcode: '156520326'
}, {
id: 2220,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '凤冈县',
regionCode: 156520327,
name: '凤冈县',
adcode: '156520327'
}, {
id: 2221,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '湄潭县',
regionCode: 156520328,
name: '湄潭县',
adcode: '156520328'
}, {
id: 2222,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '余庆县',
regionCode: 156520329,
name: '余庆县',
adcode: '156520329'
}, {
id: 2223,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '习水县',
regionCode: 156520330,
name: '习水县',
adcode: '156520330'
}, {
id: 2224,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '赤水市',
regionCode: 156520381,
name: '赤水市',
adcode: '156520381'
}, {
id: 2225,
province: '贵州省',
provinceCode: 156520000,
city: '遵义市',
cityCode: 156520300,
region: '仁怀市',
regionCode: 156520382,
name: '仁怀市',
adcode: '156520382'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '安顺市',
adcode: '156520400',
name: '安顺市',
cityCode: 156520400,
children: [{
id: 2226,
province: '贵州省',
provinceCode: 156520000,
city: '安顺市',
cityCode: 156520400,
region: '西秀区',
regionCode: 156520402,
name: '西秀区',
adcode: '156520402'
}, {
id: 2227,
province: '贵州省',
provinceCode: 156520000,
city: '安顺市',
cityCode: 156520400,
region: '平坝区',
regionCode: 156520403,
name: '平坝区',
adcode: '156520403'
}, {
id: 2228,
province: '贵州省',
provinceCode: 156520000,
city: '安顺市',
cityCode: 156520400,
region: '普定县',
regionCode: 156520422,
name: '普定县',
adcode: '156520422'
}, {
id: 2229,
province: '贵州省',
provinceCode: 156520000,
city: '安顺市',
cityCode: 156520400,
region: '镇宁布依族苗族自治县',
regionCode: 156520423,
name: '镇宁布依族苗族自治县',
adcode: '156520423'
}, {
id: 2230,
province: '贵州省',
provinceCode: 156520000,
city: '安顺市',
cityCode: 156520400,
region: '关岭布依族苗族自治县',
regionCode: 156520424,
name: '关岭布依族苗族自治县',
adcode: '156520424'
}, {
id: 2231,
province: '贵州省',
provinceCode: 156520000,
city: '安顺市',
cityCode: 156520400,
region: '紫云苗族布依族自治县',
regionCode: 156520425,
name: '紫云苗族布依族自治县',
adcode: '156520425'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
adcode: '156520500',
name: '毕节市',
cityCode: 156520500,
children: [{
id: 2232,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '七星关区',
regionCode: 156520502,
name: '七星关区',
adcode: '156520502'
}, {
id: 2233,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '大方县',
regionCode: 156520521,
name: '大方县',
adcode: '156520521'
}, {
id: 2234,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '黔西县',
regionCode: 156520522,
name: '黔西县',
adcode: '156520522'
}, {
id: 2235,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '金沙县',
regionCode: 156520523,
name: '金沙县',
adcode: '156520523'
}, {
id: 2236,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '织金县',
regionCode: 156520524,
name: '织金县',
adcode: '156520524'
}, {
id: 2237,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '纳雍县',
regionCode: 156520525,
name: '纳雍县',
adcode: '156520525'
}, {
id: 2238,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '威宁彝族回族苗族自治县',
regionCode: 156520526,
name: '威宁彝族回族苗族自治县',
adcode: '156520526'
}, {
id: 2239,
province: '贵州省',
provinceCode: 156520000,
city: '毕节市',
cityCode: 156520500,
region: '赫章县',
regionCode: 156520527,
name: '赫章县',
adcode: '156520527'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
adcode: '156520600',
name: '铜仁市',
cityCode: 156520600,
children: [{
id: 2240,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '碧江区',
regionCode: 156520602,
name: '碧江区',
adcode: '156520602'
}, {
id: 2241,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '万山区',
regionCode: 156520603,
name: '万山区',
adcode: '156520603'
}, {
id: 2242,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '江口县',
regionCode: 156520621,
name: '江口县',
adcode: '156520621'
}, {
id: 2243,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '玉屏侗族自治县',
regionCode: 156520622,
name: '玉屏侗族自治县',
adcode: '156520622'
}, {
id: 2244,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '石阡县',
regionCode: 156520623,
name: '石阡县',
adcode: '156520623'
}, {
id: 2245,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '思南县',
regionCode: 156520624,
name: '思南县',
adcode: '156520624'
}, {
id: 2246,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '印江土家族苗族自治县',
regionCode: 156520625,
name: '印江土家族苗族自治县',
adcode: '156520625'
}, {
id: 2247,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '德江县',
regionCode: 156520626,
name: '德江县',
adcode: '156520626'
}, {
id: 2248,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '沿河土家族自治县',
regionCode: 156520627,
name: '沿河土家族自治县',
adcode: '156520627'
}, {
id: 2249,
province: '贵州省',
provinceCode: 156520000,
city: '铜仁市',
cityCode: 156520600,
region: '松桃苗族自治县',
regionCode: 156520628,
name: '松桃苗族自治县',
adcode: '156520628'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
adcode: '156522300',
name: '黔西南布依族苗族自治州',
cityCode: 156522300,
children: [{
id: 2250,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '兴义市',
regionCode: 156522301,
name: '兴义市',
adcode: '156522301'
}, {
id: 2251,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '兴仁市',
regionCode: 156522302,
name: '兴仁市',
adcode: '156522302'
}, {
id: 2252,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '普安县',
regionCode: 156522323,
name: '普安县',
adcode: '156522323'
}, {
id: 2253,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '晴隆县',
regionCode: 156522324,
name: '晴隆县',
adcode: '156522324'
}, {
id: 2254,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '贞丰县',
regionCode: 156522325,
name: '贞丰县',
adcode: '156522325'
}, {
id: 2255,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '望谟县',
regionCode: 156522326,
name: '望谟县',
adcode: '156522326'
}, {
id: 2256,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '册亨县',
regionCode: 156522327,
name: '册亨县',
adcode: '156522327'
}, {
id: 2257,
province: '贵州省',
provinceCode: 156520000,
city: '黔西南布依族苗族自治州',
cityCode: 156522300,
region: '安龙县',
regionCode: 156522328,
name: '安龙县',
adcode: '156522328'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
adcode: '156522600',
name: '黔东南苗族侗族自治州',
cityCode: 156522600,
children: [{
id: 2258,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '凯里市',
regionCode: 156522601,
name: '凯里市',
adcode: '156522601'
}, {
id: 2259,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '黄平县',
regionCode: 156522622,
name: '黄平县',
adcode: '156522622'
}, {
id: 2260,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '施秉县',
regionCode: 156522623,
name: '施秉县',
adcode: '156522623'
}, {
id: 2261,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '三穗县',
regionCode: 156522624,
name: '三穗县',
adcode: '156522624'
}, {
id: 2262,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '镇远县',
regionCode: 156522625,
name: '镇远县',
adcode: '156522625'
}, {
id: 2263,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '岑巩县',
regionCode: 156522626,
name: '岑巩县',
adcode: '156522626'
}, {
id: 2264,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '天柱县',
regionCode: 156522627,
name: '天柱县',
adcode: '156522627'
}, {
id: 2265,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '锦屏县',
regionCode: 156522628,
name: '锦屏县',
adcode: '156522628'
}, {
id: 2266,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '剑河县',
regionCode: 156522629,
name: '剑河县',
adcode: '156522629'
}, {
id: 2267,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '台江县',
regionCode: 156522630,
name: '台江县',
adcode: '156522630'
}, {
id: 2268,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '黎平县',
regionCode: 156522631,
name: '黎平县',
adcode: '156522631'
}, {
id: 2269,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '榕江县',
regionCode: 156522632,
name: '榕江县',
adcode: '156522632'
}, {
id: 2270,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '从江县',
regionCode: 156522633,
name: '从江县',
adcode: '156522633'
}, {
id: 2271,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '雷山县',
regionCode: 156522634,
name: '雷山县',
adcode: '156522634'
}, {
id: 2272,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '麻江县',
regionCode: 156522635,
name: '麻江县',
adcode: '156522635'
}, {
id: 2273,
province: '贵州省',
provinceCode: 156520000,
city: '黔东南苗族侗族自治州',
cityCode: 156522600,
region: '丹寨县',
regionCode: 156522636,
name: '丹寨县',
adcode: '156522636'
}]
}, {
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
adcode: '156522700',
name: '黔南布依族苗族自治州',
cityCode: 156522700,
children: [{
id: 2274,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '都匀市',
regionCode: 156522701,
name: '都匀市',
adcode: '156522701'
}, {
id: 2275,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '福泉市',
regionCode: 156522702,
name: '福泉市',
adcode: '156522702'
}, {
id: 2276,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '荔波县',
regionCode: 156522722,
name: '荔波县',
adcode: '156522722'
}, {
id: 2277,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '贵定县',
regionCode: 156522723,
name: '贵定县',
adcode: '156522723'
}, {
id: 2278,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '瓮安县',
regionCode: 156522725,
name: '瓮安县',
adcode: '156522725'
}, {
id: 2279,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '独山县',
regionCode: 156522726,
name: '独山县',
adcode: '156522726'
}, {
id: 2280,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '平塘县',
regionCode: 156522727,
name: '平塘县',
adcode: '156522727'
}, {
id: 2281,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '罗甸县',
regionCode: 156522728,
name: '罗甸县',
adcode: '156522728'
}, {
id: 2282,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '长顺县',
regionCode: 156522729,
name: '长顺县',
adcode: '156522729'
}, {
id: 2283,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '龙里县',
regionCode: 156522730,
name: '龙里县',
adcode: '156522730'
}, {
id: 2284,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '惠水县',
regionCode: 156522731,
name: '惠水县',
adcode: '156522731'
}, {
id: 2285,
province: '贵州省',
provinceCode: 156520000,
city: '黔南布依族苗族自治州',
cityCode: 156522700,
region: '三都水族自治县',
regionCode: 156522732,
name: '三都水族自治县',
adcode: '156522732'
}]
}]
}, {
province: '云南省',
provinceCode: 156530000,
adcode: '156530000',
name: '云南省',
children: [{
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
adcode: '156530100',
name: '昆明市',
cityCode: 156530100,
children: [{
id: 2286,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '五华区',
regionCode: 156530102,
name: '五华区',
adcode: '156530102'
}, {
id: 2287,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '盘龙区',
regionCode: 156530103,
name: '盘龙区',
adcode: '156530103'
}, {
id: 2288,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '官渡区',
regionCode: 156530111,
name: '官渡区',
adcode: '156530111'
}, {
id: 2289,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '西山区',
regionCode: 156530112,
name: '西山区',
adcode: '156530112'
}, {
id: 2290,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '东川区',
regionCode: 156530113,
name: '东川区',
adcode: '156530113'
}, {
id: 2291,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '呈贡区',
regionCode: 156530114,
name: '呈贡区',
adcode: '156530114'
}, {
id: 2292,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '晋宁区',
regionCode: 156530115,
name: '晋宁区',
adcode: '156530115'
}, {
id: 2293,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '富民县',
regionCode: 156530124,
name: '富民县',
adcode: '156530124'
}, {
id: 2294,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '宜良县',
regionCode: 156530125,
name: '宜良县',
adcode: '156530125'
}, {
id: 2295,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '石林彝族自治县',
regionCode: 156530126,
name: '石林彝族自治县',
adcode: '156530126'
}, {
id: 2296,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '嵩明县',
regionCode: 156530127,
name: '嵩明县',
adcode: '156530127'
}, {
id: 2297,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '禄劝彝族苗族自治县',
regionCode: 156530128,
name: '禄劝彝族苗族自治县',
adcode: '156530128'
}, {
id: 2298,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '寻甸回族彝族自治县',
regionCode: 156530129,
name: '寻甸回族彝族自治县',
adcode: '156530129'
}, {
id: 2299,
province: '云南省',
provinceCode: 156530000,
city: '昆明市',
cityCode: 156530100,
region: '安宁市',
regionCode: 156530181,
name: '安宁市',
adcode: '156530181'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
adcode: '156530300',
name: '曲靖市',
cityCode: 156530300,
children: [{
id: 2300,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '麒麟区',
regionCode: 156530302,
name: '麒麟区',
adcode: '156530302'
}, {
id: 2301,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '沾益区',
regionCode: 156530303,
name: '沾益区',
adcode: '156530303'
}, {
id: 2302,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '马龙区',
regionCode: 156530304,
name: '马龙区',
adcode: '156530304'
}, {
id: 2303,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '陆良县',
regionCode: 156530322,
name: '陆良县',
adcode: '156530322'
}, {
id: 2304,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '师宗县',
regionCode: 156530323,
name: '师宗县',
adcode: '156530323'
}, {
id: 2305,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '罗平县',
regionCode: 156530324,
name: '罗平县',
adcode: '156530324'
}, {
id: 2306,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '富源县',
regionCode: 156530325,
name: '富源县',
adcode: '156530325'
}, {
id: 2307,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '会泽县',
regionCode: 156530326,
name: '会泽县',
adcode: '156530326'
}, {
id: 2308,
province: '云南省',
provinceCode: 156530000,
city: '曲靖市',
cityCode: 156530300,
region: '宣威市',
regionCode: 156530381,
name: '宣威市',
adcode: '156530381'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
adcode: '156530400',
name: '玉溪市',
cityCode: 156530400,
children: [{
id: 2309,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '红塔区',
regionCode: 156530402,
name: '红塔区',
adcode: '156530402'
}, {
id: 2310,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '江川区',
regionCode: 156530403,
name: '江川区',
adcode: '156530403'
}, {
id: 2311,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '通海县',
regionCode: 156530423,
name: '通海县',
adcode: '156530423'
}, {
id: 2312,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '华宁县',
regionCode: 156530424,
name: '华宁县',
adcode: '156530424'
}, {
id: 2313,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '易门县',
regionCode: 156530425,
name: '易门县',
adcode: '156530425'
}, {
id: 2314,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '峨山彝族自治县',
regionCode: 156530426,
name: '峨山彝族自治县',
adcode: '156530426'
}, {
id: 2315,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '新平彝族傣族自治县',
regionCode: 156530427,
name: '新平彝族傣族自治县',
adcode: '156530427'
}, {
id: 2316,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '元江哈尼族彝族傣族自治县',
regionCode: 156530428,
name: '元江哈尼族彝族傣族自治县',
adcode: '156530428'
}, {
id: 2317,
province: '云南省',
provinceCode: 156530000,
city: '玉溪市',
cityCode: 156530400,
region: '澄江市',
regionCode: 156530481,
name: '澄江市',
adcode: '156530481'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '保山市',
adcode: '156530500',
name: '保山市',
cityCode: 156530500,
children: [{
id: 2318,
province: '云南省',
provinceCode: 156530000,
city: '保山市',
cityCode: 156530500,
region: '隆阳区',
regionCode: 156530502,
name: '隆阳区',
adcode: '156530502'
}, {
id: 2319,
province: '云南省',
provinceCode: 156530000,
city: '保山市',
cityCode: 156530500,
region: '施甸县',
regionCode: 156530521,
name: '施甸县',
adcode: '156530521'
}, {
id: 2320,
province: '云南省',
provinceCode: 156530000,
city: '保山市',
cityCode: 156530500,
region: '龙陵县',
regionCode: 156530523,
name: '龙陵县',
adcode: '156530523'
}, {
id: 2321,
province: '云南省',
provinceCode: 156530000,
city: '保山市',
cityCode: 156530500,
region: '昌宁县',
regionCode: 156530524,
name: '昌宁县',
adcode: '156530524'
}, {
id: 2322,
province: '云南省',
provinceCode: 156530000,
city: '保山市',
cityCode: 156530500,
region: '腾冲市',
regionCode: 156530581,
name: '腾冲市',
adcode: '156530581'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
adcode: '156530600',
name: '昭通市',
cityCode: 156530600,
children: [{
id: 2323,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '昭阳区',
regionCode: 156530602,
name: '昭阳区',
adcode: '156530602'
}, {
id: 2324,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '鲁甸县',
regionCode: 156530621,
name: '鲁甸县',
adcode: '156530621'
}, {
id: 2325,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '巧家县',
regionCode: 156530622,
name: '巧家县',
adcode: '156530622'
}, {
id: 2326,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '盐津县',
regionCode: 156530623,
name: '盐津县',
adcode: '156530623'
}, {
id: 2327,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '大关县',
regionCode: 156530624,
name: '大关县',
adcode: '156530624'
}, {
id: 2328,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '永善县',
regionCode: 156530625,
name: '永善县',
adcode: '156530625'
}, {
id: 2329,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '绥江县',
regionCode: 156530626,
name: '绥江县',
adcode: '156530626'
}, {
id: 2330,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '镇雄县',
regionCode: 156530627,
name: '镇雄县',
adcode: '156530627'
}, {
id: 2331,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '彝良县',
regionCode: 156530628,
name: '彝良县',
adcode: '156530628'
}, {
id: 2332,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '威信县',
regionCode: 156530629,
name: '威信县',
adcode: '156530629'
}, {
id: 2333,
province: '云南省',
provinceCode: 156530000,
city: '昭通市',
cityCode: 156530600,
region: '水富市',
regionCode: 156530681,
name: '水富市',
adcode: '156530681'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '丽江市',
adcode: '156530700',
name: '丽江市',
cityCode: 156530700,
children: [{
id: 2334,
province: '云南省',
provinceCode: 156530000,
city: '丽江市',
cityCode: 156530700,
region: '古城区',
regionCode: 156530702,
name: '古城区',
adcode: '156530702'
}, {
id: 2335,
province: '云南省',
provinceCode: 156530000,
city: '丽江市',
cityCode: 156530700,
region: '玉龙纳西族自治县',
regionCode: 156530721,
name: '玉龙纳西族自治县',
adcode: '156530721'
}, {
id: 2336,
province: '云南省',
provinceCode: 156530000,
city: '丽江市',
cityCode: 156530700,
region: '永胜县',
regionCode: 156530722,
name: '永胜县',
adcode: '156530722'
}, {
id: 2337,
province: '云南省',
provinceCode: 156530000,
city: '丽江市',
cityCode: 156530700,
region: '华坪县',
regionCode: 156530723,
name: '华坪县',
adcode: '156530723'
}, {
id: 2338,
province: '云南省',
provinceCode: 156530000,
city: '丽江市',
cityCode: 156530700,
region: '宁蒗彝族自治县',
regionCode: 156530724,
name: '宁蒗彝族自治县',
adcode: '156530724'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
adcode: '156530800',
name: '普洱市',
cityCode: 156530800,
children: [{
id: 2339,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '思茅区',
regionCode: 156530802,
name: '思茅区',
adcode: '156530802'
}, {
id: 2340,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '宁洱哈尼族彝族自治县',
regionCode: 156530821,
name: '宁洱哈尼族彝族自治县',
adcode: '156530821'
}, {
id: 2341,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '墨江哈尼族自治县',
regionCode: 156530822,
name: '墨江哈尼族自治县',
adcode: '156530822'
}, {
id: 2342,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '景东彝族自治县',
regionCode: 156530823,
name: '景东彝族自治县',
adcode: '156530823'
}, {
id: 2343,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '景谷傣族彝族自治县',
regionCode: 156530824,
name: '景谷傣族彝族自治县',
adcode: '156530824'
}, {
id: 2344,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '镇沅彝族哈尼族拉祜族自治县',
regionCode: 156530825,
name: '镇沅彝族哈尼族拉祜族自治县',
adcode: '156530825'
}, {
id: 2345,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '江城哈尼族彝族自治县',
regionCode: 156530826,
name: '江城哈尼族彝族自治县',
adcode: '156530826'
}, {
id: 2346,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '孟连傣族拉祜族佤族自治县',
regionCode: 156530827,
name: '孟连傣族拉祜族佤族自治县',
adcode: '156530827'
}, {
id: 2347,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '澜沧拉祜族自治县',
regionCode: 156530828,
name: '澜沧拉祜族自治县',
adcode: '156530828'
}, {
id: 2348,
province: '云南省',
provinceCode: 156530000,
city: '普洱市',
cityCode: 156530800,
region: '西盟佤族自治县',
regionCode: 156530829,
name: '西盟佤族自治县',
adcode: '156530829'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
adcode: '156530900',
name: '临沧市',
cityCode: 156530900,
children: [{
id: 2349,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '临翔区',
regionCode: 156530902,
name: '临翔区',
adcode: '156530902'
}, {
id: 2350,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '凤庆县',
regionCode: 156530921,
name: '凤庆县',
adcode: '156530921'
}, {
id: 2351,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '云县',
regionCode: 156530922,
name: '云县',
adcode: '156530922'
}, {
id: 2352,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '永德县',
regionCode: 156530923,
name: '永德县',
adcode: '156530923'
}, {
id: 2353,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '镇康县',
regionCode: 156530924,
name: '镇康县',
adcode: '156530924'
}, {
id: 2354,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '双江拉祜族佤族布朗族傣族自治县',
regionCode: 156530925,
name: '双江拉祜族佤族布朗族傣族自治县',
adcode: '156530925'
}, {
id: 2355,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '耿马傣族佤族自治县',
regionCode: 156530926,
name: '耿马傣族佤族自治县',
adcode: '156530926'
}, {
id: 2356,
province: '云南省',
provinceCode: 156530000,
city: '临沧市',
cityCode: 156530900,
region: '沧源佤族自治县',
regionCode: 156530927,
name: '沧源佤族自治县',
adcode: '156530927'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
adcode: '156532300',
name: '楚雄彝族自治州',
cityCode: 156532300,
children: [{
id: 2357,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '楚雄市',
regionCode: 156532301,
name: '楚雄市',
adcode: '156532301'
}, {
id: 2358,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '双柏县',
regionCode: 156532322,
name: '双柏县',
adcode: '156532322'
}, {
id: 2359,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '牟定县',
regionCode: 156532323,
name: '牟定县',
adcode: '156532323'
}, {
id: 2360,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '南华县',
regionCode: 156532324,
name: '南华县',
adcode: '156532324'
}, {
id: 2361,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '姚安县',
regionCode: 156532325,
name: '姚安县',
adcode: '156532325'
}, {
id: 2362,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '大姚县',
regionCode: 156532326,
name: '大姚县',
adcode: '156532326'
}, {
id: 2363,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '永仁县',
regionCode: 156532327,
name: '永仁县',
adcode: '156532327'
}, {
id: 2364,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '元谋县',
regionCode: 156532328,
name: '元谋县',
adcode: '156532328'
}, {
id: 2365,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '武定县',
regionCode: 156532329,
name: '武定县',
adcode: '156532329'
}, {
id: 2366,
province: '云南省',
provinceCode: 156530000,
city: '楚雄彝族自治州',
cityCode: 156532300,
region: '禄丰县',
regionCode: 156532331,
name: '禄丰县',
adcode: '156532331'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
adcode: '156532500',
name: '红河哈尼族彝族自治州',
cityCode: 156532500,
children: [{
id: 2367,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '个旧市',
regionCode: 156532501,
name: '个旧市',
adcode: '156532501'
}, {
id: 2368,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '开远市',
regionCode: 156532502,
name: '开远市',
adcode: '156532502'
}, {
id: 2369,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '蒙自市',
regionCode: 156532503,
name: '蒙自市',
adcode: '156532503'
}, {
id: 2370,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '弥勒市',
regionCode: 156532504,
name: '弥勒市',
adcode: '156532504'
}, {
id: 2371,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '屏边苗族自治县',
regionCode: 156532523,
name: '屏边苗族自治县',
adcode: '156532523'
}, {
id: 2372,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '建水县',
regionCode: 156532524,
name: '建水县',
adcode: '156532524'
}, {
id: 2373,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '石屏县',
regionCode: 156532525,
name: '石屏县',
adcode: '156532525'
}, {
id: 2374,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '泸西县',
regionCode: 156532527,
name: '泸西县',
adcode: '156532527'
}, {
id: 2375,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '元阳县',
regionCode: 156532528,
name: '元阳县',
adcode: '156532528'
}, {
id: 2376,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '红河县',
regionCode: 156532529,
name: '红河县',
adcode: '156532529'
}, {
id: 2377,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '金平苗族瑶族傣族自治县',
regionCode: 156532530,
name: '金平苗族瑶族傣族自治县',
adcode: '156532530'
}, {
id: 2378,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '绿春县',
regionCode: 156532531,
name: '绿春县',
adcode: '156532531'
}, {
id: 2379,
province: '云南省',
provinceCode: 156530000,
city: '红河哈尼族彝族自治州',
cityCode: 156532500,
region: '河口瑶族自治县',
regionCode: 156532532,
name: '河口瑶族自治县',
adcode: '156532532'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
adcode: '156532600',
name: '文山壮族苗族自治州',
cityCode: 156532600,
children: [{
id: 2380,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '文山市',
regionCode: 156532601,
name: '文山市',
adcode: '156532601'
}, {
id: 2381,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '砚山县',
regionCode: 156532622,
name: '砚山县',
adcode: '156532622'
}, {
id: 2382,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '西畴县',
regionCode: 156532623,
name: '西畴县',
adcode: '156532623'
}, {
id: 2383,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '麻栗坡县',
regionCode: 156532624,
name: '麻栗坡县',
adcode: '156532624'
}, {
id: 2384,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '马关县',
regionCode: 156532625,
name: '马关县',
adcode: '156532625'
}, {
id: 2385,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '丘北县',
regionCode: 156532626,
name: '丘北县',
adcode: '156532626'
}, {
id: 2386,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '广南县',
regionCode: 156532627,
name: '广南县',
adcode: '156532627'
}, {
id: 2387,
province: '云南省',
provinceCode: 156530000,
city: '文山壮族苗族自治州',
cityCode: 156532600,
region: '富宁县',
regionCode: 156532628,
name: '富宁县',
adcode: '156532628'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '西双版纳傣族自治州',
adcode: '156532800',
name: '西双版纳傣族自治州',
cityCode: 156532800,
children: [{
id: 2388,
province: '云南省',
provinceCode: 156530000,
city: '西双版纳傣族自治州',
cityCode: 156532800,
region: '景洪市',
regionCode: 156532801,
name: '景洪市',
adcode: '156532801'
}, {
id: 2389,
province: '云南省',
provinceCode: 156530000,
city: '西双版纳傣族自治州',
cityCode: 156532800,
region: '勐海县',
regionCode: 156532822,
name: '勐海县',
adcode: '156532822'
}, {
id: 2390,
province: '云南省',
provinceCode: 156530000,
city: '西双版纳傣族自治州',
cityCode: 156532800,
region: '勐腊县',
regionCode: 156532823,
name: '勐腊县',
adcode: '156532823'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
adcode: '156532900',
name: '大理白族自治州',
cityCode: 156532900,
children: [{
id: 2391,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '大理市',
regionCode: 156532901,
name: '大理市',
adcode: '156532901'
}, {
id: 2392,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '漾濞彝族自治县',
regionCode: 156532922,
name: '漾濞彝族自治县',
adcode: '156532922'
}, {
id: 2393,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '祥云县',
regionCode: 156532923,
name: '祥云县',
adcode: '156532923'
}, {
id: 2394,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '宾川县',
regionCode: 156532924,
name: '宾川县',
adcode: '156532924'
}, {
id: 2395,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '弥渡县',
regionCode: 156532925,
name: '弥渡县',
adcode: '156532925'
}, {
id: 2396,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '南涧彝族自治县',
regionCode: 156532926,
name: '南涧彝族自治县',
adcode: '156532926'
}, {
id: 2397,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '巍山彝族回族自治县',
regionCode: 156532927,
name: '巍山彝族回族自治县',
adcode: '156532927'
}, {
id: 2398,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '永平县',
regionCode: 156532928,
name: '永平县',
adcode: '156532928'
}, {
id: 2399,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '云龙县',
regionCode: 156532929,
name: '云龙县',
adcode: '156532929'
}, {
id: 2400,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '洱源县',
regionCode: 156532930,
name: '洱源县',
adcode: '156532930'
}, {
id: 2401,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '剑川县',
regionCode: 156532931,
name: '剑川县',
adcode: '156532931'
}, {
id: 2402,
province: '云南省',
provinceCode: 156530000,
city: '大理白族自治州',
cityCode: 156532900,
region: '鹤庆县',
regionCode: 156532932,
name: '鹤庆县',
adcode: '156532932'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '德宏傣族景颇族自治州',
adcode: '156533100',
name: '德宏傣族景颇族自治州',
cityCode: 156533100,
children: [{
id: 2403,
province: '云南省',
provinceCode: 156530000,
city: '德宏傣族景颇族自治州',
cityCode: 156533100,
region: '瑞丽市',
regionCode: 156533102,
name: '瑞丽市',
adcode: '156533102'
}, {
id: 2404,
province: '云南省',
provinceCode: 156530000,
city: '德宏傣族景颇族自治州',
cityCode: 156533100,
region: '芒市',
regionCode: 156533103,
name: '芒市',
adcode: '156533103'
}, {
id: 2405,
province: '云南省',
provinceCode: 156530000,
city: '德宏傣族景颇族自治州',
cityCode: 156533100,
region: '梁河县',
regionCode: 156533122,
name: '梁河县',
adcode: '156533122'
}, {
id: 2406,
province: '云南省',
provinceCode: 156530000,
city: '德宏傣族景颇族自治州',
cityCode: 156533100,
region: '盈江县',
regionCode: 156533123,
name: '盈江县',
adcode: '156533123'
}, {
id: 2407,
province: '云南省',
provinceCode: 156530000,
city: '德宏傣族景颇族自治州',
cityCode: 156533100,
region: '陇川县',
regionCode: 156533124,
name: '陇川县',
adcode: '156533124'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '怒江傈僳族自治州',
adcode: '156533300',
name: '怒江傈僳族自治州',
cityCode: 156533300,
children: [{
id: 2408,
province: '云南省',
provinceCode: 156530000,
city: '怒江傈僳族自治州',
cityCode: 156533300,
region: '泸水市',
regionCode: 156533301,
name: '泸水市',
adcode: '156533301'
}, {
id: 2409,
province: '云南省',
provinceCode: 156530000,
city: '怒江傈僳族自治州',
cityCode: 156533300,
region: '福贡县',
regionCode: 156533323,
name: '福贡县',
adcode: '156533323'
}, {
id: 2410,
province: '云南省',
provinceCode: 156530000,
city: '怒江傈僳族自治州',
cityCode: 156533300,
region: '贡山独龙族怒族自治县',
regionCode: 156533324,
name: '贡山独龙族怒族自治县',
adcode: '156533324'
}, {
id: 2411,
province: '云南省',
provinceCode: 156530000,
city: '怒江傈僳族自治州',
cityCode: 156533300,
region: '兰坪白族普米族自治县',
regionCode: 156533325,
name: '兰坪白族普米族自治县',
adcode: '156533325'
}]
}, {
province: '云南省',
provinceCode: 156530000,
city: '迪庆藏族自治州',
adcode: '156533400',
name: '迪庆藏族自治州',
cityCode: 156533400,
children: [{
id: 2412,
province: '云南省',
provinceCode: 156530000,
city: '迪庆藏族自治州',
cityCode: 156533400,
region: '香格里拉市',
regionCode: 156533401,
name: '香格里拉市',
adcode: '156533401'
}, {
id: 2413,
province: '云南省',
provinceCode: 156530000,
city: '迪庆藏族自治州',
cityCode: 156533400,
region: '德钦县',
regionCode: 156533422,
name: '德钦县',
adcode: '156533422'
}, {
id: 2414,
province: '云南省',
provinceCode: 156530000,
city: '迪庆藏族自治州',
cityCode: 156533400,
region: '维西傈僳族自治县',
regionCode: 156533423,
name: '维西傈僳族自治县',
adcode: '156533423'
}]
}]
}, {
province: '西藏自治区',
provinceCode: 156540000,
adcode: '156540000',
name: '西藏自治区',
children: [{
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
adcode: '156540100',
name: '拉萨市',
cityCode: 156540100,
children: [{
id: 2415,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '城关区',
regionCode: 156540102,
name: '城关区',
adcode: '156540102'
}, {
id: 2416,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '堆龙德庆区',
regionCode: 156540103,
name: '堆龙德庆区',
adcode: '156540103'
}, {
id: 2417,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '达孜区',
regionCode: 156540104,
name: '达孜区',
adcode: '156540104'
}, {
id: 2418,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '林周县',
regionCode: 156540121,
name: '林周县',
adcode: '156540121'
}, {
id: 2419,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '当雄县',
regionCode: 156540122,
name: '当雄县',
adcode: '156540122'
}, {
id: 2420,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '尼木县',
regionCode: 156540123,
name: '尼木县',
adcode: '156540123'
}, {
id: 2421,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '曲水县',
regionCode: 156540124,
name: '曲水县',
adcode: '156540124'
}, {
id: 2422,
province: '西藏自治区',
provinceCode: 156540000,
city: '拉萨市',
cityCode: 156540100,
region: '墨竹工卡县',
regionCode: 156540127,
name: '墨竹工卡县',
adcode: '156540127'
}]
}, {
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
adcode: '156540200',
name: '日喀则市',
cityCode: 156540200,
children: [{
id: 2423,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '桑珠孜区',
regionCode: 156540202,
name: '桑珠孜区',
adcode: '156540202'
}, {
id: 2424,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '南木林县',
regionCode: 156540221,
name: '南木林县',
adcode: '156540221'
}, {
id: 2425,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '江孜县',
regionCode: 156540222,
name: '江孜县',
adcode: '156540222'
}, {
id: 2426,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '定日县',
regionCode: 156540223,
name: '定日县',
adcode: '156540223'
}, {
id: 2427,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '萨迦县',
regionCode: 156540224,
name: '萨迦县',
adcode: '156540224'
}, {
id: 2428,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '拉孜县',
regionCode: 156540225,
name: '拉孜县',
adcode: '156540225'
}, {
id: 2429,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '昂仁县',
regionCode: 156540226,
name: '昂仁县',
adcode: '156540226'
}, {
id: 2430,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '谢通门县',
regionCode: 156540227,
name: '谢通门县',
adcode: '156540227'
}, {
id: 2431,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '白朗县',
regionCode: 156540228,
name: '白朗县',
adcode: '156540228'
}, {
id: 2432,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '仁布县',
regionCode: 156540229,
name: '仁布县',
adcode: '156540229'
}, {
id: 2433,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '康马县',
regionCode: 156540230,
name: '康马县',
adcode: '156540230'
}, {
id: 2434,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '定结县',
regionCode: 156540231,
name: '定结县',
adcode: '156540231'
}, {
id: 2435,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '仲巴县',
regionCode: 156540232,
name: '仲巴县',
adcode: '156540232'
}, {
id: 2436,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '亚东县',
regionCode: 156540233,
name: '亚东县',
adcode: '156540233'
}, {
id: 2437,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '吉隆县',
regionCode: 156540234,
name: '吉隆县',
adcode: '156540234'
}, {
id: 2438,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '聂拉木县',
regionCode: 156540235,
name: '聂拉木县',
adcode: '156540235'
}, {
id: 2439,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '萨嘎县',
regionCode: 156540236,
name: '萨嘎县',
adcode: '156540236'
}, {
id: 2440,
province: '西藏自治区',
provinceCode: 156540000,
city: '日喀则市',
cityCode: 156540200,
region: '岗巴县',
regionCode: 156540237,
name: '岗巴县',
adcode: '156540237'
}]
}, {
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
adcode: '156540300',
name: '昌都市',
cityCode: 156540300,
children: [{
id: 2441,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '卡若区',
regionCode: 156540302,
name: '卡若区',
adcode: '156540302'
}, {
id: 2442,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '江达县',
regionCode: 156540321,
name: '江达县',
adcode: '156540321'
}, {
id: 2443,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '贡觉县',
regionCode: 156540322,
name: '贡觉县',
adcode: '156540322'
}, {
id: 2444,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '类乌齐县',
regionCode: 156540323,
name: '类乌齐县',
adcode: '156540323'
}, {
id: 2445,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '丁青县',
regionCode: 156540324,
name: '丁青县',
adcode: '156540324'
}, {
id: 2446,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '察雅县',
regionCode: 156540325,
name: '察雅县',
adcode: '156540325'
}, {
id: 2447,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '八宿县',
regionCode: 156540326,
name: '八宿县',
adcode: '156540326'
}, {
id: 2448,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '左贡县',
regionCode: 156540327,
name: '左贡县',
adcode: '156540327'
}, {
id: 2449,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '芒康县',
regionCode: 156540328,
name: '芒康县',
adcode: '156540328'
}, {
id: 2450,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '洛隆县',
regionCode: 156540329,
name: '洛隆县',
adcode: '156540329'
}, {
id: 2451,
province: '西藏自治区',
provinceCode: 156540000,
city: '昌都市',
cityCode: 156540300,
region: '边坝县',
regionCode: 156540330,
name: '边坝县',
adcode: '156540330'
}]
}, {
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
adcode: '156540400',
name: '林芝市',
cityCode: 156540400,
children: [{
id: 2452,
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
cityCode: 156540400,
region: '巴宜区',
regionCode: 156540402,
name: '巴宜区',
adcode: '156540402'
}, {
id: 2453,
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
cityCode: 156540400,
region: '工布江达县',
regionCode: 156540421,
name: '工布江达县',
adcode: '156540421'
}, {
id: 2454,
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
cityCode: 156540400,
region: '米林县',
regionCode: 156540422,
name: '米林县',
adcode: '156540422'
}, {
id: 2455,
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
cityCode: 156540400,
region: '墨脱县',
regionCode: 156540423,
name: '墨脱县',
adcode: '156540423'
}, {
id: 2456,
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
cityCode: 156540400,
region: '波密县',
regionCode: 156540424,
name: '波密县',
adcode: '156540424'
}, {
id: 2457,
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
cityCode: 156540400,
region: '察隅县',
regionCode: 156540425,
name: '察隅县',
adcode: '156540425'
}, {
id: 2458,
province: '西藏自治区',
provinceCode: 156540000,
city: '林芝市',
cityCode: 156540400,
region: '朗县',
regionCode: 156540426,
name: '朗县',
adcode: '156540426'
}]
}, {
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
adcode: '156540500',
name: '山南市',
cityCode: 156540500,
children: [{
id: 2459,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '乃东区',
regionCode: 156540502,
name: '乃东区',
adcode: '156540502'
}, {
id: 2460,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '扎囊县',
regionCode: 156540521,
name: '扎囊县',
adcode: '156540521'
}, {
id: 2461,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '贡嘎县',
regionCode: 156540522,
name: '贡嘎县',
adcode: '156540522'
}, {
id: 2462,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '桑日县',
regionCode: 156540523,
name: '桑日县',
adcode: '156540523'
}, {
id: 2463,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '琼结县',
regionCode: 156540524,
name: '琼结县',
adcode: '156540524'
}, {
id: 2464,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '曲松县',
regionCode: 156540525,
name: '曲松县',
adcode: '156540525'
}, {
id: 2465,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '措美县',
regionCode: 156540526,
name: '措美县',
adcode: '156540526'
}, {
id: 2466,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '洛扎县',
regionCode: 156540527,
name: '洛扎县',
adcode: '156540527'
}, {
id: 2467,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '加查县',
regionCode: 156540528,
name: '加查县',
adcode: '156540528'
}, {
id: 2468,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '隆子县',
regionCode: 156540529,
name: '隆子县',
adcode: '156540529'
}, {
id: 2469,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '错那县',
regionCode: 156540530,
name: '错那县',
adcode: '156540530'
}, {
id: 2470,
province: '西藏自治区',
provinceCode: 156540000,
city: '山南市',
cityCode: 156540500,
region: '浪卡子县',
regionCode: 156540531,
name: '浪卡子县',
adcode: '156540531'
}]
}, {
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
adcode: '156540600',
name: '那曲市',
cityCode: 156540600,
children: [{
id: 2471,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '色尼区',
regionCode: 156540602,
name: '色尼区',
adcode: '156540602'
}, {
id: 2472,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '嘉黎县',
regionCode: 156540621,
name: '嘉黎县',
adcode: '156540621'
}, {
id: 2473,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '比如县',
regionCode: 156540622,
name: '比如县',
adcode: '156540622'
}, {
id: 2474,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '聂荣县',
regionCode: 156540623,
name: '聂荣县',
adcode: '156540623'
}, {
id: 2475,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '安多县',
regionCode: 156540624,
name: '安多县',
adcode: '156540624'
}, {
id: 2476,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '申扎县',
regionCode: 156540625,
name: '申扎县',
adcode: '156540625'
}, {
id: 2477,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '索县',
regionCode: 156540626,
name: '索县',
adcode: '156540626'
}, {
id: 2478,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '班戈县',
regionCode: 156540627,
name: '班戈县',
adcode: '156540627'
}, {
id: 2479,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '巴青县',
regionCode: 156540628,
name: '巴青县',
adcode: '156540628'
}, {
id: 2480,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '尼玛县',
regionCode: 156540629,
name: '尼玛县',
adcode: '156540629'
}, {
id: 2481,
province: '西藏自治区',
provinceCode: 156540000,
city: '那曲市',
cityCode: 156540600,
region: '双湖县',
regionCode: 156540630,
name: '双湖县',
adcode: '156540630'
}]
}, {
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
adcode: '156542500',
name: '阿里地区',
cityCode: 156542500,
children: [{
id: 2482,
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
cityCode: 156542500,
region: '普兰县',
regionCode: 156542521,
name: '普兰县',
adcode: '156542521'
}, {
id: 2483,
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
cityCode: 156542500,
region: '札达县',
regionCode: 156542522,
name: '札达县',
adcode: '156542522'
}, {
id: 2484,
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
cityCode: 156542500,
region: '噶尔县',
regionCode: 156542523,
name: '噶尔县',
adcode: '156542523'
}, {
id: 2485,
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
cityCode: 156542500,
region: '日土县',
regionCode: 156542524,
name: '日土县',
adcode: '156542524'
}, {
id: 2486,
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
cityCode: 156542500,
region: '革吉县',
regionCode: 156542525,
name: '革吉县',
adcode: '156542525'
}, {
id: 2487,
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
cityCode: 156542500,
region: '改则县',
regionCode: 156542526,
name: '改则县',
adcode: '156542526'
}, {
id: 2488,
province: '西藏自治区',
provinceCode: 156540000,
city: '阿里地区',
cityCode: 156542500,
region: '措勤县',
regionCode: 156542527,
name: '措勤县',
adcode: '156542527'
}]
}]
}, {
province: '陕西省',
provinceCode: 156610000,
adcode: '156610000',
name: '陕西省',
children: [{
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
adcode: '156610100',
name: '西安市',
cityCode: 156610100,
children: [{
id: 2489,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '新城区',
regionCode: 156610102,
name: '新城区',
adcode: '156610102'
}, {
id: 2490,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '碑林区',
regionCode: 156610103,
name: '碑林区',
adcode: '156610103'
}, {
id: 2491,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '莲湖区',
regionCode: 156610104,
name: '莲湖区',
adcode: '156610104'
}, {
id: 2492,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '灞桥区',
regionCode: 156610111,
name: '灞桥区',
adcode: '156610111'
}, {
id: 2493,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '未央区',
regionCode: 156610112,
name: '未央区',
adcode: '156610112'
}, {
id: 2494,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '雁塔区',
regionCode: 156610113,
name: '雁塔区',
adcode: '156610113'
}, {
id: 2495,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '阎良区',
regionCode: 156610114,
name: '阎良区',
adcode: '156610114'
}, {
id: 2496,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '临潼区',
regionCode: 156610115,
name: '临潼区',
adcode: '156610115'
}, {
id: 2497,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '长安区',
regionCode: 156610116,
name: '长安区',
adcode: '156610116'
}, {
id: 2498,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '高陵区',
regionCode: 156610117,
name: '高陵区',
adcode: '156610117'
}, {
id: 2499,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '鄠邑区',
regionCode: 156610118,
name: '鄠邑区',
adcode: '156610118'
}, {
id: 2500,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '蓝田县',
regionCode: 156610122,
name: '蓝田县',
adcode: '156610122'
}, {
id: 2501,
province: '陕西省',
provinceCode: 156610000,
city: '西安市',
cityCode: 156610100,
region: '周至县',
regionCode: 156610124,
name: '周至县',
adcode: '156610124'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '铜川市',
adcode: '156610200',
name: '铜川市',
cityCode: 156610200,
children: [{
id: 2502,
province: '陕西省',
provinceCode: 156610000,
city: '铜川市',
cityCode: 156610200,
region: '王益区',
regionCode: 156610202,
name: '王益区',
adcode: '156610202'
}, {
id: 2503,
province: '陕西省',
provinceCode: 156610000,
city: '铜川市',
cityCode: 156610200,
region: '印台区',
regionCode: 156610203,
name: '印台区',
adcode: '156610203'
}, {
id: 2504,
province: '陕西省',
provinceCode: 156610000,
city: '铜川市',
cityCode: 156610200,
region: '耀州区',
regionCode: 156610204,
name: '耀州区',
adcode: '156610204'
}, {
id: 2505,
province: '陕西省',
provinceCode: 156610000,
city: '铜川市',
cityCode: 156610200,
region: '宜君县',
regionCode: 156610222,
name: '宜君县',
adcode: '156610222'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
adcode: '156610300',
name: '宝鸡市',
cityCode: 156610300,
children: [{
id: 2506,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '渭滨区',
regionCode: 156610302,
name: '渭滨区',
adcode: '156610302'
}, {
id: 2507,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '金台区',
regionCode: 156610303,
name: '金台区',
adcode: '156610303'
}, {
id: 2508,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '陈仓区',
regionCode: 156610304,
name: '陈仓区',
adcode: '156610304'
}, {
id: 2509,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '凤翔县',
regionCode: 156610322,
name: '凤翔县',
adcode: '156610322'
}, {
id: 2510,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '岐山县',
regionCode: 156610323,
name: '岐山县',
adcode: '156610323'
}, {
id: 2511,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '扶风县',
regionCode: 156610324,
name: '扶风县',
adcode: '156610324'
}, {
id: 2512,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '眉县',
regionCode: 156610326,
name: '眉县',
adcode: '156610326'
}, {
id: 2513,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '陇县',
regionCode: 156610327,
name: '陇县',
adcode: '156610327'
}, {
id: 2514,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '千阳县',
regionCode: 156610328,
name: '千阳县',
adcode: '156610328'
}, {
id: 2515,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '麟游县',
regionCode: 156610329,
name: '麟游县',
adcode: '156610329'
}, {
id: 2516,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '凤县',
regionCode: 156610330,
name: '凤县',
adcode: '156610330'
}, {
id: 2517,
province: '陕西省',
provinceCode: 156610000,
city: '宝鸡市',
cityCode: 156610300,
region: '太白县',
regionCode: 156610331,
name: '太白县',
adcode: '156610331'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
adcode: '156610400',
name: '咸阳市',
cityCode: 156610400,
children: [{
id: 2518,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '秦都区',
regionCode: 156610402,
name: '秦都区',
adcode: '156610402'
}, {
id: 2519,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '杨陵区',
regionCode: 156610403,
name: '杨陵区',
adcode: '156610403'
}, {
id: 2520,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '渭城区',
regionCode: 156610404,
name: '渭城区',
adcode: '156610404'
}, {
id: 2521,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '三原县',
regionCode: 156610422,
name: '三原县',
adcode: '156610422'
}, {
id: 2522,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '泾阳县',
regionCode: 156610423,
name: '泾阳县',
adcode: '156610423'
}, {
id: 2523,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '乾县',
regionCode: 156610424,
name: '乾县',
adcode: '156610424'
}, {
id: 2524,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '礼泉县',
regionCode: 156610425,
name: '礼泉县',
adcode: '156610425'
}, {
id: 2525,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '永寿县',
regionCode: 156610426,
name: '永寿县',
adcode: '156610426'
}, {
id: 2526,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '长武县',
regionCode: 156610428,
name: '长武县',
adcode: '156610428'
}, {
id: 2527,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '旬邑县',
regionCode: 156610429,
name: '旬邑县',
adcode: '156610429'
}, {
id: 2528,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '淳化县',
regionCode: 156610430,
name: '淳化县',
adcode: '156610430'
}, {
id: 2529,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '武功县',
regionCode: 156610431,
name: '武功县',
adcode: '156610431'
}, {
id: 2530,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '兴平市',
regionCode: 156610481,
name: '兴平市',
adcode: '156610481'
}, {
id: 2531,
province: '陕西省',
provinceCode: 156610000,
city: '咸阳市',
cityCode: 156610400,
region: '彬州市',
regionCode: 156610482,
name: '彬州市',
adcode: '156610482'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
adcode: '156610500',
name: '渭南市',
cityCode: 156610500,
children: [{
id: 2532,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '临渭区',
regionCode: 156610502,
name: '临渭区',
adcode: '156610502'
}, {
id: 2533,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '华州区',
regionCode: 156610503,
name: '华州区',
adcode: '156610503'
}, {
id: 2534,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '潼关县',
regionCode: 156610522,
name: '潼关县',
adcode: '156610522'
}, {
id: 2535,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '大荔县',
regionCode: 156610523,
name: '大荔县',
adcode: '156610523'
}, {
id: 2536,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '合阳县',
regionCode: 156610524,
name: '合阳县',
adcode: '156610524'
}, {
id: 2537,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '澄城县',
regionCode: 156610525,
name: '澄城县',
adcode: '156610525'
}, {
id: 2538,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '蒲城县',
regionCode: 156610526,
name: '蒲城县',
adcode: '156610526'
}, {
id: 2539,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '白水县',
regionCode: 156610527,
name: '白水县',
adcode: '156610527'
}, {
id: 2540,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '富平县',
regionCode: 156610528,
name: '富平县',
adcode: '156610528'
}, {
id: 2541,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '韩城市',
regionCode: 156610581,
name: '韩城市',
adcode: '156610581'
}, {
id: 2542,
province: '陕西省',
provinceCode: 156610000,
city: '渭南市',
cityCode: 156610500,
region: '华阴市',
regionCode: 156610582,
name: '华阴市',
adcode: '156610582'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
adcode: '156610600',
name: '延安市',
cityCode: 156610600,
children: [{
id: 2543,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '宝塔区',
regionCode: 156610602,
name: '宝塔区',
adcode: '156610602'
}, {
id: 2544,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '安塞区',
regionCode: 156610603,
name: '安塞区',
adcode: '156610603'
}, {
id: 2545,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '延长县',
regionCode: 156610621,
name: '延长县',
adcode: '156610621'
}, {
id: 2546,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '延川县',
regionCode: 156610622,
name: '延川县',
adcode: '156610622'
}, {
id: 2547,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '志丹县',
regionCode: 156610625,
name: '志丹县',
adcode: '156610625'
}, {
id: 2548,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '吴起县',
regionCode: 156610626,
name: '吴起县',
adcode: '156610626'
}, {
id: 2549,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '甘泉县',
regionCode: 156610627,
name: '甘泉县',
adcode: '156610627'
}, {
id: 2550,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '富县',
regionCode: 156610628,
name: '富县',
adcode: '156610628'
}, {
id: 2551,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '洛川县',
regionCode: 156610629,
name: '洛川县',
adcode: '156610629'
}, {
id: 2552,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '宜川县',
regionCode: 156610630,
name: '宜川县',
adcode: '156610630'
}, {
id: 2553,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '黄龙县',
regionCode: 156610631,
name: '黄龙县',
adcode: '156610631'
}, {
id: 2554,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '黄陵县',
regionCode: 156610632,
name: '黄陵县',
adcode: '156610632'
}, {
id: 2555,
province: '陕西省',
provinceCode: 156610000,
city: '延安市',
cityCode: 156610600,
region: '子长市',
regionCode: 156610681,
name: '子长市',
adcode: '156610681'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
adcode: '156610700',
name: '汉中市',
cityCode: 156610700,
children: [{
id: 2556,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '汉台区',
regionCode: 156610702,
name: '汉台区',
adcode: '156610702'
}, {
id: 2557,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '南郑区',
regionCode: 156610703,
name: '南郑区',
adcode: '156610703'
}, {
id: 2558,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '城固县',
regionCode: 156610722,
name: '城固县',
adcode: '156610722'
}, {
id: 2559,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '洋县',
regionCode: 156610723,
name: '洋县',
adcode: '156610723'
}, {
id: 2560,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '西乡县',
regionCode: 156610724,
name: '西乡县',
adcode: '156610724'
}, {
id: 2561,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '勉县',
regionCode: 156610725,
name: '勉县',
adcode: '156610725'
}, {
id: 2562,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '宁强县',
regionCode: 156610726,
name: '宁强县',
adcode: '156610726'
}, {
id: 2563,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '略阳县',
regionCode: 156610727,
name: '略阳县',
adcode: '156610727'
}, {
id: 2564,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '镇巴县',
regionCode: 156610728,
name: '镇巴县',
adcode: '156610728'
}, {
id: 2565,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '留坝县',
regionCode: 156610729,
name: '留坝县',
adcode: '156610729'
}, {
id: 2566,
province: '陕西省',
provinceCode: 156610000,
city: '汉中市',
cityCode: 156610700,
region: '佛坪县',
regionCode: 156610730,
name: '佛坪县',
adcode: '156610730'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
adcode: '156610800',
name: '榆林市',
cityCode: 156610800,
children: [{
id: 2567,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '榆阳区',
regionCode: 156610802,
name: '榆阳区',
adcode: '156610802'
}, {
id: 2568,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '横山区',
regionCode: 156610803,
name: '横山区',
adcode: '156610803'
}, {
id: 2569,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '府谷县',
regionCode: 156610822,
name: '府谷县',
adcode: '156610822'
}, {
id: 2570,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '靖边县',
regionCode: 156610824,
name: '靖边县',
adcode: '156610824'
}, {
id: 2571,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '定边县',
regionCode: 156610825,
name: '定边县',
adcode: '156610825'
}, {
id: 2572,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '绥德县',
regionCode: 156610826,
name: '绥德县',
adcode: '156610826'
}, {
id: 2573,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '米脂县',
regionCode: 156610827,
name: '米脂县',
adcode: '156610827'
}, {
id: 2574,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '佳县',
regionCode: 156610828,
name: '佳县',
adcode: '156610828'
}, {
id: 2575,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '吴堡县',
regionCode: 156610829,
name: '吴堡县',
adcode: '156610829'
}, {
id: 2576,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '清涧县',
regionCode: 156610830,
name: '清涧县',
adcode: '156610830'
}, {
id: 2577,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '子洲县',
regionCode: 156610831,
name: '子洲县',
adcode: '156610831'
}, {
id: 2578,
province: '陕西省',
provinceCode: 156610000,
city: '榆林市',
cityCode: 156610800,
region: '神木市',
regionCode: 156610881,
name: '神木市',
adcode: '156610881'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
adcode: '156610900',
name: '安康市',
cityCode: 156610900,
children: [{
id: 2579,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '汉滨区',
regionCode: 156610902,
name: '汉滨区',
adcode: '156610902'
}, {
id: 2580,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '汉阴县',
regionCode: 156610921,
name: '汉阴县',
adcode: '156610921'
}, {
id: 2581,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '石泉县',
regionCode: 156610922,
name: '石泉县',
adcode: '156610922'
}, {
id: 2582,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '宁陕县',
regionCode: 156610923,
name: '宁陕县',
adcode: '156610923'
}, {
id: 2583,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '紫阳县',
regionCode: 156610924,
name: '紫阳县',
adcode: '156610924'
}, {
id: 2584,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '岚皋县',
regionCode: 156610925,
name: '岚皋县',
adcode: '156610925'
}, {
id: 2585,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '平利县',
regionCode: 156610926,
name: '平利县',
adcode: '156610926'
}, {
id: 2586,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '镇坪县',
regionCode: 156610927,
name: '镇坪县',
adcode: '156610927'
}, {
id: 2587,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '旬阳县',
regionCode: 156610928,
name: '旬阳县',
adcode: '156610928'
}, {
id: 2588,
province: '陕西省',
provinceCode: 156610000,
city: '安康市',
cityCode: 156610900,
region: '白河县',
regionCode: 156610929,
name: '白河县',
adcode: '156610929'
}]
}, {
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
adcode: '156611000',
name: '商洛市',
cityCode: 156611000,
children: [{
id: 2589,
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
cityCode: 156611000,
region: '商州区',
regionCode: 156611002,
name: '商州区',
adcode: '156611002'
}, {
id: 2590,
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
cityCode: 156611000,
region: '洛南县',
regionCode: 156611021,
name: '洛南县',
adcode: '156611021'
}, {
id: 2591,
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
cityCode: 156611000,
region: '丹凤县',
regionCode: 156611022,
name: '丹凤县',
adcode: '156611022'
}, {
id: 2592,
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
cityCode: 156611000,
region: '商南县',
regionCode: 156611023,
name: '商南县',
adcode: '156611023'
}, {
id: 2593,
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
cityCode: 156611000,
region: '山阳县',
regionCode: 156611024,
name: '山阳县',
adcode: '156611024'
}, {
id: 2594,
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
cityCode: 156611000,
region: '镇安县',
regionCode: 156611025,
name: '镇安县',
adcode: '156611025'
}, {
id: 2595,
province: '陕西省',
provinceCode: 156610000,
city: '商洛市',
cityCode: 156611000,
region: '柞水县',
regionCode: 156611026,
name: '柞水县',
adcode: '156611026'
}]
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
adcode: '156620000',
name: '甘肃省',
children: [{
province: '甘肃省',
provinceCode: 156620000,
city: '甘肃省直辖',
adcode: '156620000',
name: '甘肃省直辖',
cityCode: 156620000,
children: [{
id: 2683,
province: '甘肃省',
provinceCode: 156620000,
city: '甘肃省直辖',
cityCode: 156620000,
region: '甘肃中牧山丹马场',
regionCode: 156629700,
name: '甘肃中牧山丹马场',
adcode: '156629700'
}, {
id: 2684,
province: '甘肃省',
provinceCode: 156620000,
city: '甘肃省直辖',
cityCode: 156620000,
region: '莲花山风景林自然保护区',
regionCode: 156629800,
name: '莲花山风景林自然保护区',
adcode: '156629800'
}, {
id: 2685,
province: '甘肃省',
provinceCode: 156620000,
city: '甘肃省直辖',
cityCode: 156620000,
region: '太子山天然林保护区',
regionCode: 156629900,
name: '太子山天然林保护区',
adcode: '156629900'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
adcode: '156620100',
name: '兰州市',
cityCode: 156620100,
children: [{
id: 2596,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '城关区',
regionCode: 156620102,
name: '城关区',
adcode: '156620102'
}, {
id: 2597,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '七里河区',
regionCode: 156620103,
name: '七里河区',
adcode: '156620103'
}, {
id: 2598,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '西固区',
regionCode: 156620104,
name: '西固区',
adcode: '156620104'
}, {
id: 2599,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '安宁区',
regionCode: 156620105,
name: '安宁区',
adcode: '156620105'
}, {
id: 2600,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '红古区',
regionCode: 156620111,
name: '红古区',
adcode: '156620111'
}, {
id: 2601,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '永登县',
regionCode: 156620121,
name: '永登县',
adcode: '156620121'
}, {
id: 2602,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '皋兰县',
regionCode: 156620122,
name: '皋兰县',
adcode: '156620122'
}, {
id: 2603,
province: '甘肃省',
provinceCode: 156620000,
city: '兰州市',
cityCode: 156620100,
region: '榆中县',
regionCode: 156620123,
name: '榆中县',
adcode: '156620123'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '嘉峪关市',
adcode: '156620200',
name: '嘉峪关市',
cityCode: 156620200,
children: [{
id: 2604,
province: '甘肃省',
provinceCode: 156620000,
city: '嘉峪关市',
cityCode: 156620200,
region: '嘉峪关市',
regionCode: 156620201,
name: '嘉峪关市',
adcode: '156620201'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '金昌市',
adcode: '156620300',
name: '金昌市',
cityCode: 156620300,
children: [{
id: 2605,
province: '甘肃省',
provinceCode: 156620000,
city: '金昌市',
cityCode: 156620300,
region: '金川区',
regionCode: 156620302,
name: '金川区',
adcode: '156620302'
}, {
id: 2606,
province: '甘肃省',
provinceCode: 156620000,
city: '金昌市',
cityCode: 156620300,
region: '永昌县',
regionCode: 156620321,
name: '永昌县',
adcode: '156620321'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '白银市',
adcode: '156620400',
name: '白银市',
cityCode: 156620400,
children: [{
id: 2607,
province: '甘肃省',
provinceCode: 156620000,
city: '白银市',
cityCode: 156620400,
region: '白银区',
regionCode: 156620402,
name: '白银区',
adcode: '156620402'
}, {
id: 2608,
province: '甘肃省',
provinceCode: 156620000,
city: '白银市',
cityCode: 156620400,
region: '平川区',
regionCode: 156620403,
name: '平川区',
adcode: '156620403'
}, {
id: 2609,
province: '甘肃省',
provinceCode: 156620000,
city: '白银市',
cityCode: 156620400,
region: '靖远县',
regionCode: 156620421,
name: '靖远县',
adcode: '156620421'
}, {
id: 2610,
province: '甘肃省',
provinceCode: 156620000,
city: '白银市',
cityCode: 156620400,
region: '会宁县',
regionCode: 156620422,
name: '会宁县',
adcode: '156620422'
}, {
id: 2611,
province: '甘肃省',
provinceCode: 156620000,
city: '白银市',
cityCode: 156620400,
region: '景泰县',
regionCode: 156620423,
name: '景泰县',
adcode: '156620423'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
adcode: '156620500',
name: '天水市',
cityCode: 156620500,
children: [{
id: 2612,
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
cityCode: 156620500,
region: '秦州区',
regionCode: 156620502,
name: '秦州区',
adcode: '156620502'
}, {
id: 2613,
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
cityCode: 156620500,
region: '麦积区',
regionCode: 156620503,
name: '麦积区',
adcode: '156620503'
}, {
id: 2614,
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
cityCode: 156620500,
region: '清水县',
regionCode: 156620521,
name: '清水县',
adcode: '156620521'
}, {
id: 2615,
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
cityCode: 156620500,
region: '秦安县',
regionCode: 156620522,
name: '秦安县',
adcode: '156620522'
}, {
id: 2616,
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
cityCode: 156620500,
region: '甘谷县',
regionCode: 156620523,
name: '甘谷县',
adcode: '156620523'
}, {
id: 2617,
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
cityCode: 156620500,
region: '武山县',
regionCode: 156620524,
name: '武山县',
adcode: '156620524'
}, {
id: 2618,
province: '甘肃省',
provinceCode: 156620000,
city: '天水市',
cityCode: 156620500,
region: '张家川回族自治县',
regionCode: 156620525,
name: '张家川回族自治县',
adcode: '156620525'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '武威市',
adcode: '156620600',
name: '武威市',
cityCode: 156620600,
children: [{
id: 2619,
province: '甘肃省',
provinceCode: 156620000,
city: '武威市',
cityCode: 156620600,
region: '凉州区',
regionCode: 156620602,
name: '凉州区',
adcode: '156620602'
}, {
id: 2620,
province: '甘肃省',
provinceCode: 156620000,
city: '武威市',
cityCode: 156620600,
region: '民勤县',
regionCode: 156620621,
name: '民勤县',
adcode: '156620621'
}, {
id: 2621,
province: '甘肃省',
provinceCode: 156620000,
city: '武威市',
cityCode: 156620600,
region: '古浪县',
regionCode: 156620622,
name: '古浪县',
adcode: '156620622'
}, {
id: 2622,
province: '甘肃省',
provinceCode: 156620000,
city: '武威市',
cityCode: 156620600,
region: '天祝藏族自治县',
regionCode: 156620623,
name: '天祝藏族自治县',
adcode: '156620623'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '张掖市',
adcode: '156620700',
name: '张掖市',
cityCode: 156620700,
children: [{
id: 2623,
province: '甘肃省',
provinceCode: 156620000,
city: '张掖市',
cityCode: 156620700,
region: '甘州区',
regionCode: 156620702,
name: '甘州区',
adcode: '156620702'
}, {
id: 2624,
province: '甘肃省',
provinceCode: 156620000,
city: '张掖市',
cityCode: 156620700,
region: '肃南裕固族自治县',
regionCode: 156620721,
name: '肃南裕固族自治县',
adcode: '156620721'
}, {
id: 2625,
province: '甘肃省',
provinceCode: 156620000,
city: '张掖市',
cityCode: 156620700,
region: '民乐县',
regionCode: 156620722,
name: '民乐县',
adcode: '156620722'
}, {
id: 2626,
province: '甘肃省',
provinceCode: 156620000,
city: '张掖市',
cityCode: 156620700,
region: '临泽县',
regionCode: 156620723,
name: '临泽县',
adcode: '156620723'
}, {
id: 2627,
province: '甘肃省',
provinceCode: 156620000,
city: '张掖市',
cityCode: 156620700,
region: '高台县',
regionCode: 156620724,
name: '高台县',
adcode: '156620724'
}, {
id: 2628,
province: '甘肃省',
provinceCode: 156620000,
city: '张掖市',
cityCode: 156620700,
region: '山丹县',
regionCode: 156620725,
name: '山丹县',
adcode: '156620725'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
adcode: '156620800',
name: '平凉市',
cityCode: 156620800,
children: [{
id: 2629,
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
cityCode: 156620800,
region: '崆峒区',
regionCode: 156620802,
name: '崆峒区',
adcode: '156620802'
}, {
id: 2630,
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
cityCode: 156620800,
region: '泾川县',
regionCode: 156620821,
name: '泾川县',
adcode: '156620821'
}, {
id: 2631,
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
cityCode: 156620800,
region: '灵台县',
regionCode: 156620822,
name: '灵台县',
adcode: '156620822'
}, {
id: 2632,
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
cityCode: 156620800,
region: '崇信县',
regionCode: 156620823,
name: '崇信县',
adcode: '156620823'
}, {
id: 2633,
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
cityCode: 156620800,
region: '庄浪县',
regionCode: 156620825,
name: '庄浪县',
adcode: '156620825'
}, {
id: 2634,
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
cityCode: 156620800,
region: '静宁县',
regionCode: 156620826,
name: '静宁县',
adcode: '156620826'
}, {
id: 2635,
province: '甘肃省',
provinceCode: 156620000,
city: '平凉市',
cityCode: 156620800,
region: '华亭市',
regionCode: 156620881,
name: '华亭市',
adcode: '156620881'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
adcode: '156620900',
name: '酒泉市',
cityCode: 156620900,
children: [{
id: 2636,
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
cityCode: 156620900,
region: '肃州区',
regionCode: 156620902,
name: '肃州区',
adcode: '156620902'
}, {
id: 2637,
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
cityCode: 156620900,
region: '金塔县',
regionCode: 156620921,
name: '金塔县',
adcode: '156620921'
}, {
id: 2638,
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
cityCode: 156620900,
region: '瓜州县',
regionCode: 156620922,
name: '瓜州县',
adcode: '156620922'
}, {
id: 2639,
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
cityCode: 156620900,
region: '肃北蒙古族自治县',
regionCode: 156620923,
name: '肃北蒙古族自治县',
adcode: '156620923'
}, {
id: 2640,
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
cityCode: 156620900,
region: '阿克塞哈萨克族自治县',
regionCode: 156620924,
name: '阿克塞哈萨克族自治县',
adcode: '156620924'
}, {
id: 2641,
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
cityCode: 156620900,
region: '玉门市',
regionCode: 156620981,
name: '玉门市',
adcode: '156620981'
}, {
id: 2642,
province: '甘肃省',
provinceCode: 156620000,
city: '酒泉市',
cityCode: 156620900,
region: '敦煌市',
regionCode: 156620982,
name: '敦煌市',
adcode: '156620982'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
adcode: '156621000',
name: '庆阳市',
cityCode: 156621000,
children: [{
id: 2643,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '西峰区',
regionCode: 156621002,
name: '西峰区',
adcode: '156621002'
}, {
id: 2644,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '庆城县',
regionCode: 156621021,
name: '庆城县',
adcode: '156621021'
}, {
id: 2645,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '环县',
regionCode: 156621022,
name: '环县',
adcode: '156621022'
}, {
id: 2646,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '华池县',
regionCode: 156621023,
name: '华池县',
adcode: '156621023'
}, {
id: 2647,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '合水县',
regionCode: 156621024,
name: '合水县',
adcode: '156621024'
}, {
id: 2648,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '正宁县',
regionCode: 156621025,
name: '正宁县',
adcode: '156621025'
}, {
id: 2649,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '宁县',
regionCode: 156621026,
name: '宁县',
adcode: '156621026'
}, {
id: 2650,
province: '甘肃省',
provinceCode: 156620000,
city: '庆阳市',
cityCode: 156621000,
region: '镇原县',
regionCode: 156621027,
name: '镇原县',
adcode: '156621027'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
adcode: '156621100',
name: '定西市',
cityCode: 156621100,
children: [{
id: 2651,
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
cityCode: 156621100,
region: '安定区',
regionCode: 156621102,
name: '安定区',
adcode: '156621102'
}, {
id: 2652,
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
cityCode: 156621100,
region: '通渭县',
regionCode: 156621121,
name: '通渭县',
adcode: '156621121'
}, {
id: 2653,
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
cityCode: 156621100,
region: '陇西县',
regionCode: 156621122,
name: '陇西县',
adcode: '156621122'
}, {
id: 2654,
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
cityCode: 156621100,
region: '渭源县',
regionCode: 156621123,
name: '渭源县',
adcode: '156621123'
}, {
id: 2655,
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
cityCode: 156621100,
region: '临洮县',
regionCode: 156621124,
name: '临洮县',
adcode: '156621124'
}, {
id: 2656,
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
cityCode: 156621100,
region: '漳县',
regionCode: 156621125,
name: '漳县',
adcode: '156621125'
}, {
id: 2657,
province: '甘肃省',
provinceCode: 156620000,
city: '定西市',
cityCode: 156621100,
region: '岷县',
regionCode: 156621126,
name: '岷县',
adcode: '156621126'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
adcode: '156621200',
name: '陇南市',
cityCode: 156621200,
children: [{
id: 2658,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '武都区',
regionCode: 156621202,
name: '武都区',
adcode: '156621202'
}, {
id: 2659,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '成县',
regionCode: 156621221,
name: '成县',
adcode: '156621221'
}, {
id: 2660,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '文县',
regionCode: 156621222,
name: '文县',
adcode: '156621222'
}, {
id: 2661,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '宕昌县',
regionCode: 156621223,
name: '宕昌县',
adcode: '156621223'
}, {
id: 2662,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '康县',
regionCode: 156621224,
name: '康县',
adcode: '156621224'
}, {
id: 2663,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '西和县',
regionCode: 156621225,
name: '西和县',
adcode: '156621225'
}, {
id: 2664,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '礼县',
regionCode: 156621226,
name: '礼县',
adcode: '156621226'
}, {
id: 2665,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '徽县',
regionCode: 156621227,
name: '徽县',
adcode: '156621227'
}, {
id: 2666,
province: '甘肃省',
provinceCode: 156620000,
city: '陇南市',
cityCode: 156621200,
region: '两当县',
regionCode: 156621228,
name: '两当县',
adcode: '156621228'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
adcode: '156622900',
name: '临夏回族自治州',
cityCode: 156622900,
children: [{
id: 2667,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '临夏市',
regionCode: 156622901,
name: '临夏市',
adcode: '156622901'
}, {
id: 2668,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '临夏县',
regionCode: 156622921,
name: '临夏县',
adcode: '156622921'
}, {
id: 2669,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '康乐县',
regionCode: 156622922,
name: '康乐县',
adcode: '156622922'
}, {
id: 2670,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '永靖县',
regionCode: 156622923,
name: '永靖县',
adcode: '156622923'
}, {
id: 2671,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '广河县',
regionCode: 156622924,
name: '广河县',
adcode: '156622924'
}, {
id: 2672,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '和政县',
regionCode: 156622925,
name: '和政县',
adcode: '156622925'
}, {
id: 2673,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '东乡族自治县',
regionCode: 156622926,
name: '东乡族自治县',
adcode: '156622926'
}, {
id: 2674,
province: '甘肃省',
provinceCode: 156620000,
city: '临夏回族自治州',
cityCode: 156622900,
region: '积石山保安族东乡族撒拉族自治县',
regionCode: 156622927,
name: '积石山保安族东乡族撒拉族自治县',
adcode: '156622927'
}]
}, {
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
adcode: '156623000',
name: '甘南藏族自治州',
cityCode: 156623000,
children: [{
id: 2675,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '合作市',
regionCode: 156623001,
name: '合作市',
adcode: '156623001'
}, {
id: 2676,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '临潭县',
regionCode: 156623021,
name: '临潭县',
adcode: '156623021'
}, {
id: 2677,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '卓尼县',
regionCode: 156623022,
name: '卓尼县',
adcode: '156623022'
}, {
id: 2678,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '舟曲县',
regionCode: 156623023,
name: '舟曲县',
adcode: '156623023'
}, {
id: 2679,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '迭部县',
regionCode: 156623024,
name: '迭部县',
adcode: '156623024'
}, {
id: 2680,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '玛曲县',
regionCode: 156623025,
name: '玛曲县',
adcode: '156623025'
}, {
id: 2681,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '碌曲县',
regionCode: 156623026,
name: '碌曲县',
adcode: '156623026'
}, {
id: 2682,
province: '甘肃省',
provinceCode: 156620000,
city: '甘南藏族自治州',
cityCode: 156623000,
region: '夏河县',
regionCode: 156623027,
name: '夏河县',
adcode: '156623027'
}]
}]
}, {
province: '青海省',
provinceCode: 156630000,
adcode: '156630000',
name: '青海省',
children: [{
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
adcode: '156630100',
name: '西宁市',
cityCode: 156630100,
children: [{
id: 2686,
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
cityCode: 156630100,
region: '城东区',
regionCode: 156630102,
name: '城东区',
adcode: '156630102'
}, {
id: 2687,
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
cityCode: 156630100,
region: '城中区',
regionCode: 156630103,
name: '城中区',
adcode: '156630103'
}, {
id: 2688,
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
cityCode: 156630100,
region: '城西区',
regionCode: 156630104,
name: '城西区',
adcode: '156630104'
}, {
id: 2689,
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
cityCode: 156630100,
region: '城北区',
regionCode: 156630105,
name: '城北区',
adcode: '156630105'
}, {
id: 2690,
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
cityCode: 156630100,
region: '湟中区',
regionCode: 156630106,
name: '湟中区',
adcode: '156630106'
}, {
id: 2691,
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
cityCode: 156630100,
region: '大通回族土族自治县',
regionCode: 156630121,
name: '大通回族土族自治县',
adcode: '156630121'
}, {
id: 2692,
province: '青海省',
provinceCode: 156630000,
city: '西宁市',
cityCode: 156630100,
region: '湟源县',
regionCode: 156630123,
name: '湟源县',
adcode: '156630123'
}]
}, {
province: '青海省',
provinceCode: 156630000,
city: '海东市',
adcode: '156630200',
name: '海东市',
cityCode: 156630200,
children: [{
id: 2693,
province: '青海省',
provinceCode: 156630000,
city: '海东市',
cityCode: 156630200,
region: '乐都区',
regionCode: 156630202,
name: '乐都区',
adcode: '156630202'
}, {
id: 2694,
province: '青海省',
provinceCode: 156630000,
city: '海东市',
cityCode: 156630200,
region: '平安区',
regionCode: 156630203,
name: '平安区',
adcode: '156630203'
}, {
id: 2695,
province: '青海省',
provinceCode: 156630000,
city: '海东市',
cityCode: 156630200,
region: '民和回族土族自治县',
regionCode: 156630222,
name: '民和回族土族自治县',
adcode: '156630222'
}, {
id: 2696,
province: '青海省',
provinceCode: 156630000,
city: '海东市',
cityCode: 156630200,
region: '互助土族自治县',
regionCode: 156630223,
name: '互助土族自治县',
adcode: '156630223'
}, {
id: 2697,
province: '青海省',
provinceCode: 156630000,
city: '海东市',
cityCode: 156630200,
region: '化隆回族自治县',
regionCode: 156630224,
name: '化隆回族自治县',
adcode: '156630224'
}, {
id: 2698,
province: '青海省',
provinceCode: 156630000,
city: '海东市',
cityCode: 156630200,
region: '循化撒拉族自治县',
regionCode: 156630225,
name: '循化撒拉族自治县',
adcode: '156630225'
}]
}, {
province: '青海省',
provinceCode: 156630000,
city: '海北藏族自治州',
adcode: '156632200',
name: '海北藏族自治州',
cityCode: 156632200,
children: [{
id: 2699,
province: '青海省',
provinceCode: 156630000,
city: '海北藏族自治州',
cityCode: 156632200,
region: '门源回族自治县',
regionCode: 156632221,
name: '门源回族自治县',
adcode: '156632221'
}, {
id: 2700,
province: '青海省',
provinceCode: 156630000,
city: '海北藏族自治州',
cityCode: 156632200,
region: '祁连县',
regionCode: 156632222,
name: '祁连县',
adcode: '156632222'
}, {
id: 2701,
province: '青海省',
provinceCode: 156630000,
city: '海北藏族自治州',
cityCode: 156632200,
region: '海晏县',
regionCode: 156632223,
name: '海晏县',
adcode: '156632223'
}, {
id: 2702,
province: '青海省',
provinceCode: 156630000,
city: '海北藏族自治州',
cityCode: 156632200,
region: '刚察县',
regionCode: 156632224,
name: '刚察县',
adcode: '156632224'
}]
}, {
province: '青海省',
provinceCode: 156630000,
city: '黄南藏族自治州',
adcode: '156632300',
name: '黄南藏族自治州',
cityCode: 156632300,
children: [{
id: 2703,
province: '青海省',
provinceCode: 156630000,
city: '黄南藏族自治州',
cityCode: 156632300,
region: '同仁县',
regionCode: 156632321,
name: '同仁县',
adcode: '156632321'
}, {
id: 2704,
province: '青海省',
provinceCode: 156630000,
city: '黄南藏族自治州',
cityCode: 156632300,
region: '尖扎县',
regionCode: 156632322,
name: '尖扎县',
adcode: '156632322'
}, {
id: 2705,
province: '青海省',
provinceCode: 156630000,
city: '黄南藏族自治州',
cityCode: 156632300,
region: '泽库县',
regionCode: 156632323,
name: '泽库县',
adcode: '156632323'
}, {
id: 2706,
province: '青海省',
provinceCode: 156630000,
city: '黄南藏族自治州',
cityCode: 156632300,
region: '河南蒙古族自治县',
regionCode: 156632324,
name: '河南蒙古族自治县',
adcode: '156632324'
}]
}, {
province: '青海省',
provinceCode: 156630000,
city: '海南藏族自治州',
adcode: '156632500',
name: '海南藏族自治州',
cityCode: 156632500,
children: [{
id: 2707,
province: '青海省',
provinceCode: 156630000,
city: '海南藏族自治州',
cityCode: 156632500,
region: '共和县',
regionCode: 156632521,
name: '共和县',
adcode: '156632521'
}, {
id: 2708,
province: '青海省',
provinceCode: 156630000,
city: '海南藏族自治州',
cityCode: 156632500,
region: '同德县',
regionCode: 156632522,
name: '同德县',
adcode: '156632522'
}, {
id: 2709,
province: '青海省',
provinceCode: 156630000,
city: '海南藏族自治州',
cityCode: 156632500,
region: '贵德县',
regionCode: 156632523,
name: '贵德县',
adcode: '156632523'
}, {
id: 2710,
province: '青海省',
provinceCode: 156630000,
city: '海南藏族自治州',
cityCode: 156632500,
region: '兴海县',
regionCode: 156632524,
name: '兴海县',
adcode: '156632524'
}, {
id: 2711,
province: '青海省',
provinceCode: 156630000,
city: '海南藏族自治州',
cityCode: 156632500,
region: '贵南县',
regionCode: 156632525,
name: '贵南县',
adcode: '156632525'
}]
}, {
province: '青海省',
provinceCode: 156630000,
city: '果洛藏族自治州',
adcode: '156632600',
name: '果洛藏族自治州',
cityCode: 156632600,
children: [{
id: 2712,
province: '青海省',
provinceCode: 156630000,
city: '果洛藏族自治州',
cityCode: 156632600,
region: '玛沁县',
regionCode: 156632621,
name: '玛沁县',
adcode: '156632621'
}, {
id: 2713,
province: '青海省',
provinceCode: 156630000,
city: '果洛藏族自治州',
cityCode: 156632600,
region: '班玛县',
regionCode: 156632622,
name: '班玛县',
adcode: '156632622'
}, {
id: 2714,
province: '青海省',
provinceCode: 156630000,
city: '果洛藏族自治州',
cityCode: 156632600,
region: '甘德县',
regionCode: 156632623,
name: '甘德县',
adcode: '156632623'
}, {
id: 2715,
province: '青海省',
provinceCode: 156630000,
city: '果洛藏族自治州',
cityCode: 156632600,
region: '达日县',
regionCode: 156632624,
name: '达日县',
adcode: '156632624'
}, {
id: 2716,
province: '青海省',
provinceCode: 156630000,
city: '果洛藏族自治州',
cityCode: 156632600,
region: '久治县',
regionCode: 156632625,
name: '久治县',
adcode: '156632625'
}, {
id: 2717,
province: '青海省',
provinceCode: 156630000,
city: '果洛藏族自治州',
cityCode: 156632600,
region: '玛多县',
regionCode: 156632626,
name: '玛多县',
adcode: '156632626'
}]
}, {
province: '青海省',
provinceCode: 156630000,
city: '玉树藏族自治州',
adcode: '156632700',
name: '玉树藏族自治州',
cityCode: 156632700,
children: [{
id: 2718,
province: '青海省',
provinceCode: 156630000,
city: '玉树藏族自治州',
cityCode: 156632700,
region: '玉树市',
regionCode: 156632701,
name: '玉树市',
adcode: '156632701'
}, {
id: 2719,
province: '青海省',
provinceCode: 156630000,
city: '玉树藏族自治州',
cityCode: 156632700,
region: '杂多县',
regionCode: 156632722,
name: '杂多县',
adcode: '156632722'
}, {
id: 2720,
province: '青海省',
provinceCode: 156630000,
city: '玉树藏族自治州',
cityCode: 156632700,
region: '称多县',
regionCode: 156632723,
name: '称多县',
adcode: '156632723'
}, {
id: 2721,
province: '青海省',
provinceCode: 156630000,
city: '玉树藏族自治州',
cityCode: 156632700,
region: '治多县',
regionCode: 156632724,
name: '治多县',
adcode: '156632724'
}, {
id: 2722,
province: '青海省',
provinceCode: 156630000,
city: '玉树藏族自治州',
cityCode: 156632700,
region: '囊谦县',
regionCode: 156632725,
name: '囊谦县',
adcode: '156632725'
}, {
id: 2723,
province: '青海省',
provinceCode: 156630000,
city: '玉树藏族自治州',
cityCode: 156632700,
region: '曲麻莱县',
regionCode: 156632726,
name: '曲麻莱县',
adcode: '156632726'
}]
}, {
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
adcode: '156632800',
name: '海西蒙古族藏族自治州',
cityCode: 156632800,
children: [{
id: 2724,
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
cityCode: 156632800,
region: '格尔木市',
regionCode: 156632801,
name: '格尔木市',
adcode: '156632801'
}, {
id: 2725,
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
cityCode: 156632800,
region: '德令哈市',
regionCode: 156632802,
name: '德令哈市',
adcode: '156632802'
}, {
id: 2726,
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
cityCode: 156632800,
region: '茫崖市',
regionCode: 156632803,
name: '茫崖市',
adcode: '156632803'
}, {
id: 2727,
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
cityCode: 156632800,
region: '乌兰县',
regionCode: 156632821,
name: '乌兰县',
adcode: '156632821'
}, {
id: 2728,
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
cityCode: 156632800,
region: '都兰县',
regionCode: 156632822,
name: '都兰县',
adcode: '156632822'
}, {
id: 2729,
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
cityCode: 156632800,
region: '天峻县',
regionCode: 156632823,
name: '天峻县',
adcode: '156632823'
}, {
id: 2730,
province: '青海省',
provinceCode: 156630000,
city: '海西蒙古族藏族自治州',
cityCode: 156632800,
region: '大柴旦行政委员会',
regionCode: 156632825,
name: '大柴旦行政委员会',
adcode: '156632825'
}]
}]
}, {
province: '宁夏回族自治区',
provinceCode: 156640000,
adcode: '156640000',
name: '宁夏回族自治区',
children: [{
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '银川市',
adcode: '156640100',
name: '银川市',
cityCode: 156640100,
children: [{
id: 2731,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '银川市',
cityCode: 156640100,
region: '兴庆区',
regionCode: 156640104,
name: '兴庆区',
adcode: '156640104'
}, {
id: 2732,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '银川市',
cityCode: 156640100,
region: '西夏区',
regionCode: 156640105,
name: '西夏区',
adcode: '156640105'
}, {
id: 2733,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '银川市',
cityCode: 156640100,
region: '金凤区',
regionCode: 156640106,
name: '金凤区',
adcode: '156640106'
}, {
id: 2734,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '银川市',
cityCode: 156640100,
region: '永宁县',
regionCode: 156640121,
name: '永宁县',
adcode: '156640121'
}, {
id: 2735,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '银川市',
cityCode: 156640100,
region: '贺兰县',
regionCode: 156640122,
name: '贺兰县',
adcode: '156640122'
}, {
id: 2736,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '银川市',
cityCode: 156640100,
region: '灵武市',
regionCode: 156640181,
name: '灵武市',
adcode: '156640181'
}]
}, {
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '石嘴山市',
adcode: '156640200',
name: '石嘴山市',
cityCode: 156640200,
children: [{
id: 2737,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '石嘴山市',
cityCode: 156640200,
region: '大武口区',
regionCode: 156640202,
name: '大武口区',
adcode: '156640202'
}, {
id: 2738,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '石嘴山市',
cityCode: 156640200,
region: '惠农区',
regionCode: 156640205,
name: '惠农区',
adcode: '156640205'
}, {
id: 2739,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '石嘴山市',
cityCode: 156640200,
region: '平罗县',
regionCode: 156640221,
name: '平罗县',
adcode: '156640221'
}]
}, {
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '吴忠市',
adcode: '156640300',
name: '吴忠市',
cityCode: 156640300,
children: [{
id: 2740,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '吴忠市',
cityCode: 156640300,
region: '利通区',
regionCode: 156640302,
name: '利通区',
adcode: '156640302'
}, {
id: 2741,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '吴忠市',
cityCode: 156640300,
region: '红寺堡区',
regionCode: 156640303,
name: '红寺堡区',
adcode: '156640303'
}, {
id: 2742,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '吴忠市',
cityCode: 156640300,
region: '盐池县',
regionCode: 156640323,
name: '盐池县',
adcode: '156640323'
}, {
id: 2743,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '吴忠市',
cityCode: 156640300,
region: '同心县',
regionCode: 156640324,
name: '同心县',
adcode: '156640324'
}, {
id: 2744,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '吴忠市',
cityCode: 156640300,
region: '青铜峡市',
regionCode: 156640381,
name: '青铜峡市',
adcode: '156640381'
}]
}, {
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '固原市',
adcode: '156640400',
name: '固原市',
cityCode: 156640400,
children: [{
id: 2745,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '固原市',
cityCode: 156640400,
region: '原州区',
regionCode: 156640402,
name: '原州区',
adcode: '156640402'
}, {
id: 2746,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '固原市',
cityCode: 156640400,
region: '西吉县',
regionCode: 156640422,
name: '西吉县',
adcode: '156640422'
}, {
id: 2747,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '固原市',
cityCode: 156640400,
region: '隆德县',
regionCode: 156640423,
name: '隆德县',
adcode: '156640423'
}, {
id: 2748,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '固原市',
cityCode: 156640400,
region: '泾源县',
regionCode: 156640424,
name: '泾源县',
adcode: '156640424'
}, {
id: 2749,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '固原市',
cityCode: 156640400,
region: '彭阳县',
regionCode: 156640425,
name: '彭阳县',
adcode: '156640425'
}]
}, {
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '中卫市',
adcode: '156640500',
name: '中卫市',
cityCode: 156640500,
children: [{
id: 2750,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '中卫市',
cityCode: 156640500,
region: '沙坡头区',
regionCode: 156640502,
name: '沙坡头区',
adcode: '156640502'
}, {
id: 2751,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '中卫市',
cityCode: 156640500,
region: '中宁县',
regionCode: 156640521,
name: '中宁县',
adcode: '156640521'
}, {
id: 2752,
province: '宁夏回族自治区',
provinceCode: 156640000,
city: '中卫市',
cityCode: 156640500,
region: '海原县',
regionCode: 156640522,
name: '海原县',
adcode: '156640522'
}]
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
adcode: '156650000',
name: '新疆维吾尔自治区',
children: [{
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
adcode: '156650000',
name: '新疆维吾尔自治区直辖',
cityCode: 156650000,
children: [{
id: 2849,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '石河子市',
regionCode: 156659001,
name: '石河子市',
adcode: '156659001'
}, {
id: 2850,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '阿拉尔市',
regionCode: 156659002,
name: '阿拉尔市',
adcode: '156659002'
}, {
id: 2851,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '图木舒克市',
regionCode: 156659003,
name: '图木舒克市',
adcode: '156659003'
}, {
id: 2852,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '五家渠市',
regionCode: 156659004,
name: '五家渠市',
adcode: '156659004'
}, {
id: 2853,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '北屯市',
regionCode: 156659005,
name: '北屯市',
adcode: '156659005'
}, {
id: 2854,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '铁门关市',
regionCode: 156659006,
name: '铁门关市',
adcode: '156659006'
}, {
id: 2855,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '双河市',
regionCode: 156659007,
name: '双河市',
adcode: '156659007'
}, {
id: 2856,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '可克达拉市',
regionCode: 156659008,
name: '可克达拉市',
adcode: '156659008'
}, {
id: 2857,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '昆玉市',
regionCode: 156659009,
name: '昆玉市',
adcode: '156659009'
}, {
id: 2858,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '新疆维吾尔自治区直辖',
cityCode: 156650000,
region: '胡杨河市',
regionCode: 156659010,
name: '胡杨河市',
adcode: '156659010'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
adcode: '156650100',
name: '乌鲁木齐市',
cityCode: 156650100,
children: [{
id: 2753,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '天山区',
regionCode: 156650102,
name: '天山区',
adcode: '156650102'
}, {
id: 2754,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '沙依巴克区',
regionCode: 156650103,
name: '沙依巴克区',
adcode: '156650103'
}, {
id: 2755,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '新市区',
regionCode: 156650104,
name: '新市区',
adcode: '156650104'
}, {
id: 2756,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '水磨沟区',
regionCode: 156650105,
name: '水磨沟区',
adcode: '156650105'
}, {
id: 2757,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '头屯河区',
regionCode: 156650106,
name: '头屯河区',
adcode: '156650106'
}, {
id: 2758,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '达坂城区',
regionCode: 156650107,
name: '达坂城区',
adcode: '156650107'
}, {
id: 2759,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '米东区',
regionCode: 156650109,
name: '米东区',
adcode: '156650109'
}, {
id: 2760,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '乌鲁木齐市',
cityCode: 156650100,
region: '乌鲁木齐县',
regionCode: 156650121,
name: '乌鲁木齐县',
adcode: '156650121'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克拉玛依市',
adcode: '156650200',
name: '克拉玛依市',
cityCode: 156650200,
children: [{
id: 2761,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克拉玛依市',
cityCode: 156650200,
region: '独山子区',
regionCode: 156650202,
name: '独山子区',
adcode: '156650202'
}, {
id: 2762,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克拉玛依市',
cityCode: 156650200,
region: '克拉玛依区',
regionCode: 156650203,
name: '克拉玛依区',
adcode: '156650203'
}, {
id: 2763,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克拉玛依市',
cityCode: 156650200,
region: '白碱滩区',
regionCode: 156650204,
name: '白碱滩区',
adcode: '156650204'
}, {
id: 2764,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克拉玛依市',
cityCode: 156650200,
region: '乌尔禾区',
regionCode: 156650205,
name: '乌尔禾区',
adcode: '156650205'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '吐鲁番市',
adcode: '156650400',
name: '吐鲁番市',
cityCode: 156650400,
children: [{
id: 2765,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '吐鲁番市',
cityCode: 156650400,
region: '高昌区',
regionCode: 156650402,
name: '高昌区',
adcode: '156650402'
}, {
id: 2766,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '吐鲁番市',
cityCode: 156650400,
region: '鄯善县',
regionCode: 156650421,
name: '鄯善县',
adcode: '156650421'
}, {
id: 2767,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '吐鲁番市',
cityCode: 156650400,
region: '托克逊县',
regionCode: 156650422,
name: '托克逊县',
adcode: '156650422'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '哈密市',
adcode: '156650500',
name: '哈密市',
cityCode: 156650500,
children: [{
id: 2768,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '哈密市',
cityCode: 156650500,
region: '伊州区',
regionCode: 156650502,
name: '伊州区',
adcode: '156650502'
}, {
id: 2769,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '哈密市',
cityCode: 156650500,
region: '巴里坤哈萨克自治县',
regionCode: 156650521,
name: '巴里坤哈萨克自治县',
adcode: '156650521'
}, {
id: 2770,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '哈密市',
cityCode: 156650500,
region: '伊吾县',
regionCode: 156650522,
name: '伊吾县',
adcode: '156650522'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
adcode: '156652300',
name: '昌吉回族自治州',
cityCode: 156652300,
children: [{
id: 2771,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
cityCode: 156652300,
region: '昌吉市',
regionCode: 156652301,
name: '昌吉市',
adcode: '156652301'
}, {
id: 2772,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
cityCode: 156652300,
region: '阜康市',
regionCode: 156652302,
name: '阜康市',
adcode: '156652302'
}, {
id: 2773,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
cityCode: 156652300,
region: '呼图壁县',
regionCode: 156652323,
name: '呼图壁县',
adcode: '156652323'
}, {
id: 2774,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
cityCode: 156652300,
region: '玛纳斯县',
regionCode: 156652324,
name: '玛纳斯县',
adcode: '156652324'
}, {
id: 2775,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
cityCode: 156652300,
region: '奇台县',
regionCode: 156652325,
name: '奇台县',
adcode: '156652325'
}, {
id: 2776,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
cityCode: 156652300,
region: '吉木萨尔县',
regionCode: 156652327,
name: '吉木萨尔县',
adcode: '156652327'
}, {
id: 2777,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '昌吉回族自治州',
cityCode: 156652300,
region: '木垒哈萨克自治县',
regionCode: 156652328,
name: '木垒哈萨克自治县',
adcode: '156652328'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '博尔塔拉蒙古自治州',
adcode: '156652700',
name: '博尔塔拉蒙古自治州',
cityCode: 156652700,
children: [{
id: 2778,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '博尔塔拉蒙古自治州',
cityCode: 156652700,
region: '博乐市',
regionCode: 156652701,
name: '博乐市',
adcode: '156652701'
}, {
id: 2779,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '博尔塔拉蒙古自治州',
cityCode: 156652700,
region: '阿拉山口市',
regionCode: 156652702,
name: '阿拉山口市',
adcode: '156652702'
}, {
id: 2780,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '博尔塔拉蒙古自治州',
cityCode: 156652700,
region: '精河县',
regionCode: 156652722,
name: '精河县',
adcode: '156652722'
}, {
id: 2781,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '博尔塔拉蒙古自治州',
cityCode: 156652700,
region: '温泉县',
regionCode: 156652723,
name: '温泉县',
adcode: '156652723'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
adcode: '156652800',
name: '巴音郭楞蒙古自治州',
cityCode: 156652800,
children: [{
id: 2782,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '库尔勒市',
regionCode: 156652801,
name: '库尔勒市',
adcode: '156652801'
}, {
id: 2783,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '轮台县',
regionCode: 156652822,
name: '轮台县',
adcode: '156652822'
}, {
id: 2784,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '尉犁县',
regionCode: 156652823,
name: '尉犁县',
adcode: '156652823'
}, {
id: 2785,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '若羌县',
regionCode: 156652824,
name: '若羌县',
adcode: '156652824'
}, {
id: 2786,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '且末县',
regionCode: 156652825,
name: '且末县',
adcode: '156652825'
}, {
id: 2787,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '焉耆回族自治县',
regionCode: 156652826,
name: '焉耆回族自治县',
adcode: '156652826'
}, {
id: 2788,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '和静县',
regionCode: 156652827,
name: '和静县',
adcode: '156652827'
}, {
id: 2789,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '和硕县',
regionCode: 156652828,
name: '和硕县',
adcode: '156652828'
}, {
id: 2790,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '巴音郭楞蒙古自治州',
cityCode: 156652800,
region: '博湖县',
regionCode: 156652829,
name: '博湖县',
adcode: '156652829'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
adcode: '156652900',
name: '阿克苏地区',
cityCode: 156652900,
children: [{
id: 2791,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '阿克苏市',
regionCode: 156652901,
name: '阿克苏市',
adcode: '156652901'
}, {
id: 2792,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '库车市',
regionCode: 156652902,
name: '库车市',
adcode: '156652902'
}, {
id: 2793,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '温宿县',
regionCode: 156652922,
name: '温宿县',
adcode: '156652922'
}, {
id: 2794,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '沙雅县',
regionCode: 156652924,
name: '沙雅县',
adcode: '156652924'
}, {
id: 2795,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '新和县',
regionCode: 156652925,
name: '新和县',
adcode: '156652925'
}, {
id: 2796,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '拜城县',
regionCode: 156652926,
name: '拜城县',
adcode: '156652926'
}, {
id: 2797,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '乌什县',
regionCode: 156652927,
name: '乌什县',
adcode: '156652927'
}, {
id: 2798,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '阿瓦提县',
regionCode: 156652928,
name: '阿瓦提县',
adcode: '156652928'
}, {
id: 2799,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿克苏地区',
cityCode: 156652900,
region: '柯坪县',
regionCode: 156652929,
name: '柯坪县',
adcode: '156652929'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克孜勒苏柯尔克孜自治州',
adcode: '156653000',
name: '克孜勒苏柯尔克孜自治州',
cityCode: 156653000,
children: [{
id: 2800,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克孜勒苏柯尔克孜自治州',
cityCode: 156653000,
region: '阿图什市',
regionCode: 156653001,
name: '阿图什市',
adcode: '156653001'
}, {
id: 2801,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克孜勒苏柯尔克孜自治州',
cityCode: 156653000,
region: '阿克陶县',
regionCode: 156653022,
name: '阿克陶县',
adcode: '156653022'
}, {
id: 2802,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克孜勒苏柯尔克孜自治州',
cityCode: 156653000,
region: '阿合奇县',
regionCode: 156653023,
name: '阿合奇县',
adcode: '156653023'
}, {
id: 2803,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '克孜勒苏柯尔克孜自治州',
cityCode: 156653000,
region: '乌恰县',
regionCode: 156653024,
name: '乌恰县',
adcode: '156653024'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
adcode: '156653100',
name: '喀什地区',
cityCode: 156653100,
children: [{
id: 2804,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '喀什市',
regionCode: 156653101,
name: '喀什市',
adcode: '156653101'
}, {
id: 2805,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '疏附县',
regionCode: 156653121,
name: '疏附县',
adcode: '156653121'
}, {
id: 2806,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '疏勒县',
regionCode: 156653122,
name: '疏勒县',
adcode: '156653122'
}, {
id: 2807,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '英吉沙县',
regionCode: 156653123,
name: '英吉沙县',
adcode: '156653123'
}, {
id: 2808,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '泽普县',
regionCode: 156653124,
name: '泽普县',
adcode: '156653124'
}, {
id: 2809,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '莎车县',
regionCode: 156653125,
name: '莎车县',
adcode: '156653125'
}, {
id: 2810,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '叶城县',
regionCode: 156653126,
name: '叶城县',
adcode: '156653126'
}, {
id: 2811,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '麦盖提县',
regionCode: 156653127,
name: '麦盖提县',
adcode: '156653127'
}, {
id: 2812,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '岳普湖县',
regionCode: 156653128,
name: '岳普湖县',
adcode: '156653128'
}, {
id: 2813,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '伽师县',
regionCode: 156653129,
name: '伽师县',
adcode: '156653129'
}, {
id: 2814,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '巴楚县',
regionCode: 156653130,
name: '巴楚县',
adcode: '156653130'
}, {
id: 2815,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '喀什地区',
cityCode: 156653100,
region: '塔什库尔干塔吉克自治县',
regionCode: 156653131,
name: '塔什库尔干塔吉克自治县',
adcode: '156653131'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
adcode: '156653200',
name: '和田地区',
cityCode: 156653200,
children: [{
id: 2816,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '和田市',
regionCode: 156653201,
name: '和田市',
adcode: '156653201'
}, {
id: 2817,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '和田县',
regionCode: 156653221,
name: '和田县',
adcode: '156653221'
}, {
id: 2818,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '墨玉县',
regionCode: 156653222,
name: '墨玉县',
adcode: '156653222'
}, {
id: 2819,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '皮山县',
regionCode: 156653223,
name: '皮山县',
adcode: '156653223'
}, {
id: 2820,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '洛浦县',
regionCode: 156653224,
name: '洛浦县',
adcode: '156653224'
}, {
id: 2821,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '策勒县',
regionCode: 156653225,
name: '策勒县',
adcode: '156653225'
}, {
id: 2822,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '于田县',
regionCode: 156653226,
name: '于田县',
adcode: '156653226'
}, {
id: 2823,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '和田地区',
cityCode: 156653200,
region: '民丰县',
regionCode: 156653227,
name: '民丰县',
adcode: '156653227'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
adcode: '156654000',
name: '伊犁哈萨克自治州',
cityCode: 156654000,
children: [{
id: 2824,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '伊宁市',
regionCode: 156654002,
name: '伊宁市',
adcode: '156654002'
}, {
id: 2825,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '奎屯市',
regionCode: 156654003,
name: '奎屯市',
adcode: '156654003'
}, {
id: 2826,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '霍尔果斯市',
regionCode: 156654004,
name: '霍尔果斯市',
adcode: '156654004'
}, {
id: 2827,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '伊宁县',
regionCode: 156654021,
name: '伊宁县',
adcode: '156654021'
}, {
id: 2828,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '察布查尔锡伯自治县',
regionCode: 156654022,
name: '察布查尔锡伯自治县',
adcode: '156654022'
}, {
id: 2829,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '霍城县',
regionCode: 156654023,
name: '霍城县',
adcode: '156654023'
}, {
id: 2830,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '巩留县',
regionCode: 156654024,
name: '巩留县',
adcode: '156654024'
}, {
id: 2831,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '新源县',
regionCode: 156654025,
name: '新源县',
adcode: '156654025'
}, {
id: 2832,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '昭苏县',
regionCode: 156654026,
name: '昭苏县',
adcode: '156654026'
}, {
id: 2833,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '特克斯县',
regionCode: 156654027,
name: '特克斯县',
adcode: '156654027'
}, {
id: 2834,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '伊犁哈萨克自治州',
cityCode: 156654000,
region: '尼勒克县',
regionCode: 156654028,
name: '尼勒克县',
adcode: '156654028'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
adcode: '156654200',
name: '塔城地区',
cityCode: 156654200,
children: [{
id: 2835,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
cityCode: 156654200,
region: '塔城市',
regionCode: 156654201,
name: '塔城市',
adcode: '156654201'
}, {
id: 2836,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
cityCode: 156654200,
region: '乌苏市',
regionCode: 156654202,
name: '乌苏市',
adcode: '156654202'
}, {
id: 2837,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
cityCode: 156654200,
region: '额敏县',
regionCode: 156654221,
name: '额敏县',
adcode: '156654221'
}, {
id: 2838,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
cityCode: 156654200,
region: '沙湾县',
regionCode: 156654223,
name: '沙湾县',
adcode: '156654223'
}, {
id: 2839,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
cityCode: 156654200,
region: '托里县',
regionCode: 156654224,
name: '托里县',
adcode: '156654224'
}, {
id: 2840,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
cityCode: 156654200,
region: '裕民县',
regionCode: 156654225,
name: '裕民县',
adcode: '156654225'
}, {
id: 2841,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '塔城地区',
cityCode: 156654200,
region: '和布克赛尔蒙古自治县',
regionCode: 156654226,
name: '和布克赛尔蒙古自治县',
adcode: '156654226'
}]
}, {
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
adcode: '156654300',
name: '阿勒泰地区',
cityCode: 156654300,
children: [{
id: 2842,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
cityCode: 156654300,
region: '阿勒泰市',
regionCode: 156654301,
name: '阿勒泰市',
adcode: '156654301'
}, {
id: 2843,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
cityCode: 156654300,
region: '布尔津县',
regionCode: 156654321,
name: '布尔津县',
adcode: '156654321'
}, {
id: 2844,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
cityCode: 156654300,
region: '富蕴县',
regionCode: 156654322,
name: '富蕴县',
adcode: '156654322'
}, {
id: 2845,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
cityCode: 156654300,
region: '福海县',
regionCode: 156654323,
name: '福海县',
adcode: '156654323'
}, {
id: 2846,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
cityCode: 156654300,
region: '哈巴河县',
regionCode: 156654324,
name: '哈巴河县',
adcode: '156654324'
}, {
id: 2847,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
cityCode: 156654300,
region: '青河县',
regionCode: 156654325,
name: '青河县',
adcode: '156654325'
}, {
id: 2848,
province: '新疆维吾尔自治区',
provinceCode: 156650000,
city: '阿勒泰地区',
cityCode: 156654300,
region: '吉木乃县',
regionCode: 156654326,
name: '吉木乃县',
adcode: '156654326'
}]
}]
}, {
province: '台湾省',
provinceCode: 156710000,
adcode: '156710000',
name: '台湾省',
children: [{
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
adcode: '156710000',
name: '台湾省',
cityCode: 156710000,
children: [{
id: 2859,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '澎湖县',
regionCode: 156710010,
name: '澎湖县',
adcode: '156710010'
}, {
id: 2860,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '屏东县',
regionCode: 156710011,
name: '屏东县',
adcode: '156710011'
}, {
id: 2861,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '新北市',
regionCode: 156710012,
name: '新北市',
adcode: '156710012'
}, {
id: 2862,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '台东县',
regionCode: 156710013,
name: '台东县',
adcode: '156710013'
}, {
id: 2863,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '台南市',
regionCode: 156710014,
name: '台南市',
adcode: '156710014'
}, {
id: 2864,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '台中市',
regionCode: 156710016,
name: '台中市',
adcode: '156710016'
}, {
id: 2865,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '桃园市',
regionCode: 156710018,
name: '桃园市',
adcode: '156710018'
}, {
id: 2866,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '新竹市',
regionCode: 156710019,
name: '新竹市',
adcode: '156710019'
}, {
id: 2867,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '新竹县',
regionCode: 156710020,
name: '新竹县',
adcode: '156710020'
}, {
id: 2868,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '宜兰县',
regionCode: 156710021,
name: '宜兰县',
adcode: '156710021'
}, {
id: 2869,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '云林县',
regionCode: 156710022,
name: '云林县',
adcode: '156710022'
}, {
id: 2870,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '彰化县',
regionCode: 156710023,
name: '彰化县',
adcode: '156710023'
}, {
id: 2871,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '高雄市',
regionCode: 156711000,
name: '高雄市',
adcode: '156711000'
}, {
id: 2872,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '花莲县',
regionCode: 156713000,
name: '花莲县',
adcode: '156713000'
}, {
id: 2873,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '基隆市',
regionCode: 156714000,
name: '基隆市',
adcode: '156714000'
}, {
id: 2874,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '嘉义市',
regionCode: 156715000,
name: '嘉义市',
adcode: '156715000'
}, {
id: 2875,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '嘉义县',
regionCode: 156716000,
name: '嘉义县',
adcode: '156716000'
}, {
id: 2876,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '苗栗县',
regionCode: 156717000,
name: '苗栗县',
adcode: '156717000'
}, {
id: 2877,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '南投县',
regionCode: 156718000,
name: '南投县',
adcode: '156718000'
}, {
id: 2878,
province: '台湾省',
provinceCode: 156710000,
city: '台湾省',
cityCode: 156710000,
region: '台北市',
regionCode: 156719000,
name: '台北市',
adcode: '156719000'
}]
}]
}, {
province: '香港特别行政区',
provinceCode: 156810000,
adcode: '156810000',
name: '香港特别行政区',
children: [{
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
adcode: '156810000',
name: '香港特别行政区',
cityCode: 156810000,
children: [{
id: 2879,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '中西区',
regionCode: 156810101,
name: '中西区',
adcode: '156810101'
}, {
id: 2880,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '东区',
regionCode: 156810102,
name: '东区',
adcode: '156810102'
}, {
id: 2881,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '九龙城区',
regionCode: 156810103,
name: '九龙城区',
adcode: '156810103'
}, {
id: 2882,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '观塘区',
regionCode: 156810104,
name: '观塘区',
adcode: '156810104'
}, {
id: 2883,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '南区',
regionCode: 156810105,
name: '南区',
adcode: '156810105'
}, {
id: 2884,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '深水埗区',
regionCode: 156810106,
name: '深水埗区',
adcode: '156810106'
}, {
id: 2885,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '湾仔区',
regionCode: 156810107,
name: '湾仔区',
adcode: '156810107'
}, {
id: 2886,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '黄大仙区',
regionCode: 156810108,
name: '黄大仙区',
adcode: '156810108'
}, {
id: 2887,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '油尖旺区',
regionCode: 156810109,
name: '油尖旺区',
adcode: '156810109'
}, {
id: 2888,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '离岛区',
regionCode: 156810110,
name: '离岛区',
adcode: '156810110'
}, {
id: 2889,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '葵青区',
regionCode: 156810111,
name: '葵青区',
adcode: '156810111'
}, {
id: 2890,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '北区',
regionCode: 156810112,
name: '北区',
adcode: '156810112'
}, {
id: 2891,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '西贡区',
regionCode: 156810113,
name: '西贡区',
adcode: '156810113'
}, {
id: 2892,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '沙田区',
regionCode: 156810114,
name: '沙田区',
adcode: '156810114'
}, {
id: 2893,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '屯门区',
regionCode: 156810115,
name: '屯门区',
adcode: '156810115'
}, {
id: 2894,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '大埔区',
regionCode: 156810116,
name: '大埔区',
adcode: '156810116'
}, {
id: 2895,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '荃湾区',
regionCode: 156810117,
name: '荃湾区',
adcode: '156810117'
}, {
id: 2896,
province: '香港特别行政区',
provinceCode: 156810000,
city: '香港特别行政区',
cityCode: 156810000,
region: '元朗区',
regionCode: 156810118,
name: '元朗区',
adcode: '156810118'
}]
}]
}, {
province: '澳门特别行政区',
provinceCode: 156820000,
adcode: '156820000',
name: '澳门特别行政区',
children: [{
province: '澳门特别行政区',
provinceCode: 156820000,
city: '澳门特别行政区',
adcode: '156820000',
name: '澳门特别行政区',
cityCode: 156820000,
children: [{
id: 2897,
province: '澳门特别行政区',
provinceCode: 156820000,
city: '澳门特别行政区',
cityCode: 156820000,
region: '澳门特别行政区',
regionCode: 156820000,
name: '澳门特别行政区',
adcode: '156820000'
}]
}]
}]
